import React from "react";

function Icon() {
  return (
    <svg
      height="100%"
      width="100%"
      xmlns="http://www.w3.org/2000/svg"
      className="animated"
      version="1.1"
      viewBox="0 0 500 500"
    >
      <g
        className="animable animator-hidden"
        style={{
          WebkitTransformOrigin: 260.21,
          MsTransformOrigin: 260.21,
          transformOrigin: 260.21,
        }}
      >
        <ellipse
          cx="299.15"
          cy="463.12"
          fill="#EBEBEB"
          rx="186.72"
          ry="22.71"
          style={{
            WebkitTransformOrigin: 299.15,
            MsTransformOrigin: 299.15,
            transformOrigin: 299.15,
          }}
          className="animable"
        ></ellipse>
        <ellipse
          cx="126.63"
          cy="433.4"
          fill="#EBEBEB"
          rx="92.08"
          ry="18.74"
          style={{
            WebkitTransformOrigin: 126.63,
            MsTransformOrigin: 126.63,
            transformOrigin: 126.63,
          }}
          className="animable"
        ></ellipse>
      </g>
      <g
        className="animable"
        style={{
          WebkitTransformOrigin: 435.055,
          MsTransformOrigin: 435.055,
          transformOrigin: 435.055,
        }}
      >
        <path
          d="M436.63 344.3s7.26-26.08 13.07-34.93 16.61-18.59 16.61-18.59-.25 40.22-29.68 53.52z"
          style={{
            WebkitTransformOrigin: 451.47,
            MsTransformOrigin: 451.47,
            transformOrigin: 451.47,
          }}
          fill="#1DD21D"
          className="animable"
        ></path>
        <path
          d="M437.15 343.85a124.18 124.18 0 006.62-12.63 88.37 88.37 0 013.61-13.71.07.07 0 01.13 0c-1 4.12-2.09 8.2-3.11 12.31 2.94-6.34 5.72-12.77 9.22-18.77a39.57 39.57 0 013.37-8.35c0-.07.16 0 .12.05a53.22 53.22 0 00-2.26 6.26 61.84 61.84 0 015.52-7.63c.12-.15.38 0 .25.18-4.67 6-7.89 12.74-11 19.61a104 104 0 009.12-11.4s.09 0 .06.05a94.28 94.28 0 01-9.76 12.65c-2.24 5-4.44 10.08-7.1 14.87 5.32-4.5 9.42-10.33 13.48-15.95.09-.13.28 0 .2.14-4.06 6.16-8.26 12-14.1 16.54a64.24 64.24 0 01-3.9 6.1.31.31 0 01-.47-.32z"
          style={{
            WebkitTransformOrigin: 448.9,
            MsTransformOrigin: 448.9,
            transformOrigin: 448.9,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M434.38 346.65s13.06-24 9.26-47.36-7.85-31.62-7.85-31.62-20.53 36.27-1.41 78.98z"
          style={{
            WebkitTransformOrigin: 435.283,
            MsTransformOrigin: 435.283,
            transformOrigin: 435.283,
          }}
          fill="#1DD21D"
          className="animable"
        ></path>
        <path
          d="M429 308.85a113.66 113.66 0 005 19.41c0-8.55.2-17.11.43-25.66a66.11 66.11 0 01-2.43-15.94c0-.16.23-.15.24 0a91.87 91.87 0 002.29 13.71q.3-10.59.69-21.17a.09.09 0 11.18 0c0 11 0 22.05-.07 33.08a87.65 87.65 0 003.76-13.1h.08a51.45 51.45 0 01-3.85 14.91c0 7-.13 14.09-.29 21.14 2.21-7.5 4.57-14.75 5.21-22.67 0-.1.17-.1.17 0-.18 8.74-2.43 17.6-5.31 25.81a.52.52 0 01-.14.21c-.07 2.57-.14 5.15-.23 7.72a.29.29 0 01-.57 0q-.15-7.9-.13-15.81a70.76 70.76 0 01-5.15-21.64.06.06 0 01.12 0z"
          style={{
            WebkitTransformOrigin: 434.645,
            MsTransformOrigin: 434.645,
            transformOrigin: 434.645,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M429.91 305.13a45.38 45.38 0 01.91 6.35c0 .07-.1.08-.12 0a45 45 0 01-1.08-6.33c-.01-.15.26-.15.29-.02z"
          style={{
            WebkitTransformOrigin: 430.22,
            MsTransformOrigin: 430.22,
            transformOrigin: 430.22,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M437.55 287.55c0-.07.12-.05.12 0A16.29 16.29 0 01437 292a.09.09 0 01-.18-.05c.3-1.5.48-2.95.73-4.4z"
          style={{
            WebkitTransformOrigin: 437.244,
            MsTransformOrigin: 437.244,
            transformOrigin: 437.244,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M429.61 348.49s.54-25.1-6.66-37.58a54.13 54.13 0 00-19.15-18.83s4.82 44.24 25.81 56.41z"
          style={{
            WebkitTransformOrigin: 416.71,
            MsTransformOrigin: 416.71,
            transformOrigin: 416.71,
          }}
          fill="#1DD21D"
          className="animable"
        ></path>
        <path
          d="M416.49 327a93.22 93.22 0 009.75 12.35q-2.16-7.69-5-15.13c-4-3.54-8-7.21-10.52-12.05 0-.08.08-.15.12-.07 2.66 4.29 6.23 7.72 10 11a193.39 193.39 0 00-10-21.83.16.16 0 01.27-.16 119.05 119.05 0 016.29 11.46c-.68-2.69-1.21-5.43-1.91-8.09 0-.08.09-.1.12 0a45.33 45.33 0 012.95 10.64 126.83 126.83 0 016.34 17.18c-.18-3.76-.42-7.51-.81-11.26 0-.07.12-.09.13 0a61 61 0 011.09 12.64c1 3.74 1.91 7.53 2.61 11.34 0 .1-.13.15-.16.05-.39-1.6-.81-3.19-1.24-4.77h-.09a51.06 51.06 0 01-9.94-13.21s-.02-.09 0-.09z"
          style={{
            WebkitTransformOrigin: 419.32,
            MsTransformOrigin: 419.32,
            transformOrigin: 419.32,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M408.15 306.6c.8.87 1.54 1.78 2.31 2.67a19.76 19.76 0 012.07 2.42v.06a12.24 12.24 0 01-2.4-2.37 20.54 20.54 0 01-2.05-2.69.08.08 0 01.07-.09z"
          style={{
            WebkitTransformOrigin: 410.305,
            MsTransformOrigin: 410.305,
            transformOrigin: 410.305,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M451 345.42l-.91 11.89-2.74 35.95h-23.84l-2.74-35.95-.9-11.89H451z"
          style={{
            WebkitTransformOrigin: 435.435,
            MsTransformOrigin: 435.435,
            transformOrigin: 435.435,
          }}
          fill="#DBDBDB"
          className="animable"
        ></path>
        <path
          d="M451 345.42l-.91 11.89h-29.32l-.9-11.89H451z"
          style={{
            WebkitTransformOrigin: 435.435,
            MsTransformOrigin: 435.435,
            transformOrigin: 435.435,
          }}
          fill="#A6A6A6"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 435.44,
            MsTransformOrigin: 435.44,
            transformOrigin: 435.44,
          }}
          fill="#DBDBDB"
          d="M417.75 339.59H453.13V348.71H417.75z"
          className="animable"
          transform="rotate(180)"
        ></path>
      </g>
      <g
        className="animable"
        style={{
          WebkitTransformOrigin: 250,
          MsTransformOrigin: 250,
          transformOrigin: 250,
        }}
      >
        <path
          style={{
            WebkitTransformOrigin: 250,
            MsTransformOrigin: 250,
            transformOrigin: 250,
          }}
          fill="#263238"
          d="M29.38 393.25L84.53 393.01 139.69 392.92 250 392.76 360.31 392.92 415.47 393.01 470.62 393.25 415.47 393.5 360.31 393.59 250 393.75 139.69 393.59 84.53 393.5 29.38 393.25z"
          className="animable"
        ></path>
      </g>
      <g
        className="animable animator-active"
        style={{
          WebkitTransformOrigin: 250,
          MsTransformOrigin: 250,
          transformOrigin: 250,
        }}
      >
        <path
          style={{
            WebkitTransformOrigin: 250.505,
            MsTransformOrigin: 250.505,
            transformOrigin: 250.505,
          }}
          fill="#1DD21D"
          d="M99.58 50.43H401.43V227.49H99.58z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 250.505,
            MsTransformOrigin: 250.505,
            transformOrigin: 250.505,
          }}
          d="M99.58 50.43H401.43V227.49H99.58z"
          className="animable"
          opacity="0.2"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 250.505,
            MsTransformOrigin: 250.505,
            transformOrigin: 250.505,
          }}
          fill="#455A64"
          d="M108.02 59.13H392.99V218.79H108.02z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 250,
            MsTransformOrigin: 250,
            transformOrigin: 250,
          }}
          fill="#1DD21D"
          d="M88.22 227.49H411.78V242.12H88.22z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 250,
            MsTransformOrigin: 250,
            transformOrigin: 250,
          }}
          d="M88.22 227.49H411.78V242.12H88.22z"
          className="animable"
          opacity="0.4"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 127.69,
            MsTransformOrigin: 127.69,
            transformOrigin: 127.69,
          }}
          fill="#1DD21D"
          d="M111.99 224.27H143.39V227.49H111.99z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 127.69,
            MsTransformOrigin: 127.69,
            transformOrigin: 127.69,
          }}
          fill="#FFF"
          d="M113.61 217.31H141.77V224.27H113.61z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 158.72,
            MsTransformOrigin: 158.72,
            transformOrigin: 158.72,
          }}
          fill="#FFF"
          d="M148.57 225.19H168.87V227.5H148.57z"
          className="animable"
        ></path>
        <g
          style={{
            WebkitTransformOrigin: 250.187,
            MsTransformOrigin: 250.187,
            transformOrigin: 250.187,
          }}
          className="animable"
          opacity="0.5"
        >
          <path
            d="M203.43 116.93c.08 0 0-.09.07-.11-.13.02-.06.18-.07.11z"
            style={{
              WebkitTransformOrigin: 203.46,
              MsTransformOrigin: 203.46,
              transformOrigin: 203.46,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 202.085,
              MsTransformOrigin: 202.085,
              transformOrigin: 202.085,
            }}
            fill="#FFF"
            d="M202.15 117.17L202.18 117.13 201.99 117.23 202.15 117.17z"
            className="animable"
          ></path>
          <path
            d="M201 117.17c.12.18.44 0 .65 0l.09-.14a3.22 3.22 0 01-.74.14z"
            style={{
              WebkitTransformOrigin: 201.37,
              MsTransformOrigin: 201.37,
              transformOrigin: 201.37,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M200.31 116.78c0 .07-.14.06.15 0h-.15z"
            style={{
              WebkitTransformOrigin: 200.368,
              MsTransformOrigin: 200.368,
              transformOrigin: 200.368,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M200.43 116.79c.13 0-.08-.06 0 0z"
            style={{
              WebkitTransformOrigin: 200.442,
              MsTransformOrigin: 200.442,
              transformOrigin: 200.442,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M199.85 116.83l.17-.07s-.19-.05-.13-.08c-.17.04-.14.08-.04.15z"
            style={{
              WebkitTransformOrigin: 199.894,
              MsTransformOrigin: 199.894,
              transformOrigin: 199.894,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M199.69 117h.09s-.04-.09-.09 0z"
            style={{
              WebkitTransformOrigin: 199.735,
              MsTransformOrigin: 199.735,
              transformOrigin: 199.735,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M200 116.87l-.18.06s0 .09.08 0c-.05.07-.02-.02.1-.06z"
            style={{
              WebkitTransformOrigin: 199.91,
              MsTransformOrigin: 199.91,
              transformOrigin: 199.91,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M200.07 116.9c.09 0 .21.06 0 .13.36-.03.31-.15 0-.13z"
            style={{
              WebkitTransformOrigin: 200.196,
              MsTransformOrigin: 200.196,
              transformOrigin: 200.196,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M200.89 117.35l.13.05.1-.06c-.05.03-.24-.04-.23.01z"
            style={{
              WebkitTransformOrigin: 201.005,
              MsTransformOrigin: 201.005,
              transformOrigin: 201.005,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M198.81 116.73s.06.1.07.15h.13c-.07-.07-.19-.09-.2-.15z"
            style={{
              WebkitTransformOrigin: 198.91,
              MsTransformOrigin: 198.91,
              transformOrigin: 198.91,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M198.88 116.88l-.18.07c.16.05.19-.03.18-.07z"
            style={{
              WebkitTransformOrigin: 198.791,
              MsTransformOrigin: 198.791,
              transformOrigin: 198.791,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 199.785,
              MsTransformOrigin: 199.785,
              transformOrigin: 199.785,
            }}
            fill="#FFF"
            d="M199.66 117.15L199.97 117.02 199.6 117.16 199.66 117.15z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 198.125,
              MsTransformOrigin: 198.125,
              transformOrigin: 198.125,
            }}
            fill="#FFF"
            d="M198.11 116.73L198.22 116.64 198.03 116.77 198.11 116.73z"
            className="animable"
          ></path>
          <path
            d="M197.65 116.74c.07-.07-.11-.12 0-.16a.79.79 0 00-.33.13.52.52 0 01.33.03z"
            style={{
              WebkitTransformOrigin: 197.493,
              MsTransformOrigin: 197.493,
              transformOrigin: 197.493,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M197.13 116.79l.16-.08a.35.35 0 00-.16.08z"
            style={{
              WebkitTransformOrigin: 197.21,
              MsTransformOrigin: 197.21,
              transformOrigin: 197.21,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M198.39 116.93a.28.28 0 00-.15-.11l.07.11z"
            style={{
              WebkitTransformOrigin: 198.315,
              MsTransformOrigin: 198.315,
              transformOrigin: 198.315,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M198.32 116.93z"
            style={{
              WebkitTransformOrigin: 198.32,
              MsTransformOrigin: 198.32,
              transformOrigin: 198.32,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M198.4 116.93z"
            style={{
              WebkitTransformOrigin: 198.4,
              MsTransformOrigin: 198.4,
              transformOrigin: 198.4,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M199.18 117.06c-.11.06-.33.12-.11.21.07-.07-.07-.12.11-.21z"
            style={{
              WebkitTransformOrigin: 199.078,
              MsTransformOrigin: 199.078,
              transformOrigin: 199.078,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M198.49 117.06h.2v-.1z"
            style={{
              WebkitTransformOrigin: 198.59,
              MsTransformOrigin: 198.59,
              transformOrigin: 198.59,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 198.445,
              MsTransformOrigin: 198.445,
              transformOrigin: 198.445,
            }}
            fill="#FFF"
            d="M198.4 117.1L198.49 117.06 198.42 117.05 198.4 117.1z"
            className="animable"
          ></path>
          <path
            d="M197.46 116.89a.64.64 0 01-.28.06 2 2 0 00.34 0s.06-.06-.06-.06z"
            style={{
              WebkitTransformOrigin: 197.358,
              MsTransformOrigin: 197.358,
              transformOrigin: 197.358,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M197.88 116.92s0 .02 0 0z"
            style={{
              WebkitTransformOrigin: 197.88,
              MsTransformOrigin: 197.88,
              transformOrigin: 197.88,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M196.15 117z"
            style={{
              WebkitTransformOrigin: 196.15,
              MsTransformOrigin: 196.15,
              transformOrigin: 196.15,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M197.54 117a.21.21 0 00.18 0H197.54z"
            style={{
              WebkitTransformOrigin: 197.619,
              MsTransformOrigin: 197.619,
              transformOrigin: 197.619,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M196.84 116.84l.15.06c-.05-.04-.13-.09-.15-.06z"
            style={{
              WebkitTransformOrigin: 196.915,
              MsTransformOrigin: 196.915,
              transformOrigin: 196.915,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M197.83 116.9s-.01-.02 0 0z"
            style={{
              WebkitTransformOrigin: 197.828,
              MsTransformOrigin: 197.828,
              transformOrigin: 197.828,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M197.83 116.9a.39.39 0 00-.11.06h.14z"
            style={{
              WebkitTransformOrigin: 197.79,
              MsTransformOrigin: 197.79,
              transformOrigin: 197.79,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M195.84 117.63c0-.1.24-.19.43-.08.19-.08.06-.4-.1-.58 0 0 0 .08-.2.14.07 0 .43.12.27.21s-.21 0-.34-.08c.11.12-.32.18-.27.36l.23-.07s-.08.08-.02.1z"
            style={{
              WebkitTransformOrigin: 195.995,
              MsTransformOrigin: 195.995,
              transformOrigin: 195.995,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M196.54 117h.08a.62.62 0 01-.28-.13c-.13 0-.16.08-.17.12h.4z"
            style={{
              WebkitTransformOrigin: 196.395,
              MsTransformOrigin: 196.395,
              transformOrigin: 196.395,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M197 117c-.06.11-.25.16-.13.27s.16-.09.3-.13c-.38 0 .11-.06-.16-.12h.2-.19c-.1 0 0 0 0 0l-.37.06a1 1 0 00.35-.08z"
            style={{
              WebkitTransformOrigin: 196.93,
              MsTransformOrigin: 196.93,
              transformOrigin: 196.93,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M198.87 117.5s-.05 0 0 0z"
            style={{
              WebkitTransformOrigin: 198.859,
              MsTransformOrigin: 198.859,
              transformOrigin: 198.859,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M198.71 117.44a.15.15 0 01.14 0c.08 0 0 0 0 .09s.19-.08 0-.13c-.16 0-.35-.17-.32-.18a.76.76 0 00.18.22z"
            style={{
              WebkitTransformOrigin: 198.731,
              MsTransformOrigin: 198.731,
              transformOrigin: 198.731,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M197.83 117.23h-.31l.16.09v-.05c.17.07.13 0 .15-.04z"
            style={{
              WebkitTransformOrigin: 197.675,
              MsTransformOrigin: 197.675,
              transformOrigin: 197.675,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 196.07,
              MsTransformOrigin: 196.07,
              transformOrigin: 196.07,
            }}
            fill="#FFF"
            d="M196.12 116.89L196.16 116.78 195.98 116.94 196.12 116.89z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 195.67,
              MsTransformOrigin: 195.67,
              transformOrigin: 195.67,
            }}
            fill="#FFF"
            d="M195.71 116.91L195.72 116.81 195.62 116.87 195.71 116.91z"
            className="animable"
          ></path>
          <path
            d="M172.7 118.13h-.1z"
            style={{
              WebkitTransformOrigin: 172.65,
              MsTransformOrigin: 172.65,
              transformOrigin: 172.65,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M173.36 118.14s-.02 0 0 0z"
            style={{
              WebkitTransformOrigin: 173.356,
              MsTransformOrigin: 173.356,
              transformOrigin: 173.356,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M185.69 116.92c-.13-.1-.28-.24-.26-.13v.11a.32.32 0 01.26.02z"
            style={{
              WebkitTransformOrigin: 185.559,
              MsTransformOrigin: 185.559,
              transformOrigin: 185.559,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M178.83 117.56a.44.44 0 00.09-.11.4.4 0 01-.09.11z"
            style={{
              WebkitTransformOrigin: 178.875,
              MsTransformOrigin: 178.875,
              transformOrigin: 178.875,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M178.74 118l-.18-.07a.52.52 0 00.18.07z"
            style={{
              WebkitTransformOrigin: 178.65,
              MsTransformOrigin: 178.65,
              transformOrigin: 178.65,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M169.05 118.25l-.11.11c.17 0 .06-.06.11-.11z"
            style={{
              WebkitTransformOrigin: 168.995,
              MsTransformOrigin: 168.995,
              transformOrigin: 168.995,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M191.53 117a.93.93 0 00-.29-.07c.14.01.26.07.29.07z"
            style={{
              WebkitTransformOrigin: 191.385,
              MsTransformOrigin: 191.385,
              transformOrigin: 191.385,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M173 117c-.06 0-.08 0-.08.07s.08-.07.08-.07z"
            style={{
              WebkitTransformOrigin: 172.96,
              MsTransformOrigin: 172.96,
              transformOrigin: 172.96,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M190.91 116.88h.06a.8.8 0 01.27 0 .32.32 0 00-.33 0z"
            style={{
              WebkitTransformOrigin: 191.075,
              MsTransformOrigin: 191.075,
              transformOrigin: 191.075,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M155.83 118.16s-.02 0 0 0z"
            style={{
              WebkitTransformOrigin: 155.826,
              MsTransformOrigin: 155.826,
              transformOrigin: 155.826,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M152 117.06h.15a.36.36 0 00-.15 0z"
            style={{
              WebkitTransformOrigin: 152.075,
              MsTransformOrigin: 152.075,
              transformOrigin: 152.075,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M194.07 116.86c.09 0 0 0 0 0z"
            style={{
              WebkitTransformOrigin: 194.09,
              MsTransformOrigin: 194.09,
              transformOrigin: 194.09,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M194.49 117.29z"
            style={{
              WebkitTransformOrigin: 194.49,
              MsTransformOrigin: 194.49,
              transformOrigin: 194.49,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M190.05 117.56s.01.01 0 0z"
            style={{
              WebkitTransformOrigin: 190.052,
              MsTransformOrigin: 190.052,
              transformOrigin: 190.052,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M194.2 116.91a.2.2 0 00-.11 0z"
            style={{
              WebkitTransformOrigin: 194.145,
              MsTransformOrigin: 194.145,
              transformOrigin: 194.145,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M194.18 116.86h.08s0-.02-.08 0z"
            style={{
              WebkitTransformOrigin: 194.22,
              MsTransformOrigin: 194.22,
              transformOrigin: 194.22,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M194 116.86h.14z"
            style={{
              WebkitTransformOrigin: 194.07,
              MsTransformOrigin: 194.07,
              transformOrigin: 194.07,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M162.91 117.87c-.1.03-.06.03 0 0z"
            style={{
              WebkitTransformOrigin: 162.88,
              MsTransformOrigin: 162.88,
              transformOrigin: 162.88,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M183.44 118z"
            style={{
              WebkitTransformOrigin: 183.44,
              MsTransformOrigin: 183.44,
              transformOrigin: 183.44,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M183.13 118.12a.28.28 0 01.31-.09l-.1-.31z"
            style={{
              WebkitTransformOrigin: 183.285,
              MsTransformOrigin: 183.285,
              transformOrigin: 183.285,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M171.1 118.16l.22.1c-.27.16-.46.11-.25.24 0-.34.85 0 .88-.37l.14.07H172c.28.16.21-.25.57-.2.12 0 .21.07.13.11l.28-.08c.08 0 .06.07 0 .06h.42a2.46 2.46 0 01.27-.17c.11 0-.06 0 0 .08l.24-.08c.09.09-.1.17-.27.16.22.34.2-.09.68.11h-.23c.15.2.32.13.57.25-.06-.07-.5-.31-.25-.39a.39.39 0 00.31 0c0 .12.14.09.31.08v.16c.19 0 .17-.12.28-.2a.31.31 0 01.29.25c.33 0-.22-.2.17-.23a1.47 1.47 0 00.78-.1c.19 0 0 .1 0 .14l.16-.13v.07c0 .07 0-.16.23-.21.06-.17.46.26.73.06.07 0 0 .1 0 .16a2.2 2.2 0 00.64-.27l.26.1c-.19-.12.06-.26.27-.38l-.16-.13.34-.08c.05 0 0 .08 0 .14h.07c.12.05.06.15 0 .24l-.13-.1c-.08.09-.16.2-.14.3a.23.23 0 01.11-.05v.07c0 .02.05 0 .11-.06l.08.18v-.07l.45.11a2.89 2.89 0 011.13-.52c-.13.13 0 .21 0 .37-.14-.16-.4.07-.67 0 .14 0 .11.09.08.11l.47-.15c0 .13.11.1.23.15-.09-.25.36-.17.55-.24 0 .08 0 .17-.27.15.26.19.34-.3.59-.14h-.11c.14-.08.47 0 .39 0h-.06c.39 0 1.17 0 1.23-.21a1.22 1.22 0 01-.08.3l.69-.71c-.06.18.17.62-.15.72a.68.68 0 00.4 0c-.06 0-.16-.26-.07-.28.23.2.16.11.45.28-.09 0 0-.32.16-.31v.31l.37-.28c-.1 0 0 .23.06.31s.32 0 .42 0l-.38.04c.42 0 .41-.4.82-.38-.05.05-.12.35.09.39.1-.15.43-.69.79-.8l.07.08.28-.1a5.09 5.09 0 01-.93.85c.15.07 0 .1.28.09.08.08-.13.12-.2.12h.54c0-.16.42-.16.4-.3l-.59.17c0-.17.34-.48.72-.45.1.07-.07.3-.06.36a.58.58 0 01.4-.07l-.17.09c.22.06.35-.22.61-.06.09 0 .26.21.28.11a1.27 1.27 0 01-.08-.93 4.16 4.16 0 01.57.28c.15.15-.22.36-.1.49 0 0 .09-.1.12-.12s0 .14.17.12c0-.17.41 0 .09-.14h.45c-.08-.11.21-.37.4-.42 0 0 0 .1.06.13.4 0 .62.09 1 .09 0 0 .22.09.14.16a.41.41 0 01.22-.09c.23.15-.26 0-.09.2 0-.1.3-.13.47-.2 0-.15-.38 0-.55 0 0-.21.29-.44.68-.53s.14.13.19.1c.59 0 .51-.36 1-.21.19.13 0 .26 0 .36-.26 0-.39-.08-.57-.08l.22.07a.6.6 0 01-.35 0c.16.12 1 0 1.45.13.08 0 .22-.09.16-.15h-.15c-.13-.11.28-.15.09-.2a1.16 1.16 0 01.68-.13l.06.15s-.18-.09-.26 0c.12-.07.42.2.54 0l-.19-.1a1.25 1.25 0 01.68-.19c-.11-.16-.06 0-.23-.16.15.22-.62 0-.38.22-.17-.21-.3-.09-.53-.26 0 0 .08.09-.12.07a.23.23 0 01.11.07c-.1.12-.42.12-.53.18s.05-.06 0-.12l-.16.09c0-.11-.32-.18 0-.25h-.25a.7.7 0 00-.49 0c-.12 0-.3.12-.19 0l-.4.07c-.39 0-.81.19-1.26 0a1.44 1.44 0 01-.49 0v-.1c-.17 0-.52-.1-.59 0-.18-.26-.83 0-1.13-.1v.13a2.81 2.81 0 00-.66.08v.11c-.22.09-.57-.08-.92-.07h.18c-.42-.26-.88.18-1.26 0a.26.26 0 01-.23 0l-.13-.06.11.06a1.17 1.17 0 00-.29 0v-.12c-.1 0-.08.06 0 .15l-.14.07c-.09-.19-.28.07-.4-.14-.07.1-.54.08-.6.29a.47.47 0 00-.35 0l-.05-.15-.26.2c-.16-.09-.23-.14-.07-.26-.38.18-.31.07-.64.25v-.1c-.12 0-.3.13-.37 0-.26-.19-1.29 0-2-.2.13.29-.31-.13-.34.1 0-.07-.13-.11 0-.17-.34.07-.52-.11-.75.08 0-.07.07-.1 0-.14s-.11.06-.15 0 .05-.06.11-.09c-.35 0-.39.22-.41.42-.18-.09-.27-.08-.39 0-.07-.06-.17-.13.05-.16-.12 0-.75-.09-.76.07h-.2a3.62 3.62 0 00-.57 0h.08c-.11.2-.23 0-.44.07-.49-.14-.21.07-.7-.09v.12c-.05.25-.44-.16-.72-.06l.1.07c-.15.09-.43-.35-.59-.38s.05 0 .1 0c-.41-.16-.05.15-.36.19-.05-.08.08-.22-.13-.23s-.59.27-.87.11c.06.07.12.13 0 .18s-.58-.25-.78 0c-.16 0-.54.09-.64.2-.15-.42-1 .2-1-.18h-.51a.63.63 0 00-.55.16c-.08 0 0-.06 0-.08a1.06 1.06 0 00-.92.13v-.13c-.11.07-.69-.19-1.15 0a.06.06 0 01.05 0c-.53.14-1.26-.35-1.45.1l-.35.11c.45 0-.06.2.12.28-.18 0-.46-.14-.24-.16.08-.24-.55-.08-.54-.24-.88 0-1.74-.12-2.57-.13l.1.18h-.29c-.08 0-.1-.14.1-.14-.1-.1-.34.09-.35.13-.4-.07.16-.21 0-.22h-.17c-.14.07-.15.15-.4.14s-.08-.11-.14-.12 0 0-.09 0h-.37l.15.15c-.16.07-.34 0-.17.15-.25-.25-1.36-.09-1.51-.17a1.32 1.32 0 01-.72.09c.07 0 .11.2-.13.18.09-.34-.44-.15-.63-.39.17.16-.67 0-.4.27-.2 0 0-.13-.17-.21a10 10 0 01-1.62 0s.09.11 0 .18L156 117c-.12 0-.11.25-.32.1 0 0 .07.09 0 .11-1.15-.22-2.34.17-3.5-.23.16.08.05.09-.07.1.08 0 0 .1 0 .16l-.49-.16c-.09.16-.52 0-.57.17h.15c-.2.19.29.41.26.65.23-.21.6.32 1 0 .08 0-.07.08 0 .14.1-.11.21-.13.43-.08a9.52 9.52 0 011.53.15v-.12a.54.54 0 01.24.08c.17-.18-.4 0-.25-.21.19.25 1 0 1.15.28.22 0-.07-.14.16-.13l.05.07.06-.1a.24.24 0 01.23.18.34.34 0 00-.14 0c.19.09.53 0 .6 0h-.22a15.55 15.55 0 001.94-.12l-.05-.06c.45-.1.36.06.85 0a.66.66 0 01.36-.08c-.12.07.23.13.07.2.49-.11.24-.08.56-.29l.08.09a.45.45 0 01.36-.15c-.2.08.16.14-.07.24.52.21.77-.2 1 .1.24-.26-.44-.15-.31-.2-.11-.08.19-.19.36-.17s.28.33.69.33H162c.16.07.31-.09.5 0 .11-.15.25 0 .28-.19h-.38c.21 0 .41-.29.77-.17a.68.68 0 01-.21.12c.11.06.2 0 .31 0s-.46 0-.69.19c.11.09.43-.14.32.07.16-.27.41 0 .69-.17v.12a.52.52 0 01.22-.07l-.15.15c.23-.13.44.12.65 0-.45 0-.1-.15-.29-.23.56-.16.32.31 1 .25-.08 0-.32-.07-.19-.13a1 1 0 01.36.14c.41 0-.07-.13.11-.2.14.14.21-.06.39-.1v.12c.47.07.13-.26.55-.16l-.18.17h.23v.14a.78.78 0 01.56 0c-.06-.08 0-.22.24-.22s-.08.11.22.1c-.07.07-.15.17-.28.06 0 0-.06.07-.08.11a1.08 1.08 0 00.5 0 .42.42 0 01-.12 0l.44-.17c.06 0 0 .08 0 .12a2.3 2.3 0 01.27-.08c0 .1 0 .2-.2.25l.41-.11s.21.12.16.15c.23.06.56-.19.86-.11a.19.19 0 01.11 0 1.64 1.64 0 00.88 0l.19.18c.26 0-.26-.22.18-.29s.12.15.23.2a.73.73 0 01.71-.13.78.78 0 01-.47 0zm3.26-.07c-.06 0-.19.1-.24 0s.13-.04.24 0zm4.95-.29h-.2a.36.36 0 01.2 0zm13.81-.84c-.12-.04-.12-.03 0 .04zm.29.05v-.05c0-.05-.09 0-.16 0s.08.04.16.04zm-31.42 0h.06c-.13.11-.05.08-.05.05z"
            style={{
              WebkitTransformOrigin: 173.24,
              MsTransformOrigin: 173.24,
              transformOrigin: 173.24,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M178.75 118a.07.07 0 010-.06s-.05 0 0 .06z"
            style={{
              WebkitTransformOrigin: 178.739,
              MsTransformOrigin: 178.739,
              transformOrigin: 178.739,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M169.07 118.23z"
            style={{
              WebkitTransformOrigin: 169.07,
              MsTransformOrigin: 169.07,
              transformOrigin: 169.07,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M188.88 118a.44.44 0 01-.12-.06s.03.06.12.06z"
            style={{
              WebkitTransformOrigin: 188.82,
              MsTransformOrigin: 188.82,
              transformOrigin: 188.82,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M195 116.8h-.18a.27.27 0 01.17 0s-.08.01.01 0z"
            style={{
              WebkitTransformOrigin: 194.91,
              MsTransformOrigin: 194.91,
              transformOrigin: 194.91,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M196.59 117.55h.09c-.13-.07-.21-.02-.09 0z"
            style={{
              WebkitTransformOrigin: 196.606,
              MsTransformOrigin: 196.606,
              transformOrigin: 196.606,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M195.14 117.21c0 .1.13.06.26 0 .02-.1-.12-.05-.26 0z"
            style={{
              WebkitTransformOrigin: 195.271,
              MsTransformOrigin: 195.271,
              transformOrigin: 195.271,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M195.43 117.25a.48.48 0 01.12 0c.02-.06-.05-.01-.12 0z"
            style={{
              WebkitTransformOrigin: 195.492,
              MsTransformOrigin: 195.492,
              transformOrigin: 195.492,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M193.78 116.94c.07 0 0-.13.08-.09.07-.13-.42.15-.08.09z"
            style={{
              WebkitTransformOrigin: 193.763,
              MsTransformOrigin: 193.763,
              transformOrigin: 193.763,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 195.18,
              MsTransformOrigin: 195.18,
              transformOrigin: 195.18,
            }}
            fill="#FFF"
            d="M195.24 117.54L195.2 117.41 195.12 117.52 195.24 117.54z"
            className="animable"
          ></path>
          <path
            d="M194.21 117.45h.26c-.13-.01-.27-.04-.26 0z"
            style={{
              WebkitTransformOrigin: 194.34,
              MsTransformOrigin: 194.34,
              transformOrigin: 194.34,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M194.47 117.44a.42.42 0 00.17 0 .59.59 0 00-.17 0z"
            style={{
              WebkitTransformOrigin: 194.555,
              MsTransformOrigin: 194.555,
              transformOrigin: 194.555,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 194.855,
              MsTransformOrigin: 194.855,
              transformOrigin: 194.855,
            }}
            fill="#FFF"
            d="M194.96 117.58L194.9 117.55 194.75 117.54 194.96 117.58z"
            className="animable"
          ></path>
          <path
            d="M192 117.42h-.23s0 .07.13.05.1-.01.1-.05z"
            style={{
              WebkitTransformOrigin: 191.886,
              MsTransformOrigin: 191.886,
              transformOrigin: 191.886,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M192.64 117.77c-.06 0-.06-.06-.1-.1v.16z"
            style={{
              WebkitTransformOrigin: 192.59,
              MsTransformOrigin: 192.59,
              transformOrigin: 192.59,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M192 117.8s-.34.13 0 .12c0-.05.19-.08 0-.12z"
            style={{
              WebkitTransformOrigin: 191.967,
              MsTransformOrigin: 191.967,
              transformOrigin: 191.967,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 188.56,
              MsTransformOrigin: 188.56,
              transformOrigin: 188.56,
            }}
            fill="#FFF"
            d="M188.53 117.61L188.59 117.6 188.58 117.35 188.53 117.61z"
            className="animable"
          ></path>
          <path
            d="M185.49 118.22c.27.06.06-.16.31-.09.06-.06-.2-.06-.14-.11-.16.06-.25.03-.17.2z"
            style={{
              WebkitTransformOrigin: 185.635,
              MsTransformOrigin: 185.635,
              transformOrigin: 185.635,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M185.66 118h.08z"
            style={{
              WebkitTransformOrigin: 185.7,
              MsTransformOrigin: 185.7,
              transformOrigin: 185.7,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 151.25,
              MsTransformOrigin: 151.25,
              transformOrigin: 151.25,
            }}
            fill="#FFF"
            d="M151.34 116.93L151.16 116.88 151.27 116.96 151.34 116.93z"
            className="animable"
          ></path>
          <path
            d="M151 117.12v-.17l-.1.15s.1-.02.1.02z"
            style={{
              WebkitTransformOrigin: 150.95,
              MsTransformOrigin: 150.95,
              transformOrigin: 150.95,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M174.84 118.41s-.07 0-.15-.05z"
            style={{
              WebkitTransformOrigin: 174.765,
              MsTransformOrigin: 174.765,
              transformOrigin: 174.765,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 172.48,
              MsTransformOrigin: 172.48,
              transformOrigin: 172.48,
            }}
            fill="#FFF"
            d="M172.48 118.29L172.52 118.3 172.44 118.15 172.48 118.29z"
            className="animable"
          ></path>
          <path
            d="M170.49 118.48h.26c-.18.01-.28-.18-.26 0z"
            style={{
              WebkitTransformOrigin: 170.619,
              MsTransformOrigin: 170.619,
              transformOrigin: 170.619,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M245.6 135.18c.12 0 .07-.09.09-.11-.2.02-.09.14-.09.11z"
            style={{
              WebkitTransformOrigin: 245.63,
              MsTransformOrigin: 245.63,
              transformOrigin: 245.63,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 243.49,
              MsTransformOrigin: 243.49,
              transformOrigin: 243.49,
            }}
            fill="#FFF"
            d="M243.6 135.42L243.64 135.38 243.34 135.48 243.6 135.42z"
            className="animable"
          ></path>
          <path
            d="M241.73 135.42c.18.18.68 0 1 0h.06l.15-.14a7.87 7.87 0 01-1.21.14z"
            style={{
              WebkitTransformOrigin: 242.335,
              MsTransformOrigin: 242.335,
              transformOrigin: 242.335,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M240.74 135c.06.07-.22.06.23 0h-.23z"
            style={{
              WebkitTransformOrigin: 240.839,
              MsTransformOrigin: 240.839,
              transformOrigin: 240.839,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M240.93 135c.19 0-.13-.06 0 0z"
            style={{
              WebkitTransformOrigin: 240.945,
              MsTransformOrigin: 240.945,
              transformOrigin: 240.945,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M240 135.08l.26-.07c-.06 0-.29 0-.2-.08-.25.07-.19.07-.06.15z"
            style={{
              WebkitTransformOrigin: 240.074,
              MsTransformOrigin: 240.074,
              transformOrigin: 240.074,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M239.77 135.21h.14s-.06-.05-.14 0z"
            style={{
              WebkitTransformOrigin: 239.84,
              MsTransformOrigin: 239.84,
              transformOrigin: 239.84,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M240.19 135.12l-.28.06s0 .09.13 0c-.04.03.03-.02.15-.06z"
            style={{
              WebkitTransformOrigin: 240.05,
              MsTransformOrigin: 240.05,
              transformOrigin: 240.05,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M240.35 135.15c.15 0 .34.07.08.13.49-.03.42-.15-.08-.13z"
            style={{
              WebkitTransformOrigin: 240.557,
              MsTransformOrigin: 240.557,
              transformOrigin: 240.557,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M241.64 135.6l.19.06.17-.06c-.08.03-.37-.05-.36 0z"
            style={{
              WebkitTransformOrigin: 241.82,
              MsTransformOrigin: 241.82,
              transformOrigin: 241.82,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M238.41 135s.08.11.1.15h.19a.777.777 0 00-.29-.15z"
            style={{
              WebkitTransformOrigin: 238.555,
              MsTransformOrigin: 238.555,
              transformOrigin: 238.555,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M238.51 135.13l-.28.07c.25.01.3-.02.28-.07z"
            style={{
              WebkitTransformOrigin: 238.372,
              MsTransformOrigin: 238.372,
              transformOrigin: 238.372,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 239.92,
              MsTransformOrigin: 239.92,
              transformOrigin: 239.92,
            }}
            fill="#FFF"
            d="M239.73 135.41L240.2 135.27 239.64 135.41 239.73 135.41z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 237.33,
              MsTransformOrigin: 237.33,
              transformOrigin: 237.33,
            }}
            fill="#FFF"
            d="M237.31 134.98L237.47 134.89 237.19 135.02 237.31 134.98z"
            className="animable"
          ></path>
          <path
            d="M236.59 135c.12-.07-.17-.12 0-.16a1.65 1.65 0 00-.52.13 1.37 1.37 0 01.52.03z"
            style={{
              WebkitTransformOrigin: 236.345,
              MsTransformOrigin: 236.345,
              transformOrigin: 236.345,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M235.78 135h.22a1.21 1.21 0 00-.22 0z"
            style={{
              WebkitTransformOrigin: 235.89,
              MsTransformOrigin: 235.89,
              transformOrigin: 235.89,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M237.74 135.18a.37.37 0 00-.23-.11l.12.11z"
            style={{
              WebkitTransformOrigin: 237.625,
              MsTransformOrigin: 237.625,
              transformOrigin: 237.625,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M237.77 135.18z"
            style={{
              WebkitTransformOrigin: 237.77,
              MsTransformOrigin: 237.77,
              transformOrigin: 237.77,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M239 135.31c-.17.06-.52.12-.18.21.1-.07-.1-.12.18-.21z"
            style={{
              WebkitTransformOrigin: 238.838,
              MsTransformOrigin: 238.838,
              transformOrigin: 238.838,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M237.91 135.31h.3s-.06-.07 0-.1z"
            style={{
              WebkitTransformOrigin: 238.06,
              MsTransformOrigin: 238.06,
              transformOrigin: 238.06,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 237.835,
              MsTransformOrigin: 237.835,
              transformOrigin: 237.835,
            }}
            fill="#FFF"
            d="M237.76 135.35L237.91 135.31 237.79 135.31 237.76 135.35z"
            className="animable"
          ></path>
          <path
            d="M236.3 135.14a1.46 1.46 0 01-.44.06h.53s.1-.06-.09-.06z"
            style={{
              WebkitTransformOrigin: 236.138,
              MsTransformOrigin: 236.138,
              transformOrigin: 236.138,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M237 135.17s0 .02 0 0z"
            style={{
              WebkitTransformOrigin: 237,
              MsTransformOrigin: 237,
              transformOrigin: 237,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M234.27 135.2z"
            style={{
              WebkitTransformOrigin: 234.27,
              MsTransformOrigin: 234.27,
              transformOrigin: 234.27,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M236.42 135.25a.46.46 0 00.28 0h-.31s-.02.01.03 0z"
            style={{
              WebkitTransformOrigin: 236.543,
              MsTransformOrigin: 236.543,
              transformOrigin: 236.543,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M235.33 135.09l.23.06c-.07-.04-.2-.09-.23-.06z"
            style={{
              WebkitTransformOrigin: 235.445,
              MsTransformOrigin: 235.445,
              transformOrigin: 235.445,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M236.87 135.15s-.01-.02 0 0z"
            style={{
              WebkitTransformOrigin: 236.868,
              MsTransformOrigin: 236.868,
              transformOrigin: 236.868,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M236.87 135.15a.85.85 0 00-.17.06h.22z"
            style={{
              WebkitTransformOrigin: 236.81,
              MsTransformOrigin: 236.81,
              transformOrigin: 236.81,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M233.78 135.88c0-.1.37-.19.66-.08.3-.08.11-.4-.15-.58 0 0 0 .08-.31.14.11 0 .67.12.41.21s-.32 0-.52-.08c.17.12-.5.18-.41.36l.34-.07s-.12.08-.02.1z"
            style={{
              WebkitTransformOrigin: 234.022,
              MsTransformOrigin: 234.022,
              transformOrigin: 234.022,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M234.86 135.23h.13a1.27 1.27 0 01-.43-.13c-.21 0-.25.09-.26.12h.61z"
            style={{
              WebkitTransformOrigin: 234.645,
              MsTransformOrigin: 234.645,
              transformOrigin: 234.645,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M235.54 135.21c-.09.11-.39.16-.21.27.36 0 .25-.09.47-.13-.58 0 .17-.06-.25-.12h.31-.3c-.17 0 0 0 0 0l-.58.05a2.42 2.42 0 00.56-.07z"
            style={{
              WebkitTransformOrigin: 235.42,
              MsTransformOrigin: 235.42,
              transformOrigin: 235.42,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M238.49 135.75s-.08 0 0 0z"
            style={{
              WebkitTransformOrigin: 238.472,
              MsTransformOrigin: 238.472,
              transformOrigin: 238.472,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M238.24 135.69a.33.33 0 01.22-.05c.12 0 0 .05 0 .09s.29-.08 0-.13a1.08 1.08 0 01-.5-.18.89.89 0 00.28.27z"
            style={{
              WebkitTransformOrigin: 238.274,
              MsTransformOrigin: 238.274,
              transformOrigin: 238.274,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M236.88 135.48l-.49.05.25.1v-.06c.26.02.2-.05.24-.09z"
            style={{
              WebkitTransformOrigin: 236.635,
              MsTransformOrigin: 236.635,
              transformOrigin: 236.635,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 234.13,
              MsTransformOrigin: 234.13,
              transformOrigin: 234.13,
            }}
            fill="#FFF"
            d="M234.21 135.14L234.27 135.03 233.99 135.19 234.21 135.14z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 233.515,
              MsTransformOrigin: 233.515,
              transformOrigin: 233.515,
            }}
            fill="#FFF"
            d="M233.57 135.16L233.6 135.06 233.43 135.12 233.57 135.16z"
            className="animable"
          ></path>
          <path
            d="M197.76 136.38h-.14z"
            style={{
              WebkitTransformOrigin: 197.69,
              MsTransformOrigin: 197.69,
              transformOrigin: 197.69,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M198.8 136.39s-.04 0 0 0z"
            style={{
              WebkitTransformOrigin: 198.791,
              MsTransformOrigin: 198.791,
              transformOrigin: 198.791,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M218 135.17c-.21-.09-.45-.24-.42-.13l.06.11a1 1 0 01.36.02z"
            style={{
              WebkitTransformOrigin: 217.789,
              MsTransformOrigin: 217.789,
              transformOrigin: 217.789,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M207.31 135.82h.06l.14-.1z"
            style={{
              WebkitTransformOrigin: 207.41,
              MsTransformOrigin: 207.41,
              transformOrigin: 207.41,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M207.16 136.26l-.27-.07a1 1 0 00.27.07z"
            style={{
              WebkitTransformOrigin: 207.025,
              MsTransformOrigin: 207.025,
              transformOrigin: 207.025,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M192.08 136.5l-.16.11c.26 0 .14-.06.16-.11z"
            style={{
              WebkitTransformOrigin: 192.005,
              MsTransformOrigin: 192.005,
              transformOrigin: 192.005,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M227.07 135.2a2.16 2.16 0 00-.45-.07c.22.06.38.16.45.07z"
            style={{
              WebkitTransformOrigin: 226.845,
              MsTransformOrigin: 226.845,
              transformOrigin: 226.845,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M198.17 135.23c-.09 0-.13.05-.12.07s.14-.04.12-.07z"
            style={{
              WebkitTransformOrigin: 198.11,
              MsTransformOrigin: 198.11,
              transformOrigin: 198.11,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M226.1 135.13h.1a1.84 1.84 0 01.42 0 .84.84 0 00-.52 0z"
            style={{
              WebkitTransformOrigin: 226.36,
              MsTransformOrigin: 226.36,
              transformOrigin: 226.36,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M171.51 136.41s-.03 0 0 0z"
            style={{
              WebkitTransformOrigin: 171.503,
              MsTransformOrigin: 171.503,
              transformOrigin: 171.503,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M165.51 135.32h.25a.74.74 0 00-.25 0z"
            style={{
              WebkitTransformOrigin: 165.635,
              MsTransformOrigin: 165.635,
              transformOrigin: 165.635,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M231 135.11c.14 0 0 0 0 0z"
            style={{
              WebkitTransformOrigin: 231.031,
              MsTransformOrigin: 231.031,
              transformOrigin: 231.031,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M231.68 135.54a.1.1 0 00-.06.05.1.1 0 01.06-.05z"
            style={{
              WebkitTransformOrigin: 231.65,
              MsTransformOrigin: 231.65,
              transformOrigin: 231.65,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M224.76 135.81s.02.01 0 0z"
            style={{
              WebkitTransformOrigin: 224.764,
              MsTransformOrigin: 224.764,
              transformOrigin: 224.764,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M231.22 135.16a.86.86 0 00-.17 0z"
            style={{
              WebkitTransformOrigin: 231.135,
              MsTransformOrigin: 231.135,
              transformOrigin: 231.135,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M231.2 135.11h.11s.01-.02-.11 0z"
            style={{
              WebkitTransformOrigin: 231.255,
              MsTransformOrigin: 231.255,
              transformOrigin: 231.255,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M230.83 135.12a.79.79 0 01.22 0z"
            style={{
              WebkitTransformOrigin: 230.94,
              MsTransformOrigin: 230.94,
              transformOrigin: 230.94,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M182.53 136.12c-.16.03-.1.03 0 0z"
            style={{
              WebkitTransformOrigin: 182.481,
              MsTransformOrigin: 182.481,
              transformOrigin: 182.481,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M214.48 136.29z"
            style={{
              WebkitTransformOrigin: 214.48,
              MsTransformOrigin: 214.48,
              transformOrigin: 214.48,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M214 136.38a.53.53 0 01.48-.09l-.16-.32z"
            style={{
              WebkitTransformOrigin: 214.24,
              MsTransformOrigin: 214.24,
              transformOrigin: 214.24,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M195.27 136.42l.34.09c-.41.16-.71.11-.39.25.05-.34 1.32 0 1.37-.38l.22.07h-.13c.43.16.32-.25.88-.2.2 0 .33.07.2.11l.43-.08c.13 0 .1.07 0 .06h.67l.42-.17c.17.05-.09 0 0 .08l.36-.08c.15.09-.15.17-.4.16.34.34.3-.09 1 .11h-.35c.23.2.5.13.89.25-.09-.07-.78-.3-.39-.39a.82.82 0 00.48 0c0 .12.21.09.48.08v.16c.28 0 .26-.12.43-.2a.5.5 0 01.46.25c.5 0-.36-.2.25-.23a3.3 3.3 0 001.22-.1c.3 0-.05.1 0 .14l.27-.12c.06 0 0 0 0 .06.22 0 0-.16.36-.21.1-.17.72.26 1.15.06.1.05-.06.1 0 .16a4.7 4.7 0 001-.27l.41.1c-.3-.12.08-.26.42-.37l-.26-.14.54-.08c.07 0 0 .08-.08.15h.1c.2.06.1.15 0 .24l-.2-.1c-.13.1-.26.2-.23.3a.56.56 0 01.18-.05s-.06.05 0 .07.07 0 .16-.06l.12.18v-.07l.71.11a6.19 6.19 0 011.75-.52c-.2.13 0 .22-.05.37-.22-.16-.62.07-1 0 .22 0 .17.09.11.11l.75-.14c0 .12.15.09.35.14-.15-.25.55-.16.85-.24 0 .08-.05.17-.42.15.41.19.53-.3.93-.14h-.18c.21-.08.73 0 .61.05h-.09c.59 0 1.82 0 1.91-.22a1 1 0 01-.12.3l1.07-.71c-.1.18.26.62-.23.72a1.29 1.29 0 00.62 0c-.1 0-.24-.26-.11-.28a3.09 3.09 0 00.7.28c-.15 0 0-.32.25-.31 0 0 0 .28-.07.31l.57-.28c-.14.05 0 .24.11.32-.06-.06.49 0 .64 0l-.24-.06c.65 0 .64-.4 1.28-.38a.22.22 0 00.14.39 2.75 2.75 0 011.22-.8l.11.08.44-.09a8.52 8.52 0 01-1.45.84c.24.07.07.1.43.09.13.08-.2.12-.3.13h.84c0-.17.65-.17.61-.31l-.91.17c0-.17.53-.48 1.12-.45.16.07-.11.3-.1.36a1.39 1.39 0 01.63-.07l-.26.09c.33.06.54-.22.94-.06.14 0 .42.21.44.11a.86.86 0 01-.12-.92 5.94 5.94 0 01.88.27c.23.15-.34.36-.14.49 0 0 .13-.1.18-.12s-.06.14.26.12c0-.17.64 0 .15-.14.3-.05.32 0 .68 0-.11-.12.33-.38.64-.43 0 0 0 .1.08.13.63 0 1 .09 1.56.09.06 0 .34.09.22.17a.86.86 0 01.34-.1c.35.15-.4 0-.13.2 0-.1.47-.13.72-.19-.08-.16-.59 0-.85 0 0-.21.45-.43 1.06-.53s.21.13.3.1c.92 0 .78-.36 1.54-.21.31.13 0 .27.09.36a4.3 4.3 0 01-.89-.08l.34.07a1.23 1.23 0 01-.54 0c.25.12 1.55 0 2.26.13.13 0 .34-.09.24-.14h-.22c-.21-.1.42-.15.13-.2a2.69 2.69 0 011.07-.13l.07.15s-.27-.09-.39 0c.18-.07.65.2.84 0l-.3-.1a2.78 2.78 0 011.06-.19c-.18-.15-.09 0-.36-.16.23.22-1 0-.59.22-.27-.21-.47-.09-.83-.26 0 0 .13.09-.19.07h-.07a.62.62 0 01.16.07c-.16.12-.66.12-.83.18s.08-.06 0-.12l-.26.09c0-.11-.49-.18-.05-.25h-.4a1.61 1.61 0 00-.75 0c-.19 0-.47.12-.31 0l-.62.07a6.78 6.78 0 01-2 0 3 3 0 01-.77 0l-.06-.1c-.27 0-.8-.1-.91 0-.29-.27-1.29-.06-1.76-.11v.13a6.53 6.53 0 00-1 .08v.11a9.52 9.52 0 01-1.42-.07h.27c-.65-.26-1.37.18-2 0a.73.73 0 01-.36 0l-.2-.06.17.06a2.66 2.66 0 00-.45 0l-.08-.12c-.16 0-.13.05 0 .14l-.22.08c-.14-.2-.44.06-.63-.15-.11.11-.84.08-.93.29 0 0-.06 0 0 0a1.23 1.23 0 00-.54 0l-.08-.15-.41.2c-.25-.09-.35-.14-.1-.26-.6.18-.49.07-1 .25v-.1c-.18 0-.47.13-.58 0-.41-.19-2 0-3.05-.2.2.29-.48-.13-.52.1-.06-.07-.21-.11 0-.17-.53.07-.8-.11-1.16.08-.07-.07.11-.1.06-.14s-.17.06-.23 0 .08-.06.16-.09c-.54 0-.59.22-.63.42a.59.59 0 00-.61.05c-.1-.06-.26-.13.08-.15-.19 0-1.16-.1-1.18.06a.58.58 0 00-.32 0 8.61 8.61 0 00-.88 0h.12c-.17.2-.35.05-.69.07-.77-.14-.33.07-1.09-.09v.12c-.07.26-.68-.15-1.12-.06l.16.07c-.24.09-.67-.35-.92-.38-.05 0 .09 0 .16-.05-.63-.15-.08.15-.55.19-.09-.08.11-.21-.21-.23-.16-.07-.93.27-1.36.11.1.07.19.13 0 .18s-.91-.24-1.21 0h-.06a4.42 4.42 0 00-1 .2c-.24-.41-1.6.2-1.59-.18h-.8a1.49 1.49 0 00-.87.16c-.12 0 0-.06 0-.08a2.5 2.5 0 00-1.43.13l-.07-.13a12 12 0 00-1.8 0 .13.13 0 01.08-.05c-.81.14-2-.35-2.25.1l-.54.12c.7 0-.1.19.18.27-.27 0-.7-.14-.37-.16h.05c.13-.24-.86-.08-.84-.24-1.37 0-2.71-.12-4-.13l.15.18h-.45c-.11 0-.16-.14.16-.14-.16-.1-.53.09-.54.13-.63-.07.24-.21.05-.22h-.26.06a1.11 1.11 0 01-.61.14c-.25 0-.13-.11-.23-.12s0 0-.14 0h-.57l.23.15c-.25.07-.53 0-.27.15-.38-.25-2.11-.09-2.34-.17a3.41 3.41 0 01-1.13.1c.11 0 .17.19-.2.17.14-.34-.68-.15-1-.39.26.16-1.06 0-.64.27-.3 0 0-.13-.25-.21a24.44 24.44 0 01-2.53 0s.14.11-.05.18l-.48-.22c-.18 0-.17.25-.49.1 0 0 .11.09 0 .11-1.78-.22-3.63.17-5.44-.23.25.09.08.09-.1.1.12 0 0 .11 0 .17l-.76-.17c-.14.17-.81 0-.89.17h.24c-.32.19.45.42.4.66.36-.22.94.31 1.53 0 .12 0-.11.07-.05.13a.87.87 0 01.66-.08 20.12 20.12 0 012.37.14l-.07-.12a1.49 1.49 0 01.38.08c.25-.18-.64 0-.4-.2.3.24 1.59 0 1.79.27.34 0-.1-.13.24-.13l.09.07.09-.09c.23 0 .34.1.35.17a.75.75 0 00-.21 0 4.7 4.7 0 00.93 0h-.34c1-.07 2.1 0 3-.12l-.07-.06c.69-.1.55.07 1.32 0a1.91 1.91 0 01.57-.08c-.19.07.36.13.11.2.75-.11.37-.08.87-.29l.12.09a1 1 0 01.56-.15c-.31.08.25.14-.1.25.8.2 1.19-.21 1.56.09.36-.26-.7-.14-.49-.2-.18-.08.3-.19.55-.17s.44.33 1.08.33h-.13c.24.07.47-.08.77 0 .17-.15.38 0 .43-.19h-.59a2.61 2.61 0 011.2-.17 1.13 1.13 0 01-.32.12c.16.06.31 0 .48 0 0 .2-.72 0-1.08.2.18.08.68-.15.5.07.26-.28.64 0 1.07-.18v.12a1.35 1.35 0 01.34-.07l-.23.15c.36-.13.68.12 1 0-.71 0-.16-.15-.46-.23.88-.16.51.31 1.49.25-.14 0-.5-.07-.29-.13a1.84 1.84 0 01.54.14c.65 0-.1-.13.18-.2.22.15.32-.06.6-.1v.12c.74.07.19-.25.86-.16l-.28.17.34-.05-.07.14a1.84 1.84 0 01.87 0c-.09-.08.05-.22.37-.22s-.12.12.34.1a.34.34 0 01-.42.06s-.1.07-.12.11a2.53 2.53 0 00.77 0 .84.84 0 01-.18 0l.67-.17c.11.05 0 .09-.06.12.14 0 .23-.07.43-.08-.05.1 0 .2-.32.25l.64-.11s.33.12.25.15c.35.06.87-.19 1.34-.11a.3.3 0 01.17 0 4.18 4.18 0 001.37 0l.29.17c.41 0-.4-.22.28-.29.49 0 .19.15.36.2a1.6 1.6 0 011.1-.12c-.26.19-.37.16-.51.18zm5.08-.08c-.1 0-.3.1-.37 0 .11-.11.2-.04.37 0zm7.71-.29a.42.42 0 01-.32 0 .91.91 0 01.32 0zm21.49-.84c-.23-.04-.16-.02 0 0zm.45 0c.05 0 0 0 0 0a.43.43 0 01-.25 0s.11.08.25.05zm-48.91.05h.09c-.18.11-.18.08-.09.05z"
            style={{
              WebkitTransformOrigin: 198.79,
              MsTransformOrigin: 198.79,
              transformOrigin: 198.79,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M207.18 136.21v-.06s-.08.04 0 .06z"
            style={{
              WebkitTransformOrigin: 207.162,
              MsTransformOrigin: 207.162,
              transformOrigin: 207.162,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M192.12 136.48z"
            style={{
              WebkitTransformOrigin: 192.12,
              MsTransformOrigin: 192.12,
              transformOrigin: 192.12,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M223 136.28a.36.36 0 01-.18-.06s-.02.06.18.06z"
            style={{
              WebkitTransformOrigin: 222.91,
              MsTransformOrigin: 222.91,
              transformOrigin: 222.91,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M232.41 135.06h-.29a.64.64 0 01.27 0h.02z"
            style={{
              WebkitTransformOrigin: 232.265,
              MsTransformOrigin: 232.265,
              transformOrigin: 232.265,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M235 135.8h.13v-.06c-.24-.01-.37.04-.13.06z"
            style={{
              WebkitTransformOrigin: 235.001,
              MsTransformOrigin: 235.001,
              transformOrigin: 235.001,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M232.68 135.46c0 .1.21.06.41 0 .03-.1-.19-.05-.41 0z"
            style={{
              WebkitTransformOrigin: 232.886,
              MsTransformOrigin: 232.886,
              transformOrigin: 232.886,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M233.14 135.5h.19c.02-.06-.08-.01-.19 0z"
            style={{
              WebkitTransformOrigin: 233.236,
              MsTransformOrigin: 233.236,
              transformOrigin: 233.236,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M230.58 135.19c.1 0 .06-.13.11-.09.11-.1-.64.16-.11.09z"
            style={{
              WebkitTransformOrigin: 230.545,
              MsTransformOrigin: 230.545,
              transformOrigin: 230.545,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 232.755,
              MsTransformOrigin: 232.755,
              transformOrigin: 232.755,
            }}
            fill="#FFF"
            d="M232.85 135.79L232.78 135.66 232.66 135.77 232.85 135.79z"
            className="animable"
          ></path>
          <path
            d="M231.24 135.7H231.65c-.2-.01-.42-.04-.41 0z"
            style={{
              WebkitTransformOrigin: 231.445,
              MsTransformOrigin: 231.445,
              transformOrigin: 231.445,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M231.65 135.69a.94.94 0 00.26 0z"
            style={{
              WebkitTransformOrigin: 231.78,
              MsTransformOrigin: 231.78,
              transformOrigin: 231.78,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 232.24,
              MsTransformOrigin: 232.24,
              transformOrigin: 232.24,
            }}
            fill="#FFF"
            d="M232.4 135.83L232.31 135.8 232.08 135.79 232.4 135.83z"
            className="animable"
          ></path>
          <path
            d="M227.73 135.67h-.36s.06.07.19 0 .22.05.17 0z"
            style={{
              WebkitTransformOrigin: 227.557,
              MsTransformOrigin: 227.557,
              transformOrigin: 227.557,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M228.8 136a.36.36 0 01-.15-.1v.16z"
            style={{
              WebkitTransformOrigin: 228.725,
              MsTransformOrigin: 228.725,
              transformOrigin: 228.725,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M227.76 136.05s-.51.13-.06.12c.04-.05.39-.08.06-.12z"
            style={{
              WebkitTransformOrigin: 227.707,
              MsTransformOrigin: 227.707,
              transformOrigin: 227.707,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 222.445,
              MsTransformOrigin: 222.445,
              transformOrigin: 222.445,
            }}
            fill="#FFF"
            d="M222.4 135.86L222.49 135.85 222.47 135.6 222.4 135.86z"
            className="animable"
          ></path>
          <path
            d="M217.66 136.47c.43.06.1-.16.48-.08.1-.06-.31-.07-.21-.12-.25.06-.38.03-.27.2z"
            style={{
              WebkitTransformOrigin: 217.888,
              MsTransformOrigin: 217.888,
              transformOrigin: 217.888,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M217.93 136.27h.13z"
            style={{
              WebkitTransformOrigin: 217.995,
              MsTransformOrigin: 217.995,
              transformOrigin: 217.995,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 164.375,
              MsTransformOrigin: 164.375,
              transformOrigin: 164.375,
            }}
            fill="#FFF"
            d="M164.51 135.18L164.24 135.13 164.42 135.21 164.51 135.18z"
            className="animable"
          ></path>
          <path
            d="M164 135.37l-.06-.16-.16.14c.05 0 .22-.02.22.02z"
            style={{
              WebkitTransformOrigin: 163.89,
              MsTransformOrigin: 163.89,
              transformOrigin: 163.89,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M201.1 136.67s-.11 0-.23-.06z"
            style={{
              WebkitTransformOrigin: 200.985,
              MsTransformOrigin: 200.985,
              transformOrigin: 200.985,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 197.42,
              MsTransformOrigin: 197.42,
              transformOrigin: 197.42,
            }}
            fill="#FFF"
            d="M197.42 136.54L197.48 136.55 197.36 136.4 197.42 136.54z"
            className="animable"
          ></path>
          <path
            d="M194.33 136.73h.4c-.28.01-.44-.18-.4 0z"
            style={{
              WebkitTransformOrigin: 194.527,
              MsTransformOrigin: 194.527,
              transformOrigin: 194.527,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M208.65 140.59c.07 0 0-.1 0-.11v.11z"
            style={{
              WebkitTransformOrigin: 208.666,
              MsTransformOrigin: 208.666,
              transformOrigin: 208.666,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 207.49,
              MsTransformOrigin: 207.49,
              transformOrigin: 207.49,
            }}
            fill="#FFF"
            d="M207.55 140.83L207.57 140.79 207.41 140.89 207.55 140.83z"
            className="animable"
          ></path>
          <path
            d="M206.53 140.83c.1.17.37 0 .55 0l.09-.14a2.42 2.42 0 01-.64.14z"
            style={{
              WebkitTransformOrigin: 206.85,
              MsTransformOrigin: 206.85,
              transformOrigin: 206.85,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M206 140.44c0 .07-.11.06.13 0z"
            style={{
              WebkitTransformOrigin: 206.052,
              MsTransformOrigin: 206.052,
              transformOrigin: 206.052,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M206.09 140.44c.11 0-.07-.05 0 0z"
            style={{
              WebkitTransformOrigin: 206.1,
              MsTransformOrigin: 206.1,
              transformOrigin: 206.1,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M205.59 140.48l.14-.06s-.15 0-.11-.08c-.14.04-.11.08-.03.14z"
            style={{
              WebkitTransformOrigin: 205.626,
              MsTransformOrigin: 205.626,
              transformOrigin: 205.626,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M205.46 140.61h.07s-.03-.04-.07 0z"
            style={{
              WebkitTransformOrigin: 205.495,
              MsTransformOrigin: 205.495,
              transformOrigin: 205.495,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M205.69 140.53l-.16.06s0 .09.07 0c-.01.03.02-.02.09-.06z"
            style={{
              WebkitTransformOrigin: 205.61,
              MsTransformOrigin: 205.61,
              transformOrigin: 205.61,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M205.77 140.56c.08 0 .19.06 0 .13.32-.03.28-.15 0-.13z"
            style={{
              WebkitTransformOrigin: 205.883,
              MsTransformOrigin: 205.883,
              transformOrigin: 205.883,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M206.48 141l.1.05.1-.06c-.05.01-.21.01-.2.01z"
            style={{
              WebkitTransformOrigin: 206.58,
              MsTransformOrigin: 206.58,
              transformOrigin: 206.58,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M204.71 140.39v.15h.11c-.01-.07-.11-.09-.11-.15z"
            style={{
              WebkitTransformOrigin: 204.765,
              MsTransformOrigin: 204.765,
              transformOrigin: 204.765,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M204.76 140.54l-.15.07c.14 0 .16-.03.15-.07z"
            style={{
              WebkitTransformOrigin: 204.686,
              MsTransformOrigin: 204.686,
              transformOrigin: 204.686,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 205.535,
              MsTransformOrigin: 205.535,
              transformOrigin: 205.535,
            }}
            fill="#FFF"
            d="M205.43 140.81L205.69 140.68 205.38 140.81 205.43 140.81z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 204.115,
              MsTransformOrigin: 204.115,
              transformOrigin: 204.115,
            }}
            fill="#FFF"
            d="M204.11 140.39L204.19 140.3 204.04 140.43 204.11 140.39z"
            className="animable"
          ></path>
          <path
            d="M203.71 140.4c.06-.07-.09-.12 0-.17a.78.78 0 00-.29.14.35.35 0 01.29.03z"
            style={{
              WebkitTransformOrigin: 203.572,
              MsTransformOrigin: 203.572,
              transformOrigin: 203.572,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M203.26 140.45l.14-.08a.41.41 0 00-.14.08z"
            style={{
              WebkitTransformOrigin: 203.33,
              MsTransformOrigin: 203.33,
              transformOrigin: 203.33,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M204.34 140.59a.21.21 0 00-.12-.11l.06.11z"
            style={{
              WebkitTransformOrigin: 204.28,
              MsTransformOrigin: 204.28,
              transformOrigin: 204.28,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M204.35 140.59z"
            style={{
              WebkitTransformOrigin: 204.35,
              MsTransformOrigin: 204.35,
              transformOrigin: 204.35,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M205 140.72c-.09.06-.29.12-.1.21.1-.07-.02-.12.1-.21z"
            style={{
              WebkitTransformOrigin: 204.91,
              MsTransformOrigin: 204.91,
              transformOrigin: 204.91,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M204.43 140.72h.17v-.1z"
            style={{
              WebkitTransformOrigin: 204.515,
              MsTransformOrigin: 204.515,
              transformOrigin: 204.515,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 204.39,
              MsTransformOrigin: 204.39,
              transformOrigin: 204.39,
            }}
            fill="#FFF"
            d="M204.35 140.76L204.43 140.72 204.37 140.71 204.35 140.76z"
            className="animable"
          ></path>
          <path
            d="M203.55 140.55a.61.61 0 01-.24.06 1.43 1.43 0 00.29 0s.05-.07-.05-.06z"
            style={{
              WebkitTransformOrigin: 203.461,
              MsTransformOrigin: 203.461,
              transformOrigin: 203.461,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M203.9 140.58s.01.02 0 0z"
            style={{
              WebkitTransformOrigin: 203.902,
              MsTransformOrigin: 203.902,
              transformOrigin: 203.902,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M202.43 140.61z"
            style={{
              WebkitTransformOrigin: 202.43,
              MsTransformOrigin: 202.43,
              transformOrigin: 202.43,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M203.61 140.66a.16.16 0 00.16 0h-.16z"
            style={{
              WebkitTransformOrigin: 203.684,
              MsTransformOrigin: 203.684,
              transformOrigin: 203.684,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M203 140.5l.12.06s-.12-.09-.12-.06z"
            style={{
              WebkitTransformOrigin: 203.06,
              MsTransformOrigin: 203.06,
              transformOrigin: 203.06,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M203.86 140.55s-.01-.01 0 0z"
            style={{
              WebkitTransformOrigin: 203.858,
              MsTransformOrigin: 203.858,
              transformOrigin: 203.858,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M203.86 140.55l-.09.07h.12z"
            style={{
              WebkitTransformOrigin: 203.83,
              MsTransformOrigin: 203.83,
              transformOrigin: 203.83,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M202.17 141.29c0-.1.2-.19.36-.08.16-.08.06-.4-.08-.59 0 0 0 .09-.17.15.06 0 .36.12.23.21s-.18 0-.29-.08c.09.12-.28.17-.23.36l.19-.07s-.06.08-.01.1z"
            style={{
              WebkitTransformOrigin: 202.299,
              MsTransformOrigin: 202.299,
              transformOrigin: 202.299,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M202.76 140.63h.07a.46.46 0 01-.23-.13c-.12 0-.14.08-.15.12h.31z"
            style={{
              WebkitTransformOrigin: 202.64,
              MsTransformOrigin: 202.64,
              transformOrigin: 202.64,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M203.13 140.62c0 .11-.21.16-.11.27s.14-.09.26-.13c-.32 0 .09-.06-.14-.13h.17l-.17-.05c-.09 0 0 0 0 0l-.32.06a1 1 0 00.31-.02z"
            style={{
              WebkitTransformOrigin: 203.065,
              MsTransformOrigin: 203.065,
              transformOrigin: 203.065,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M204.75 141.16s-.04 0 0 0z"
            style={{
              WebkitTransformOrigin: 204.741,
              MsTransformOrigin: 204.741,
              transformOrigin: 204.741,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M204.62 141.1a.11.11 0 01.12 0c.06 0 0 0 0 .09s.16-.08 0-.13c-.13 0-.29-.17-.27-.18a.83.83 0 00.15.22z"
            style={{
              WebkitTransformOrigin: 204.64,
              MsTransformOrigin: 204.64,
              transformOrigin: 204.64,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M203.87 140.89l-.27.05.13.09V141c.15 0 .12-.07.14-.11z"
            style={{
              WebkitTransformOrigin: 203.735,
              MsTransformOrigin: 203.735,
              transformOrigin: 203.735,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 202.36,
              MsTransformOrigin: 202.36,
              transformOrigin: 202.36,
            }}
            fill="#FFF"
            d="M202.4 140.55L202.44 140.44 202.28 140.6 202.4 140.55z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 202.025,
              MsTransformOrigin: 202.025,
              transformOrigin: 202.025,
            }}
            fill="#FFF"
            d="M202.06 140.56L202.07 140.47 201.98 140.53 202.06 140.56z"
            className="animable"
          ></path>
          <path
            d="M182.41 141.79h-.08z"
            style={{
              WebkitTransformOrigin: 182.37,
              MsTransformOrigin: 182.37,
              transformOrigin: 182.37,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M183 141.8v-.05.05z"
            style={{
              WebkitTransformOrigin: 183,
              MsTransformOrigin: 183,
              transformOrigin: 183,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M193.51 140.58c-.12-.1-.25-.24-.23-.13v.11a.27.27 0 01.23.02z"
            style={{
              WebkitTransformOrigin: 193.394,
              MsTransformOrigin: 193.394,
              transformOrigin: 193.394,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M187.65 141.22a.76.76 0 00.08-.11.41.41 0 01-.08.11z"
            style={{
              WebkitTransformOrigin: 187.69,
              MsTransformOrigin: 187.69,
              transformOrigin: 187.69,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M187.57 141.67l-.15-.07a.35.35 0 00.15.07z"
            style={{
              WebkitTransformOrigin: 187.495,
              MsTransformOrigin: 187.495,
              transformOrigin: 187.495,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M179.3 141.91l-.09.11c.14-.02.08-.02.09-.11z"
            style={{
              WebkitTransformOrigin: 179.257,
              MsTransformOrigin: 179.257,
              transformOrigin: 179.257,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M198.49 140.61a.73.73 0 00-.25-.07c.12.06.22.16.25.07z"
            style={{
              WebkitTransformOrigin: 198.365,
              MsTransformOrigin: 198.365,
              transformOrigin: 198.365,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M182.64 140.64s-.07 0-.07.07.08-.04.07-.07z"
            style={{
              WebkitTransformOrigin: 182.605,
              MsTransformOrigin: 182.605,
              transformOrigin: 182.605,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M198 140.54a.56.56 0 01.23 0 .23.23 0 00-.23 0z"
            style={{
              WebkitTransformOrigin: 198.115,
              MsTransformOrigin: 198.115,
              transformOrigin: 198.115,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M168 141.82z"
            style={{
              WebkitTransformOrigin: 168,
              MsTransformOrigin: 168,
              transformOrigin: 168,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M164.72 140.72z"
            style={{
              WebkitTransformOrigin: 164.72,
              MsTransformOrigin: 164.72,
              transformOrigin: 164.72,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M200.65 140.52c.08 0 0 0 0 0z"
            style={{
              WebkitTransformOrigin: 200.668,
              MsTransformOrigin: 200.668,
              transformOrigin: 200.668,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M201 141a.11.11 0 000 .05.11.11 0 010-.05z"
            style={{
              WebkitTransformOrigin: 200.999,
              MsTransformOrigin: 200.999,
              transformOrigin: 200.999,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M197.22 141.22s.01.01 0 0z"
            style={{
              WebkitTransformOrigin: 197.222,
              MsTransformOrigin: 197.222,
              transformOrigin: 197.222,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M200.77 140.57a.17.17 0 00-.1 0z"
            style={{
              WebkitTransformOrigin: 200.72,
              MsTransformOrigin: 200.72,
              transformOrigin: 200.72,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M200.75 140.52h.07s0-.02-.07 0z"
            style={{
              WebkitTransformOrigin: 200.785,
              MsTransformOrigin: 200.785,
              transformOrigin: 200.785,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M200.55 140.52h.12z"
            style={{
              WebkitTransformOrigin: 200.61,
              MsTransformOrigin: 200.61,
              transformOrigin: 200.61,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M174.06 141.53c-.06.03-.06.03 0 0z"
            style={{
              WebkitTransformOrigin: 174.037,
              MsTransformOrigin: 174.037,
              transformOrigin: 174.037,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 191.585,
              MsTransformOrigin: 191.585,
              transformOrigin: 191.585,
            }}
            fill="#FFF"
            d="M191.58 141.7L191.59 141.7 191.58 141.69 191.58 141.7z"
            className="animable"
          ></path>
          <path
            d="M191.32 141.78a.21.21 0 01.26-.09l-.09-.31z"
            style={{
              WebkitTransformOrigin: 191.45,
              MsTransformOrigin: 191.45,
              transformOrigin: 191.45,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M181.05 141.82l.18.1c-.22.16-.38.11-.21.24 0-.34.72 0 .75-.37l.12.07h-.07c.24.17.17-.24.48-.19.11 0 .18.07.11.11l.24-.08c.07 0 0 .06 0 .06h.37l.23-.17c.09 0 0 0 0 .08l.2-.08c.08.08-.08.17-.22.16.19.34.16-.09.57.11h-.19c.12.2.27.13.49.25-.05-.07-.43-.31-.22-.39a.3.3 0 00.27 0c0 .12.11.09.26.08v.2c.15 0 .14-.13.23-.2s.21.14.25.25c.28 0-.19-.2.14-.23a1.1 1.1 0 00.67-.1c.16 0 0 .1 0 .14l.15-.13v.07c0 .02 0-.16.2-.21s.39.26.63.06c.06 0 0 .1 0 .16a2 2 0 00.54-.27l.23.1c-.17-.12 0-.26.23-.38l-.14-.13.29-.08v.14h.06c.1.06.05.16 0 .25l-.11-.1a.41.41 0 00-.12.3.19.19 0 01.09-.05v.07c0 .02 0 0 .09-.06l.07.18v-.07l.38.11a2.32 2.32 0 011-.52c-.11.13 0 .21 0 .37-.12-.16-.34.07-.57 0 .12 0 .1.09.07.11l.4-.15c0 .13.09.1.2.15-.08-.25.3-.17.47-.24 0 .08 0 .17-.23.15.22.18.28-.3.5-.14h-.09c-.02 0 .39 0 .33.06.33 0 1 0 1-.21a1.84 1.84 0 01-.07.3l.59-.71c-.05.18.14.61-.13.72a.5.5 0 00.34 0c-.05 0-.13-.26-.06-.28.2.2.14.11.39.28-.08 0 0-.32.13-.32s0 .29 0 .32l.31-.28c-.08.05 0 .23.06.31s.27 0 .35 0l-.13-.06c.35 0 .35-.4.7-.38 0 .05-.1.35.07.39.09-.15.37-.69.68-.81l.06.09.24-.1a4.93 4.93 0 01-.8.85c.14.07 0 .1.24.09s-.11.12-.17.12l.46.05c0-.16.36-.16.34-.3l-.5.17c0-.17.29-.48.62-.45.08.07-.07.3-.06.36s.31-.11.34-.07l-.14.09c.19.06.3-.22.52-.06.08 0 .23.21.24.11a1.51 1.51 0 01-.07-.93 3.38 3.38 0 01.49.28c.12.15-.19.36-.08.49 0 0 .07-.1.1-.12s0 .14.14.12.35 0 .08-.14c.17-.05.18 0 .38 0-.06-.11.18-.37.35-.42a.2.2 0 000 .13c.35 0 .53.09.86.09 0 0 .18.09.12.16a.34.34 0 01.19-.09c.19.15-.23 0-.08.2 0-.1.26-.13.4-.2 0-.15-.33 0-.47 0 0-.22.25-.44.58-.53s.12.13.17.1c.5 0 .43-.37.84-.21.17.13 0 .26 0 .36-.22.05-.34-.08-.49-.08l.19.06a.35.35 0 01-.3 0c.14.13.85 0 1.24.14.07-.05.19-.09.13-.15h-.12c-.11-.11.23-.15.08-.2a.85.85 0 01.58-.13v.15s-.15-.09-.21 0c.09-.07.35.2.46 0l-.16-.1c.16-.08.37-.24.57-.2-.09-.15 0 0-.19-.16.12.23-.53 0-.33.23-.15-.21-.26-.09-.45-.27 0 .06.07.1-.1.08a.22.22 0 01.09.07c-.09.12-.36.11-.46.17s.05 0 0-.11l-.14.09c0-.11-.27-.18 0-.25H200a.55.55 0 00-.41-.05c-.1 0-.26.13-.17 0l-.34.07c-.34 0-.7.19-1.08 0a1.05 1.05 0 01-.42 0v-.1c-.14 0-.43-.1-.5 0-.15-.26-.7-.05-1-.1v.13a2 2 0 00-.56.08v.11c-.19.09-.48-.08-.78-.07h.15c-.36-.26-.75.18-1.07 0a.18.18 0 01-.2 0 .6.6 0 00-.11-.06l.09.06a.85.85 0 00-.25 0v-.12c-.09 0-.07.06 0 .15l-.13.07c-.07-.19-.24.07-.34-.14-.06.1-.46.08-.51.29a.35.35 0 00-.3 0v-.15l-.23.2c-.13-.09-.19-.14-.06-.26-.32.18-.26.07-.54.25v-.1c-.09 0-.25.13-.31 0-.23-.19-1.1 0-1.67-.2.11.29-.27-.13-.29.1 0-.07-.12-.11 0-.17-.29.07-.44-.11-.64.08 0-.07.06-.1 0-.14s-.09.06-.12 0 0-.06.09-.09c-.3 0-.33.22-.35.42-.15-.09-.23-.08-.34.05-.05-.06-.14-.13.05-.16-.11 0-.64-.09-.65.07h-.17a2.67 2.67 0 00-.49 0h.07c-.09.19-.19 0-.38.07-.43-.14-.19.06-.6-.09v.12c0 .25-.37-.16-.61-.06l.08.07c-.13.09-.37-.35-.5-.38s0 0 .09 0c-.35-.16 0 .15-.31.19 0-.09.06-.22-.11-.23s-.51.27-.75.11c.06.07.11.13 0 .18s-.5-.25-.67 0c-.14 0-.46.09-.55.2-.13-.42-.87.2-.87-.18h-.44a.49.49 0 00-.48.16c-.06 0 0-.07 0-.09a.85.85 0 00-.79.13v-.12c-.09.07-.59-.19-1 0v-.05c-.45.14-1.08-.35-1.24.1l-.3.11c.39 0-.05.2.1.27-.15 0-.38-.13-.2-.15.07-.24-.48-.09-.47-.25-.75 0-1.48-.11-2.19-.12l.08.18h-.24c-.07 0-.09-.15.09-.14-.09-.1-.3.09-.3.13-.35-.07.13-.21 0-.22h-.15c-.12.07-.13.15-.34.14s-.07-.11-.12-.12 0 0-.08 0h-.31l.12.15c-.14.07-.29 0-.15.15-.21-.25-1.15-.09-1.28-.17a1 1 0 01-.62.09c.06 0 .1.2-.11.18.08-.34-.37-.15-.53-.39.14.16-.58 0-.35.27-.17 0 0-.13-.14-.21-.4.13-.89-.08-1.38 0 0 0 .07.11 0 .18l-.27-.22c-.1 0-.09.25-.27.1 0 0 .07.09 0 .11-1-.22-2 .17-3-.23.13.08 0 .09-.06.1.06 0 0 .1 0 .16l-.42-.16c-.07.16-.44 0-.48.17h.13c-.18.19.24.41.22.65.19-.21.51.32.83 0 .07 0-.06.08 0 .14.08-.11.18-.13.36-.08a7.12 7.12 0 011.31.15l-.05-.12a.38.38 0 01.21.08c.14-.18-.34 0-.22-.21.17.24.87 0 1 .28.19 0-.06-.14.13-.13v.07l.05-.1a.22.22 0 01.19.18.25.25 0 00-.12 0c.16.09.46 0 .51 0h-.18a11.24 11.24 0 001.65-.12v-.06c.39-.1.31.06.73 0a.57.57 0 01.32-.08c-.11.07.19.13.06.2.41-.11.2-.09.47-.29l.07.09a.38.38 0 01.31-.15c-.17.08.13.14-.06.24.44.21.65-.2.85.1.21-.26-.38-.15-.26-.2-.1-.09.16-.19.3-.17s.24.33.59.33h-.07c.13.07.26-.09.42 0 .09-.15.21 0 .24-.19l-.32.05c.18-.05.35-.29.65-.17a.46.46 0 01-.17.12c.09.06.17 0 .26 0s-.39 0-.59.19c.1.09.37-.14.27.07.15-.27.35 0 .59-.17v.12a.3.3 0 01.18-.07l-.12.15c.19-.13.37.12.56 0-.39 0-.09-.14-.26-.23.48-.15.28.32.82.26-.08 0-.28-.07-.16-.13a.83.83 0 01.3.13c.35 0-.06-.12.09-.19.13.14.18-.06.34-.11v.12c.4.08.1-.25.47-.15l-.15.16h.19v.14a.56.56 0 01.47 0c-.05-.08 0-.22.21-.22s-.07.11.18.1c0 .07-.12.17-.23.06s-.05.07-.07.11c.14.08.34 0 .43 0h-.1l.37-.17c.06.05 0 .08 0 .12s.13-.07.24-.08 0 .2-.18.25l.36-.11s.18.11.13.15c.2.06.48-.19.74-.11a.17.17 0 01.09-.06c.25 0 .46.15.75 0l.16.18c.23 0-.22-.22.16-.29s.1.15.19.2.36-.27.61-.13c-.18.02-.25-.01-.32 0zm2.78-.07c-.05 0-.16.1-.2 0s.11-.04.2 0zm4.23-.29h-.17a.27.27 0 01.17 0zm11.79-.84c-.13-.05-.09-.03 0 0zm.25 0h-.14c-.06 0 .04.08.14.05zm-26.83.05c-.06.11-.03.08 0 .05z"
            style={{
              WebkitTransformOrigin: 182.94,
              MsTransformOrigin: 182.94,
              transformOrigin: 182.94,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M187.58 141.62a.14.14 0 010-.06s-.04.04 0 .06z"
            style={{
              WebkitTransformOrigin: 187.571,
              MsTransformOrigin: 187.571,
              transformOrigin: 187.571,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M179.32 141.89z"
            style={{
              WebkitTransformOrigin: 179.32,
              MsTransformOrigin: 179.32,
              transformOrigin: 179.32,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M196.23 141.69a.21.21 0 01-.1-.06s.02.05.1.06z"
            style={{
              WebkitTransformOrigin: 196.18,
              MsTransformOrigin: 196.18,
              transformOrigin: 196.18,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M201.42 140.46h-.16a.34.34 0 01.14 0s-.03.01.02 0z"
            style={{
              WebkitTransformOrigin: 201.34,
              MsTransformOrigin: 201.34,
              transformOrigin: 201.34,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M202.81 141.21h.07v-.05c-.11-.02-.18.03-.07.05z"
            style={{
              WebkitTransformOrigin: 202.817,
              MsTransformOrigin: 202.817,
              transformOrigin: 202.817,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M201.57 140.86c0 .11.11.07.22 0 .02-.09-.1-.04-.22 0z"
            style={{
              WebkitTransformOrigin: 201.681,
              MsTransformOrigin: 201.681,
              transformOrigin: 201.681,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M201.82 140.91h.1c.02-.06-.04-.02-.1 0z"
            style={{
              WebkitTransformOrigin: 201.872,
              MsTransformOrigin: 201.872,
              transformOrigin: 201.872,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M200.41 140.6c.06 0 0-.13.07-.09.05-.13-.36.16-.07.09z"
            style={{
              WebkitTransformOrigin: 200.395,
              MsTransformOrigin: 200.395,
              transformOrigin: 200.395,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 201.61,
              MsTransformOrigin: 201.61,
              transformOrigin: 201.61,
            }}
            fill="#FFF"
            d="M201.66 141.2L201.62 141.07 201.56 141.17 201.66 141.2z"
            className="animable"
          ></path>
          <path
            d="M200.77 141.11H201c.05 0-.23-.04-.23 0z"
            style={{
              WebkitTransformOrigin: 200.888,
              MsTransformOrigin: 200.888,
              transformOrigin: 200.888,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M201 141.1a.28.28 0 00.14 0 .39.39 0 00-.14 0z"
            style={{
              WebkitTransformOrigin: 201.07,
              MsTransformOrigin: 201.07,
              transformOrigin: 201.07,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 201.32,
              MsTransformOrigin: 201.32,
              transformOrigin: 201.32,
            }}
            fill="#FFF"
            d="M201.41 141.24L201.36 141.21 201.23 141.2 201.41 141.24z"
            className="animable"
          ></path>
          <path
            d="M198.85 141.08h-.2s0 .07.11 0 .12.04.09 0z"
            style={{
              WebkitTransformOrigin: 198.757,
              MsTransformOrigin: 198.757,
              transformOrigin: 198.757,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M199.44 141.43a.28.28 0 01-.09-.1v.16z"
            style={{
              WebkitTransformOrigin: 199.395,
              MsTransformOrigin: 199.395,
              transformOrigin: 199.395,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M198.87 141.46s-.28.13 0 .12c-.02-.05.18-.08 0-.12z"
            style={{
              WebkitTransformOrigin: 198.846,
              MsTransformOrigin: 198.846,
              transformOrigin: 198.846,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 195.945,
              MsTransformOrigin: 195.945,
              transformOrigin: 195.945,
            }}
            fill="#FFF"
            d="M195.92 141.26L195.97 141.26 195.97 141.01 195.92 141.26z"
            className="animable"
          ></path>
          <path
            d="M193.33 141.87c.23.07 0-.15.26-.08.06-.06-.17-.06-.11-.11-.14.06-.22.03-.15.19z"
            style={{
              WebkitTransformOrigin: 193.452,
              MsTransformOrigin: 193.452,
              transformOrigin: 193.452,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M193.48 141.68h.07z"
            style={{
              WebkitTransformOrigin: 193.515,
              MsTransformOrigin: 193.515,
              transformOrigin: 193.515,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 164.105,
              MsTransformOrigin: 164.105,
              transformOrigin: 164.105,
            }}
            fill="#FFF"
            d="M164.18 140.59L164.03 140.53 164.12 140.62 164.18 140.59z"
            className="animable"
          ></path>
          <path
            d="M163.89 140.78v-.17l-.09.15s.07-.02.09.02z"
            style={{
              WebkitTransformOrigin: 163.845,
              MsTransformOrigin: 163.845,
              transformOrigin: 163.845,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M184.24 142.07s-.05 0-.12-.05z"
            style={{
              WebkitTransformOrigin: 184.18,
              MsTransformOrigin: 184.18,
              transformOrigin: 184.18,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 182.225,
              MsTransformOrigin: 182.225,
              transformOrigin: 182.225,
            }}
            fill="#FFF"
            d="M182.22 141.95L182.26 141.96 182.19 141.81 182.22 141.95z"
            className="animable"
          ></path>
          <path
            d="M180.53 142.14h.22c-.15.01-.24-.14-.22 0z"
            style={{
              WebkitTransformOrigin: 180.639,
              MsTransformOrigin: 180.639,
              transformOrigin: 180.639,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M229.39 146c.1 0 .06-.1.08-.12-.16.03-.07.12-.08.12z"
            style={{
              WebkitTransformOrigin: 229.422,
              MsTransformOrigin: 229.422,
              transformOrigin: 229.422,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 227.7,
              MsTransformOrigin: 227.7,
              transformOrigin: 227.7,
            }}
            fill="#FFF"
            d="M227.79 146.24L227.82 146.19 227.58 146.3 227.79 146.24z"
            className="animable"
          ></path>
          <path
            d="M226.29 146.23c.14.18.55 0 .81 0h.05l.12-.14a5 5 0 01-.98.14z"
            style={{
              WebkitTransformOrigin: 226.78,
              MsTransformOrigin: 226.78,
              transformOrigin: 226.78,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M225.49 145.85c0 .07-.17.06.19 0z"
            style={{
              WebkitTransformOrigin: 225.565,
              MsTransformOrigin: 225.565,
              transformOrigin: 225.565,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M225.65 145.85c.16 0-.11-.06 0 0z"
            style={{
              WebkitTransformOrigin: 225.662,
              MsTransformOrigin: 225.662,
              transformOrigin: 225.662,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M224.92 145.89l.21-.06s-.23-.05-.16-.08c-.22.03-.17.07-.05.14z"
            style={{
              WebkitTransformOrigin: 224.974,
              MsTransformOrigin: 224.974,
              transformOrigin: 224.974,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M224.72 146h.11-.11z"
            style={{
              WebkitTransformOrigin: 224.775,
              MsTransformOrigin: 224.775,
              transformOrigin: 224.775,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M225.06 145.94l-.23.06s0 .08.1 0c-.01 0 .07 0 .13-.06z"
            style={{
              WebkitTransformOrigin: 224.945,
              MsTransformOrigin: 224.945,
              transformOrigin: 224.945,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M225.19 146c.11 0 .26.06.06.12.39-.05.33-.18-.06-.12z"
            style={{
              WebkitTransformOrigin: 225.352,
              MsTransformOrigin: 225.352,
              transformOrigin: 225.352,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M226.22 146.42l.15.05.14-.06c-.07.03-.3-.05-.29.01z"
            style={{
              WebkitTransformOrigin: 226.365,
              MsTransformOrigin: 226.365,
              transformOrigin: 226.365,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M223.63 145.8s.07.1.08.15h.15c-.07-.07-.22-.09-.23-.15z"
            style={{
              WebkitTransformOrigin: 223.745,
              MsTransformOrigin: 223.745,
              transformOrigin: 223.745,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M223.71 146l-.23.06c.21-.06.24-.06.23-.06z"
            style={{
              WebkitTransformOrigin: 223.596,
              MsTransformOrigin: 223.596,
              transformOrigin: 223.596,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 224.835,
              MsTransformOrigin: 224.835,
              transformOrigin: 224.835,
            }}
            fill="#FFF"
            d="M224.69 146.22L225.06 146.08 224.61 146.22 224.69 146.22z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 222.765,
              MsTransformOrigin: 222.765,
              transformOrigin: 222.765,
            }}
            fill="#FFF"
            d="M222.75 145.79L222.88 145.71 222.65 145.84 222.75 145.79z"
            className="animable"
          ></path>
          <path
            d="M222.17 145.81c.09-.07-.14-.12 0-.17a1.6 1.6 0 00-.42.13.81.81 0 01.42.04z"
            style={{
              WebkitTransformOrigin: 221.971,
              MsTransformOrigin: 221.971,
              transformOrigin: 221.971,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M221.52 145.86l.2-.09a.88.88 0 00-.2.09z"
            style={{
              WebkitTransformOrigin: 221.62,
              MsTransformOrigin: 221.62,
              transformOrigin: 221.62,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M223.09 146a.22.22 0 00-.18-.11l.09.1z"
            style={{
              WebkitTransformOrigin: 223,
              MsTransformOrigin: 223,
              transformOrigin: 223,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M223 146z"
            style={{
              WebkitTransformOrigin: 223,
              MsTransformOrigin: 223,
              transformOrigin: 223,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M223.11 146z"
            style={{
              WebkitTransformOrigin: 223.11,
              MsTransformOrigin: 223.11,
              transformOrigin: 223.11,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M224.08 146.12c-.13.06-.41.13-.14.22.06-.07-.06-.13.14-.22z"
            style={{
              WebkitTransformOrigin: 223.953,
              MsTransformOrigin: 223.953,
              transformOrigin: 223.953,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M223.22 146.13h.25s-.05-.06 0-.09z"
            style={{
              WebkitTransformOrigin: 223.345,
              MsTransformOrigin: 223.345,
              transformOrigin: 223.345,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 223.16,
              MsTransformOrigin: 223.16,
              transformOrigin: 223.16,
            }}
            fill="#FFF"
            d="M223.1 146.16L223.22 146.13 223.13 146.12 223.1 146.16z"
            className="animable"
          ></path>
          <path
            d="M221.94 146a1 1 0 01-.35 0 2.85 2.85 0 00.42 0h-.07z"
            style={{
              WebkitTransformOrigin: 221.811,
              MsTransformOrigin: 221.811,
              transformOrigin: 221.811,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M222.45 146z"
            style={{
              WebkitTransformOrigin: 222.45,
              MsTransformOrigin: 222.45,
              transformOrigin: 222.45,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M220.3 146z"
            style={{
              WebkitTransformOrigin: 220.3,
              MsTransformOrigin: 220.3,
              transformOrigin: 220.3,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M222 146.07a.33.33 0 00.23 0h-.25.02z"
            style={{
              WebkitTransformOrigin: 222.105,
              MsTransformOrigin: 222.105,
              transformOrigin: 222.105,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M221.16 145.91l.18.05c-.05-.03-.16-.08-.18-.05z"
            style={{
              WebkitTransformOrigin: 221.25,
              MsTransformOrigin: 221.25,
              transformOrigin: 221.25,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M222.4 146s-.02 0 0 0z"
            style={{
              WebkitTransformOrigin: 222.396,
              MsTransformOrigin: 222.396,
              transformOrigin: 222.396,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M222.4 146a.46.46 0 00-.14.07h.17z"
            style={{
              WebkitTransformOrigin: 222.345,
              MsTransformOrigin: 222.345,
              transformOrigin: 222.345,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M219.92 146.7c0-.1.29-.19.53-.09.23-.07.08-.4-.13-.58 0 .05 0 .09-.24.14.08.06.53.13.33.22s-.26 0-.42-.09c.13.13-.4.18-.34.36l.28-.06s-.09.07-.01.1z"
            style={{
              WebkitTransformOrigin: 220.105,
              MsTransformOrigin: 220.105,
              transformOrigin: 220.105,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M220.78 146h.1a1.35 1.35 0 01-.34-.13c-.16 0-.2.08-.21.11h.49z"
            style={{
              WebkitTransformOrigin: 220.605,
              MsTransformOrigin: 220.605,
              transformOrigin: 220.605,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M221.33 146c-.08.11-.32.15-.17.27s.2-.09.38-.14c-.47 0 .13-.06-.21-.12h.26-.25c-.14 0 0 0 0 0l-.47.06a2.17 2.17 0 00.46-.07z"
            style={{
              WebkitTransformOrigin: 221.23,
              MsTransformOrigin: 221.23,
              transformOrigin: 221.23,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M223.69 146.57s-.06 0 0 0z"
            style={{
              WebkitTransformOrigin: 223.677,
              MsTransformOrigin: 223.677,
              transformOrigin: 223.677,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M223.5 146.51a.2.2 0 01.17 0c.1 0 0 0 0 .09s.24-.08 0-.13c-.18 0-.43-.17-.39-.19a.69.69 0 00.22.23z"
            style={{
              WebkitTransformOrigin: 223.526,
              MsTransformOrigin: 223.526,
              transformOrigin: 223.526,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M222.4 146.3h-.39l.2.09v-.05c.21.07.16 0 .19-.04z"
            style={{
              WebkitTransformOrigin: 222.205,
              MsTransformOrigin: 222.205,
              transformOrigin: 222.205,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 220.2,
              MsTransformOrigin: 220.2,
              transformOrigin: 220.2,
            }}
            fill="#FFF"
            d="M220.26 145.96L220.31 145.85 220.09 146.01 220.26 145.96z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 219.7,
              MsTransformOrigin: 219.7,
              transformOrigin: 219.7,
            }}
            fill="#FFF"
            d="M219.75 145.97L219.77 145.87 219.63 145.93 219.75 145.97z"
            className="animable"
          ></path>
          <path
            d="M191 147.2h-.12z"
            style={{
              WebkitTransformOrigin: 190.94,
              MsTransformOrigin: 190.94,
              transformOrigin: 190.94,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M191.86 147.21v-.05s-.03.05 0 .05z"
            style={{
              WebkitTransformOrigin: 191.853,
              MsTransformOrigin: 191.853,
              transformOrigin: 191.853,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M207.25 146c-.17-.09-.36-.23-.34-.12l.06.11a.64.64 0 01.28.01z"
            style={{
              WebkitTransformOrigin: 207.079,
              MsTransformOrigin: 207.079,
              transformOrigin: 207.079,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M198.69 146.63h.05l.11-.1z"
            style={{
              WebkitTransformOrigin: 198.77,
              MsTransformOrigin: 198.77,
              transformOrigin: 198.77,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M198.57 147.08l-.22-.07a.71.71 0 00.22.07z"
            style={{
              WebkitTransformOrigin: 198.46,
              MsTransformOrigin: 198.46,
              transformOrigin: 198.46,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M186.48 147.32l-.14.11c.21 0 .12-.06.14-.11z"
            style={{
              WebkitTransformOrigin: 186.411,
              MsTransformOrigin: 186.411,
              transformOrigin: 186.411,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M214.54 146a1.41 1.41 0 00-.36-.06c.17.06.31.16.36.06z"
            style={{
              WebkitTransformOrigin: 214.36,
              MsTransformOrigin: 214.36,
              transformOrigin: 214.36,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M191.36 146.05c-.08 0-.11 0-.1.07s.11-.04.1-.07z"
            style={{
              WebkitTransformOrigin: 191.309,
              MsTransformOrigin: 191.309,
              transformOrigin: 191.309,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M213.76 146h.08a1.78 1.78 0 01.34 0 .48.48 0 00-.42 0z"
            style={{
              WebkitTransformOrigin: 213.97,
              MsTransformOrigin: 213.97,
              transformOrigin: 213.97,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M170 147.23z"
            style={{
              WebkitTransformOrigin: 170,
              MsTransformOrigin: 170,
              transformOrigin: 170,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M165.16 146.13z"
            style={{
              WebkitTransformOrigin: 165.16,
              MsTransformOrigin: 165.16,
              transformOrigin: 165.16,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M217.7 145.93c.11 0 0 0 0 0z"
            style={{
              WebkitTransformOrigin: 217.724,
              MsTransformOrigin: 217.724,
              transformOrigin: 217.724,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M218.23 146.35a.1.1 0 000 .06.1.1 0 010-.06z"
            style={{
              WebkitTransformOrigin: 218.228,
              MsTransformOrigin: 218.228,
              transformOrigin: 218.228,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M212.68 146.62s.02.02 0 0z"
            style={{
              WebkitTransformOrigin: 212.684,
              MsTransformOrigin: 212.684,
              transformOrigin: 212.684,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M217.86 146h-.13z"
            style={{
              WebkitTransformOrigin: 217.795,
              MsTransformOrigin: 217.795,
              transformOrigin: 217.795,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M217.84 145.92h.1s0-.01-.1 0z"
            style={{
              WebkitTransformOrigin: 217.89,
              MsTransformOrigin: 217.89,
              transformOrigin: 217.89,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M217.55 145.93z"
            style={{
              WebkitTransformOrigin: 217.55,
              MsTransformOrigin: 217.55,
              transformOrigin: 217.55,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M178.82 146.94c-.14.06-.09.06 0 0z"
            style={{
              WebkitTransformOrigin: 178.776,
              MsTransformOrigin: 178.776,
              transformOrigin: 178.776,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M204.44 147.11z"
            style={{
              WebkitTransformOrigin: 204.44,
              MsTransformOrigin: 204.44,
              transformOrigin: 204.44,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M204.05 147.19a.38.38 0 01.39-.09l-.13-.31z"
            style={{
              WebkitTransformOrigin: 204.245,
              MsTransformOrigin: 204.245,
              transformOrigin: 204.245,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M189 147.23l.27.1c-.32.16-.56.1-.31.24 0-.34 1.06 0 1.1-.37l.18.07h-.11c.35.17.26-.24.71-.19.15 0 .26.07.16.11l.35-.08c.1 0 .07.06 0 .06h.54a2.59 2.59 0 01.33-.17c.14 0-.06 0 0 .08l.3-.09c.12.09-.13.18-.33.17.27.33.24-.09.84.11h-.28c.18.19.39.12.71.24-.08-.06-.63-.3-.31-.38a.66.66 0 00.38 0c0 .12.17.09.38.08v.16c.23-.05.21-.13.34-.2a.39.39 0 01.37.24c.41 0-.28-.19.2-.22a2.28 2.28 0 001-.1c.24 0 0 .09.05.14l.21-.13c.05 0 0 0 0 .06.18 0 0-.16.29-.2.08-.18.58.26.92.06.09 0 0 .1 0 .16a3.65 3.65 0 00.79-.27l.33.1c-.24-.12.07-.26.34-.38a1.53 1.53 0 00-.21-.13l.43-.09c.06 0 0 .08-.06.15h.08c.16.06.07.15 0 .24l-.15-.1c-.11.1-.21.21-.19.3a.39.39 0 01.14 0v.07c0 .02.06 0 .13-.06l.1.17v-.07l.57.12a4 4 0 011.41-.52c-.16.13 0 .21 0 .37-.17-.17-.5.07-.83 0 .17 0 .14.09.09.12l.6-.15c0 .13.12.1.28.15-.12-.25.44-.17.69-.25 0 .09 0 .17-.34.15.32.19.42-.29.74-.13h-.14c.17-.07.58 0 .48.06h-.07c.48 0 1.46 0 1.53-.21a.93.93 0 01-.09.3l.86-.72c-.08.19.21.62-.19.73a1.05 1.05 0 00.5 0c-.08 0-.2-.27-.09-.28a2.25 2.25 0 00.56.28c-.11 0 0-.33.2-.32 0 .05 0 .29-.05.32l.46-.29c-.12.05 0 .24.08.32h.52l-.19-.07c.51.05.51-.39 1-.38-.06.06-.15.36.11.4a2.24 2.24 0 011-.81l.09.08.35-.09a7.1 7.1 0 01-1.16.85c.19.07 0 .1.35.09.1.08-.16.12-.25.12h.68c0-.17.51-.17.49-.31l-.74.18c0-.17.43-.48.91-.45.12.07-.09.3-.08.36a.81.81 0 01.5-.07l-.21.09c.27.06.44-.23.76-.07.11 0 .33.22.35.12a1 1 0 01-.1-.93 3.79 3.79 0 01.71.28c.18.15-.27.36-.12.49 0 0 .11-.11.15-.12s0 .14.21.12c0-.17.51 0 .11-.15h.56c-.09-.11.26-.37.51-.42 0 0 0 .1.06.12.51 0 .78.1 1.25.1 0 0 .27.09.18.16a.53.53 0 01.27-.09c.29.15-.32 0-.11.2 0-.1.38-.14.59-.2-.07-.15-.48 0-.69 0 0-.21.36-.43.86-.53s.17.14.23.11c.74 0 .63-.37 1.24-.22.25.14 0 .27.07.37-.32 0-.49-.09-.71-.08l.27.06a.7.7 0 01-.43 0c.2.12 1.24 0 1.81.14.1-.05.27-.09.19-.15h-.18c-.16-.11.34-.15.11-.2a1.62 1.62 0 01.85-.14l.07.16c0-.05-.22-.09-.32-.05.14-.06.52.21.68 0l-.24-.11a1.92 1.92 0 01.84-.19c-.14-.15-.07 0-.28-.16.18.22-.77 0-.47.23-.22-.21-.38-.09-.67-.27 0 0 .1.1-.15.07a.15.15 0 01-.06 0 .36.36 0 01.13.08c-.12.12-.52.11-.66.17s.06-.06 0-.11l-.2.09c0-.11-.4-.19 0-.25h-.32a1.24 1.24 0 00-.6 0c-.15 0-.38.13-.25 0l-.5.07a4.16 4.16 0 01-1.57 0 1.69 1.69 0 01-.62 0l-.05-.09c-.22 0-.64-.1-.73 0-.23-.26-1-.06-1.41-.1v.13a4.22 4.22 0 00-.83.07v.12c-.27.09-.7-.08-1.14-.07h.22c-.52-.25-1.1.19-1.57 0a.41.41 0 01-.29 0l-.16-.06.14.06a3.5 3.5 0 00-.37.05l-.26.04c-.14 0-.11.06 0 .15a.75.75 0 00-.18.07c-.11-.19-.35.07-.5-.14-.09.1-.68.08-.75.29a.73.73 0 00-.44 0l-.06-.16-.33.21c-.2-.09-.28-.15-.08-.26-.48.18-.39.06-.8.24v-.1c-.14 0-.38.14-.46.06-.33-.19-1.61 0-2.45-.2.16.29-.39-.13-.42.09 0-.07-.16-.1 0-.16-.42.06-.64-.11-.93.08-.05-.07.09-.1 0-.15s-.14.06-.18 0 .06 0 .13-.08c-.44 0-.48.22-.52.42a.39.39 0 00-.49.05c-.07-.07-.2-.13.07-.16-.15 0-.93-.09-.94.07a.39.39 0 00-.26 0h-.7.09c-.13.19-.28 0-.55.07-.62-.14-.27.06-.88-.1v.12c0 .26-.54-.15-.89-.05l.12.07c-.19.09-.54-.35-.73-.38 0 0 .07 0 .12-.06-.51-.15-.06.16-.44.2-.07-.09.09-.22-.17-.23s-.74.27-1.09.11c.08.06.16.13 0 .18s-.73-.25-1 0h-.05a2.6 2.6 0 00-.8.2c-.19-.42-1.28.2-1.28-.18h-.63a.94.94 0 00-.69.15c-.09 0 0-.06 0-.08a1.71 1.71 0 00-1.15.13v-.12c-.13.07-.86-.2-1.44 0a.11.11 0 01.06-.06c-.65.15-1.56-.34-1.8.11l-.44.11c.56 0-.08.2.15.27-.22 0-.57-.13-.3-.16.1-.24-.69-.09-.68-.25-1.1 0-2.17-.12-3.2-.13l.12.19h-.36c-.09-.05-.13-.15.13-.14-.13-.1-.43.09-.44.13-.5-.08.2-.22 0-.22h-.2c-.17.08-.18.16-.49.15s-.1-.11-.18-.12 0 0-.11 0h-.46l.18.14c-.2.07-.42 0-.21.16-.31-.25-1.69-.09-1.88-.17a2.2 2.2 0 01-.9.09c.08 0 .13.19-.16.17.1-.33-.55-.14-.79-.38.22.16-.84 0-.5.26-.25 0 0-.12-.21-.2a17.59 17.59 0 01-2 0s.11.11 0 .18l-.38-.22c-.15 0-.13.25-.4.1 0 0 .1.09 0 .1-1.43-.21-2.92.18-4.36-.22.19.08.06.09-.09.09.1 0 0 .11 0 .17l-.61-.16c-.11.16-.65 0-.71.17h.19c-.25.18.36.41.32.65.29-.21.76.32 1.22 0 .11 0-.08.08 0 .13.12-.1.26-.12.53-.07a14.79 14.79 0 011.91.15l-.06-.12a.73.73 0 01.3.08c.21-.18-.51 0-.32-.21.24.24 1.27 0 1.44.28.27 0-.09-.14.19-.14l.08.08.07-.1c.18 0 .27.11.28.17H170a3 3 0 00.75 0h-.27a24.06 24.06 0 002.42-.12l-.06-.06c.56-.1.45.06 1.06 0a1 1 0 01.46-.08c-.16.07.29.13.08.2.61-.11.3-.09.7-.3l.1.1a.62.62 0 01.45-.15c-.25.07.2.14-.08.24.64.2.95-.2 1.25.09.29-.25-.56-.14-.4-.19-.13-.09.25-.2.45-.17s.35.33.87.32h-.11c.19.07.38-.09.62 0 .13-.16.3 0 .34-.19l-.47.05c.27-.06.52-.29 1-.18a.72.72 0 01-.25.13c.13.05.25 0 .38 0 0 .2-.58 0-.86.19.13.08.54-.14.4.07.2-.27.5 0 .85-.17v.12a.67.67 0 01.27-.07l-.18.15c.28-.13.55.11.82 0-.57 0-.13-.14-.37-.23.7-.16.4.31 1.19.26-.11 0-.4-.07-.23-.13a1.28 1.28 0 01.43.13c.52 0-.08-.12.15-.19.17.14.25-.06.48-.11v.12c.59.08.16-.25.69-.15l-.22.16h.28l-.06.14a1.1 1.1 0 01.69 0c-.07-.09 0-.22.3-.22s-.1.11.28.09c-.09.08-.18.17-.34.06 0 0-.09.08-.1.12a1.65 1.65 0 00.62 0h-.15l.54-.17c.09 0 0 .08 0 .12a2 2 0 01.35-.08c0 .1 0 .2-.26.24l.51-.1s.27.11.2.15c.29.06.7-.19 1.08-.12h.14a2.35 2.35 0 001.09 0l.24.18c.33 0-.32-.22.23-.29.38-.06.14.15.28.2a1.09 1.09 0 01.88-.13 1.15 1.15 0 01-.51-.21zm4.07-.08c-.08 0-.23.11-.29 0 .12-.1.22-.04.32 0zm6.19-.29a.28.28 0 01-.25 0 .56.56 0 01.28 0zm17.23-.84c-.16-.02-.09-.02.03-.02zm.36.06v-.05c0-.05-.1 0-.2 0s.13.07.23.05zm-39.22 0h.07c-.13.11-.08.08-.04.04z"
            style={{
              WebkitTransformOrigin: 191.85,
              MsTransformOrigin: 191.85,
              transformOrigin: 191.85,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M198.59 147v-.07c0-.07-.07.07 0 .07z"
            style={{
              WebkitTransformOrigin: 198.574,
              MsTransformOrigin: 198.574,
              transformOrigin: 198.574,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M186.5 147.3z"
            style={{
              WebkitTransformOrigin: 186.5,
              MsTransformOrigin: 186.5,
              transformOrigin: 186.5,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M211.23 147.1a.45.45 0 01-.15-.06s.03.05.15.06z"
            style={{
              WebkitTransformOrigin: 211.155,
              MsTransformOrigin: 211.155,
              transformOrigin: 211.155,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M218.82 145.87h-.23a.52.52 0 01.21 0h.02z"
            style={{
              WebkitTransformOrigin: 218.705,
              MsTransformOrigin: 218.705,
              transformOrigin: 218.705,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M220.85 146.62h.11c-.16-.07-.26-.03-.11 0z"
            style={{
              WebkitTransformOrigin: 220.868,
              MsTransformOrigin: 220.868,
              transformOrigin: 220.868,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M219 146.27c0 .1.16.07.33 0 .05-.09-.12-.04-.33 0z"
            style={{
              WebkitTransformOrigin: 219.169,
              MsTransformOrigin: 219.169,
              transformOrigin: 219.169,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M219.4 146.32h.16c.01-.06-.07-.02-.16 0z"
            style={{
              WebkitTransformOrigin: 219.48,
              MsTransformOrigin: 219.48,
              transformOrigin: 219.48,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M217.35 146c.08 0 .05-.13.09-.09.09-.12-.52.17-.09.09z"
            style={{
              WebkitTransformOrigin: 217.322,
              MsTransformOrigin: 217.322,
              transformOrigin: 217.322,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 219.095,
              MsTransformOrigin: 219.095,
              transformOrigin: 219.095,
            }}
            fill="#FFF"
            d="M219.17 146.61L219.11 146.48 219.02 146.58 219.17 146.61z"
            className="animable"
          ></path>
          <path
            d="M217.88 146.51h.33c-.16-.01-.34-.03-.33 0z"
            style={{
              WebkitTransformOrigin: 218.045,
              MsTransformOrigin: 218.045,
              transformOrigin: 218.045,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M218.21 146.51a.65.65 0 00.21 0 .78.78 0 00-.21 0z"
            style={{
              WebkitTransformOrigin: 218.315,
              MsTransformOrigin: 218.315,
              transformOrigin: 218.315,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 218.68,
              MsTransformOrigin: 218.68,
              transformOrigin: 218.68,
            }}
            fill="#FFF"
            d="M218.81 146.64L218.73 146.62 218.55 146.61 218.81 146.64z"
            className="animable"
          ></path>
          <path
            d="M215.06 146.49h-.29s0 .07.16.05.17-.01.13-.05z"
            style={{
              WebkitTransformOrigin: 214.925,
              MsTransformOrigin: 214.925,
              transformOrigin: 214.925,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M215.92 146.83c-.07 0-.08-.05-.12-.09v.15z"
            style={{
              WebkitTransformOrigin: 215.86,
              MsTransformOrigin: 215.86,
              transformOrigin: 215.86,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M215.09 146.87s-.41.12-.05.11c.03-.04.31-.07.05-.11z"
            style={{
              WebkitTransformOrigin: 215.046,
              MsTransformOrigin: 215.046,
              transformOrigin: 215.046,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 210.82,
              MsTransformOrigin: 210.82,
              transformOrigin: 210.82,
            }}
            fill="#FFF"
            d="M210.78 146.67L210.86 146.67 210.85 146.42 210.78 146.67z"
            className="animable"
          ></path>
          <path
            d="M207 147.28c.34.06.08-.15.39-.08.08-.06-.25-.06-.17-.11-.22.06-.32.02-.22.19z"
            style={{
              WebkitTransformOrigin: 207.182,
              MsTransformOrigin: 207.182,
              transformOrigin: 207.182,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M207.21 147.09h.1a.19.19 0 00-.1 0z"
            style={{
              WebkitTransformOrigin: 207.26,
              MsTransformOrigin: 207.26,
              transformOrigin: 207.26,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 164.26,
              MsTransformOrigin: 164.26,
              transformOrigin: 164.26,
            }}
            fill="#FFF"
            d="M164.37 146L164.15 145.94 164.29 146.03 164.37 146z"
            className="animable"
          ></path>
          <path
            d="M164 146.18v-.16l-.13.15a.27.27 0 01.13.01z"
            style={{
              WebkitTransformOrigin: 163.935,
              MsTransformOrigin: 163.935,
              transformOrigin: 163.935,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M193.71 147.48s-.08 0-.18-.05z"
            style={{
              WebkitTransformOrigin: 193.62,
              MsTransformOrigin: 193.62,
              transformOrigin: 193.62,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 190.755,
              MsTransformOrigin: 190.755,
              transformOrigin: 190.755,
            }}
            fill="#FFF"
            d="M190.75 147.36L190.8 147.36 190.71 147.22 190.75 147.36z"
            className="animable"
          ></path>
          <path
            d="M188.27 147.55h.33c-.22 0-.35-.19-.33 0z"
            style={{
              WebkitTransformOrigin: 188.434,
              MsTransformOrigin: 188.434,
              transformOrigin: 188.434,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M190.55 151.41v-.12c0-.02.01.14 0 .12z"
            style={{
              WebkitTransformOrigin: 190.552,
              MsTransformOrigin: 190.552,
              transformOrigin: 190.552,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 189.86,
              MsTransformOrigin: 189.86,
              transformOrigin: 189.86,
            }}
            fill="#FFF"
            d="M189.9 151.64L189.91 151.6 189.81 151.71 189.9 151.64z"
            className="animable"
          ></path>
          <path
            d="M189.29 151.64c.06.18.22 0 .33 0l.05-.15c-.12.11-.29.2-.38.15z"
            style={{
              WebkitTransformOrigin: 189.48,
              MsTransformOrigin: 189.48,
              transformOrigin: 189.48,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M189 151.26c0 .07-.07.06.08 0z"
            style={{
              WebkitTransformOrigin: 189.032,
              MsTransformOrigin: 189.032,
              transformOrigin: 189.032,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M189 151.26c.07 0 0-.06 0 0z"
            style={{
              WebkitTransformOrigin: 189.016,
              MsTransformOrigin: 189.016,
              transformOrigin: 189.016,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M188.73 151.3l.08-.06s-.09-.05-.06-.08-.07.07-.02.14z"
            style={{
              WebkitTransformOrigin: 188.763,
              MsTransformOrigin: 188.763,
              transformOrigin: 188.763,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M188.65 151.43s.02-.05 0 0z"
            style={{
              WebkitTransformOrigin: 188.654,
              MsTransformOrigin: 188.654,
              transformOrigin: 188.654,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M188.78 151.35l-.09.05s0 .09 0 0c.04.04.05-.01.09-.05z"
            style={{
              WebkitTransformOrigin: 188.735,
              MsTransformOrigin: 188.735,
              transformOrigin: 188.735,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M188.84 151.38s.11.06 0 .12c.16-.02.16-.15 0-.12z"
            style={{
              WebkitTransformOrigin: 188.9,
              MsTransformOrigin: 188.9,
              transformOrigin: 188.9,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M189.26 151.83h.06l.06-.06s-.13 0-.12.06z"
            style={{
              WebkitTransformOrigin: 189.32,
              MsTransformOrigin: 189.32,
              transformOrigin: 189.32,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M188.2 151.21v.15l.07-.05s-.07-.05-.07-.1z"
            style={{
              WebkitTransformOrigin: 188.235,
              MsTransformOrigin: 188.235,
              transformOrigin: 188.235,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M188.23 151.36l-.09.06c.08.01.1-.02.09-.06z"
            style={{
              WebkitTransformOrigin: 188.186,
              MsTransformOrigin: 188.186,
              transformOrigin: 188.186,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 188.695,
              MsTransformOrigin: 188.695,
              transformOrigin: 188.695,
            }}
            fill="#FFF"
            d="M188.63 151.63L188.79 151.49 188.6 151.63 188.63 151.63z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 187.85,
              MsTransformOrigin: 187.85,
              transformOrigin: 187.85,
            }}
            fill="#FFF"
            d="M187.84 151.2L187.9 151.12 187.8 151.25 187.84 151.2z"
            className="animable"
          ></path>
          <path
            d="M187.6 151.22v-.17c0-.05-.12.08-.17.13s.1-.02.17.04z"
            style={{
              WebkitTransformOrigin: 187.51,
              MsTransformOrigin: 187.51,
              transformOrigin: 187.51,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M187.34 151.26l.08-.08a.3.3 0 00-.08.08z"
            style={{
              WebkitTransformOrigin: 187.38,
              MsTransformOrigin: 187.38,
              transformOrigin: 187.38,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M188 151.4s0-.08-.07-.1v.1z"
            style={{
              WebkitTransformOrigin: 187.965,
              MsTransformOrigin: 187.965,
              transformOrigin: 187.965,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M188 151.41z"
            style={{
              WebkitTransformOrigin: 188,
              MsTransformOrigin: 188,
              transformOrigin: 188,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M188 151.4s0 .02 0 0z"
            style={{
              WebkitTransformOrigin: 188,
              MsTransformOrigin: 188,
              transformOrigin: 188,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M188.39 151.53c-.06.06-.17.13-.06.22.04-.08-.03-.13.06-.22z"
            style={{
              WebkitTransformOrigin: 188.337,
              MsTransformOrigin: 188.337,
              transformOrigin: 188.337,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M188 151.54h.1a.12.12 0 010-.1z"
            style={{
              WebkitTransformOrigin: 188.05,
              MsTransformOrigin: 188.05,
              transformOrigin: 188.05,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 188.015,
              MsTransformOrigin: 188.015,
              transformOrigin: 188.015,
            }}
            fill="#FFF"
            d="M187.99 151.57L188.04 151.54 188 151.53 187.99 151.57z"
            className="animable"
          ></path>
          <path
            d="M187.51 151.36a.2.2 0 01-.14.06.47.47 0 00.17 0s.03-.06-.03-.06z"
            style={{
              WebkitTransformOrigin: 187.459,
              MsTransformOrigin: 187.459,
              transformOrigin: 187.459,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M187.72 151.39s0 .02 0 0z"
            style={{
              WebkitTransformOrigin: 187.72,
              MsTransformOrigin: 187.72,
              transformOrigin: 187.72,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M186.84 151.42z"
            style={{
              WebkitTransformOrigin: 186.84,
              MsTransformOrigin: 186.84,
              transformOrigin: 186.84,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M187.55 151.47a.07.07 0 00.09 0h-.1s-.01.01.01 0z"
            style={{
              WebkitTransformOrigin: 187.589,
              MsTransformOrigin: 187.589,
              transformOrigin: 187.589,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M187.19 151.31a.21.21 0 00.08.06s-.07-.08-.08-.06z"
            style={{
              WebkitTransformOrigin: 187.23,
              MsTransformOrigin: 187.23,
              transformOrigin: 187.23,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M187.7 151.37l-.06.07h.07s-.01-.06-.01-.07z"
            style={{
              WebkitTransformOrigin: 187.675,
              MsTransformOrigin: 187.675,
              transformOrigin: 187.675,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M186.69 152.11a.12.12 0 01.21-.09c.1-.07 0-.4-.05-.58 0 0 0 .08-.1.14s.22.13.14.22-.11 0-.17-.09c.05.12-.17.18-.14.36l.11-.06s-.04.07 0 .1z"
            style={{
              WebkitTransformOrigin: 186.76,
              MsTransformOrigin: 186.76,
              transformOrigin: 186.76,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M187 151.45c-.05 0-.08-.06-.14-.14a.2.2 0 00-.09.12h.2z"
            style={{
              WebkitTransformOrigin: 186.885,
              MsTransformOrigin: 186.885,
              transformOrigin: 186.885,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M187.26 151.44c0 .11-.13.15-.07.27s.09-.09.16-.14c-.19 0 .05-.06-.09-.12h.11-.1l-.19.06z"
            style={{
              WebkitTransformOrigin: 187.225,
              MsTransformOrigin: 187.225,
              transformOrigin: 187.225,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M188.23 152s-.03 0 0 0z"
            style={{
              WebkitTransformOrigin: 188.223,
              MsTransformOrigin: 188.223,
              transformOrigin: 188.223,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M188.15 151.91h.07c.07 0 0 0 0 .08s.09-.07 0-.13c-.08 0-.18-.17-.17-.19a.64.64 0 00.1.24z"
            style={{
              WebkitTransformOrigin: 188.155,
              MsTransformOrigin: 188.155,
              transformOrigin: 188.155,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M187.7 151.7l-.16.06.08.09v-.06c.09.03.07-.04.08-.09z"
            style={{
              WebkitTransformOrigin: 187.62,
              MsTransformOrigin: 187.62,
              transformOrigin: 187.62,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 186.8,
              MsTransformOrigin: 186.8,
              transformOrigin: 186.8,
            }}
            fill="#FFF"
            d="M186.83 151.37L186.85 151.25 186.75 151.41 186.83 151.37z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 186.6,
              MsTransformOrigin: 186.6,
              transformOrigin: 186.6,
            }}
            fill="#FFF"
            d="M186.62 151.38L186.63 151.28 186.57 151.34 186.62 151.38z"
            className="animable"
          ></path>
          <path
            d="M174.89 152.61z"
            style={{
              WebkitTransformOrigin: 174.89,
              MsTransformOrigin: 174.89,
              transformOrigin: 174.89,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M175.23 152.62v-.05s-.01.04 0 .05z"
            style={{
              WebkitTransformOrigin: 175.228,
              MsTransformOrigin: 175.228,
              transformOrigin: 175.228,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M181.52 151.39c-.07-.09-.15-.23-.14-.12v.11a.13.13 0 01.14.01z"
            style={{
              WebkitTransformOrigin: 181.45,
              MsTransformOrigin: 181.45,
              transformOrigin: 181.45,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M178 152s0-.07.05-.1z"
            style={{
              WebkitTransformOrigin: 178.025,
              MsTransformOrigin: 178.025,
              transformOrigin: 178.025,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M178 152.49l-.09-.07a.35.35 0 00.09.07z"
            style={{
              WebkitTransformOrigin: 177.955,
              MsTransformOrigin: 177.955,
              transformOrigin: 177.955,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M173 152.72l-.06.11c.13 0 .06-.05.06-.11z"
            style={{
              WebkitTransformOrigin: 172.979,
              MsTransformOrigin: 172.979,
              transformOrigin: 172.979,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M184.49 151.42a.29.29 0 00-.15-.06c.07.06.13.15.15.06z"
            style={{
              WebkitTransformOrigin: 184.415,
              MsTransformOrigin: 184.415,
              transformOrigin: 184.415,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M175 151.46a.07.07 0 000 .06.06.06 0 000-.06z"
            style={{
              WebkitTransformOrigin: 175.001,
              MsTransformOrigin: 175.001,
              transformOrigin: 175.001,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M184.17 151.36a.23.23 0 01.14 0c-.02-.05-.08-.08-.14 0z"
            style={{
              WebkitTransformOrigin: 184.24,
              MsTransformOrigin: 184.24,
              transformOrigin: 184.24,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M166.3 152.63s-.01.01 0 0z"
            style={{
              WebkitTransformOrigin: 166.298,
              MsTransformOrigin: 166.298,
              transformOrigin: 166.298,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M164.34 151.54h.08s-.04-.02-.08 0z"
            style={{
              WebkitTransformOrigin: 164.38,
              MsTransformOrigin: 164.38,
              transformOrigin: 164.38,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M185.78 151.33c.05 0 0 0 0 0z"
            style={{
              WebkitTransformOrigin: 185.791,
              MsTransformOrigin: 185.791,
              transformOrigin: 185.791,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M186 151.76a.11.11 0 000 .06.08.08 0 010-.06z"
            style={{
              WebkitTransformOrigin: 185.997,
              MsTransformOrigin: 185.997,
              transformOrigin: 185.997,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M185.85 151.38h-.06z"
            style={{
              WebkitTransformOrigin: 185.82,
              MsTransformOrigin: 185.82,
              transformOrigin: 185.82,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M185.84 151.33s.04-.02 0 0z"
            style={{
              WebkitTransformOrigin: 185.849,
              MsTransformOrigin: 185.849,
              transformOrigin: 185.849,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M185.72 151.34h.07z"
            style={{
              WebkitTransformOrigin: 185.755,
              MsTransformOrigin: 185.755,
              transformOrigin: 185.755,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M169.91 152.34s-.03.03 0 0z"
            style={{
              WebkitTransformOrigin: 169.903,
              MsTransformOrigin: 169.903,
              transformOrigin: 169.903,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 180.37,
              MsTransformOrigin: 180.37,
              transformOrigin: 180.37,
            }}
            fill="#FFF"
            d="M180.37 152.52L180.37 152.51 180.37 152.51 180.37 152.52z"
            className="animable"
          ></path>
          <path
            d="M180.21 152.6c.07-.14.11-.12.16-.09l-.06-.31z"
            style={{
              WebkitTransformOrigin: 180.29,
              MsTransformOrigin: 180.29,
              transformOrigin: 180.29,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M174.08 152.64l.11.1c-.13.16-.23.1-.13.24 0-.34.44 0 .45-.37l.07.07c.14.16.11-.25.29-.2s.11.08.06.12l.15-.09v.06h.21a.61.61 0 01.14-.17c.05 0 0 0 0 .07l.12-.08a.12.12 0 01-.13.16c.11.34.1-.08.34.12h-.11c.07.19.16.12.29.24 0-.06-.26-.3-.13-.39s.09 0 .16 0c0 .12.07.09.16.09v.16c.09-.05.09-.13.14-.2s.13.14.15.24-.12-.2.08-.23.24 0 .4-.1c.1.06 0 .1 0 .15l.09-.13v.06c0 .06 0-.16.12-.2s.23.26.37.06v.16a1.12 1.12 0 00.33-.28l.13.11c-.1-.12 0-.26.14-.38a.6.6 0 00-.08-.13l.17-.09v.15c.06.06 0 .15 0 .24l-.06-.1a.69.69 0 00-.07.3.1.1 0 01.05 0v.06c0 .06 0 0 .05-.06v.18-.07l.24.11c.16-.18.3-.44.57-.51-.07.13 0 .21 0 .36-.07-.16-.2.07-.34 0a.08.08 0 010 .12l.24-.15c0 .13 0 .09.12.15-.05-.25.18-.17.28-.25 0 .09 0 .17-.14.15.13.19.17-.29.3-.13h-.06c-.06 0 .24 0 .2.06.2 0 .6 0 .63-.21v.3l.35-.72c0 .19.09.62-.08.72a.18.18 0 00.21 0s-.08-.27 0-.29c.12.21.08.11.23.29-.05 0 0-.33.08-.32s0 .28 0 .31l.19-.28c-.05.05 0 .24 0 .32s.16 0 .21 0l-.08-.07c.21 0 .21-.39.42-.38 0 .06-.06.36.05.39 0-.14.21-.69.4-.8v.08l.15-.09a5 5 0 01-.48.85c.08.06 0 .1.14.09s-.06.12-.1.12h.28c0-.17.21-.17.2-.31l-.3.18c0-.17.17-.48.37-.45v.35c0 .05.18-.11.2-.07l-.08.09c.11.07.17-.22.31-.06 0 0 .13.22.14.12a2.28 2.28 0 010-.93 1.21 1.21 0 01.29.28c.07.15-.11.36 0 .48a.23.23 0 01.06-.12c.05 0 0 .15.08.13s.21 0 .05-.15c.1-.05.11 0 .23 0a.48.48 0 01.21-.42.22.22 0 000 .12c.21 0 .32.09.51.1 0 0 .11.09.07.16s.06-.09.12-.09c.11.15-.14 0-.05.2 0-.1.16-.14.24-.2s-.19 0-.28 0a.63.63 0 01.35-.53c.16 0 .07.14.1.11.3 0 .25-.37.5-.22.1.14 0 .27 0 .37s-.2-.09-.29-.08l.11.06a.14.14 0 01-.18 0c.09.12.51 0 .74.13 0 0 .12-.09.08-.14h-.07c-.07-.11.14-.15 0-.2.1-.08.21-.2.35-.14v.16c0-.05-.09-.1-.13-.05s.21.21.27 0l-.09-.11c.09-.07.22-.24.34-.19-.06-.15 0 0-.12-.16.08.22-.31 0-.19.22-.09-.2-.15-.08-.27-.26 0 0 0 .1-.06.07a.22.22 0 010 .08c0 .11-.22.11-.27.17s0-.06 0-.11l-.08.09c0-.11-.17-.19 0-.25h-.13a.22.22 0 00-.25 0c-.06 0-.15.12-.1 0l-.2.07c-.2 0-.42.18-.65 0a.32.32 0 01-.25 0v-.09c-.09 0-.26-.1-.3 0-.09-.26-.42-.06-.57-.1v.12a.93.93 0 00-.33.08v.11c-.12.1-.29-.07-.47-.06 0-.05.06 0 .09 0-.22-.25-.45.19-.64 0a.08.08 0 01-.12 0l-.06-.06v.06a.37.37 0 00-.15.05v-.12c-.06 0 0 .06 0 .15a.23.23 0 00-.07.07c0-.19-.14.07-.2-.14 0 .1-.28.07-.31.29v-.05c0-.05-.12 0-.18 0v-.16l-.14.21c-.08-.09-.11-.15 0-.27-.2.18-.16.07-.33.25v-.1c-.06 0-.15.14-.19.06s-.65 0-1-.2c.07.29-.15-.13-.17.09 0-.07-.06-.11 0-.17-.17.07-.26-.11-.38.08v-.14c0-.04-.06.06-.07 0s0-.06.05-.09c-.18 0-.2.23-.21.43-.09-.1-.13-.08-.2.05 0-.07-.08-.14 0-.16-.07 0-.38-.1-.39.06h-.1a1.41 1.41 0 00-.29 0c-.06.19-.12 0-.23.06-.26-.13-.11.07-.36-.09v.12c0 .26-.22-.15-.36-.05l.05.07c-.08.09-.22-.35-.3-.39s0 0 .05 0c-.21-.15 0 .16-.18.2s0-.22-.07-.24-.3.28-.45.12c0 .06.07.13 0 .18s-.3-.25-.4-.05-.28.09-.33.2c-.08-.41-.52.21-.52-.18h-.26a.27.27 0 00-.29.16v-.08c-.24-.08-.27-.06-.47.13v-.12c-.06.07-.35-.2-.59-.05a.09.09 0 010-.06c-.27.15-.64-.34-.74.11l-.18.11c.23 0 0 .2.06.27-.09 0-.23-.14-.12-.16 0-.23-.29-.08-.28-.24-.45 0-.89-.12-1.31-.13l.05.18h-.15s-.05-.14.06-.13c-.06-.11-.18.09-.18.13-.21-.08.08-.22 0-.22h-.08c-.07.08-.08.16-.2.15s0-.12-.07-.12h-.24l.08.14c-.09.07-.18 0-.09.16-.13-.26-.69-.09-.77-.17a.45.45 0 01-.37.09s.06.19-.06.17c0-.33-.22-.14-.32-.38.09.15-.35 0-.21.26-.1 0 0-.12-.08-.2-.24.13-.53-.09-.83 0 0 0 .05.11 0 .17l-.15-.22c-.06 0-.06.26-.17.1v.11c-.58-.21-1.19.18-1.78-.23.08.09 0 .1 0 .1v.17l-.25-.17c-.05.17-.27 0-.29.17h.07c-.1.19.15.42.14.66.11-.21.3.31.49 0v.13c0-.1.11-.12.22-.08a2.52 2.52 0 01.78.14v-.12a.24.24 0 01.12.09c.09-.18-.21 0-.13-.21.1.24.52 0 .59.28.11 0 0-.14.08-.14v.08-.1a.18.18 0 01.11.17H166.62h-.1c.31-.07.68 0 1-.13v-.05c.23-.1.18.06.43 0a.21.21 0 01.19-.08c-.06.06.12.13 0 .2.25-.11.13-.09.29-.3v.1c0-.09.06-.13.18-.16-.1.08.08.14 0 .25.26.2.39-.21.51.09.12-.26-.23-.14-.16-.2s.1-.19.18-.16.14.33.35.32.16-.09.25 0c.06-.16.13 0 .14-.19h-.19c.11 0 .21-.28.39-.17a.28.28 0 01-.1.12c.05.06.1 0 .16 0s-.24 0-.36.2c.06.08.23-.14.17.07.08-.27.2 0 .35-.17v.11s.07-.07.11-.07l-.08.16c.12-.13.23.11.34 0-.23 0-.05-.14-.15-.23.28-.16.16.31.48.25 0 0-.16-.07-.09-.12a.38.38 0 01.18.13c.21 0 0-.12.05-.19.08.14.11-.06.2-.11v.12c.25.08.07-.25.29-.16l-.1.17h.12v.13c.13-.1.17-.07.29 0a.17.17 0 01.12-.23c.07.08 0 .12.11.1 0 .08-.07.17-.14.06a.56.56 0 010 .12c.08.08.2 0 .25 0l.22-.17v.12c0 .04.07-.07.14-.08s0 .2-.11.24l.21-.11c0 .05.11.12.08.16.12.05.29-.19.44-.12a.1.1 0 01.06 0c.14 0 .27.14.44 0l.1.17c.14 0-.13-.22.09-.28s.06.15.12.2.21-.27.36-.13c-.27.14-.31.12-.35.13zm1.66-.08s-.1.11-.12 0 .07-.04.12 0zm2.53-.29h-.11a.12.12 0 01.11 0zm7-.84c-.05-.04-.02-.02.03 0zm.15 0h-.09c-.04 0 .07.08.12.05zm-16 .05c-.02.12 0 .09.02.05z"
            style={{
              WebkitTransformOrigin: 175.26,
              MsTransformOrigin: 175.26,
              transformOrigin: 175.26,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M178 152.44a.17.17 0 010-.07v.07z"
            style={{
              WebkitTransformOrigin: 177.998,
              MsTransformOrigin: 177.998,
              transformOrigin: 177.998,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M173.05 152.7z"
            style={{
              WebkitTransformOrigin: 173.05,
              MsTransformOrigin: 173.05,
              transformOrigin: 173.05,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M183.14 152.51a.13.13 0 01-.06-.07.06.06 0 00.06.07z"
            style={{
              WebkitTransformOrigin: 183.11,
              MsTransformOrigin: 183.11,
              transformOrigin: 183.11,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M186.24 151.28h-.1H186.24z"
            style={{
              WebkitTransformOrigin: 186.19,
              MsTransformOrigin: 186.19,
              transformOrigin: 186.19,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M187.07 152c-.02 0-.07 0 0 0z"
            style={{
              WebkitTransformOrigin: 187.052,
              MsTransformOrigin: 187.052,
              transformOrigin: 187.052,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M186.33 151.68c0 .1.06.07.13 0 .01-.09-.06-.05-.13 0z"
            style={{
              WebkitTransformOrigin: 186.395,
              MsTransformOrigin: 186.395,
              transformOrigin: 186.395,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M186.48 151.73h.06c.01-.06-.03-.02-.06 0z"
            style={{
              WebkitTransformOrigin: 186.511,
              MsTransformOrigin: 186.511,
              transformOrigin: 186.511,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M185.64 151.42v-.09c.07-.13-.18.16 0 .09z"
            style={{
              WebkitTransformOrigin: 185.613,
              MsTransformOrigin: 185.613,
              transformOrigin: 185.613,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 186.35,
              MsTransformOrigin: 186.35,
              transformOrigin: 186.35,
            }}
            fill="#FFF"
            d="M186.38 152.01L186.36 151.89 186.32 151.99 186.38 152.01z"
            className="animable"
          ></path>
          <path
            d="M185.85 151.92h.11a.05.05 0 010-.05c-.04.04-.11.02-.11.05z"
            style={{
              WebkitTransformOrigin: 185.905,
              MsTransformOrigin: 185.905,
              transformOrigin: 185.905,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M186 151.91a.08.08 0 00.08 0z"
            style={{
              WebkitTransformOrigin: 186.04,
              MsTransformOrigin: 186.04,
              transformOrigin: 186.04,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 186.18,
              MsTransformOrigin: 186.18,
              transformOrigin: 186.18,
            }}
            fill="#FFF"
            d="M186.23 152.05L186.2 152.03 186.13 152.02 186.23 152.05z"
            className="animable"
          ></path>
          <path
            d="M184.7 151.9h-.11s0 .07.06.06.07-.02.05-.06z"
            style={{
              WebkitTransformOrigin: 184.65,
              MsTransformOrigin: 184.65,
              transformOrigin: 184.65,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M185.06 152.24s0-.05-.06-.09v.15z"
            style={{
              WebkitTransformOrigin: 185.03,
              MsTransformOrigin: 185.03,
              transformOrigin: 185.03,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M184.72 152.28s-.17.12 0 .11.1-.08 0-.11z"
            style={{
              WebkitTransformOrigin: 184.734,
              MsTransformOrigin: 184.734,
              transformOrigin: 184.734,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 182.975,
              MsTransformOrigin: 182.975,
              transformOrigin: 182.975,
            }}
            fill="#FFF"
            d="M182.96 152.08L182.99 152.08 182.98 151.82 182.96 152.08z"
            className="animable"
          ></path>
          <path
            d="M181.41 152.69c.14.06 0-.16.16-.08s-.11-.06-.07-.11-.13.02-.09.19z"
            style={{
              WebkitTransformOrigin: 181.513,
              MsTransformOrigin: 181.513,
              transformOrigin: 181.513,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M181.5 152.5z"
            style={{
              WebkitTransformOrigin: 181.5,
              MsTransformOrigin: 181.5,
              transformOrigin: 181.5,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 163.965,
              MsTransformOrigin: 163.965,
              transformOrigin: 163.965,
            }}
            fill="#FFF"
            d="M164.01 151.4L163.92 151.35 163.98 151.44 164.01 151.4z"
            className="animable"
          ></path>
          <path
            d="M163.84 151.59v-.16.15s-.01-.02 0 .01z"
            style={{
              WebkitTransformOrigin: 163.838,
              MsTransformOrigin: 163.838,
              transformOrigin: 163.838,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M176 152.89h-.07z"
            style={{
              WebkitTransformOrigin: 175.965,
              MsTransformOrigin: 175.965,
              transformOrigin: 175.965,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 174.78,
              MsTransformOrigin: 174.78,
              transformOrigin: 174.78,
            }}
            fill="#FFF"
            d="M174.78 152.77L174.8 152.77 174.76 152.62 174.78 152.77z"
            className="animable"
          ></path>
          <path
            d="M173.77 153h.13c.04 0-.14-.23-.13 0z"
            style={{
              WebkitTransformOrigin: 173.838,
              MsTransformOrigin: 173.838,
              transformOrigin: 173.838,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M222.91 164.22c.09 0 .06-.09.07-.11-.15.02-.07.14-.07.11z"
            style={{
              WebkitTransformOrigin: 222.934,
              MsTransformOrigin: 222.934,
              transformOrigin: 222.934,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 221.385,
              MsTransformOrigin: 221.385,
              transformOrigin: 221.385,
            }}
            fill="#FFF"
            d="M221.47 164.46L221.49 164.42 221.28 164.52 221.47 164.46z"
            className="animable"
          ></path>
          <path
            d="M220.12 164.46c.12.18.49 0 .73 0l.1-.14a4 4 0 01-.83.14z"
            style={{
              WebkitTransformOrigin: 220.535,
              MsTransformOrigin: 220.535,
              transformOrigin: 220.535,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M219.4 164.07c0 .07-.16.06.17 0h-.17z"
            style={{
              WebkitTransformOrigin: 219.466,
              MsTransformOrigin: 219.466,
              transformOrigin: 219.466,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M219.54 164.08c.14 0-.1-.06 0 0z"
            style={{
              WebkitTransformOrigin: 219.55,
              MsTransformOrigin: 219.55,
              transformOrigin: 219.55,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M218.88 164.12l.19-.07s-.21-.05-.15-.08c-.19.03-.15.08-.04.15z"
            style={{
              WebkitTransformOrigin: 218.929,
              MsTransformOrigin: 218.929,
              transformOrigin: 218.929,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M218.7 164.25h.1s-.04-.05-.1 0z"
            style={{
              WebkitTransformOrigin: 218.75,
              MsTransformOrigin: 218.75,
              transformOrigin: 218.75,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M219 164.16l-.2.06s0 .09.09 0c-.01.03.03-.02.11-.06z"
            style={{
              WebkitTransformOrigin: 218.9,
              MsTransformOrigin: 218.9,
              transformOrigin: 218.9,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M219.12 164.19c.11 0 .24.07 0 .13.41-.03.36-.15 0-.13z"
            style={{
              WebkitTransformOrigin: 219.265,
              MsTransformOrigin: 219.265,
              transformOrigin: 219.265,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M220.05 164.64l.14.06.12-.06c-.06.02-.31-.05-.26 0z"
            style={{
              WebkitTransformOrigin: 220.177,
              MsTransformOrigin: 220.177,
              transformOrigin: 220.177,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M217.71 164s.07.11.08.15h.14c-.07-.05-.21-.07-.22-.15z"
            style={{
              WebkitTransformOrigin: 217.82,
              MsTransformOrigin: 217.82,
              transformOrigin: 217.82,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M217.79 164.17l-.21.07c.19.01.22-.02.21-.07z"
            style={{
              WebkitTransformOrigin: 217.686,
              MsTransformOrigin: 217.686,
              transformOrigin: 217.686,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 218.805,
              MsTransformOrigin: 218.805,
              transformOrigin: 218.805,
            }}
            fill="#FFF"
            d="M218.67 164.44L219.01 164.31 218.6 164.45 218.67 164.44z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 216.935,
              MsTransformOrigin: 216.935,
              transformOrigin: 216.935,
            }}
            fill="#FFF"
            d="M216.92 164.02L217.04 163.93 216.83 164.06 216.92 164.02z"
            className="animable"
          ></path>
          <path
            d="M216.4 164c.09-.07-.12-.12 0-.16a.91.91 0 00-.37.13.63.63 0 01.37.03z"
            style={{
              WebkitTransformOrigin: 216.227,
              MsTransformOrigin: 216.227,
              transformOrigin: 216.227,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M215.81 164.08l.19-.08a1 1 0 00-.19.08z"
            style={{
              WebkitTransformOrigin: 215.905,
              MsTransformOrigin: 215.905,
              transformOrigin: 215.905,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M217.23 164.22a.28.28 0 00-.16-.11l.08.11z"
            style={{
              WebkitTransformOrigin: 217.15,
              MsTransformOrigin: 217.15,
              transformOrigin: 217.15,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M217.25 164.22z"
            style={{
              WebkitTransformOrigin: 217.25,
              MsTransformOrigin: 217.25,
              transformOrigin: 217.25,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M218.13 164.35c-.13.06-.38.12-.13.21.08-.07-.06-.12.13-.21z"
            style={{
              WebkitTransformOrigin: 218.012,
              MsTransformOrigin: 218.012,
              transformOrigin: 218.012,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M217.35 164.35h.22v-.1z"
            style={{
              WebkitTransformOrigin: 217.46,
              MsTransformOrigin: 217.46,
              transformOrigin: 217.46,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 217.295,
              MsTransformOrigin: 217.295,
              transformOrigin: 217.295,
            }}
            fill="#FFF"
            d="M217.24 164.39L217.35 164.35 217.27 164.34 217.24 164.39z"
            className="animable"
          ></path>
          <path
            d="M216.19 164.18a.79.79 0 01-.32.06h.38s.08-.06-.06-.06z"
            style={{
              WebkitTransformOrigin: 216.071,
              MsTransformOrigin: 216.071,
              transformOrigin: 216.071,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M216.66 164.21s0 .02 0 0z"
            style={{
              WebkitTransformOrigin: 216.66,
              MsTransformOrigin: 216.66,
              transformOrigin: 216.66,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M214.72 164.24z"
            style={{
              WebkitTransformOrigin: 214.72,
              MsTransformOrigin: 214.72,
              transformOrigin: 214.72,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M216.27 164.29a.27.27 0 00.21 0h-.23s-.01.01.02 0z"
            style={{
              WebkitTransformOrigin: 216.364,
              MsTransformOrigin: 216.364,
              transformOrigin: 216.364,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M215.49 164.13l.17.06s-.15-.09-.17-.06z"
            style={{
              WebkitTransformOrigin: 215.575,
              MsTransformOrigin: 215.575,
              transformOrigin: 215.575,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M216.6 164.19s-.01-.02 0 0z"
            style={{
              WebkitTransformOrigin: 216.598,
              MsTransformOrigin: 216.598,
              transformOrigin: 216.598,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M216.6 164.19l-.12.06h.16z"
            style={{
              WebkitTransformOrigin: 216.56,
              MsTransformOrigin: 216.56,
              transformOrigin: 216.56,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M214.37 164.92c0-.1.27-.19.48-.08.21-.08.07-.4-.11-.58 0 0 0 .08-.23.14.08 0 .49.12.3.21s-.23 0-.37-.08c.12.12-.37.18-.31.36l.26-.07s-.09.08-.02.1z"
            style={{
              WebkitTransformOrigin: 214.54,
              MsTransformOrigin: 214.54,
              transformOrigin: 214.54,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M215.15 164.27h.09a.76.76 0 01-.31-.13c-.15 0-.18.09-.19.12h.44z"
            style={{
              WebkitTransformOrigin: 214.99,
              MsTransformOrigin: 214.99,
              transformOrigin: 214.99,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M215.64 164.25c-.07.11-.28.16-.15.27s.18-.09.34-.13c-.42 0 .12-.06-.18-.12h.22l-.21-.05c-.12 0 0 0 0 0l-.43.05a1.28 1.28 0 00.41-.02z"
            style={{
              WebkitTransformOrigin: 215.55,
              MsTransformOrigin: 215.55,
              transformOrigin: 215.55,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M217.77 164.79s-.05 0 0 0z"
            style={{
              WebkitTransformOrigin: 217.759,
              MsTransformOrigin: 217.759,
              transformOrigin: 217.759,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M217.6 164.73a.16.16 0 01.15 0c.09 0 0 0 0 .09s.21-.08 0-.13c-.17 0-.39-.17-.36-.18a.69.69 0 00.21.22z"
            style={{
              WebkitTransformOrigin: 217.615,
              MsTransformOrigin: 217.615,
              transformOrigin: 217.615,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M216.61 164.52h-.36l.18.1v-.06c.2.07.15 0 .18-.04z"
            style={{
              WebkitTransformOrigin: 216.43,
              MsTransformOrigin: 216.43,
              transformOrigin: 216.43,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 214.625,
              MsTransformOrigin: 214.625,
              transformOrigin: 214.625,
            }}
            fill="#FFF"
            d="M214.68 164.18L214.73 164.07 214.52 164.23 214.68 164.18z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 214.18,
              MsTransformOrigin: 214.18,
              transformOrigin: 214.18,
            }}
            fill="#FFF"
            d="M214.22 164.2L214.24 164.1 214.12 164.16 214.22 164.2z"
            className="animable"
          ></path>
          <path
            d="M188.33 165.42h-.1z"
            style={{
              WebkitTransformOrigin: 188.28,
              MsTransformOrigin: 188.28,
              transformOrigin: 188.28,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M189.09 165.43v-.05s-.03.05 0 .05z"
            style={{
              WebkitTransformOrigin: 189.083,
              MsTransformOrigin: 189.083,
              transformOrigin: 189.083,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M203 164.21c-.15-.09-.32-.24-.3-.13v.11a.48.48 0 01.3.02z"
            style={{
              WebkitTransformOrigin: 202.849,
              MsTransformOrigin: 202.849,
              transformOrigin: 202.849,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M195.24 164.86l.11-.1z"
            style={{
              WebkitTransformOrigin: 195.295,
              MsTransformOrigin: 195.295,
              transformOrigin: 195.295,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M195.13 165.3l-.2-.07a.66.66 0 00.2.07z"
            style={{
              WebkitTransformOrigin: 195.03,
              MsTransformOrigin: 195.03,
              transformOrigin: 195.03,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M184.23 165.54l-.12.11c.19 0 .11-.06.12-.11z"
            style={{
              WebkitTransformOrigin: 184.174,
              MsTransformOrigin: 184.174,
              transformOrigin: 184.174,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M209.52 164.24a1.16 1.16 0 00-.32-.07c.15.06.28.16.32.07z"
            style={{
              WebkitTransformOrigin: 209.36,
              MsTransformOrigin: 209.36,
              transformOrigin: 209.36,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M188.63 164.27c-.06 0-.09 0-.09.07s.1-.04.09-.07z"
            style={{
              WebkitTransformOrigin: 188.585,
              MsTransformOrigin: 188.585,
              transformOrigin: 188.585,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M208.82 164.17h.07a1 1 0 01.31 0 .46.46 0 00-.38 0z"
            style={{
              WebkitTransformOrigin: 209.01,
              MsTransformOrigin: 209.01,
              transformOrigin: 209.01,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M169.36 165.45s-.02 0 0 0z"
            style={{
              WebkitTransformOrigin: 169.356,
              MsTransformOrigin: 169.356,
              transformOrigin: 169.356,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M165 164.36h.17a.34.34 0 00-.17 0z"
            style={{
              WebkitTransformOrigin: 165.085,
              MsTransformOrigin: 165.085,
              transformOrigin: 165.085,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M212.38 164.15c.09 0 0 0 0 0z"
            style={{
              WebkitTransformOrigin: 212.4,
              MsTransformOrigin: 212.4,
              transformOrigin: 212.4,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M212.85 164.58z"
            style={{
              WebkitTransformOrigin: 212.85,
              MsTransformOrigin: 212.85,
              transformOrigin: 212.85,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M207.85 164.85s.02.01 0 0z"
            style={{
              WebkitTransformOrigin: 207.854,
              MsTransformOrigin: 207.854,
              transformOrigin: 207.854,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M212.52 164.2h-.12z"
            style={{
              WebkitTransformOrigin: 212.46,
              MsTransformOrigin: 212.46,
              transformOrigin: 212.46,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M212.5 164.15h.09s0-.02-.09 0z"
            style={{
              WebkitTransformOrigin: 212.545,
              MsTransformOrigin: 212.545,
              transformOrigin: 212.545,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M212.24 164.16a.42.42 0 01.16 0z"
            style={{
              WebkitTransformOrigin: 212.32,
              MsTransformOrigin: 212.32,
              transformOrigin: 212.32,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M177.33 165.16c-.12.03-.08.03 0 0z"
            style={{
              WebkitTransformOrigin: 177.292,
              MsTransformOrigin: 177.292,
              transformOrigin: 177.292,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M200.42 165.33z"
            style={{
              WebkitTransformOrigin: 200.42,
              MsTransformOrigin: 200.42,
              transformOrigin: 200.42,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M200.07 165.42a.3.3 0 01.35-.09l-.12-.32z"
            style={{
              WebkitTransformOrigin: 200.245,
              MsTransformOrigin: 200.245,
              transformOrigin: 200.245,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M186.54 165.46l.24.09c-.29.16-.51.11-.28.25 0-.34 1 0 1-.38l.16.07h-.1c.32.16.24-.25.64-.2.14 0 .24.07.14.11l.32-.08c.09 0 .07.07 0 .06h.48c.07 0 .23-.13.3-.17s-.06 0 0 .08l.27-.08c.11.09-.11.17-.3.16.25.34.22-.09.76.11h-.25c.16.2.36.13.64.25-.07-.07-.57-.3-.28-.39a.45.45 0 00.35 0c0 .12.15.09.34.08v.16c.2 0 .19-.12.31-.2a.35.35 0 01.33.25c.36 0-.26-.2.18-.23a1.74 1.74 0 00.88-.1c.22.05 0 .1 0 .14l.19-.12c.05 0 0 0 0 .06.16 0 0-.16.27-.21.07-.17.51.26.82.06.08 0 0 .1 0 .16a2.64 2.64 0 00.72-.27l.29.1c-.22-.12.06-.26.31-.37l-.19-.14.39-.08c.05 0 0 .08-.05.15h.07c.14.06.06.15 0 .24l-.14-.1c-.09.1-.18.2-.16.3a.27.27 0 01.12-.05v.07c0 .02.06 0 .12-.06l.09.18v-.07l.51.11a3.65 3.65 0 011.27-.52c-.14.13 0 .22 0 .37-.16-.16-.45.07-.75 0 .16 0 .12.09.08.11l.54-.15c0 .13.11.1.25.15-.1-.25.4-.16.62-.24 0 .08 0 .17-.3.15.29.19.38-.3.67-.14h-.13c.15-.08.52 0 .44 0h-.07c.43 0 1.32 0 1.38-.22a1.22 1.22 0 01-.08.3l.77-.71c-.07.18.19.62-.17.72a.69.69 0 00.45 0c-.07 0-.17-.26-.08-.28.26.2.18.11.51.28-.11 0 0-.32.18-.31 0 0 0 .28-.05.31l.41-.28c-.1.05 0 .24.08.32s.36 0 .47 0l-.18-.06c.47 0 .46-.4.93-.38-.06.06-.14.35.09.39.11-.14.48-.69.89-.8l.08.08.31-.1a5.57 5.57 0 01-1 .85c.17.07.05.1.31.09.09.08-.14.12-.22.13l.61.05c0-.17.46-.17.44-.31l-.66.17c0-.17.38-.48.81-.45.11.07-.08.3-.07.36a.74.74 0 01.45-.07l-.18.09c.24.06.39-.22.68-.06.1 0 .3.21.31.11a1.12 1.12 0 01-.08-.92 4.1 4.1 0 01.64.27c.16.15-.25.36-.11.49 0 0 .1-.1.13-.12s0 .14.19.12c0-.17.46 0 .1-.14.23-.05.24 0 .5 0-.08-.12.24-.38.46-.43 0 .05 0 .1.06.13.46 0 .7.09 1.13.09 0 0 .24.09.16.17a.49.49 0 01.24-.1c.26.15-.29 0-.09.2 0-.1.33-.13.52-.19-.06-.16-.43 0-.62 0 0-.21.33-.43.77-.53s.16.13.22.1c.66 0 .56-.36 1.11-.21.22.13 0 .27.06.36-.29 0-.44-.08-.64-.08l.25.07a.66.66 0 01-.39 0c.18.12 1.12 0 1.63.13.09 0 .25-.09.17-.14h-.16c-.15-.1.31-.15.1-.2a1.44 1.44 0 01.77-.13l.06.15s-.2-.09-.29 0c.13-.07.47.2.61 0l-.21-.1a1.44 1.44 0 01.75-.19c-.12-.15-.06 0-.25-.16.17.22-.69 0-.43.22-.19-.21-.34-.09-.6-.26 0 0 .09.09-.13.07h-.05a.26.26 0 01.11.07c-.11.12-.47.12-.59.18s.05-.06 0-.12l-.18.09c0-.11-.36-.18 0-.25h-.29a.85.85 0 00-.54 0c-.14 0-.35.12-.23 0l-.45.07a3.58 3.58 0 01-1.42 0 1.53 1.53 0 01-.55 0l-.05-.1c-.19 0-.58-.1-.66 0-.21-.27-.93-.06-1.27-.11v.13a3.47 3.47 0 00-.74.08v.11c-.25.09-.64-.08-1-.07h.2c-.47-.26-1 .18-1.41 0a.38.38 0 01-.26 0l-.15-.06.13.06a1.47 1.47 0 00-.33 0l-.05-.12c-.12 0-.09.05 0 .14l-.16.08c-.1-.2-.32.06-.45-.15-.08.11-.61.08-.68.29a.68.68 0 00-.4 0v-.15l-.3.2c-.18-.09-.25-.14-.07-.26-.44.18-.35.07-.72.25v-.1c-.13 0-.34.13-.42.05-.3-.19-1.45 0-2.21-.2.15.29-.34-.13-.37.1-.05-.07-.15-.11 0-.17-.39.07-.58-.11-.84.08-.05-.07.08-.1 0-.14s-.12.06-.16 0 0-.06.11-.09c-.39 0-.43.22-.46.42a.33.33 0 00-.44.05c-.07-.06-.18-.13.06-.15-.14 0-.84-.1-.85.06h-.23a4.44 4.44 0 00-.63 0h.08c-.12.2-.25 0-.5.07-.56-.14-.24.07-.79-.09v.12c0 .26-.49-.15-.81-.06l.12.07c-.18.09-.49-.35-.67-.38h.12c-.46-.15-.06.15-.4.19-.07-.08.08-.21-.15-.23s-.67.27-1 .11c.07.07.14.13 0 .18s-.65-.24-.87 0h-.05a2.53 2.53 0 00-.72.2c-.17-.41-1.15.2-1.15-.18h-.57a.82.82 0 00-.62.16c-.09 0 0-.06 0-.08a1.34 1.34 0 00-1 .13l-.05-.13c-.12.07-.77-.19-1.3 0a.1.1 0 01.06-.05c-.59.14-1.41-.35-1.63.1l-.39.12c.5 0-.07.19.13.27-.2 0-.51-.14-.27-.16.09-.24-.62-.08-.61-.24-1 0-2-.12-2.89-.13l.11.18h-.32c-.09 0-.12-.14.11-.14-.12-.1-.39.09-.39.13-.45-.07.18-.21 0-.22h-.19c-.15.07-.17.15-.44.14s-.09-.11-.16-.12 0 0-.11 0h-.41l.17.15c-.19.07-.39 0-.2.15-.28-.25-1.52-.09-1.69-.17a1.71 1.71 0 01-.82.09c.08 0 .13.2-.14.18.1-.34-.49-.15-.71-.39.2.16-.76 0-.45.27-.23 0 0-.13-.18-.21a12.77 12.77 0 01-1.83 0c0 .05.1.11 0 .18l-.35-.22c-.13 0-.12.25-.35.1 0 0 .08.09 0 .11-1.28-.22-2.62.17-3.93-.23.18.09.06.09-.08.1.09 0 0 .11 0 .17l-.55-.17c-.1.17-.58 0-.64.17h.17c-.23.19.33.42.29.66.26-.22.68.31 1.1 0 .1 0-.08.07 0 .13a.49.49 0 01.48-.08 10.57 10.57 0 011.72.14v-.12a.79.79 0 01.27.08c.19-.18-.46 0-.29-.2.22.24 1.15 0 1.3.27.25 0-.08-.13.17-.13l.07.07.06-.09c.17 0 .25.1.26.17a.44.44 0 00-.16 0c.21.09.6 0 .67 0h-.24a19.5 19.5 0 002.18-.12l-.05-.06c.5-.1.4.07 1 0a1 1 0 01.41-.08c-.14.07.26.13.07.2.55-.11.28-.08.64-.29l.08.09a.57.57 0 01.41-.15c-.23.08.17.14-.08.25.58.2.86-.21 1.13.09.26-.26-.5-.14-.35-.2-.13-.08.22-.19.4-.17s.31.33.78.33h-.1c.18.07.34-.08.56 0 .12-.15.28 0 .31-.19l-.43.05c.24-.05.47-.28.87-.17a.7.7 0 01-.23.12c.12.06.22 0 .35 0 0 .2-.52 0-.78.2.12.08.49-.15.36.07.18-.28.46 0 .77-.18v.12a.68.68 0 01.25-.07l-.17.15c.25-.13.49.12.74.05-.52 0-.12-.15-.34-.23.64-.16.37.31 1.08.25-.1 0-.36-.07-.21-.13a1.06 1.06 0 01.39.14c.47 0-.07-.13.13-.2.16.15.23-.06.44-.1v.12c.53.07.14-.25.62-.16l-.2.17h.25l-.05.14a1 1 0 01.62 0c-.06-.08 0-.22.27-.22s-.09.12.25.1c-.08.07-.16.17-.31.06s-.07.07-.09.11a1.35 1.35 0 00.56 0 .5.5 0 01-.13 0l.49-.17c.07 0 0 .09 0 .12a3 3 0 01.32-.08c0 .1 0 .2-.24.25l.47-.11s.23.12.17.15c.26.06.63-.19 1-.11a.23.23 0 01.13-.05 2 2 0 001 0l.22.18c.3 0-.29-.22.2-.29s.13.15.26.2a.87.87 0 01.8-.12c-.64-.02-.72-.05-.82-.03zm3.66-.08c-.07 0-.21.1-.26 0s.14-.04.26 0zm5.58-.29h-.23a.49.49 0 01.23 0zm15.53-.84c-.17-.04-.11-.02 0 0zm.33.05v-.05c0-.05-.09 0-.18 0s.08.08.18.05zm-35.35 0h.06c-.14.11-.1.08-.06.05z"
            style={{
              WebkitTransformOrigin: 189.215,
              MsTransformOrigin: 189.215,
              transformOrigin: 189.215,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M195.15 165.25a.09.09 0 010-.06s-.06.04 0 .06z"
            style={{
              WebkitTransformOrigin: 195.137,
              MsTransformOrigin: 195.137,
              transformOrigin: 195.137,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M184.26 165.52z"
            style={{
              WebkitTransformOrigin: 184.26,
              MsTransformOrigin: 184.26,
              transformOrigin: 184.26,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M206.54 165.32a.22.22 0 01-.13-.06s.03.06.13.06z"
            style={{
              WebkitTransformOrigin: 206.475,
              MsTransformOrigin: 206.475,
              transformOrigin: 206.475,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M213.38 164.1h-.21a.32.32 0 01.19 0h.02z"
            style={{
              WebkitTransformOrigin: 213.275,
              MsTransformOrigin: 213.275,
              transformOrigin: 213.275,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M215.21 164.84h.1v-.06c-.14-.01-.23.04-.1.06z"
            style={{
              WebkitTransformOrigin: 215.229,
              MsTransformOrigin: 215.229,
              transformOrigin: 215.229,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M213.58 164.5c0 .1.15.06.29 0s-.14-.05-.29 0z"
            style={{
              WebkitTransformOrigin: 213.725,
              MsTransformOrigin: 213.725,
              transformOrigin: 213.725,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M213.91 164.54h.09c.06-.06 0-.01-.09 0z"
            style={{
              WebkitTransformOrigin: 213.967,
              MsTransformOrigin: 213.967,
              transformOrigin: 213.967,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M212.06 164.23c.07 0 0-.13.08-.09.08-.14-.47.16-.08.09z"
            style={{
              WebkitTransformOrigin: 212.033,
              MsTransformOrigin: 212.033,
              transformOrigin: 212.033,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 213.63,
              MsTransformOrigin: 213.63,
              transformOrigin: 213.63,
            }}
            fill="#FFF"
            d="M213.7 164.83L213.64 164.71 213.56 164.81 213.7 164.83z"
            className="animable"
          ></path>
          <path
            d="M212.53 164.74h.3c-.15-.01-.3-.04-.3 0z"
            style={{
              WebkitTransformOrigin: 212.68,
              MsTransformOrigin: 212.68,
              transformOrigin: 212.68,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M212.83 164.73a.5.5 0 00.19 0z"
            style={{
              WebkitTransformOrigin: 212.925,
              MsTransformOrigin: 212.925,
              transformOrigin: 212.925,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 213.255,
              MsTransformOrigin: 213.255,
              transformOrigin: 213.255,
            }}
            fill="#FFF"
            d="M213.37 164.87L213.3 164.84 213.14 164.83 213.37 164.87z"
            className="animable"
          ></path>
          <path
            d="M210 164.71h-.25s0 .07.14.05.11 0 .11-.05z"
            style={{
              WebkitTransformOrigin: 209.876,
              MsTransformOrigin: 209.876,
              transformOrigin: 209.876,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M210.77 165.06c-.07 0-.07-.06-.11-.1v.16z"
            style={{
              WebkitTransformOrigin: 210.715,
              MsTransformOrigin: 210.715,
              transformOrigin: 210.715,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M210 165.09s-.37.13-.05.12c.05-.05.31-.08.05-.12z"
            style={{
              WebkitTransformOrigin: 209.967,
              MsTransformOrigin: 209.967,
              transformOrigin: 209.967,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 206.175,
              MsTransformOrigin: 206.175,
              transformOrigin: 206.175,
            }}
            fill="#FFF"
            d="M206.14 164.9L206.21 164.9 206.2 164.64 206.14 164.9z"
            className="animable"
          ></path>
          <path
            d="M202.72 165.51c.31.06.07-.16.35-.08.07-.06-.23-.07-.15-.12-.19.06-.28.03-.2.2z"
            style={{
              WebkitTransformOrigin: 202.886,
              MsTransformOrigin: 202.886,
              transformOrigin: 202.886,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M202.92 165.31h.09z"
            style={{
              WebkitTransformOrigin: 202.965,
              MsTransformOrigin: 202.965,
              transformOrigin: 202.965,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 164.21,
              MsTransformOrigin: 164.21,
              transformOrigin: 164.21,
            }}
            fill="#FFF"
            d="M164.31 164.22L164.11 164.17 164.24 164.25 164.31 164.22z"
            className="animable"
          ></path>
          <path
            d="M163.93 164.41l-.05-.16-.11.14s.13-.02.16.02z"
            style={{
              WebkitTransformOrigin: 163.85,
              MsTransformOrigin: 163.85,
              transformOrigin: 163.85,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M190.75 165.71s-.07 0-.16-.06z"
            style={{
              WebkitTransformOrigin: 190.67,
              MsTransformOrigin: 190.67,
              transformOrigin: 190.67,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 188.09,
              MsTransformOrigin: 188.09,
              transformOrigin: 188.09,
            }}
            fill="#FFF"
            d="M188.09 165.58L188.13 165.59 188.05 165.44 188.09 165.58z"
            className="animable"
          ></path>
          <path
            d="M185.85 165.77h.29c-.2.01-.31-.18-.29 0z"
            style={{
              WebkitTransformOrigin: 185.994,
              MsTransformOrigin: 185.994,
              transformOrigin: 185.994,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M232.2 169.63c.1 0 .07-.1.08-.11-.17.02-.07.14-.08.11z"
            style={{
              WebkitTransformOrigin: 232.23,
              MsTransformOrigin: 232.23,
              transformOrigin: 232.23,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 230.435,
              MsTransformOrigin: 230.435,
              transformOrigin: 230.435,
            }}
            fill="#FFF"
            d="M230.53 169.87L230.56 169.82 230.31 169.93 230.53 169.87z"
            className="animable"
          ></path>
          <path
            d="M229 169.87c.15.17.57 0 .84 0h.05l.12-.14a5.36 5.36 0 01-1.01.14z"
            style={{
              WebkitTransformOrigin: 229.505,
              MsTransformOrigin: 229.505,
              transformOrigin: 229.505,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M228.14 169.48c.05.07-.18.06.19 0a.42.42 0 01-.19 0z"
            style={{
              WebkitTransformOrigin: 228.222,
              MsTransformOrigin: 228.222,
              transformOrigin: 228.222,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M228.3 169.48c.16 0-.11 0 0 0z"
            style={{
              WebkitTransformOrigin: 228.312,
              MsTransformOrigin: 228.312,
              transformOrigin: 228.312,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M227.54 169.52l.21-.06s-.23-.05-.16-.08c-.23.04-.18.08-.05.14z"
            style={{
              WebkitTransformOrigin: 227.59,
              MsTransformOrigin: 227.59,
              transformOrigin: 227.59,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M227.33 169.65h.11s-.05-.04-.11 0z"
            style={{
              WebkitTransformOrigin: 227.385,
              MsTransformOrigin: 227.385,
              transformOrigin: 227.385,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M227.68 169.57l-.24.06s0 .08.11 0 .03-.02.13-.06z"
            style={{
              WebkitTransformOrigin: 227.56,
              MsTransformOrigin: 227.56,
              transformOrigin: 227.56,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M227.82 169.6c.12 0 .27.06.06.13.41-.03.35-.15-.06-.13z"
            style={{
              WebkitTransformOrigin: 227.99,
              MsTransformOrigin: 227.99,
              transformOrigin: 227.99,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M228.89 170.05h.16l.14-.06c-.07.08-.31.01-.3.06z"
            style={{
              WebkitTransformOrigin: 229.04,
              MsTransformOrigin: 229.04,
              transformOrigin: 229.04,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M226.19 169.43s.07.1.09.15h.16c-.09-.07-.24-.09-.25-.15z"
            style={{
              WebkitTransformOrigin: 226.315,
              MsTransformOrigin: 226.315,
              transformOrigin: 226.315,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M226.28 169.58l-.24.07c.21 0 .25-.03.24-.07z"
            style={{
              WebkitTransformOrigin: 226.161,
              MsTransformOrigin: 226.161,
              transformOrigin: 226.161,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 227.455,
              MsTransformOrigin: 227.455,
              transformOrigin: 227.455,
            }}
            fill="#FFF"
            d="M227.29 169.85L227.69 169.72 227.22 169.85 227.29 169.85z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 225.29,
              MsTransformOrigin: 225.29,
              transformOrigin: 225.29,
            }}
            fill="#FFF"
            d="M225.27 169.43L225.41 169.34 225.17 169.47 225.27 169.43z"
            className="animable"
          ></path>
          <path
            d="M224.67 169.44c.1-.07-.14-.12 0-.17a1.42 1.42 0 00-.44.14.78.78 0 01.44.03z"
            style={{
              WebkitTransformOrigin: 224.463,
              MsTransformOrigin: 224.463,
              transformOrigin: 224.463,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M224 169.49l.21-.08a.6.6 0 00-.21.08z"
            style={{
              WebkitTransformOrigin: 224.105,
              MsTransformOrigin: 224.105,
              transformOrigin: 224.105,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M225.63 169.63a.32.32 0 00-.19-.11l.09.11z"
            style={{
              WebkitTransformOrigin: 225.535,
              MsTransformOrigin: 225.535,
              transformOrigin: 225.535,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M225.54 169.63z"
            style={{
              WebkitTransformOrigin: 225.54,
              MsTransformOrigin: 225.54,
              transformOrigin: 225.54,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M225.65 169.63z"
            style={{
              WebkitTransformOrigin: 225.65,
              MsTransformOrigin: 225.65,
              transformOrigin: 225.65,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M226.67 169.76c-.15.06-.44.12-.15.21.1-.07-.07-.12.15-.21z"
            style={{
              WebkitTransformOrigin: 226.533,
              MsTransformOrigin: 226.533,
              transformOrigin: 226.533,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M225.77 169.76h.25s-.05-.07 0-.1z"
            style={{
              WebkitTransformOrigin: 225.895,
              MsTransformOrigin: 225.895,
              transformOrigin: 225.895,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 225.71,
              MsTransformOrigin: 225.71,
              transformOrigin: 225.71,
            }}
            fill="#FFF"
            d="M225.65 169.8L225.77 169.76 225.68 169.75 225.65 169.8z"
            className="animable"
          ></path>
          <path
            d="M224.43 169.59a1.36 1.36 0 01-.37.06h.44s.08-.07-.07-.06z"
            style={{
              WebkitTransformOrigin: 224.291,
              MsTransformOrigin: 224.291,
              transformOrigin: 224.291,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M225 169.62s0 .02 0 0z"
            style={{
              WebkitTransformOrigin: 225,
              MsTransformOrigin: 225,
              transformOrigin: 225,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M222.72 169.65z"
            style={{
              WebkitTransformOrigin: 222.72,
              MsTransformOrigin: 222.72,
              transformOrigin: 222.72,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M224.52 169.7a.35.35 0 00.24 0H224.52z"
            style={{
              WebkitTransformOrigin: 224.629,
              MsTransformOrigin: 224.629,
              transformOrigin: 224.629,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M223.62 169.54l.19.06c-.06-.04-.17-.09-.19-.06z"
            style={{
              WebkitTransformOrigin: 223.715,
              MsTransformOrigin: 223.715,
              transformOrigin: 223.715,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M224.91 169.59s-.02-.01 0 0z"
            style={{
              WebkitTransformOrigin: 224.906,
              MsTransformOrigin: 224.906,
              transformOrigin: 224.906,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M224.91 169.59l-.15.07h.18z"
            style={{
              WebkitTransformOrigin: 224.85,
              MsTransformOrigin: 224.85,
              transformOrigin: 224.85,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M222.32 170.33c0-.1.31-.19.55-.08.25-.08.09-.4-.12-.59 0 .05 0 .09-.26.15.08.05.55.12.34.21s-.27 0-.43-.09c.14.13-.43.18-.35.37l.29-.07s-.1.08-.02.1z"
            style={{
              WebkitTransformOrigin: 222.52,
              MsTransformOrigin: 222.52,
              transformOrigin: 222.52,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M223.22 169.67h.11a.93.93 0 01-.36-.13c-.17.05-.21.08-.22.12h.47z"
            style={{
              WebkitTransformOrigin: 223.04,
              MsTransformOrigin: 223.04,
              transformOrigin: 223.04,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M223.79 169.66c-.08.11-.33.16-.18.27.31 0 .22-.09.4-.13-.49 0 .14-.06-.21-.13h.26l-.25-.05c-.14 0 0 0 0 0l-.49.06a2.25 2.25 0 00.47-.02z"
            style={{
              WebkitTransformOrigin: 223.69,
              MsTransformOrigin: 223.69,
              transformOrigin: 223.69,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M226.25 170.2s-.06 0 0 0z"
            style={{
              WebkitTransformOrigin: 226.237,
              MsTransformOrigin: 226.237,
              transformOrigin: 226.237,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M226.05 170.14a.24.24 0 01.18 0c.1 0 0 0 0 .09s.24-.08 0-.13a.86.86 0 01-.42-.18.93.93 0 00.24.22z"
            style={{
              WebkitTransformOrigin: 226.073,
              MsTransformOrigin: 226.073,
              transformOrigin: 226.073,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M224.91 169.93h-.41l.21.09c.22-.02.17-.02.2-.09z"
            style={{
              WebkitTransformOrigin: 224.705,
              MsTransformOrigin: 224.705,
              transformOrigin: 224.705,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 222.615,
              MsTransformOrigin: 222.615,
              transformOrigin: 222.615,
            }}
            fill="#FFF"
            d="M222.68 169.59L222.73 169.48 222.5 169.64 222.68 169.59z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 222.1,
              MsTransformOrigin: 222.1,
              transformOrigin: 222.1,
            }}
            fill="#FFF"
            d="M222.15 169.6L222.17 169.51 222.03 169.57 222.15 169.6z"
            className="animable"
          ></path>
          <path
            d="M192.19 170.83h-.12z"
            style={{
              WebkitTransformOrigin: 192.13,
              MsTransformOrigin: 192.13,
              transformOrigin: 192.13,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M193.06 170.84v-.05s-.06.05 0 .05z"
            style={{
              WebkitTransformOrigin: 193.047,
              MsTransformOrigin: 193.047,
              transformOrigin: 193.047,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M209.11 169.62c-.17-.1-.37-.24-.35-.13l.06.11a.54.54 0 01.29.02z"
            style={{
              WebkitTransformOrigin: 208.934,
              MsTransformOrigin: 208.934,
              transformOrigin: 208.934,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M200.18 170.26a.65.65 0 00.12-.11z"
            style={{
              WebkitTransformOrigin: 200.24,
              MsTransformOrigin: 200.24,
              transformOrigin: 200.24,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M200.06 170.71l-.23-.07a.79.79 0 00.23.07z"
            style={{
              WebkitTransformOrigin: 199.945,
              MsTransformOrigin: 199.945,
              transformOrigin: 199.945,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M187.45 171l-.14.11c.22-.05.12-.11.14-.11z"
            style={{
              WebkitTransformOrigin: 187.383,
              MsTransformOrigin: 187.383,
              transformOrigin: 187.383,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M216.71 169.65a1.54 1.54 0 00-.38-.07c.19.06.33.16.38.07z"
            style={{
              WebkitTransformOrigin: 216.52,
              MsTransformOrigin: 216.52,
              transformOrigin: 216.52,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M192.54 169.68c-.08 0-.11 0-.11.07s.12-.04.11-.07z"
            style={{
              WebkitTransformOrigin: 192.485,
              MsTransformOrigin: 192.485,
              transformOrigin: 192.485,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M215.9 169.58h.08a1.31 1.31 0 01.35 0 .5.5 0 00-.43 0z"
            style={{
              WebkitTransformOrigin: 216.115,
              MsTransformOrigin: 216.115,
              transformOrigin: 216.115,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M170.24 170.86s-.03 0 0 0z"
            style={{
              WebkitTransformOrigin: 170.233,
              MsTransformOrigin: 170.233,
              transformOrigin: 170.233,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M165.22 169.76z"
            style={{
              WebkitTransformOrigin: 165.22,
              MsTransformOrigin: 165.22,
              transformOrigin: 165.22,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M220 169.56c.11 0 0 0 0 0z"
            style={{
              WebkitTransformOrigin: 220.024,
              MsTransformOrigin: 220.024,
              transformOrigin: 220.024,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M220.56 170a.06.06 0 00-.05 0 .08.08 0 01.05 0z"
            style={{
              WebkitTransformOrigin: 220.535,
              MsTransformOrigin: 220.535,
              transformOrigin: 220.535,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M214.78 170.26z"
            style={{
              WebkitTransformOrigin: 214.78,
              MsTransformOrigin: 214.78,
              transformOrigin: 214.78,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M220.18 169.61a.32.32 0 00-.14 0z"
            style={{
              WebkitTransformOrigin: 220.11,
              MsTransformOrigin: 220.11,
              transformOrigin: 220.11,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M220.16 169.56h.1s0-.02-.1 0z"
            style={{
              WebkitTransformOrigin: 220.21,
              MsTransformOrigin: 220.21,
              transformOrigin: 220.21,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M219.85 169.56h.19z"
            style={{
              WebkitTransformOrigin: 219.945,
              MsTransformOrigin: 219.945,
              transformOrigin: 219.945,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M179.46 170.57c-.14.03-.09.03 0 0z"
            style={{
              WebkitTransformOrigin: 179.416,
              MsTransformOrigin: 179.416,
              transformOrigin: 179.416,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M206.18 170.74z"
            style={{
              WebkitTransformOrigin: 206.18,
              MsTransformOrigin: 206.18,
              transformOrigin: 206.18,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M205.78 170.82a.43.43 0 01.4-.09l-.14-.31z"
            style={{
              WebkitTransformOrigin: 205.98,
              MsTransformOrigin: 205.98,
              transformOrigin: 205.98,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M190.11 170.86l.29.1c-.34.16-.59.11-.33.24 0-.34 1.11 0 1.15-.37l.18.07h-.11c.36.17.27-.24.74-.19.16 0 .28.07.16.11l.37-.08c.1 0 .08.06 0 .06h.56a3.78 3.78 0 01.35-.17c.14 0-.07 0 0 .08l.3-.08c.13.08-.13.17-.34.16.29.34.26-.09.88.11h-.29c.18.2.41.13.74.25-.08-.07-.66-.31-.32-.39a.61.61 0 00.39 0c0 .12.18.09.4.08v.16c.23 0 .22-.13.36-.2a.4.4 0 01.38.25c.42 0-.3-.2.21-.23a2.48 2.48 0 001-.1c.25.05 0 .1 0 .14l.22-.13c.05 0 0 .05 0 .07.19-.05 0-.16.31-.21.08-.17.59.26.95.06.09 0 0 .1 0 .16a3.75 3.75 0 00.82-.27l.35.1c-.25-.12.07-.26.35-.38l-.22-.13.46-.08c.05 0 0 .08-.07.14h.09c.16.06.07.16 0 .25l-.17-.1c-.11.09-.21.2-.19.3h.15s-.05 0 0 .07.06 0 .13-.06l.1.18v-.07l.59.11a4.25 4.25 0 011.47-.52c-.17.13 0 .21 0 .37-.18-.17-.52.07-.87 0 .18 0 .14.09.1.11l.62-.15c0 .13.13.1.29.15-.12-.25.47-.17.72-.24 0 .08 0 .17-.36.15.35.18.44-.3.78-.14h-.15c.18-.07.61 0 .51.06H204c.5 0 1.52 0 1.6-.21a1.32 1.32 0 01-.1.3l.9-.71c-.08.18.22.61-.2.72a1.14 1.14 0 00.52 0c-.08 0-.2-.26-.09-.28a2.32 2.32 0 00.59.28c-.13 0 0-.32.2-.32v.32l.48-.28c-.12.05 0 .23.08.31s.42 0 .54 0l-.2-.06c.54 0 .54-.4 1.07-.38-.06 0-.16.35.11.39a2.44 2.44 0 011-.81l.09.09.37-.1a7 7 0 01-1.21.85c.2.07.05.1.36.09.1.08-.17.12-.26.12h.71c0-.16.54-.16.51-.3l-.77.17c0-.17.45-.48.95-.45.12.07-.1.3-.09.36a1 1 0 01.52-.07l-.21.09c.28.06.45-.23.79-.06.11 0 .34.21.36.11a1 1 0 01-.1-.93 6.15 6.15 0 01.74.28c.19.15-.28.36-.12.49 0 0 .11-.1.15-.12s0 .14.22.12c0-.17.53 0 .12-.14.26-.05.27 0 .58 0-.1-.11.27-.37.53-.42 0 0 0 .1.07.13.53 0 .81.09 1.3.09 0 0 .28.09.18.16a.7.7 0 01.29-.09c.29.15-.34 0-.11.2 0-.1.39-.13.6-.2-.06-.15-.49 0-.71 0 0-.22.37-.44.89-.53s.18.13.25.1c.77 0 .65-.37 1.29-.21.25.13 0 .26.07.36-.34 0-.51-.08-.74-.08l.28.06a.77.77 0 01-.45 0c.21.13 1.3 0 1.89.14.1-.05.29-.09.2-.15h-.19c-.17-.11.36-.15.12-.2a1.88 1.88 0 01.89-.13l.06.15a.38.38 0 00-.33 0c.15-.07.54.2.71 0l-.25-.1a2.07 2.07 0 01.88-.2c-.15-.15-.08 0-.3-.16.19.23-.8 0-.49.23-.23-.21-.4-.09-.7-.27 0 .06.11.1-.15.08h-.06a.26.26 0 01.13.07c-.13.12-.55.11-.69.17s.07-.05 0-.11l-.21.09c0-.11-.41-.18 0-.25H219a1.25 1.25 0 00-.63-.05c-.15 0-.39.13-.25 0l-.52.07a4.76 4.76 0 01-1.64 0 2.43 2.43 0 01-.64 0l-.06-.1c-.22 0-.66-.1-.76 0-.24-.26-1.08 0-1.47-.1v.13a4.58 4.58 0 00-.86.08v.11a6.66 6.66 0 01-1.19-.07h.23c-.55-.25-1.15.19-1.64 0a.39.39 0 01-.3 0 .85.85 0 00-.17-.06l.14.06a1.87 1.87 0 00-.37 0l-.06-.12c-.14 0-.11.06 0 .15l-.19.07c-.11-.19-.37.07-.52-.14-.1.1-.71.08-.78.29a.8.8 0 00-.46 0l-.07-.15-.34.2c-.21-.09-.29-.14-.09-.26-.49.18-.4.07-.82.25v-.1c-.16 0-.4.13-.49.05-.34-.19-1.68 0-2.55-.2.17.29-.4-.13-.44.1-.05-.07-.17-.11 0-.17-.44.07-.67-.11-1 .08-.05-.07.09-.1 0-.14s-.14.06-.19 0 .07-.06.14-.09c-.46 0-.5.22-.54.42a.43.43 0 00-.51.05c-.08-.06-.21-.13.07-.16-.16 0-1-.09-1 .07h-.27a5.93 5.93 0 00-.73 0h.09c-.14.19-.29 0-.57.07-.65-.14-.28.06-.92-.09v.12c-.06.25-.57-.16-.94-.06l.13.07c-.2.09-.56-.35-.76-.38h.13c-.53-.16-.07.15-.47.19-.07-.09.1-.22-.17-.23s-.77.27-1.14.11c.09.07.16.13 0 .18s-.76-.25-1 0a.23.23 0 010-.05 3.16 3.16 0 00-.83.2c-.2-.42-1.34.2-1.33-.18h-.66a1 1 0 00-.72.16c-.1 0 0-.07 0-.09a1.85 1.85 0 00-1.2.13l-.05-.12a8.36 8.36 0 00-1.5-.05.08.08 0 01.06-.05c-.68.14-1.63-.35-1.88.1l-.45.11c.58 0-.09.2.15.27-.23 0-.59-.13-.31-.15.11-.24-.72-.09-.7-.25-1.15 0-2.27-.11-3.35-.12l.13.18h-.38c-.09 0-.13-.15.14-.14-.14-.1-.45.09-.46.13-.52-.07.21-.21 0-.22h-.22.05a.83.83 0 01-.52.14c-.2 0-.1-.11-.18-.12s0 0-.12 0h-.48l.19.15c-.21.07-.44 0-.22.15-.32-.25-1.76-.09-2-.17a2.21 2.21 0 01-.94.09c.09 0 .14.2-.17.18.11-.34-.57-.15-.82-.39.23.16-.87 0-.52.27-.26 0 0-.13-.22-.21a17 17 0 01-2.11 0s.12.11-.05.18l-.4-.22c-.15 0-.13.25-.41.1 0 0 .1.09 0 .11-1.49-.22-3 .17-4.55-.23.2.08.07.09-.09.1.1 0 0 .1 0 .16l-.63-.16c-.12.16-.68 0-.75.17h.2c-.26.19.37.41.34.65.29-.21.78.32 1.27 0 .11.05-.09.08 0 .14.12-.11.27-.13.55-.08a16.13 16.13 0 012 .15l-.07-.12a.8.8 0 01.32.08c.21-.18-.53 0-.33-.21.25.24 1.32 0 1.49.28.29 0-.08-.14.21-.13l.07.07.08-.1c.19 0 .28.11.29.18a.55.55 0 00-.18 0c.24.09.69 0 .78 0l-.28-.05c.79-.07 1.75 0 2.52-.12l-.06-.06c.58-.1.47.06 1.11 0a1.18 1.18 0 01.48-.08c-.16.07.3.13.09.2.63-.11.31-.09.73-.29l.1.09a.71.71 0 01.47-.15c-.26.08.2.14-.09.24.67.21 1-.2 1.3.1.31-.26-.58-.15-.4-.2-.15-.09.25-.19.46-.17s.36.33.9.33h-.11c.2.07.4-.09.65 0 .13-.15.32 0 .36-.19l-.5.05c.28-.05.55-.29 1-.17a1 1 0 01-.27.12c.13.06.26 0 .4 0 0 .2-.6 0-.9.19.14.09.57-.14.42.07.21-.27.53 0 .89-.17v.12a.72.72 0 01.28-.07l-.19.15c.29-.13.57.12.85 0-.59 0-.13-.14-.38-.23.73-.15.42.32 1.24.26-.11 0-.42-.07-.24-.13a1.61 1.61 0 01.45.13c.55 0-.08-.12.15-.19.19.14.27-.06.51-.11v.12c.62.08.16-.25.72-.15l-.24.16h.29l-.06.14a1.31 1.31 0 01.73 0c-.07-.08 0-.22.31-.22s-.1.11.29.1c-.09.07-.19.17-.36.06 0 0-.08.07-.1.11a1.81 1.81 0 00.65 0 .65.65 0 01-.16 0l.57-.17c.09 0 0 .08-.05.12a3.44 3.44 0 01.36-.08c-.05.1 0 .2-.27.25l.53-.11s.28.11.21.15c.3.06.73-.19 1.12-.11a.31.31 0 01.15-.06 2.57 2.57 0 001.14 0l.24.18c.35 0-.33-.22.24-.29.41-.06.15.15.29.2a1.21 1.21 0 01.93-.13 1.3 1.3 0 01-.29.14zm4.25-.07c-.09 0-.25.1-.31 0s.17-.04.31 0zm6.45-.29a.28.28 0 01-.26 0 .5.5 0 01.26 0zm18-.84c-.23-.05-.16-.03-.03 0zm.38.05v-.05c0-.05-.11 0-.21 0s.02.08.18.05zm-40.9 0h.07c-.2.11-.15.08-.1.05z"
            style={{
              WebkitTransformOrigin: 192.92,
              MsTransformOrigin: 192.92,
              transformOrigin: 192.92,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M200.08 170.66v-.06c0-.06-.08.04 0 .06z"
            style={{
              WebkitTransformOrigin: 200.062,
              MsTransformOrigin: 200.062,
              transformOrigin: 200.062,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M187.47 170.93z"
            style={{
              WebkitTransformOrigin: 187.47,
              MsTransformOrigin: 187.47,
              transformOrigin: 187.47,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M213.26 170.73a.45.45 0 01-.15-.06s.03.05.15.06z"
            style={{
              WebkitTransformOrigin: 213.185,
              MsTransformOrigin: 213.185,
              transformOrigin: 213.185,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M221.18 169.5h-.25a.78.78 0 01.22 0s-.05.01.03 0z"
            style={{
              WebkitTransformOrigin: 221.055,
              MsTransformOrigin: 221.055,
              transformOrigin: 221.055,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M223.29 170.25h.11c-.16-.07-.26-.02-.11 0z"
            style={{
              WebkitTransformOrigin: 223.308,
              MsTransformOrigin: 223.308,
              transformOrigin: 223.308,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M221.4 169.9c0 .11.17.07.35 0 .02-.09-.17-.04-.35 0z"
            style={{
              WebkitTransformOrigin: 221.576,
              MsTransformOrigin: 221.576,
              transformOrigin: 221.576,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M221.78 170h.16c.06-.11-.06-.07-.16 0z"
            style={{
              WebkitTransformOrigin: 221.868,
              MsTransformOrigin: 221.868,
              transformOrigin: 221.868,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M219.64 169.64c.08 0 .05-.13.1-.09.09-.13-.54.16-.1.09z"
            style={{
              WebkitTransformOrigin: 219.616,
              MsTransformOrigin: 219.616,
              transformOrigin: 219.616,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 221.46,
              MsTransformOrigin: 221.46,
              transformOrigin: 221.46,
            }}
            fill="#FFF"
            d="M221.54 170.24L221.48 170.11 221.38 170.21 221.54 170.24z"
            className="animable"
          ></path>
          <path
            d="M220.19 170.15H220.54c-.17-.02-.36-.04-.35 0z"
            style={{
              WebkitTransformOrigin: 220.365,
              MsTransformOrigin: 220.365,
              transformOrigin: 220.365,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M220.54 170.14a.72.72 0 00.22 0 .9.9 0 00-.22 0z"
            style={{
              WebkitTransformOrigin: 220.65,
              MsTransformOrigin: 220.65,
              transformOrigin: 220.65,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 221.03,
              MsTransformOrigin: 221.03,
              transformOrigin: 221.03,
            }}
            fill="#FFF"
            d="M221.17 170.28L221.09 170.25 220.89 170.24 221.17 170.28z"
            className="animable"
          ></path>
          <path
            d="M217.26 170.12h-.3s0 .07.16.05.18-.01.14-.05z"
            style={{
              WebkitTransformOrigin: 217.119,
              MsTransformOrigin: 217.119,
              transformOrigin: 217.119,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M218.16 170.47a.28.28 0 01-.13-.1v.16z"
            style={{
              WebkitTransformOrigin: 218.095,
              MsTransformOrigin: 218.095,
              transformOrigin: 218.095,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M217.29 170.5s-.43.13-.06.12c.03-.05.33-.08.06-.12z"
            style={{
              WebkitTransformOrigin: 217.241,
              MsTransformOrigin: 217.241,
              transformOrigin: 217.241,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 212.835,
              MsTransformOrigin: 212.835,
              transformOrigin: 212.835,
            }}
            fill="#FFF"
            d="M212.8 170.31L212.87 170.3 212.86 170.05 212.8 170.31z"
            className="animable"
          ></path>
          <path
            d="M208.84 170.91c.35.07.08-.15.4-.08.09-.06-.26-.06-.17-.11-.22.06-.33.03-.23.19z"
            style={{
              WebkitTransformOrigin: 209.029,
              MsTransformOrigin: 209.029,
              transformOrigin: 209.029,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M209.07 170.72h.11z"
            style={{
              WebkitTransformOrigin: 209.125,
              MsTransformOrigin: 209.125,
              transformOrigin: 209.125,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 164.28,
              MsTransformOrigin: 164.28,
              transformOrigin: 164.28,
            }}
            fill="#FFF"
            d="M164.39 169.63L164.17 169.57 164.31 169.66 164.39 169.63z"
            className="animable"
          ></path>
          <path
            d="M164 169.82l-.06-.17-.13.15s.11-.02.19.02z"
            style={{
              WebkitTransformOrigin: 163.905,
              MsTransformOrigin: 163.905,
              transformOrigin: 163.905,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M195 171.11h-.2z"
            style={{
              WebkitTransformOrigin: 194.9,
              MsTransformOrigin: 194.9,
              transformOrigin: 194.9,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 191.91,
              MsTransformOrigin: 191.91,
              transformOrigin: 191.91,
            }}
            fill="#FFF"
            d="M191.91 170.99L191.96 171 191.86 170.85 191.91 170.99z"
            className="animable"
          ></path>
          <path
            d="M189.32 171.18h.34c-.23 0-.37-.18-.34 0z"
            style={{
              WebkitTransformOrigin: 189.488,
              MsTransformOrigin: 189.488,
              transformOrigin: 189.488,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M193.34 175v-.12.12z"
            style={{
              WebkitTransformOrigin: 193.34,
              MsTransformOrigin: 193.34,
              transformOrigin: 193.34,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 192.575,
              MsTransformOrigin: 192.575,
              transformOrigin: 192.575,
            }}
            fill="#FFF"
            d="M192.62 175.28L192.63 175.23 192.52 175.34 192.62 175.28z"
            className="animable"
          ></path>
          <path
            d="M191.94 175.27c.07.18.25 0 .37 0v-.14c-.08.1-.26.19-.37.14z"
            style={{
              WebkitTransformOrigin: 192.125,
              MsTransformOrigin: 192.125,
              transformOrigin: 192.125,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M191.58 174.89c0 .07-.08.06.09 0z"
            style={{
              WebkitTransformOrigin: 191.616,
              MsTransformOrigin: 191.616,
              transformOrigin: 191.616,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M191.65 174.89c.07 0-.05-.06 0 0z"
            style={{
              WebkitTransformOrigin: 191.655,
              MsTransformOrigin: 191.655,
              transformOrigin: 191.655,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M191.32 174.93l.1-.06s-.11-.05-.08-.08-.07.07-.02.14z"
            style={{
              WebkitTransformOrigin: 191.363,
              MsTransformOrigin: 191.363,
              transformOrigin: 191.363,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M191.23 175.06h.05s-.02-.06-.05 0z"
            style={{
              WebkitTransformOrigin: 191.255,
              MsTransformOrigin: 191.255,
              transformOrigin: 191.255,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M191.39 175l-.11.06s0 .08.05 0 .01-.06.06-.06z"
            style={{
              WebkitTransformOrigin: 191.335,
              MsTransformOrigin: 191.335,
              transformOrigin: 191.335,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M191.44 175c.06 0 .12.06 0 .12.21-.01.18-.12 0-.12z"
            style={{
              WebkitTransformOrigin: 191.513,
              MsTransformOrigin: 191.513,
              transformOrigin: 191.513,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M191.91 175.46h.07l.06-.06s-.14 0-.13.06z"
            style={{
              WebkitTransformOrigin: 191.975,
              MsTransformOrigin: 191.975,
              transformOrigin: 191.975,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M190.74 174.84v.15h.07s-.07-.09-.07-.15z"
            style={{
              WebkitTransformOrigin: 190.775,
              MsTransformOrigin: 190.775,
              transformOrigin: 190.775,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M190.78 175l-.11.06c.1 0 .11-.06.11-.06z"
            style={{
              WebkitTransformOrigin: 190.725,
              MsTransformOrigin: 190.725,
              transformOrigin: 190.725,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 191.29,
              MsTransformOrigin: 191.29,
              transformOrigin: 191.29,
            }}
            fill="#FFF"
            d="M191.22 175.26L191.39 175.12 191.19 175.26 191.22 175.26z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 190.35,
              MsTransformOrigin: 190.35,
              transformOrigin: 190.35,
            }}
            fill="#FFF"
            d="M190.34 174.84L190.4 174.75 190.3 174.88 190.34 174.84z"
            className="animable"
          ></path>
          <path
            d="M190.08 174.85c0-.07-.06-.12 0-.17a.59.59 0 00-.19.13.18.18 0 01.19.04z"
            style={{
              WebkitTransformOrigin: 189.985,
              MsTransformOrigin: 189.985,
              transformOrigin: 189.985,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M189.79 174.9l.09-.09z"
            style={{
              WebkitTransformOrigin: 189.835,
              MsTransformOrigin: 189.835,
              transformOrigin: 189.835,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M190.5 175s0-.09-.08-.11v.1z"
            style={{
              WebkitTransformOrigin: 190.46,
              MsTransformOrigin: 190.46,
              transformOrigin: 190.46,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M190.46 175z"
            style={{
              WebkitTransformOrigin: 190.46,
              MsTransformOrigin: 190.46,
              transformOrigin: 190.46,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M190.51 175s-.01.05 0 0z"
            style={{
              WebkitTransformOrigin: 190.508,
              MsTransformOrigin: 190.508,
              transformOrigin: 190.508,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M191 175.16c-.06.06-.19.13-.07.22 0-.07-.08-.13.07-.22z"
            style={{
              WebkitTransformOrigin: 190.94,
              MsTransformOrigin: 190.94,
              transformOrigin: 190.94,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M190.56 175.17h.11v-.09z"
            style={{
              WebkitTransformOrigin: 190.615,
              MsTransformOrigin: 190.615,
              transformOrigin: 190.615,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 190.535,
              MsTransformOrigin: 190.535,
              transformOrigin: 190.535,
            }}
            fill="#FFF"
            d="M190.51 175.2L190.56 175.17 190.52 175.16 190.51 175.2z"
            className="animable"
          ></path>
          <path
            d="M190 175a.24.24 0 01-.16.05.65.65 0 00.19 0s.02-.05-.03-.05z"
            style={{
              WebkitTransformOrigin: 189.937,
              MsTransformOrigin: 189.937,
              transformOrigin: 189.937,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M190.21 175z"
            style={{
              WebkitTransformOrigin: 190.21,
              MsTransformOrigin: 190.21,
              transformOrigin: 190.21,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M189.24 175.05z"
            style={{
              WebkitTransformOrigin: 189.24,
              MsTransformOrigin: 189.24,
              transformOrigin: 189.24,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M190 175.11a.08.08 0 00.1 0h-.11.01z"
            style={{
              WebkitTransformOrigin: 190.045,
              MsTransformOrigin: 190.045,
              transformOrigin: 190.045,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M189.63 175l.08.05s-.07-.13-.08-.05z"
            style={{
              WebkitTransformOrigin: 189.67,
              MsTransformOrigin: 189.67,
              transformOrigin: 189.67,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M190.19 175s-.01 0 0 0z"
            style={{
              WebkitTransformOrigin: 190.188,
              MsTransformOrigin: 190.188,
              transformOrigin: 190.188,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M190.19 175a.23.23 0 00-.07.07.2.2 0 00.08 0z"
            style={{
              WebkitTransformOrigin: 190.16,
              MsTransformOrigin: 190.16,
              transformOrigin: 190.16,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M189.07 175.74a.14.14 0 01.24-.09c.1-.07 0-.4-.06-.58 0 .05 0 .09-.11.14 0 .06.24.13.15.22s-.12 0-.19-.09c.06.13-.18.18-.15.36l.13-.06s-.08.07-.01.1z"
            style={{
              WebkitTransformOrigin: 189.15,
              MsTransformOrigin: 189.15,
              transformOrigin: 189.15,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M189.46 175.08c-.05 0-.08-.06-.15-.13a.19.19 0 00-.1.11h.22z"
            style={{
              WebkitTransformOrigin: 189.335,
              MsTransformOrigin: 189.335,
              transformOrigin: 189.335,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M189.7 175.07c0 .11-.14.15-.07.27s.09-.09.17-.14c-.21 0 .06-.06-.09-.12h.11l-.11-.05c-.06 0 0 0 0 0l-.22.06a.44.44 0 00.21-.02z"
            style={{
              WebkitTransformOrigin: 189.655,
              MsTransformOrigin: 189.655,
              transformOrigin: 189.655,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M190.77 175.61s-.03 0 0 0z"
            style={{
              WebkitTransformOrigin: 190.763,
              MsTransformOrigin: 190.763,
              transformOrigin: 190.763,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M190.68 175.55s0-.06.08-.05 0 .05 0 .09.11-.08 0-.13c-.09 0-.2-.17-.18-.19a.74.74 0 00.1.28z"
            style={{
              WebkitTransformOrigin: 190.693,
              MsTransformOrigin: 190.693,
              transformOrigin: 190.693,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M190.19 175.34h-.18l.09.09c.1.02.07-.05.09-.09z"
            style={{
              WebkitTransformOrigin: 190.1,
              MsTransformOrigin: 190.1,
              transformOrigin: 190.1,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 189.2,
              MsTransformOrigin: 189.2,
              transformOrigin: 189.2,
            }}
            fill="#FFF"
            d="M189.22 175L189.25 174.89 189.15 175.05 189.22 175z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 188.97,
              MsTransformOrigin: 188.97,
              transformOrigin: 188.97,
            }}
            fill="#FFF"
            d="M188.99 175.01L189 174.91 188.94 174.97 188.99 175.01z"
            className="animable"
          ></path>
          <path
            d="M176.05 176.24H176z"
            style={{
              WebkitTransformOrigin: 176.025,
              MsTransformOrigin: 176.025,
              transformOrigin: 176.025,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M176.43 176.25v-.05s-.02.05 0 .05z"
            style={{
              WebkitTransformOrigin: 176.426,
              MsTransformOrigin: 176.426,
              transformOrigin: 176.426,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M183.36 175c-.07-.09-.16-.23-.15-.12v.11a.14.14 0 01.15.01z"
            style={{
              WebkitTransformOrigin: 183.285,
              MsTransformOrigin: 183.285,
              transformOrigin: 183.285,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M179.5 175.67l.06-.1z"
            style={{
              WebkitTransformOrigin: 179.53,
              MsTransformOrigin: 179.53,
              transformOrigin: 179.53,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M179.45 176.12l-.1-.07a.2.2 0 00.1.07z"
            style={{
              WebkitTransformOrigin: 179.4,
              MsTransformOrigin: 179.4,
              transformOrigin: 179.4,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M174 176.36l-.06.11c.06 0 .06-.06.06-.11z"
            style={{
              WebkitTransformOrigin: 173.97,
              MsTransformOrigin: 173.97,
              transformOrigin: 173.97,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M186.64 175.05a.29.29 0 00-.16-.06c.08.06.14.15.16.06z"
            style={{
              WebkitTransformOrigin: 186.56,
              MsTransformOrigin: 186.56,
              transformOrigin: 186.56,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M176.2 175.09v.07c0 .07.01-.04 0-.07z"
            style={{
              WebkitTransformOrigin: 176.202,
              MsTransformOrigin: 176.202,
              transformOrigin: 176.202,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M186.29 175a.36.36 0 01.15 0c-.02-.06-.08-.09-.15 0z"
            style={{
              WebkitTransformOrigin: 186.365,
              MsTransformOrigin: 186.365,
              transformOrigin: 186.365,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M166.56 176.27s-.01 0 0 0z"
            style={{
              WebkitTransformOrigin: 166.558,
              MsTransformOrigin: 166.558,
              transformOrigin: 166.558,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M164.4 175.17z"
            style={{
              WebkitTransformOrigin: 164.4,
              MsTransformOrigin: 164.4,
              transformOrigin: 164.4,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M188.07 175c.05 0 0 0 0 0z"
            style={{
              WebkitTransformOrigin: 188.081,
              MsTransformOrigin: 188.081,
              transformOrigin: 188.081,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M188.31 175.39a.11.11 0 000 .06.08.08 0 010-.06z"
            style={{
              WebkitTransformOrigin: 188.307,
              MsTransformOrigin: 188.307,
              transformOrigin: 188.307,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M188.14 175h-.06z"
            style={{
              WebkitTransformOrigin: 188.11,
              MsTransformOrigin: 188.11,
              transformOrigin: 188.11,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M188.13 175h0z"
            style={{
              WebkitTransformOrigin: 188.155,
              MsTransformOrigin: 188.155,
              transformOrigin: 188.155,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M188 175z"
            style={{
              WebkitTransformOrigin: 188,
              MsTransformOrigin: 188,
              transformOrigin: 188,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M170.55 176s-.04 0 0 0z"
            style={{
              WebkitTransformOrigin: 170.541,
              MsTransformOrigin: 170.541,
              transformOrigin: 170.541,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 182.095,
              MsTransformOrigin: 182.095,
              transformOrigin: 182.095,
            }}
            fill="#FFF"
            d="M182.09 176.15L182.1 176.15 182.09 176.14 182.09 176.15z"
            className="animable"
          ></path>
          <path
            d="M181.92 176.23c.07-.13.12-.12.17-.09l-.05-.31z"
            style={{
              WebkitTransformOrigin: 182.005,
              MsTransformOrigin: 182.005,
              transformOrigin: 182.005,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M175.15 176.27l.12.1c-.14.16-.25.1-.14.24 0-.34.48 0 .5-.37l.08.07h-.05c.16.16.12-.24.32-.19s.12.07.07.11l.16-.08v.06h.24a.83.83 0 01.15-.17c.06.05 0 0 0 .08l.13-.09c.06.09 0 .18-.14.17.12.33.11-.09.37.11h-.12c.08.19.18.12.32.24 0-.06-.29-.3-.14-.38a.15.15 0 00.17 0c0 .12.08.09.17.08v.16c.1 0 .09-.13.15-.2s.14.14.17.24c.18 0-.13-.19.09-.22s.26 0 .44-.1 0 .09 0 .14l.09-.13v.06c0 .06 0-.16.13-.2s.26.26.41.06v.16a1.1 1.1 0 00.36-.27l.15.1c-.11-.12 0-.26.15-.38l-.09-.13.19-.09v.15c.07.06 0 .15 0 .24l-.08-.1a.71.71 0 00-.08.3h.07c.07 0 0 0 0 .07s0 0 .06-.06v.17-.07l.25.12c.18-.18.34-.45.63-.52-.07.13 0 .21 0 .37-.08-.17-.22.07-.37 0 .08 0 .06.09 0 .12l.27-.15c0 .13.06.1.13.15-.06-.25.2-.17.3-.25 0 .09 0 .17-.15.15.15.19.19-.29.34-.13h-.07c-.02 0 .27 0 .22.06.22 0 .66 0 .69-.21v.3l.38-.72c0 .19.1.62-.08.73a.22.22 0 00.22 0s-.08-.27 0-.28c.14.2.1.11.26.28 0 0 0-.33.09-.32s0 .29 0 .31l.21-.28c-.05.05 0 .24 0 .32s.18 0 .23 0l-.09-.07c.24 0 .23-.39.47-.38 0 .06-.07.36 0 .4.06-.15.24-.7.45-.81v.08l.16-.09a5.27 5.27 0 01-.53.85c.09.07 0 .1.16.09s-.07.12-.11.12h.3c0-.17.24-.17.22-.31l-.33.18c0-.17.19-.48.41-.45.06.07 0 .3 0 .36s.21-.12.23-.07l-.09.09c.12.06.19-.23.34-.07 0 0 .15.22.16.12a2.12 2.12 0 01-.05-.93 1.43 1.43 0 01.32.28c.08.15-.12.36 0 .49a.22.22 0 01.06-.12c.06 0 0 .14.1.12 0-.17.23 0 .05-.15.11-.05.12 0 .25 0 0-.11.12-.37.23-.42a.21.21 0 000 .12c.23 0 .35.1.56.1 0 0 .12.09.08.16s.06-.09.13-.09-.15 0-.05.2c0-.1.17-.14.26-.2s-.22 0-.31 0a.63.63 0 01.38-.53c.18-.05.08.14.11.11.33 0 .28-.37.56-.22.11.14 0 .27 0 .37-.14 0-.22-.09-.32-.08l.12.06a.16.16 0 01-.19 0c.09.12.56 0 .81.14.05-.05.13-.09.09-.15h-.08c-.08-.11.15-.15 0-.2.11-.08.23-.2.38-.14v.16c0-.05-.1-.09-.14-.05s.23.21.3 0l-.1-.11c.11-.07.24-.24.38-.19-.07-.15 0 0-.13-.16.08.22-.35 0-.21.23-.1-.21-.18-.09-.31-.27 0 0 0 .1-.06.07v.05a.21.21 0 01.06.08c-.06.12-.24.11-.3.17s0-.06 0-.11l-.09.09c0-.11-.18-.19 0-.25h-.14a.27.27 0 00-.27 0c-.07 0-.17.13-.12 0l-.22.07c-.22 0-.46.19-.71 0a.36.36 0 01-.28 0v-.09c-.1 0-.29-.1-.33 0-.1-.26-.47-.06-.64-.1v.25a.86.86 0 00-.37.07v.12c-.13.09-.32-.08-.52-.07h.1c-.24-.25-.5.19-.71 0a.09.09 0 01-.13 0l-.07-.06a.17.17 0 00.06.06.71.71 0 00-.16 0V175c-.06 0-.05.06 0 .15a.27.27 0 00-.08.07c-.05-.19-.16.07-.22-.14 0 .1-.31.08-.34.29s-.13-.05-.19 0v-.16l-.15.21c-.09-.09-.13-.15 0-.26-.21.18-.17.06-.36.24v-.1c-.06 0-.17.14-.21.06s-.72 0-1.1-.2c.07.29-.17-.13-.19.09 0-.07-.07-.1 0-.16-.19.06-.29-.11-.42.08v-.15c0-.05-.06.06-.08 0s0-.05.06-.08c-.2 0-.22.22-.23.42-.1-.1-.15-.08-.23 0 0-.07-.09-.14 0-.16-.06 0-.41-.09-.42.07h-.12a1.61 1.61 0 00-.31 0c-.06.19-.13 0-.25.07-.27-.14-.12.06-.39-.1v.12c0 .26-.24-.15-.4 0l.06.07c-.09.09-.25-.35-.33-.38s0 0 0-.06c-.23-.15 0 .16-.2.2s0-.22-.07-.23-.34.27-.49.11c0 .06.06.13 0 .18s-.33-.25-.44 0a.09.09 0 010-.05c-.09.05-.3.08-.35.2-.09-.42-.58.2-.58-.18h-.29a.27.27 0 00-.31.15v-.08c-.27-.07-.29-.06-.52.13v-.12c-.06.07-.39-.2-.65-.05a.09.09 0 010-.06c-.3.15-.71-.34-.82.11l-.19.11c.25 0 0 .2.06.27-.09 0-.25-.13-.13-.16 0-.24-.31-.09-.31-.25-.49 0-1-.12-1.44-.13v.19h-.16s-.06-.15.06-.14c-.06-.1-.19.09-.2.13-.22-.08.09-.22 0-.22h-.09c-.08.08-.08.16-.22.15s0-.11-.08-.12 0 0-.06 0h-.2l.08.14c-.09.07-.19 0-.1.16-.13-.25-.76-.09-.84-.17a.5.5 0 01-.41.09s.06.19-.07.17c.05-.33-.25-.14-.35-.38.09.16-.38 0-.23.26-.11 0 0-.12-.09-.2-.27.13-.59-.09-.92 0v.18l-.17-.22c-.07 0-.06.25-.18.1v.1c-.64-.21-1.31.18-2-.22.09.08 0 .09 0 .09v.17l-.27-.16c-.05.16-.29 0-.32.17h.09c-.12.18.16.41.14.65.13-.21.34.32.55 0v.13c0 .05.11-.12.23-.07a3.11 3.11 0 01.86.15v-.12c.08 0 .1 0 .14.08.09-.18-.23 0-.14-.21.1.24.57 0 .64.28.13 0 0-.14.09-.14v.08-.1a.18.18 0 01.13.17h-.08c.11.08.3 0 .34 0h-.12a5 5 0 001.09-.12v-.06c.25-.1.2.06.48 0a.25.25 0 01.21-.08c-.07.07.13.13 0 .2.27-.11.13-.09.31-.3v.1c.06-.09.07-.13.21-.15-.12.07.09.14 0 .24.29.2.43-.2.56.09.14-.25-.25-.14-.17-.19-.07-.09.11-.2.2-.17s.15.33.39.32h-.05c-.05 0 .17-.09.28 0 .06-.16.14 0 .15-.19h-.21c.12-.05.23-.28.43-.17a.33.33 0 01-.11.13c.06.05.11 0 .17 0s-.26 0-.39.19c.06.08.25-.14.18.07.1-.27.23 0 .39-.17v.12s.08-.08.12-.07l-.08.15c.13-.13.24.11.37 0-.26 0-.06-.14-.17-.23.32-.16.18.31.54.26 0 0-.18-.08-.11-.13a.39.39 0 01.2.13c.23 0 0-.12.06-.19.08.14.12-.06.22-.11v.12c.27.08.07-.25.31-.16l-.1.17h.13v.14c.14-.11.18-.08.31 0a.16.16 0 01.14-.22c.08.07 0 .11.12.09 0 .08-.08.17-.15.06a.56.56 0 000 .12c.08.08.21 0 .27 0h-.06l.24-.17v.12c0 .04.08-.07.16-.08s0 .2-.12.24l.23-.1s.12.11.09.15c.13.06.32-.19.49-.12l.06-.05c.06-.05.3.15.49 0l.11.18c.15 0-.15-.22.1-.29s.07.15.13.2.24-.27.4-.13c-.05.03-.09.01-.14.02zm1.84-.08s-.11.11-.14 0 .07-.04.15 0zm2.78-.29h-.11a.12.12 0 01.11 0zm7.77-.84c-.09-.06-.06-.06 0 0zm.16.06v-.05c0-.05-.05 0-.09 0s.04.07.09.05zm-17.67 0c-.03.11-.03.08-.03.04z"
            style={{
              WebkitTransformOrigin: 176.3,
              MsTransformOrigin: 176.3,
              transformOrigin: 176.3,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M179.46 176.07a.14.14 0 010-.07.05.05 0 000 .07z"
            style={{
              WebkitTransformOrigin: 179.453,
              MsTransformOrigin: 179.453,
              transformOrigin: 179.453,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M174 176.34z"
            style={{
              WebkitTransformOrigin: 174,
              MsTransformOrigin: 174,
              transformOrigin: 174,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M185.15 176.14l-.06-.06s.01.05.06.06z"
            style={{
              WebkitTransformOrigin: 185.12,
              MsTransformOrigin: 185.12,
              transformOrigin: 185.12,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M188.57 174.91h-.1a.11.11 0 01.09 0h.01z"
            style={{
              WebkitTransformOrigin: 188.52,
              MsTransformOrigin: 188.52,
              transformOrigin: 188.52,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M189.49 175.66c-.02-.07-.07-.03 0 0z"
            style={{
              WebkitTransformOrigin: 189.472,
              MsTransformOrigin: 189.472,
              transformOrigin: 189.472,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M188.67 175.31c0 .1.08.07.15.05.01-.14-.07-.09-.15-.05z"
            style={{
              WebkitTransformOrigin: 188.745,
              MsTransformOrigin: 188.745,
              transformOrigin: 188.745,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M188.84 175.36h.07s-.03-.02-.07 0z"
            style={{
              WebkitTransformOrigin: 188.875,
              MsTransformOrigin: 188.875,
              transformOrigin: 188.875,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M187.91 175.05v-.09c.09-.13-.19.16 0 .09z"
            style={{
              WebkitTransformOrigin: 187.885,
              MsTransformOrigin: 187.885,
              transformOrigin: 187.885,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 188.695,
              MsTransformOrigin: 188.695,
              transformOrigin: 188.695,
            }}
            fill="#FFF"
            d="M188.73 175.65L188.71 175.52 188.66 175.62 188.73 175.65z"
            className="animable"
          ></path>
          <path
            d="M188.15 175.55h.12s-.12-.03-.12 0z"
            style={{
              WebkitTransformOrigin: 188.21,
              MsTransformOrigin: 188.21,
              transformOrigin: 188.21,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M188.3 175.55h.09a.16.16 0 00-.09 0z"
            style={{
              WebkitTransformOrigin: 188.345,
              MsTransformOrigin: 188.345,
              transformOrigin: 188.345,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 188.51,
              MsTransformOrigin: 188.51,
              transformOrigin: 188.51,
            }}
            fill="#FFF"
            d="M188.57 175.68L188.54 175.66 188.45 175.65 188.57 175.68z"
            className="animable"
          ></path>
          <path
            d="M186.88 175.53h-.13s0 .07.07.05.08-.01.06-.05z"
            style={{
              WebkitTransformOrigin: 186.82,
              MsTransformOrigin: 186.82,
              transformOrigin: 186.82,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M187.27 175.87s0-.05-.06-.09v.15z"
            style={{
              WebkitTransformOrigin: 187.24,
              MsTransformOrigin: 187.24,
              transformOrigin: 187.24,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M186.89 175.91s-.18.12 0 .11c-.01-.02.11-.02 0-.11z"
            style={{
              WebkitTransformOrigin: 186.873,
              MsTransformOrigin: 186.873,
              transformOrigin: 186.873,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 184.97,
              MsTransformOrigin: 184.97,
              transformOrigin: 184.97,
            }}
            fill="#FFF"
            d="M184.95 175.71L184.99 175.71 184.98 175.46 184.95 175.71z"
            className="animable"
          ></path>
          <path
            d="M183.24 176.32c.16.06 0-.15.18-.08s-.11-.06-.08-.11-.14.02-.1.19z"
            style={{
              WebkitTransformOrigin: 183.357,
              MsTransformOrigin: 183.357,
              transformOrigin: 183.357,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M183.34 176.13z"
            style={{
              WebkitTransformOrigin: 183.34,
              MsTransformOrigin: 183.34,
              transformOrigin: 183.34,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 163.99,
              MsTransformOrigin: 163.99,
              transformOrigin: 163.99,
            }}
            fill="#FFF"
            d="M164.04 175.03L163.94 174.98 164 175.07 164.04 175.03z"
            className="animable"
          ></path>
          <path
            d="M163.85 175.22v-.16l-.06.15s.04-.02.06.01z"
            style={{
              WebkitTransformOrigin: 163.82,
              MsTransformOrigin: 163.82,
              transformOrigin: 163.82,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M177.26 176.52h-.09z"
            style={{
              WebkitTransformOrigin: 177.215,
              MsTransformOrigin: 177.215,
              transformOrigin: 177.215,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 175.93,
              MsTransformOrigin: 175.93,
              transformOrigin: 175.93,
            }}
            fill="#FFF"
            d="M175.93 176.4L175.95 176.4 175.91 176.26 175.93 176.4z"
            className="animable"
          ></path>
          <path
            d="M174.81 176.59h.15c-.1 0-.16-.19-.15 0z"
            style={{
              WebkitTransformOrigin: 174.884,
              MsTransformOrigin: 174.884,
              transformOrigin: 174.884,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M336.77 165.05c.09 0 .06-.09.07-.11-.15.06-.06.14-.07.11z"
            style={{
              WebkitTransformOrigin: 336.796,
              MsTransformOrigin: 336.796,
              transformOrigin: 336.796,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 335.245,
              MsTransformOrigin: 335.245,
              transformOrigin: 335.245,
            }}
            fill="#FFF"
            d="M335.33 165.29L335.35 165.25 335.14 165.35 335.33 165.29z"
            className="animable"
          ></path>
          <path
            d="M334 165.29c.13.18.49 0 .73 0l.11-.14a4.18 4.18 0 01-.84.14z"
            style={{
              WebkitTransformOrigin: 334.42,
              MsTransformOrigin: 334.42,
              transformOrigin: 334.42,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M333.26 164.9c0 .07-.16.06.17 0z"
            style={{
              WebkitTransformOrigin: 333.326,
              MsTransformOrigin: 333.326,
              transformOrigin: 333.326,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M333.4 164.9c.14 0-.1-.05 0 0z"
            style={{
              WebkitTransformOrigin: 333.41,
              MsTransformOrigin: 333.41,
              transformOrigin: 333.41,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M332.74 164.94l.19-.06s-.21 0-.15-.08c-.19.04-.15.08-.04.14z"
            style={{
              WebkitTransformOrigin: 332.789,
              MsTransformOrigin: 332.789,
              transformOrigin: 332.789,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M332.56 165.07h.1s-.04-.07-.1 0z"
            style={{
              WebkitTransformOrigin: 332.61,
              MsTransformOrigin: 332.61,
              transformOrigin: 332.61,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M332.87 165l-.21.06s0 .09.09 0c-.01.02.03-.06.12-.06z"
            style={{
              WebkitTransformOrigin: 332.765,
              MsTransformOrigin: 332.765,
              transformOrigin: 332.765,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M333 165c.11 0 .24.06.06.13.33-.01.28-.13-.06-.13z"
            style={{
              WebkitTransformOrigin: 333.141,
              MsTransformOrigin: 333.141,
              transformOrigin: 333.141,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M333.91 165.47l.14.05.12-.06c-.06.03-.27-.04-.26.01z"
            style={{
              WebkitTransformOrigin: 334.04,
              MsTransformOrigin: 334.04,
              transformOrigin: 334.04,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M331.57 164.85s.07.1.08.15h.14c-.07-.07-.21-.09-.22-.15z"
            style={{
              WebkitTransformOrigin: 331.68,
              MsTransformOrigin: 331.68,
              transformOrigin: 331.68,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M331.65 165l-.21.07c.19 0 .22-.07.21-.07z"
            style={{
              WebkitTransformOrigin: 331.546,
              MsTransformOrigin: 331.546,
              transformOrigin: 331.546,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 332.665,
              MsTransformOrigin: 332.665,
              transformOrigin: 332.665,
            }}
            fill="#FFF"
            d="M332.53 165.27L332.87 165.14 332.46 165.28 332.53 165.27z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 330.795,
              MsTransformOrigin: 330.795,
              transformOrigin: 330.795,
            }}
            fill="#FFF"
            d="M330.78 164.85L330.9 164.76 330.69 164.89 330.78 164.85z"
            className="animable"
          ></path>
          <path
            d="M330.26 164.86c.09-.07-.12-.12 0-.17a1.09 1.09 0 00-.37.14.63.63 0 01.37.03z"
            style={{
              WebkitTransformOrigin: 330.087,
              MsTransformOrigin: 330.087,
              transformOrigin: 330.087,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M329.68 164.91l.18-.08a.48.48 0 00-.18.08z"
            style={{
              WebkitTransformOrigin: 329.77,
              MsTransformOrigin: 329.77,
              transformOrigin: 329.77,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M331.09 165.05a.21.21 0 00-.16-.11l.08.11z"
            style={{
              WebkitTransformOrigin: 331.01,
              MsTransformOrigin: 331.01,
              transformOrigin: 331.01,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M331.11 165.05z"
            style={{
              WebkitTransformOrigin: 331.11,
              MsTransformOrigin: 331.11,
              transformOrigin: 331.11,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M332 165.18c-.12.06-.38.12-.13.21.07-.07-.07-.12.13-.21z"
            style={{
              WebkitTransformOrigin: 331.883,
              MsTransformOrigin: 331.883,
              transformOrigin: 331.883,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M331.21 165.18h.22v-.1z"
            style={{
              WebkitTransformOrigin: 331.32,
              MsTransformOrigin: 331.32,
              transformOrigin: 331.32,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 331.16,
              MsTransformOrigin: 331.16,
              transformOrigin: 331.16,
            }}
            fill="#FFF"
            d="M331.11 165.22L331.21 165.18 331.13 165.17 331.11 165.22z"
            className="animable"
          ></path>
          <path
            d="M330.05 165a.78.78 0 01-.31.06 2.34 2.34 0 00.38 0s.07-.06-.07-.06z"
            style={{
              WebkitTransformOrigin: 329.939,
              MsTransformOrigin: 329.939,
              transformOrigin: 329.939,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M330.52 165s0 .06 0 0z"
            style={{
              WebkitTransformOrigin: 330.52,
              MsTransformOrigin: 330.52,
              transformOrigin: 330.52,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M328.58 165.07z"
            style={{
              WebkitTransformOrigin: 328.58,
              MsTransformOrigin: 328.58,
              transformOrigin: 328.58,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M330.14 165.12a.25.25 0 00.2 0h-.2z"
            style={{
              WebkitTransformOrigin: 330.229,
              MsTransformOrigin: 330.229,
              transformOrigin: 330.229,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M329.35 165l.17.06s-.15-.13-.17-.06z"
            style={{
              WebkitTransformOrigin: 329.435,
              MsTransformOrigin: 329.435,
              transformOrigin: 329.435,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M330.47 165s-.02 0 0 0z"
            style={{
              WebkitTransformOrigin: 330.466,
              MsTransformOrigin: 330.466,
              transformOrigin: 330.466,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M330.47 165l-.13.07h.16l-.03-.07z"
            style={{
              WebkitTransformOrigin: 330.42,
              MsTransformOrigin: 330.42,
              transformOrigin: 330.42,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M328.23 165.75c0-.1.27-.19.48-.08.21-.08.07-.4-.11-.58 0 0 0 .08-.22.14.07.05.48.12.29.21s-.23 0-.37-.08c.12.12-.37.17-.3.36l.25-.07s-.09.08-.02.1z"
            style={{
              WebkitTransformOrigin: 328.404,
              MsTransformOrigin: 328.404,
              transformOrigin: 328.404,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M329 165.1h.09a.76.76 0 01-.31-.13c-.14.05-.18.08-.19.12h.41z"
            style={{
              WebkitTransformOrigin: 328.84,
              MsTransformOrigin: 328.84,
              transformOrigin: 328.84,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M329.5 165.08c-.07.11-.28.16-.15.27s.19-.09.34-.13c-.42 0 .12-.06-.18-.13h.23-.22c-.12 0 0 0 0 0l-.43.06a1.72 1.72 0 00.41-.07z"
            style={{
              WebkitTransformOrigin: 329.415,
              MsTransformOrigin: 329.415,
              transformOrigin: 329.415,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M331.63 165.62s-.05 0 0 0z"
            style={{
              WebkitTransformOrigin: 331.619,
              MsTransformOrigin: 331.619,
              transformOrigin: 331.619,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M331.46 165.56a.16.16 0 01.15-.05c.09 0 0 .05 0 .09s.21-.08 0-.13c-.17 0-.39-.17-.36-.18a.77.77 0 00.21.27z"
            style={{
              WebkitTransformOrigin: 331.475,
              MsTransformOrigin: 331.475,
              transformOrigin: 331.475,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M330.47 165.35l-.35.05.18.09v-.05c.19.02.14-.05.17-.09z"
            style={{
              WebkitTransformOrigin: 330.295,
              MsTransformOrigin: 330.295,
              transformOrigin: 330.295,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 328.485,
              MsTransformOrigin: 328.485,
              transformOrigin: 328.485,
            }}
            fill="#FFF"
            d="M328.54 165.01L328.59 164.9 328.38 165.06 328.54 165.01z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 328.04,
              MsTransformOrigin: 328.04,
              transformOrigin: 328.04,
            }}
            fill="#FFF"
            d="M328.08 165.03L328.1 164.93 327.98 164.99 328.08 165.03z"
            className="animable"
          ></path>
          <path
            d="M302.2 166.25h-.11z"
            style={{
              WebkitTransformOrigin: 302.145,
              MsTransformOrigin: 302.145,
              transformOrigin: 302.145,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M303 166.26s-.08 0 0 0z"
            style={{
              WebkitTransformOrigin: 302.982,
              MsTransformOrigin: 302.982,
              transformOrigin: 302.982,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M316.82 165c-.15-.1-.32-.24-.31-.13l.05.11a.43.43 0 01.26.02z"
            style={{
              WebkitTransformOrigin: 316.665,
              MsTransformOrigin: 316.665,
              transformOrigin: 316.665,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M309.1 165.68a1.14 1.14 0 00.11-.11z"
            style={{
              WebkitTransformOrigin: 309.155,
              MsTransformOrigin: 309.155,
              transformOrigin: 309.155,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M309 166.13l-.2-.07a.66.66 0 00.2.07z"
            style={{
              WebkitTransformOrigin: 308.9,
              MsTransformOrigin: 308.9,
              transformOrigin: 308.9,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M298.1 166.37l-.13.11c.19 0 .11-.06.13-.11z"
            style={{
              WebkitTransformOrigin: 298.035,
              MsTransformOrigin: 298.035,
              transformOrigin: 298.035,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M323.38 165.07a1.16 1.16 0 00-.32-.07c.16.06.28.16.32.07z"
            style={{
              WebkitTransformOrigin: 323.22,
              MsTransformOrigin: 323.22,
              transformOrigin: 323.22,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M302.49 165.1c-.06 0-.09 0-.09.07s.11-.04.09-.07z"
            style={{
              WebkitTransformOrigin: 302.446,
              MsTransformOrigin: 302.446,
              transformOrigin: 302.446,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M322.68 165h.07a1 1 0 01.31 0 .42.42 0 00-.38 0z"
            style={{
              WebkitTransformOrigin: 322.87,
              MsTransformOrigin: 322.87,
              transformOrigin: 322.87,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M283.22 166.28s-.02 0 0 0z"
            style={{
              WebkitTransformOrigin: 283.216,
              MsTransformOrigin: 283.216,
              transformOrigin: 283.216,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M278.89 165.18h.18a.52.52 0 00-.18 0z"
            style={{
              WebkitTransformOrigin: 278.98,
              MsTransformOrigin: 278.98,
              transformOrigin: 278.98,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M326.24 165c.09 0 0 0 0 0z"
            style={{
              WebkitTransformOrigin: 326.26,
              MsTransformOrigin: 326.26,
              transformOrigin: 326.26,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M326.71 165.41a.07.07 0 000 .05.07.07 0 010-.05z"
            style={{
              WebkitTransformOrigin: 326.708,
              MsTransformOrigin: 326.708,
              transformOrigin: 326.708,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M321.71 165.68s.02.01 0 0z"
            style={{
              WebkitTransformOrigin: 321.714,
              MsTransformOrigin: 321.714,
              transformOrigin: 321.714,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M326.38 165a.24.24 0 00-.12 0z"
            style={{
              WebkitTransformOrigin: 326.32,
              MsTransformOrigin: 326.32,
              transformOrigin: 326.32,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M326.36 165h0z"
            style={{
              WebkitTransformOrigin: 326.405,
              MsTransformOrigin: 326.405,
              transformOrigin: 326.405,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M326.1 165h.16z"
            style={{
              WebkitTransformOrigin: 326.18,
              MsTransformOrigin: 326.18,
              transformOrigin: 326.18,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M291.19 166c-.12 0-.07 0 0 0z"
            style={{
              WebkitTransformOrigin: 291.154,
              MsTransformOrigin: 291.154,
              transformOrigin: 291.154,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M314.28 166.16z"
            style={{
              WebkitTransformOrigin: 314.28,
              MsTransformOrigin: 314.28,
              transformOrigin: 314.28,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M313.93 166.24a.34.34 0 01.35-.09l-.11-.31z"
            style={{
              WebkitTransformOrigin: 314.105,
              MsTransformOrigin: 314.105,
              transformOrigin: 314.105,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M300.4 166.28l.24.1c-.29.16-.51.11-.28.24 0-.34 1 0 1-.37l.16.07h-.1c.32.17.24-.24.64-.19.14 0 .24.07.15.11l.31-.08c.09 0 .07.06 0 .06h.48a2.14 2.14 0 01.3-.17c.12.05-.07 0 0 .08l.26-.08c.11.08-.11.17-.29.16.24.34.22-.09.75.11h-.25c.16.2.36.13.64.25-.06-.07-.57-.31-.28-.39a.5.5 0 00.35 0c0 .12.15.09.34.08v.16c.2 0 .19-.12.31-.2a.35.35 0 01.33.25c.37 0-.25-.2.18-.23a1.86 1.86 0 00.88-.1c.22.05 0 .1 0 .14l.19-.13c.05 0 0 0 0 .07.16-.05 0-.16.26-.21.07-.17.52.26.83.06.07.05 0 .1 0 .16a2.64 2.64 0 00.72-.27l.29.1c-.21-.12.07-.26.31-.38l-.19-.13.39-.08c.05 0 0 .08-.05.14h.07c.14 0 .07.15 0 .24l-.15-.1c-.09.09-.18.2-.16.3a.27.27 0 01.13-.05s-.05.05 0 .07.05 0 .11-.06l.09.18v-.07l.51.11a3.35 3.35 0 011.26-.52c-.14.13 0 .21 0 .37-.16-.16-.45.07-.75 0 .16 0 .12.09.08.11l.54-.15c0 .13.12.1.26.15-.11-.25.4-.17.61-.24 0 .08 0 .17-.3.15.29.19.38-.3.67-.14h-.13c.15-.07.53 0 .44.06h-.07c.44 0 1.32 0 1.38-.21a.9.9 0 01-.08.3l.77-.71c-.07.18.19.61-.16.72a.82.82 0 00.44 0c-.07 0-.17-.26-.08-.28a2.25 2.25 0 00.51.28c-.1 0 0-.32.18-.32 0 0 0 .29-.05.32l.42-.28c-.11 0 0 .23.07.31s.36 0 .47 0l-.18-.06c.47 0 .46-.4.93-.38-.06.05-.14.35.09.39a2.16 2.16 0 01.89-.81l.08.09.32-.1a6 6 0 01-1.05.85c.17.07.05.1.31.09.09.08-.14.12-.22.12l.61.05c0-.16.47-.16.44-.3l-.66.17c0-.17.38-.48.82-.45.11.07-.09.3-.08.36a.74.74 0 01.45-.07l-.18.09c.24.06.39-.22.68-.06.1 0 .3.21.32.11a1.11 1.11 0 01-.09-.93 5.72 5.72 0 01.64.28c.16.15-.25.36-.11.49 0-.05.1-.1.13-.12s0 .14.19.12c0-.17.46 0 .11-.14h.49c-.08-.11.24-.37.46-.42 0 0 0 .1.06.13.46 0 .7.09 1.13.09 0 0 .24.09.16.16a.5.5 0 01.25-.09c.25.15-.3 0-.1.2 0-.1.34-.13.52-.2-.05-.15-.43 0-.62 0 0-.21.33-.44.77-.53s.16.13.22.1c.66 0 .56-.37 1.12-.21.21.13 0 .26 0 .36-.28.05-.44-.08-.63-.08l.24.07a.65.65 0 01-.39 0c.18.13 1.12 0 1.63.14.09 0 .25-.09.18-.15h-.17c-.15-.11.31-.15.1-.2a1.44 1.44 0 01.77-.13l.06.15s-.2-.09-.29 0c.13-.07.47.2.61 0l-.21-.1a1.48 1.48 0 01.76-.19c-.13-.16-.07 0-.26-.16.17.22-.69 0-.42.22-.2-.21-.35-.09-.61-.26 0 .05.1.09-.13.07h-.05a.27.27 0 01.12.07c-.12.12-.48.12-.6.18s.06-.06 0-.12l-.18.09c0-.11-.36-.18 0-.25h-.29a.85.85 0 00-.54 0c-.14 0-.34.12-.23 0l-.45.07a3.58 3.58 0 01-1.42 0 1.81 1.81 0 01-.55 0l-.05-.1c-.19 0-.58-.1-.66 0-.21-.26-.93-.05-1.27-.1v.25a3.47 3.47 0 00-.74.08v.11c-.25.09-.64-.08-1-.07h.19c-.47-.26-1 .18-1.41 0a.33.33 0 01-.26 0 .59.59 0 00-.14-.06.67.67 0 00.12.06 1.47 1.47 0 00-.33 0l-.05-.12c-.12 0-.09.06 0 .15l-.16.07c-.1-.19-.32.07-.45-.14-.08.1-.61.08-.68.29a.58.58 0 00-.39 0l-.06-.15-.3.2c-.18-.09-.25-.14-.07-.26-.43.18-.35.07-.72.25v-.1c-.13 0-.34.13-.42 0-.29-.19-1.45 0-2.2-.2.14.29-.35-.13-.38.1-.05-.07-.15-.11 0-.17-.38.07-.58-.11-.84.08-.05-.07.08-.1 0-.14s-.12.06-.16 0 .06-.06.12-.09c-.4 0-.44.22-.46.42a.35.35 0 00-.45 0c-.06-.06-.18-.13.06-.16-.13 0-.83-.09-.85.07h-.86.08c-.12.2-.25.05-.49.07-.55-.14-.24.07-.79-.09v.12c-.05.25-.49-.16-.81-.06l.12.07c-.18.09-.49-.35-.66-.38s.06 0 .11-.05c-.46-.16-.06.15-.4.19-.07-.09.08-.22-.15-.23s-.67.27-1 .11c.07.07.13.13 0 .18s-.66-.25-.88 0c0 0-.05 0-.05-.05-.18.05-.6.09-.71.2-.18-.42-1.16.2-1.16-.18h-.57a.78.78 0 00-.62.16c-.08 0 0-.06 0-.08a1.34 1.34 0 00-1 .12l-.05-.12c-.12.07-.77-.19-1.3-.05a.1.1 0 01.06 0c-.59.14-1.41-.35-1.63.1l-.39.11c.51 0-.07.2.13.28-.19 0-.51-.14-.26-.16.09-.24-.62-.09-.61-.25-1 0-2-.11-2.89-.12l.11.18h-.32c-.09 0-.12-.14.11-.14-.12-.1-.38.09-.39.13-.45-.07.18-.21 0-.22h-.19c-.15.07-.16.15-.44.14s-.09-.11-.16-.12 0 0-.11 0h-.41l.17.15c-.18.07-.39 0-.2.15-.27-.25-1.52-.09-1.69-.17a1.65 1.65 0 01-.81.09c.07 0 .12.2-.15.18.1-.34-.49-.15-.7-.39.19.16-.76 0-.46.27-.22 0 0-.13-.18-.21a12.8 12.8 0 01-1.83 0c0 .05.1.11 0 .18l-.35-.22c-.13 0-.12.25-.35.1 0 0 .08.09 0 .11-1.28-.22-2.62.17-3.93-.23.18.08.06.09-.07.1.08 0 0 .1 0 .16l-.54-.16c-.1.16-.59 0-.65.17h.18c-.23.19.32.41.28.65.26-.21.68.32 1.11 0 .09.05-.08.08 0 .14.1-.11.23-.13.47-.08a11.88 11.88 0 011.71.15v-.12a.72.72 0 01.27.08c.19-.18-.45 0-.28-.21.21.24 1.14 0 1.29.28.25 0-.08-.14.17-.13l.07.07.06-.1c.17 0 .25.11.26.18a.44.44 0 00-.16 0c.21.09.6 0 .67 0l-.24-.05a19.5 19.5 0 002.18-.12l-.05-.06c.5-.1.4.06 1 0a.88.88 0 01.41-.08c-.14.07.26.13.08.2.54-.11.27-.09.63-.29l.08.09a.57.57 0 01.41-.15c-.23.08.18.14-.08.24.58.21.86-.2 1.13.1.27-.26-.5-.15-.35-.2-.13-.09.22-.19.4-.17s.31.33.78.33h-.1c.18.07.35-.09.56 0 .12-.15.28 0 .31-.19h-.43c.25 0 .47-.29.87-.17a.7.7 0 01-.23.12c.12.06.23 0 .35 0 0 .2-.52 0-.78.19.12.09.49-.14.36.07.19-.27.46 0 .77-.17v.12a.57.57 0 01.25-.07l-.17.15c.26-.13.49.12.74 0-.51 0-.12-.14-.33-.22.63-.16.36.31 1.07.25-.1 0-.36-.07-.21-.13a1.27 1.27 0 01.39.13c.47 0-.07-.12.13-.19.16.14.23-.06.44-.11v.13c.53.07.14-.26.62-.16l-.2.16h.25l-.05.14a1 1 0 01.62 0c-.06-.08 0-.22.28-.22s-.09.11.24.1c-.07.07-.16.17-.3.06s-.08.07-.09.11a1.3 1.3 0 00.55 0 .5.5 0 01-.13 0l.49-.17c.08.05 0 .08 0 .12a2.24 2.24 0 01.31-.08c0 .1 0 .2-.24.25l.47-.11s.24.11.18.15c.25.06.63-.19 1-.11h.12a2.07 2.07 0 001 0l.21.18c.3 0-.29-.22.21-.29s.13.15.25.2a.91.91 0 01.8-.13 1 1 0 01-.63.06zm3.67-.07c-.08 0-.22.1-.27 0s.14-.04.27 0zm5.57-.29h-.23a.47.47 0 01.23 0zm15.53-.84c-.17-.08-.11-.03 0 0zm.33 0a.24.24 0 01-.18 0s.08.08.18.05zm-35.35.05h.07c-.15.11-.11.08-.07.05z"
            style={{
              WebkitTransformOrigin: 302.94,
              MsTransformOrigin: 302.94,
              transformOrigin: 302.94,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M309 166.08a.09.09 0 010-.06v.06z"
            style={{
              WebkitTransformOrigin: 308.997,
              MsTransformOrigin: 308.997,
              transformOrigin: 308.997,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M298.12 166.35z"
            style={{
              WebkitTransformOrigin: 298.12,
              MsTransformOrigin: 298.12,
              transformOrigin: 298.12,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M320.4 166.15a.4.4 0 01-.13-.06s.03.05.13.06z"
            style={{
              WebkitTransformOrigin: 320.335,
              MsTransformOrigin: 320.335,
              transformOrigin: 320.335,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M327.24 164.92h-.21a.44.44 0 01.19 0s-.04.01.02 0z"
            style={{
              WebkitTransformOrigin: 327.135,
              MsTransformOrigin: 327.135,
              transformOrigin: 327.135,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M329.07 165.67h.1v-.05c-.17-.02-.23.03-.1.05z"
            style={{
              WebkitTransformOrigin: 329.085,
              MsTransformOrigin: 329.085,
              transformOrigin: 329.085,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M327.44 165.32c0 .11.15.07.3.05.01-.14-.14-.09-.3-.05z"
            style={{
              WebkitTransformOrigin: 327.59,
              MsTransformOrigin: 327.59,
              transformOrigin: 327.59,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M327.77 165.37h.14c.01-.06-.06-.01-.14 0z"
            style={{
              WebkitTransformOrigin: 327.84,
              MsTransformOrigin: 327.84,
              transformOrigin: 327.84,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M325.92 165.06c.07 0 0-.13.08-.09.08-.13-.47.16-.08.09z"
            style={{
              WebkitTransformOrigin: 325.893,
              MsTransformOrigin: 325.893,
              transformOrigin: 325.893,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 327.49,
              MsTransformOrigin: 327.49,
              transformOrigin: 327.49,
            }}
            fill="#FFF"
            d="M327.56 165.66L327.5 165.53 327.42 165.63 327.56 165.66z"
            className="animable"
          ></path>
          <path
            d="M326.39 165.57h.3c-.14-.02-.3-.04-.3 0z"
            style={{
              WebkitTransformOrigin: 326.54,
              MsTransformOrigin: 326.54,
              transformOrigin: 326.54,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M326.69 165.56a.5.5 0 00.19 0 .68.68 0 00-.19 0z"
            style={{
              WebkitTransformOrigin: 326.785,
              MsTransformOrigin: 326.785,
              transformOrigin: 326.785,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 327.12,
              MsTransformOrigin: 327.12,
              transformOrigin: 327.12,
            }}
            fill="#FFF"
            d="M327.24 165.7L327.17 165.67 327 165.66 327.24 165.7z"
            className="animable"
          ></path>
          <path
            d="M323.86 165.54h-.26s0 .07.14 0 .16.04.12 0z"
            style={{
              WebkitTransformOrigin: 323.739,
              MsTransformOrigin: 323.739,
              transformOrigin: 323.739,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M324.63 165.89c-.07 0-.07-.06-.11-.1v.21z"
            style={{
              WebkitTransformOrigin: 324.575,
              MsTransformOrigin: 324.575,
              transformOrigin: 324.575,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M323.88 165.92c0 .05-.37.13 0 .12-.02-.04.24-.04 0-.12z"
            style={{
              WebkitTransformOrigin: 323.849,
              MsTransformOrigin: 323.849,
              transformOrigin: 323.849,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 320.035,
              MsTransformOrigin: 320.035,
              transformOrigin: 320.035,
            }}
            fill="#FFF"
            d="M320 165.73L320.07 165.72 320.06 165.47 320 165.73z"
            className="animable"
          ></path>
          <path
            d="M316.58 166.33c.31.07.07-.15.35-.08.07-.06-.23-.06-.15-.11-.19.06-.28.03-.2.19z"
            style={{
              WebkitTransformOrigin: 316.746,
              MsTransformOrigin: 316.746,
              transformOrigin: 316.746,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M316.78 166.14h.09z"
            style={{
              WebkitTransformOrigin: 316.825,
              MsTransformOrigin: 316.825,
              transformOrigin: 316.825,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 278.07,
              MsTransformOrigin: 278.07,
              transformOrigin: 278.07,
            }}
            fill="#FFF"
            d="M278.17 165.05L277.97 164.99 278.1 165.08 278.17 165.05z"
            className="animable"
          ></path>
          <path
            d="M277.79 165.24v-.17l-.12.15s.09-.02.12.02z"
            style={{
              WebkitTransformOrigin: 277.73,
              MsTransformOrigin: 277.73,
              transformOrigin: 277.73,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M304.61 166.53s-.08 0-.17-.05z"
            style={{
              WebkitTransformOrigin: 304.525,
              MsTransformOrigin: 304.525,
              transformOrigin: 304.525,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 301.955,
              MsTransformOrigin: 301.955,
              transformOrigin: 301.955,
            }}
            fill="#FFF"
            d="M301.95 166.41L302 166.42 301.91 166.27 301.95 166.41z"
            className="animable"
          ></path>
          <path
            d="M299.72 166.6h.29c-.2.01-.32-.18-.29 0z"
            style={{
              WebkitTransformOrigin: 299.863,
              MsTransformOrigin: 299.863,
              transformOrigin: 299.863,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M346.06 170.46c.1 0 .07-.1.08-.12-.14.03-.07.15-.08.12z"
            style={{
              WebkitTransformOrigin: 346.096,
              MsTransformOrigin: 346.096,
              transformOrigin: 346.096,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 344.3,
              MsTransformOrigin: 344.3,
              transformOrigin: 344.3,
            }}
            fill="#FFF"
            d="M344.39 170.7L344.42 170.65 344.18 170.76 344.39 170.7z"
            className="animable"
          ></path>
          <path
            d="M342.83 170.69c.15.18.57 0 .85 0l.13-.14a5.42 5.42 0 01-.98.14z"
            style={{
              WebkitTransformOrigin: 343.32,
              MsTransformOrigin: 343.32,
              transformOrigin: 343.32,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M342 170.31c.05.07-.18.06.19 0z"
            style={{
              WebkitTransformOrigin: 342.082,
              MsTransformOrigin: 342.082,
              transformOrigin: 342.082,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M342.16 170.31c.16 0-.11-.06 0 0z"
            style={{
              WebkitTransformOrigin: 342.172,
              MsTransformOrigin: 342.172,
              transformOrigin: 342.172,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M341.4 170.35l.21-.06s-.23 0-.16-.08c-.22.03-.18.08-.05.14z"
            style={{
              WebkitTransformOrigin: 341.452,
              MsTransformOrigin: 341.452,
              transformOrigin: 341.452,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M341.19 170.48h.12s-.05-.05-.12 0z"
            style={{
              WebkitTransformOrigin: 341.25,
              MsTransformOrigin: 341.25,
              transformOrigin: 341.25,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M341.54 170.4l-.23.06s0 .08.1 0c-.02.03.03-.02.13-.06z"
            style={{
              WebkitTransformOrigin: 341.425,
              MsTransformOrigin: 341.425,
              transformOrigin: 341.425,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M341.68 170.43c.12 0 .28.06.06.12.41-.02.35-.15-.06-.12z"
            style={{
              WebkitTransformOrigin: 341.85,
              MsTransformOrigin: 341.85,
              transformOrigin: 341.85,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M342.75 170.88l.16.05.14-.06c-.05.03-.31-.05-.3.01z"
            style={{
              WebkitTransformOrigin: 342.9,
              MsTransformOrigin: 342.9,
              transformOrigin: 342.9,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M340.05 170.26s.07.1.09.15h.16c-.08-.07-.24-.09-.25-.15z"
            style={{
              WebkitTransformOrigin: 340.175,
              MsTransformOrigin: 340.175,
              transformOrigin: 340.175,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M340.14 170.41l-.24.07c.21 0 .25-.03.24-.07z"
            style={{
              WebkitTransformOrigin: 340.021,
              MsTransformOrigin: 340.021,
              transformOrigin: 340.021,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 341.315,
              MsTransformOrigin: 341.315,
              transformOrigin: 341.315,
            }}
            fill="#FFF"
            d="M341.15 170.68L341.55 170.54 341.08 170.68 341.15 170.68z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 339.15,
              MsTransformOrigin: 339.15,
              transformOrigin: 339.15,
            }}
            fill="#FFF"
            d="M339.13 170.26L339.27 170.17 339.03 170.3 339.13 170.26z"
            className="animable"
          ></path>
          <path
            d="M338.53 170.27c.1-.07-.14-.12 0-.17a1.75 1.75 0 00-.44.13.88.88 0 01.44.04z"
            style={{
              WebkitTransformOrigin: 338.323,
              MsTransformOrigin: 338.323,
              transformOrigin: 338.323,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M337.85 170.32a1 1 0 00.21-.09z"
            style={{
              WebkitTransformOrigin: 337.955,
              MsTransformOrigin: 337.955,
              transformOrigin: 337.955,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M339.49 170.46a.22.22 0 00-.19-.11l.1.1z"
            style={{
              WebkitTransformOrigin: 339.395,
              MsTransformOrigin: 339.395,
              transformOrigin: 339.395,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M339.4 170.46z"
            style={{
              WebkitTransformOrigin: 339.4,
              MsTransformOrigin: 339.4,
              transformOrigin: 339.4,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M339.51 170.46z"
            style={{
              WebkitTransformOrigin: 339.51,
              MsTransformOrigin: 339.51,
              transformOrigin: 339.51,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M340.53 170.58c-.14.06-.44.13-.15.22.1-.07-.06-.13.15-.22z"
            style={{
              WebkitTransformOrigin: 340.394,
              MsTransformOrigin: 340.394,
              transformOrigin: 340.394,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M339.63 170.59h.26s-.06-.06 0-.09z"
            style={{
              WebkitTransformOrigin: 339.76,
              MsTransformOrigin: 339.76,
              transformOrigin: 339.76,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 339.57,
              MsTransformOrigin: 339.57,
              transformOrigin: 339.57,
            }}
            fill="#FFF"
            d="M339.51 170.62L339.63 170.59 339.54 170.58 339.51 170.62z"
            className="animable"
          ></path>
          <path
            d="M338.29 170.42a1.07 1.07 0 01-.37.05 2.25 2.25 0 00.44 0s.08-.06-.07-.05z"
            style={{
              WebkitTransformOrigin: 338.151,
              MsTransformOrigin: 338.151,
              transformOrigin: 338.151,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M338.83 170.45s0 .01 0 0z"
            style={{
              WebkitTransformOrigin: 338.83,
              MsTransformOrigin: 338.83,
              transformOrigin: 338.83,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M336.59 170.47z"
            style={{
              WebkitTransformOrigin: 336.59,
              MsTransformOrigin: 336.59,
              transformOrigin: 336.59,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M338.38 170.53a.35.35 0 00.24 0H338.38z"
            style={{
              WebkitTransformOrigin: 338.489,
              MsTransformOrigin: 338.489,
              transformOrigin: 338.489,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M337.48 170.37l.19.06c-.06-.04-.17-.09-.19-.06z"
            style={{
              WebkitTransformOrigin: 337.575,
              MsTransformOrigin: 337.575,
              transformOrigin: 337.575,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M338.77 170.42s-.02-.01 0 0z"
            style={{
              WebkitTransformOrigin: 338.766,
              MsTransformOrigin: 338.766,
              transformOrigin: 338.766,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M338.77 170.42l-.15.07h.18z"
            style={{
              WebkitTransformOrigin: 338.71,
              MsTransformOrigin: 338.71,
              transformOrigin: 338.71,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M336.18 171.16c0-.1.31-.19.56-.08.24-.08.08-.4-.13-.59 0 0 0 .09-.26.14.09.06.56.13.34.22s-.27 0-.43-.09c.14.13-.42.18-.35.36l.29-.06s-.1.07-.02.1z"
            style={{
              WebkitTransformOrigin: 336.382,
              MsTransformOrigin: 336.382,
              transformOrigin: 336.382,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M337.09 170.5h.1a1.45 1.45 0 01-.36-.13c-.17 0-.21.08-.22.11h.51z"
            style={{
              WebkitTransformOrigin: 336.9,
              MsTransformOrigin: 336.9,
              transformOrigin: 336.9,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M337.65 170.49c-.08.11-.33.15-.17.27s.21-.09.39-.14c-.49 0 .14-.06-.21-.12h.26-.25c-.14 0 0 0 0 0l-.49.06a2.25 2.25 0 00.47-.07z"
            style={{
              WebkitTransformOrigin: 337.55,
              MsTransformOrigin: 337.55,
              transformOrigin: 337.55,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M340.11 171s-.05 0 0 0z"
            style={{
              WebkitTransformOrigin: 340.099,
              MsTransformOrigin: 340.099,
              transformOrigin: 340.099,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M339.91 171a.24.24 0 01.18-.05c.1 0 0 .05 0 .09s.24-.08 0-.13c-.2 0-.45-.17-.42-.19a.83.83 0 00.24.28z"
            style={{
              WebkitTransformOrigin: 339.932,
              MsTransformOrigin: 339.932,
              transformOrigin: 339.932,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M338.77 170.76l-.41.05.21.09v-.05c.22.02.17-.05.2-.09z"
            style={{
              WebkitTransformOrigin: 338.565,
              MsTransformOrigin: 338.565,
              transformOrigin: 338.565,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 336.475,
              MsTransformOrigin: 336.475,
              transformOrigin: 336.475,
            }}
            fill="#FFF"
            d="M336.54 170.42L336.59 170.31 336.36 170.47 336.54 170.42z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 335.96,
              MsTransformOrigin: 335.96,
              transformOrigin: 335.96,
            }}
            fill="#FFF"
            d="M336.01 170.43L336.03 170.34 335.89 170.4 336.01 170.43z"
            className="animable"
          ></path>
          <path
            d="M306.06 171.66h-.12z"
            style={{
              WebkitTransformOrigin: 306,
              MsTransformOrigin: 306,
              transformOrigin: 306,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M306.92 171.67s-.03 0 0 0z"
            style={{
              WebkitTransformOrigin: 306.913,
              MsTransformOrigin: 306.913,
              transformOrigin: 306.913,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M323 170.44c-.17-.09-.37-.23-.35-.12l.06.11a.68.68 0 01.29.01z"
            style={{
              WebkitTransformOrigin: 322.824,
              MsTransformOrigin: 322.824,
              transformOrigin: 322.824,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M314 171.09h.06l.11-.11z"
            style={{
              WebkitTransformOrigin: 314.085,
              MsTransformOrigin: 314.085,
              transformOrigin: 314.085,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M313.92 171.54l-.23-.07a.79.79 0 00.23.07z"
            style={{
              WebkitTransformOrigin: 313.805,
              MsTransformOrigin: 313.805,
              transformOrigin: 313.805,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M301.31 171.78l-.14.11c.22 0 .12-.06.14-.11z"
            style={{
              WebkitTransformOrigin: 301.243,
              MsTransformOrigin: 301.243,
              transformOrigin: 301.243,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M330.57 170.47a1.48 1.48 0 00-.37-.06c.18.06.32.15.37.06z"
            style={{
              WebkitTransformOrigin: 330.385,
              MsTransformOrigin: 330.385,
              transformOrigin: 330.385,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M306.4 170.51c-.08 0-.11 0-.1.07s.11-.04.1-.07z"
            style={{
              WebkitTransformOrigin: 306.349,
              MsTransformOrigin: 306.349,
              transformOrigin: 306.349,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M329.76 170.41h.08a2 2 0 01.36 0 .52.52 0 00-.44 0z"
            style={{
              WebkitTransformOrigin: 329.98,
              MsTransformOrigin: 329.98,
              transformOrigin: 329.98,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M284.1 171.69s-.03 0 0 0z"
            style={{
              WebkitTransformOrigin: 284.093,
              MsTransformOrigin: 284.093,
              transformOrigin: 284.093,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M279.09 170.59z"
            style={{
              WebkitTransformOrigin: 279.09,
              MsTransformOrigin: 279.09,
              transformOrigin: 279.09,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M333.87 170.39c.12 0 0 0 0 0z"
            style={{
              WebkitTransformOrigin: 333.897,
              MsTransformOrigin: 333.897,
              transformOrigin: 333.897,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M334.42 170.82v.05c0 .05-.02-.04 0-.05z"
            style={{
              WebkitTransformOrigin: 334.416,
              MsTransformOrigin: 334.416,
              transformOrigin: 334.416,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M328.64 171.08s.02.02 0 0z"
            style={{
              WebkitTransformOrigin: 328.644,
              MsTransformOrigin: 328.644,
              transformOrigin: 328.644,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M334 170.44h-.14z"
            style={{
              WebkitTransformOrigin: 333.93,
              MsTransformOrigin: 333.93,
              transformOrigin: 333.93,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M334 170.38h.1s.02-.01-.1 0z"
            style={{
              WebkitTransformOrigin: 334.051,
              MsTransformOrigin: 334.051,
              transformOrigin: 334.051,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M333.72 170.39z"
            style={{
              WebkitTransformOrigin: 333.72,
              MsTransformOrigin: 333.72,
              transformOrigin: 333.72,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M293.32 171.4c-.14.03-.09.02 0 0z"
            style={{
              WebkitTransformOrigin: 293.276,
              MsTransformOrigin: 293.276,
              transformOrigin: 293.276,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M320 171.57z"
            style={{
              WebkitTransformOrigin: 320,
              MsTransformOrigin: 320,
              transformOrigin: 320,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M319.64 171.65a.4.4 0 01.4-.09l-.13-.31z"
            style={{
              WebkitTransformOrigin: 319.84,
              MsTransformOrigin: 319.84,
              transformOrigin: 319.84,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M304 171.69l.28.1c-.34.16-.59.11-.32.24 0-.34 1.1 0 1.14-.37l.19.07h-.12c.36.17.27-.24.74-.19.16 0 .28.07.17.11l.36-.08c.11 0 .08.06 0 .06h.56a2.16 2.16 0 01.34-.17c.14.05-.07 0 0 .08l.31-.09c.12.09-.13.18-.35.17.29.33.26-.09.88.11h-.29c.19.19.41.12.74.24-.08-.06-.66-.3-.32-.38a.73.73 0 00.4 0c0 .12.17.09.39.08v.16c.24-.05.22-.13.36-.2a.4.4 0 01.38.25c.42 0-.29-.2.21-.23a2.48 2.48 0 001-.1c.25 0 0 .09 0 .14l.22-.13c.05 0 0 0 0 .06.19-.05 0-.16.31-.2.08-.18.6.26.95.06.09 0 0 .1 0 .16a4 4 0 00.83-.27l.34.1c-.25-.12.07-.26.35-.38a1.53 1.53 0 00-.21-.13l.45-.09c.05 0 0 .08-.07.15h.09c.16.06.07.15 0 .24l-.16-.09c-.12.09-.22.2-.2.29h.15s-.05.05 0 .07.06 0 .13-.06l.11.18v-.08l.59.12a4.33 4.33 0 011.47-.52c-.17.13 0 .21 0 .37-.18-.17-.52.07-.87 0 .18 0 .14.09.1.12l.62-.15c0 .13.13.1.29.15-.12-.25.47-.17.72-.24 0 .08 0 .17-.35.14.34.19.44-.29.77-.13h-.15c.18-.07.61 0 .51.06h-.08c.5 0 1.53 0 1.6-.21a.76.76 0 01-.1.3l.9-.71c-.08.18.22.61-.19.72a1.09 1.09 0 00.51 0c-.08 0-.2-.27-.09-.28a2.49 2.49 0 00.59.28c-.12 0 0-.33.2-.32v.32l.48-.29c-.12 0 0 .24.08.32s.42 0 .55 0l-.21-.07c.54.05.54-.39 1.07-.38-.06.06-.16.36.12.4a2.27 2.27 0 011-.81l.09.09.37-.1a7.17 7.17 0 01-1.21.85c.2.07.05.1.36.09.1.08-.17.12-.26.12l.71.05c0-.17.54-.17.51-.31l-.76.18c0-.17.44-.48.94-.45.12.07-.1.3-.09.36a1 1 0 01.52-.07l-.21.09c.28.06.46-.23.79-.07.11 0 .34.22.36.12a1 1 0 01-.1-.93 4.45 4.45 0 01.74.28c.19.15-.28.36-.12.49 0-.05.11-.11.15-.12s-.05.14.22.12c0-.17.53 0 .12-.15h.58c-.1-.11.27-.37.53-.42 0 0 0 .1.07.12.53 0 .81.1 1.3.1.05 0 .29.09.18.16a.58.58 0 01.29-.09c.3.15-.34 0-.11.2 0-.1.39-.14.61-.2-.07-.15-.5 0-.72 0 0-.21.38-.43.89-.52s.18.13.25.1c.77 0 .65-.37 1.29-.21.25.13 0 .26.07.36-.33.05-.51-.09-.74-.08l.28.06a.77.77 0 01-.45 0c.21.12 1.3 0 1.89.14.11 0 .29-.09.2-.15h-.19c-.17-.11.36-.15.12-.2a1.66 1.66 0 01.89-.13l.06.15c0-.05-.23-.09-.33-.05.15-.06.55.21.71 0l-.25-.11a2.07 2.07 0 01.88-.19c-.14-.15-.07 0-.3-.16.2.22-.8 0-.49.23-.23-.21-.4-.09-.69-.27 0 .05.1.1-.16.08h-.06c.06 0 .12.05.14.08s-.55.11-.7.17.07-.05 0-.11l-.21.09c0-.11-.41-.19 0-.25h-.34a1.33 1.33 0 00-.62 0c-.16 0-.4.13-.26 0l-.52.07a4.54 4.54 0 01-1.64 0 2 2 0 01-.64 0l-.06-.1c-.22 0-.66-.1-.76 0-.24-.26-1.07-.05-1.46-.1v.13a3.93 3.93 0 00-.86.08v.11a6.71 6.71 0 01-1.19-.07h.23c-.54-.25-1.15.19-1.64 0a.44.44 0 01-.3 0l-.17-.06.15.07a1.89 1.89 0 00-.38 0l-.06-.12c-.13 0-.11.06 0 .15a.84.84 0 00-.19.07c-.11-.19-.37.07-.52-.14-.1.1-.71.08-.78.29 0 0-.05 0 0 0a.8.8 0 00-.46 0l-.06-.15-.35.2c-.2-.09-.29-.15-.08-.26-.5.18-.41.06-.83.24v-.1c-.15 0-.4.14-.49.06-.34-.19-1.68 0-2.55-.2.17.29-.4-.13-.44.09-.05-.07-.17-.1 0-.16-.44.06-.66-.11-1 .08-.05-.07.09-.1 0-.14s-.14 0-.19 0 .07-.05.14-.08c-.46 0-.5.22-.54.42a.42.42 0 00-.51.05c-.08-.07-.21-.13.07-.16-.16 0-1-.09-1 .07a.42.42 0 00-.27 0h-.73.09c-.13.19-.29 0-.57.07-.65-.14-.28.06-.92-.1v.12c-.06.26-.57-.15-.94-.05l.14.07c-.21.09-.57-.35-.77-.38 0 0 .07 0 .13-.06-.53-.15-.07.16-.46.2-.08-.09.09-.22-.18-.23s-.77.27-1.13.11c.08.06.16.13 0 .18s-.76-.25-1 0h-.05c-.22 0-.71.08-.83.2-.2-.42-1.34.2-1.34-.18h-.66a1 1 0 00-.73.15c-.09 0 0-.06 0-.08a1.82 1.82 0 00-1.19.13l-.06-.12a7.44 7.44 0 00-1.5 0 .14.14 0 01.07-.06c-.69.15-1.64-.34-1.89.11l-.45.11c.58 0-.09.2.15.27-.23 0-.59-.13-.31-.16h.05c.1-.24-.73-.09-.71-.25-1.15 0-2.27-.12-3.34-.13l.12.19h-.37c-.1-.05-.14-.15.13-.14-.14-.1-.45.09-.46.13-.52-.08.21-.22 0-.22h-.22.05c-.18.07-.19.15-.51.14s-.11-.11-.19-.12 0 0-.12 0h-.47l.19.14c-.21.07-.45 0-.23.16-.32-.25-1.76-.09-2-.17a2.38 2.38 0 01-.94.09c.09 0 .14.19-.17.17.12-.33-.56-.14-.81-.38.22.16-.88 0-.53.26-.26 0 0-.12-.21-.2a17.13 17.13 0 01-2.12 0s.12.11 0 .18l-.4-.22c-.15 0-.14.25-.42.1 0 0 .1.09 0 .1-1.49-.21-3 .18-4.55-.22.2.08.07.09-.09.09.1 0 0 .11 0 .17l-.63-.16c-.12.16-.68 0-.75.17h.2c-.26.18.38.41.34.65.3-.21.78.32 1.27 0 .11.05-.09.08 0 .13.12-.1.27-.12.55-.07a16.13 16.13 0 012 .15l-.07-.12a.8.8 0 01.32.08c.22-.18-.53 0-.33-.21.25.24 1.32 0 1.49.28.29 0-.08-.14.21-.14l.07.08.08-.1c.19 0 .28.11.29.17h-.18a4 4 0 00.78 0l-.28-.05c.79-.07 1.76 0 2.52-.12l-.06-.06c.58-.1.47.06 1.11 0a1 1 0 01.48-.08c-.16.07.3.13.09.2.63-.11.31-.09.73-.29l.1.09a.66.66 0 01.47-.15c-.26.08.21.14-.09.24.67.2 1-.2 1.31.09.3-.25-.58-.14-.41-.19-.15-.09.25-.2.46-.17s.37.33.91.32h-.12c.21.07.4-.09.65 0 .14-.16.32 0 .36-.19h-.5c.28-.06.55-.29 1-.18a.85.85 0 01-.27.13h.4c0 .2-.6 0-.9.19.15.09.57-.14.42.07.21-.27.53 0 .89-.17v.12a.72.72 0 01.28-.07l-.19.15c.3-.13.57.11.85 0-.59 0-.13-.14-.38-.23.73-.16.42.31 1.24.26-.11 0-.42-.07-.24-.13a1.79 1.79 0 01.46.13c.54 0-.09-.12.14-.19.19.14.27-.06.51-.11v.12c.62.08.16-.25.72-.15l-.24.16h.3l-.06.14a1.19 1.19 0 01.72 0c-.07-.09 0-.22.31-.22s-.1.11.29.09c-.09.08-.19.17-.36.06 0 0-.08.08-.1.12a1.81 1.81 0 00.65 0h-.16l.57-.17c.09.05 0 .08-.05.12a2 2 0 01.36-.08c-.05.1 0 .2-.27.24l.53-.1s.28.11.21.15c.3.06.73-.19 1.12-.12l.15-.05a2.57 2.57 0 001.14 0l.25.18c.34 0-.34-.22.23-.29.41-.06.15.15.3.2a1.18 1.18 0 01.92-.13 1.25 1.25 0 01-.52.09zm4.24-.08c-.08 0-.25.11-.31 0 .07-.1.15-.04.29 0zm6.45-.29a.31.31 0 01-.26 0 .6.6 0 01.24 0zm18-.84c-.24-.04-.18-.02-.05 0zm.38.06h-.21c-.1 0 .05.02.14 0zm-40.9 0h.07c-.24.11-.17.08-.12.04z"
            style={{
              WebkitTransformOrigin: 306.965,
              MsTransformOrigin: 306.965,
              transformOrigin: 306.965,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M313.94 171.49v-.07c0-.07-.07.05 0 .07z"
            style={{
              WebkitTransformOrigin: 313.924,
              MsTransformOrigin: 313.924,
              transformOrigin: 313.924,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M301.34 171.76z"
            style={{
              WebkitTransformOrigin: 301.34,
              MsTransformOrigin: 301.34,
              transformOrigin: 301.34,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M327.12 171.56a.45.45 0 01-.15-.06s.03.05.15.06z"
            style={{
              WebkitTransformOrigin: 327.045,
              MsTransformOrigin: 327.045,
              transformOrigin: 327.045,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M335 170.33h-.25a.54.54 0 01.22 0h.03z"
            style={{
              WebkitTransformOrigin: 334.875,
              MsTransformOrigin: 334.875,
              transformOrigin: 334.875,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M337.16 171.08h.11V171c-.17 0-.27.05-.11.08z"
            style={{
              WebkitTransformOrigin: 337.175,
              MsTransformOrigin: 337.175,
              transformOrigin: 337.175,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M335.26 170.73c0 .1.18.07.35.05.02-.14-.17-.09-.35-.05z"
            style={{
              WebkitTransformOrigin: 335.436,
              MsTransformOrigin: 335.436,
              transformOrigin: 335.436,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M335.65 170.78h.15c.02-.06-.06-.02-.15 0z"
            style={{
              WebkitTransformOrigin: 335.727,
              MsTransformOrigin: 335.727,
              transformOrigin: 335.727,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M333.5 170.47c.08 0 .05-.13.1-.09.09-.13-.54.16-.1.09z"
            style={{
              WebkitTransformOrigin: 333.476,
              MsTransformOrigin: 333.476,
              transformOrigin: 333.476,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 335.325,
              MsTransformOrigin: 335.325,
              transformOrigin: 335.325,
            }}
            fill="#FFF"
            d="M335.4 171.07L335.34 170.94 335.25 171.04 335.4 171.07z"
            className="animable"
          ></path>
          <path
            d="M334.05 171H334.4c-.17 0-.35-.06-.35 0z"
            style={{
              WebkitTransformOrigin: 334.225,
              MsTransformOrigin: 334.225,
              transformOrigin: 334.225,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M334.4 171a.68.68 0 00.22 0 .9.9 0 00-.22 0z"
            style={{
              WebkitTransformOrigin: 334.51,
              MsTransformOrigin: 334.51,
              transformOrigin: 334.51,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 334.89,
              MsTransformOrigin: 334.89,
              transformOrigin: 334.89,
            }}
            fill="#FFF"
            d="M335.03 171.1L334.95 171.08 334.75 171.07 335.03 171.1z"
            className="animable"
          ></path>
          <path
            d="M331.12 171h-.3s.05.07.16 0 .18 0 .14 0z"
            style={{
              WebkitTransformOrigin: 330.976,
              MsTransformOrigin: 330.976,
              transformOrigin: 330.976,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M332 171.29c-.08 0-.09 0-.13-.09v.15z"
            style={{
              WebkitTransformOrigin: 331.935,
              MsTransformOrigin: 331.935,
              transformOrigin: 331.935,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M331.15 171.33s-.43.12-.06.11c.03-.04.33-.07.06-.11z"
            style={{
              WebkitTransformOrigin: 331.101,
              MsTransformOrigin: 331.101,
              transformOrigin: 331.101,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 326.7,
              MsTransformOrigin: 326.7,
              transformOrigin: 326.7,
            }}
            fill="#FFF"
            d="M326.66 171.13L326.74 171.13 326.72 170.88 326.66 171.13z"
            className="animable"
          ></path>
          <path
            d="M322.7 171.74c.35.06.09-.15.4-.08.09-.06-.26-.06-.17-.11-.21.06-.33.03-.23.19z"
            style={{
              WebkitTransformOrigin: 322.89,
              MsTransformOrigin: 322.89,
              transformOrigin: 322.89,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M322.93 171.55h.11a.32.32 0 00-.11 0z"
            style={{
              WebkitTransformOrigin: 322.985,
              MsTransformOrigin: 322.985,
              transformOrigin: 322.985,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 278.14,
              MsTransformOrigin: 278.14,
              transformOrigin: 278.14,
            }}
            fill="#FFF"
            d="M278.25 170.46L278.03 170.4 278.17 170.49 278.25 170.46z"
            className="animable"
          ></path>
          <path
            d="M277.82 170.64l-.06-.16-.13.15a.31.31 0 01.19.01z"
            style={{
              WebkitTransformOrigin: 277.725,
              MsTransformOrigin: 277.725,
              transformOrigin: 277.725,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M308.85 171.94s-.09 0-.2-.05z"
            style={{
              WebkitTransformOrigin: 308.75,
              MsTransformOrigin: 308.75,
              transformOrigin: 308.75,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 305.77,
              MsTransformOrigin: 305.77,
              transformOrigin: 305.77,
            }}
            fill="#FFF"
            d="M305.77 171.82L305.82 171.82 305.72 171.68 305.77 171.82z"
            className="animable"
          ></path>
          <path
            d="M303.18 172h.34c-.23 0-.36-.18-.34 0z"
            style={{
              WebkitTransformOrigin: 303.349,
              MsTransformOrigin: 303.349,
              transformOrigin: 303.349,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M307.2 175.87v-.12.12z"
            style={{
              WebkitTransformOrigin: 307.2,
              MsTransformOrigin: 307.2,
              transformOrigin: 307.2,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 306.435,
              MsTransformOrigin: 306.435,
              transformOrigin: 306.435,
            }}
            fill="#FFF"
            d="M306.48 176.1L306.49 176.06 306.38 176.17 306.48 176.1z"
            className="animable"
          ></path>
          <path
            d="M305.8 176.1c.07.18.25 0 .37 0l.05-.15c-.12.11-.31.2-.42.15z"
            style={{
              WebkitTransformOrigin: 306.01,
              MsTransformOrigin: 306.01,
              transformOrigin: 306.01,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M305.44 175.72c0 .07-.07.06.09 0z"
            style={{
              WebkitTransformOrigin: 305.477,
              MsTransformOrigin: 305.477,
              transformOrigin: 305.477,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M305.51 175.72c.07 0 0-.06 0 0z"
            style={{
              WebkitTransformOrigin: 305.526,
              MsTransformOrigin: 305.526,
              transformOrigin: 305.526,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M305.18 175.76l.1-.06s-.1 0-.07-.08-.08.07-.03.14z"
            style={{
              WebkitTransformOrigin: 305.223,
              MsTransformOrigin: 305.223,
              transformOrigin: 305.223,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M305.1 175.89s.02-.05 0 0z"
            style={{
              WebkitTransformOrigin: 305.104,
              MsTransformOrigin: 305.104,
              transformOrigin: 305.104,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M305.25 175.81l-.11.05s0 .09.05 0c-.01.04.01-.01.06-.05z"
            style={{
              WebkitTransformOrigin: 305.195,
              MsTransformOrigin: 305.195,
              transformOrigin: 305.195,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M305.31 175.84c.05 0 .12.06 0 .12.2-.02.17-.15 0-.12z"
            style={{
              WebkitTransformOrigin: 305.379,
              MsTransformOrigin: 305.379,
              transformOrigin: 305.379,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M305.77 176.29l.07.05.06-.06s-.14-.05-.13.01z"
            style={{
              WebkitTransformOrigin: 305.835,
              MsTransformOrigin: 305.835,
              transformOrigin: 305.835,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M304.6 175.67a1.13 1.13 0 000 .15h.07s-.06-.1-.07-.15z"
            style={{
              WebkitTransformOrigin: 304.634,
              MsTransformOrigin: 304.634,
              transformOrigin: 304.634,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M304.64 175.82l-.1.06c.09.01.11-.02.1-.06z"
            style={{
              WebkitTransformOrigin: 304.591,
              MsTransformOrigin: 304.591,
              transformOrigin: 304.591,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 305.15,
              MsTransformOrigin: 305.15,
              transformOrigin: 305.15,
            }}
            fill="#FFF"
            d="M305.08 176.09L305.25 175.95 305.05 176.09 305.08 176.09z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 304.21,
              MsTransformOrigin: 304.21,
              transformOrigin: 304.21,
            }}
            fill="#FFF"
            d="M304.21 175.66L304.26 175.58 304.16 175.71 304.21 175.66z"
            className="animable"
          ></path>
          <path
            d="M303.94 175.68c.05-.07-.06-.12 0-.17s-.13.08-.19.13a.18.18 0 01.19.04z"
            style={{
              WebkitTransformOrigin: 303.852,
              MsTransformOrigin: 303.852,
              transformOrigin: 303.852,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M303.65 175.72a.22.22 0 00.09-.08.32.32 0 00-.09.08z"
            style={{
              WebkitTransformOrigin: 303.695,
              MsTransformOrigin: 303.695,
              transformOrigin: 303.695,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M304.36 175.86s0-.08-.08-.1v.1z"
            style={{
              WebkitTransformOrigin: 304.32,
              MsTransformOrigin: 304.32,
              transformOrigin: 304.32,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M304.32 175.87z"
            style={{
              WebkitTransformOrigin: 304.32,
              MsTransformOrigin: 304.32,
              transformOrigin: 304.32,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M304.37 175.86s0 .02 0 0z"
            style={{
              WebkitTransformOrigin: 304.37,
              MsTransformOrigin: 304.37,
              transformOrigin: 304.37,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M304.81 176c-.06.06-.19.13-.07.22.05-.09-.02-.14.07-.22z"
            style={{
              WebkitTransformOrigin: 304.75,
              MsTransformOrigin: 304.75,
              transformOrigin: 304.75,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M304.42 176h.11v-.1z"
            style={{
              WebkitTransformOrigin: 304.475,
              MsTransformOrigin: 304.475,
              transformOrigin: 304.475,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 304.395,
              MsTransformOrigin: 304.395,
              transformOrigin: 304.395,
            }}
            fill="#FFF"
            d="M304.37 176.03L304.42 176 304.38 175.99 304.37 176.03z"
            className="animable"
          ></path>
          <path
            d="M303.84 175.82a.2.2 0 01-.16.06h.19s.04-.06-.03-.06z"
            style={{
              WebkitTransformOrigin: 303.781,
              MsTransformOrigin: 303.781,
              transformOrigin: 303.781,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M304.07 175.85s.01.02 0 0z"
            style={{
              WebkitTransformOrigin: 304.072,
              MsTransformOrigin: 304.072,
              transformOrigin: 304.072,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M303.1 175.88z"
            style={{
              WebkitTransformOrigin: 303.1,
              MsTransformOrigin: 303.1,
              transformOrigin: 303.1,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M303.88 175.93h.1-.11s0 .01.01 0z"
            style={{
              WebkitTransformOrigin: 303.925,
              MsTransformOrigin: 303.925,
              transformOrigin: 303.925,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M303.49 175.77a.21.21 0 00.08.06s-.07-.08-.08-.06z"
            style={{
              WebkitTransformOrigin: 303.53,
              MsTransformOrigin: 303.53,
              transformOrigin: 303.53,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M304.05 175.83a.23.23 0 00-.07.07h.08s-.01-.06-.01-.07z"
            style={{
              WebkitTransformOrigin: 304.02,
              MsTransformOrigin: 304.02,
              transformOrigin: 304.02,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M302.93 176.57a.14.14 0 01.24-.09c.11-.07 0-.4-.06-.58 0 0 0 .08-.11.14 0 .06.24.13.15.22s-.12 0-.19-.09c.06.12-.18.18-.15.36l.13-.06s-.04.07-.01.1z"
            style={{
              WebkitTransformOrigin: 303.012,
              MsTransformOrigin: 303.012,
              transformOrigin: 303.012,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M303.32 175.91h.05c-.06 0-.09-.06-.16-.14s-.09.09-.09.12h.22z"
            style={{
              WebkitTransformOrigin: 303.245,
              MsTransformOrigin: 303.245,
              transformOrigin: 303.245,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M303.57 175.9c0 .11-.15.15-.08.27s.09-.09.17-.14c-.21 0 .06-.06-.09-.12h.11-.11c-.06 0 0 0 0 0l-.21.06z"
            style={{
              WebkitTransformOrigin: 303.52,
              MsTransformOrigin: 303.52,
              transformOrigin: 303.52,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M304.63 176.44s-.03 0 0 0z"
            style={{
              WebkitTransformOrigin: 304.623,
              MsTransformOrigin: 304.623,
              transformOrigin: 304.623,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M304.54 176.37s0-.05.08 0 0 0 0 .08.11-.07 0-.13c-.09 0-.2-.17-.18-.19a.82.82 0 00.1.24z"
            style={{
              WebkitTransformOrigin: 304.553,
              MsTransformOrigin: 304.553,
              transformOrigin: 304.553,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M304.05 176.16l-.18.06.09.09v-.06c.1.03.04-.04.09-.09z"
            style={{
              WebkitTransformOrigin: 303.96,
              MsTransformOrigin: 303.96,
              transformOrigin: 303.96,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 303.06,
              MsTransformOrigin: 303.06,
              transformOrigin: 303.06,
            }}
            fill="#FFF"
            d="M303.08 175.83L303.11 175.71 303.01 175.88 303.08 175.83z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 302.83,
              MsTransformOrigin: 302.83,
              transformOrigin: 302.83,
            }}
            fill="#FFF"
            d="M302.86 175.84L302.86 175.74 302.8 175.8 302.86 175.84z"
            className="animable"
          ></path>
          <path
            d="M289.91 177.07h-.05z"
            style={{
              WebkitTransformOrigin: 289.885,
              MsTransformOrigin: 289.885,
              transformOrigin: 289.885,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M290.29 177.08V177s-.02.07 0 .08z"
            style={{
              WebkitTransformOrigin: 290.286,
              MsTransformOrigin: 290.286,
              transformOrigin: 290.286,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M297.22 175.85c-.07-.09-.16-.23-.15-.12v.11a.14.14 0 01.15.01z"
            style={{
              WebkitTransformOrigin: 297.145,
              MsTransformOrigin: 297.145,
              transformOrigin: 297.145,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M293.36 176.5s0-.07.05-.1z"
            style={{
              WebkitTransformOrigin: 293.385,
              MsTransformOrigin: 293.385,
              transformOrigin: 293.385,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M293.31 177l-.1-.07z"
            style={{
              WebkitTransformOrigin: 293.26,
              MsTransformOrigin: 293.26,
              transformOrigin: 293.26,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M287.86 177.18l-.06.11c.1 0 .05-.05.06-.11z"
            style={{
              WebkitTransformOrigin: 287.832,
              MsTransformOrigin: 287.832,
              transformOrigin: 287.832,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M300.51 175.88a.35.35 0 00-.17-.06c.08.06.15.18.17.06z"
            style={{
              WebkitTransformOrigin: 300.425,
              MsTransformOrigin: 300.425,
              transformOrigin: 300.425,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M290.06 175.92s-.05 0 0 .06.01-.04 0-.06z"
            style={{
              WebkitTransformOrigin: 290.061,
              MsTransformOrigin: 290.061,
              transformOrigin: 290.061,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M300.16 175.82a.26.26 0 01.15 0s-.09-.08-.15 0z"
            style={{
              WebkitTransformOrigin: 300.235,
              MsTransformOrigin: 300.235,
              transformOrigin: 300.235,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M280.43 177.09s-.02.01 0 0z"
            style={{
              WebkitTransformOrigin: 280.426,
              MsTransformOrigin: 280.426,
              transformOrigin: 280.426,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M278.26 176h.09a.1.1 0 00-.09 0z"
            style={{
              WebkitTransformOrigin: 278.305,
              MsTransformOrigin: 278.305,
              transformOrigin: 278.305,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M301.93 175.79c.05 0 0 0 0 0z"
            style={{
              WebkitTransformOrigin: 301.941,
              MsTransformOrigin: 301.941,
              transformOrigin: 301.941,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M302.17 176.22a.11.11 0 000 .06.08.08 0 010-.06z"
            style={{
              WebkitTransformOrigin: 302.167,
              MsTransformOrigin: 302.167,
              transformOrigin: 302.167,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M302 175.84h-.07z"
            style={{
              WebkitTransformOrigin: 301.965,
              MsTransformOrigin: 301.965,
              transformOrigin: 301.965,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M302 175.79s0-.02 0 0z"
            style={{
              WebkitTransformOrigin: 302,
              MsTransformOrigin: 302,
              transformOrigin: 302,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M301.86 175.8h.08z"
            style={{
              WebkitTransformOrigin: 301.9,
              MsTransformOrigin: 301.9,
              transformOrigin: 301.9,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M284.41 176.8c-.06.04-.04.03 0 0z"
            style={{
              WebkitTransformOrigin: 284.391,
              MsTransformOrigin: 284.391,
              transformOrigin: 284.391,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 295.955,
              MsTransformOrigin: 295.955,
              transformOrigin: 295.955,
            }}
            fill="#FFF"
            d="M295.96 176.98L295.96 176.97 295.95 176.97 295.96 176.98z"
            className="animable"
          ></path>
          <path
            d="M295.78 177.06c.08-.13.12-.12.17-.09l-.05-.31z"
            style={{
              WebkitTransformOrigin: 295.865,
              MsTransformOrigin: 295.865,
              transformOrigin: 295.865,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M289 177.1l.13.1c-.15.16-.26.1-.14.24 0-.34.47 0 .49-.37l.08.07h-.05c.16.16.12-.24.32-.2s.12.08.07.12l.16-.08c.05 0 0 .06 0 0h.24a.63.63 0 01.15-.17c.06 0 0 0 0 .08l.13-.09c.06.09-.05.18-.14.16.12.34.11-.08.38.12h-.13c.08.19.18.12.32.24 0-.06-.28-.3-.14-.39s.09 0 .17 0c0 .13.08.1.17.09v.16c.1-.05.09-.13.15-.2s.14.14.17.24c.18 0-.13-.2.09-.23s.26 0 .44-.1c.11.06 0 .1 0 .15l.1-.13v.06c0 .06 0-.16.13-.2s.26.26.41.06v.16a1.06 1.06 0 00.35-.28l.15.11c-.11-.12 0-.26.15-.38a.56.56 0 00-.09-.13l.2-.09v.15c.07.06 0 .15 0 .24a.36.36 0 01-.07-.1.61.61 0 00-.09.3h.07a.08.08 0 000 .06h.06v.17-.07l.25.11c.19-.18.34-.44.63-.51-.07.13 0 .21 0 .37-.08-.17-.23.07-.38 0 .08 0 .06.09 0 .12l.27-.15c0 .13.06.09.13.15-.06-.25.2-.17.31-.25 0 .09 0 .17-.16.15.15.19.19-.29.34-.13h-.06c-.01 0 .26 0 .21.06.22 0 .66 0 .69-.21v.3l.38-.72c0 .19.1.62-.08.72a.21.21 0 00.23 0s-.09-.27 0-.28c.13.2.09.1.25.28 0 0 0-.33.09-.32s0 .28 0 .31l.2-.28c-.05 0 0 .24 0 .32s.18 0 .23 0l-.08-.07c.23 0 .23-.39.46-.38 0 .06-.07.36.05.39.05-.14.24-.69.44-.8v.08l.16-.09a5.27 5.27 0 01-.53.85c.09.06 0 .1.16.09s-.07.12-.11.12l.3.05c0-.17.24-.17.23-.31l-.34.18c0-.17.2-.48.41-.45s0 .3 0 .35.2-.11.22-.07l-.09.09c.12.07.19-.22.34-.06s.15.22.16.12a2.29 2.29 0 01-.05-.93 1.24 1.24 0 01.32.28c.08.15-.12.36-.05.49a.23.23 0 01.07-.13c.05 0 0 .15.09.13s.23 0 .05-.15h.25a.49.49 0 01.23-.42.21.21 0 000 .12c.23 0 .35.09.56.1 0 0 .13.09.08.16s.06-.09.13-.09c.12.15-.15 0-.05.2 0-.1.17-.14.26-.2s-.22 0-.31 0a.62.62 0 01.39-.53c.17 0 .07.14.1.11.34 0 .29-.37.56-.22.11.14 0 .27 0 .37-.14.05-.22-.09-.32-.08l.12.06a.16.16 0 01-.19 0c.09.12.56 0 .82.14 0-.05.12-.1.08-.15h-.08c-.07-.11.15-.15 0-.2.11-.08.23-.2.38-.14v.16c0-.05-.1-.09-.14-.05s.24.21.3 0l-.1-.11c.11-.07.24-.24.38-.19-.06-.15 0 0-.13-.16.08.22-.35 0-.21.22-.1-.2-.17-.08-.3-.26 0 .05 0 .1-.07.07a.16.16 0 01.06.08c-.05.11-.24.11-.3.17s0-.06 0-.11l-.09.09c0-.11-.18-.19 0-.25h-.14a.25.25 0 00-.27 0c-.07 0-.17.13-.11 0l-.23.07c-.22 0-.46.18-.71 0a.36.36 0 01-.28 0v-.09c-.1 0-.29-.1-.33 0-.1-.26-.46-.06-.63-.1v.12a1.07 1.07 0 00-.37.08v.24c-.13.09-.32-.08-.52-.07 0-.05.07 0 .1 0-.23-.25-.49.19-.71 0a.09.09 0 01-.13 0l-.08-.06.06.06a.71.71 0 00-.16.05v-.12c-.06 0-.05.06 0 .15l-.08.07c0-.19-.16.07-.22-.14 0 .1-.31.07-.34.29v-.05a.17.17 0 00-.19 0v-.16l-.15.21c-.09-.09-.13-.15 0-.27-.21.18-.17.07-.36.25v-.1c-.06 0-.17.14-.21.06s-.72 0-1.1-.2c.08.29-.17-.13-.19.09 0-.07-.07-.11 0-.17-.19.07-.29-.11-.42.09v-.15c0-.04-.06.06-.08 0s0-.06.06-.09c-.2 0-.22.23-.23.43-.1-.1-.15-.08-.22.05 0-.07-.1-.14 0-.16-.07 0-.42-.1-.43.06h-.11a1.74 1.74 0 00-.32 0c-.06.19-.13 0-.25.06-.28-.13-.12.07-.4-.09v.12c0 .26-.25-.15-.41-.05l.06.07c-.09.09-.25-.35-.33-.39s0 0 .05-.05c-.23-.15 0 .16-.2.2s0-.22-.07-.24-.34.28-.49.12c0 .06.07.13 0 .18s-.33-.25-.44 0a.07.07 0 010-.06c-.1.06-.31.09-.36.2-.09-.41-.58.21-.58-.18h-.29a.29.29 0 00-.31.16v-.08c-.27-.08-.29-.06-.52.13v-.12c-.06.07-.39-.2-.65 0a.09.09 0 010-.06c-.3.15-.71-.34-.81.11l-.2.11c.25 0 0 .2.07.27-.1 0-.26-.14-.14-.16.05-.23-.31-.08-.31-.24-.49 0-1-.12-1.44-.13l.05.18h-.16s0-.14.06-.13c-.06-.1-.19.09-.2.13-.22-.08.09-.22 0-.22h-.09c-.08.08-.08.16-.22.15s-.05-.11-.08-.12 0 0-.05 0h-.21l.08.14c-.09.07-.19 0-.09.16-.14-.25-.77-.09-.85-.17a.54.54 0 01-.41.09s.06.19-.07.17c.05-.33-.24-.14-.35-.38.09.16-.38 0-.23.26-.11 0 0-.12-.09-.2-.27.13-.59-.09-.92 0v.17l-.17-.22c-.06 0-.06.26-.18.11v.1c-.64-.21-1.31.18-2-.23.08.09 0 .1 0 .1v.17l-.27-.17c-.05.17-.29 0-.32.17h.09c-.12.18.16.41.14.65.13-.21.34.31.55 0v.13c.05-.1.12-.12.24-.08a3.5 3.5 0 01.86.14v-.11c.09 0 .1.05.14.08.09-.18-.23 0-.14-.21.1.24.57 0 .64.28.13 0 0-.14.09-.14v.08-.1a.18.18 0 01.12.17h.26-.12a4.45 4.45 0 001.09-.13c.26-.1.21.06.48 0a.25.25 0 01.21-.08c-.07.06.13.13 0 .2.27-.11.13-.09.31-.3v.1c.07-.09.07-.13.21-.16-.11.08.09.15 0 .25.29.2.43-.2.56.09.14-.25-.25-.14-.17-.2s.11-.19.2-.16.16.33.39.32h-.05c.09.06.17-.09.28 0 .06-.16.14 0 .15-.19h-.21c.12 0 .24-.28.44-.17a.46.46 0 01-.12.12c.06.06.11 0 .17 0s-.26 0-.39.19c.07.08.25-.14.18.07.1-.27.23 0 .39-.17v.07s.08-.08.12-.08l-.08.16c.13-.13.25.11.37 0-.26 0-.06-.14-.17-.23.32-.16.18.31.54.25 0 0-.18-.07-.11-.12a.39.39 0 01.2.13c.24 0 0-.12.07-.19.07.14.11-.06.21-.11v.19c.27.08.07-.25.32-.16l-.11.17h.13v.13c.14-.1.18-.07.32 0a.16.16 0 01.13-.22c.08.07 0 .11.12.09 0 .08-.07.17-.15.06a.56.56 0 000 .12c.08.08.22 0 .28 0h-.07l.2-.19v.12c0 .04.09-.07.16-.08s0 .2-.12.24l.23-.11s.12.12.09.16c.13.05.32-.19.49-.12h.06c.06 0 .3.14.49 0l.11.18c.15 0-.15-.23.1-.29s.07.15.13.2.24-.27.4-.13c-.04-.06-.08-.08-.14-.07zm1.84-.08s-.11.11-.14 0 .09-.02.15-.02zm2.78-.29h-.11a.12.12 0 01.12 0zm7.77-.84c-.07-.04-.05-.02.01 0zm.16.05v-.05c0-.05-.05 0-.09 0s.05.11.1.05zm-17.67.05c-.03.07-.01.01.01.01z"
            style={{
              WebkitTransformOrigin: 290.155,
              MsTransformOrigin: 290.155,
              transformOrigin: 290.155,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M293.32 176.9v-.07a.05.05 0 000 .07z"
            style={{
              WebkitTransformOrigin: 293.313,
              MsTransformOrigin: 293.313,
              transformOrigin: 293.313,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M287.87 177.16z"
            style={{
              WebkitTransformOrigin: 287.87,
              MsTransformOrigin: 287.87,
              transformOrigin: 287.87,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M299 177a.17.17 0 01-.06-.06l.06.06z"
            style={{
              WebkitTransformOrigin: 298.97,
              MsTransformOrigin: 298.97,
              transformOrigin: 298.97,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M302.44 175.74h-.11a.15.15 0 01.1 0h.01z"
            style={{
              WebkitTransformOrigin: 302.385,
              MsTransformOrigin: 302.385,
              transformOrigin: 302.385,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M303.35 176.49v-.06c-.02-.01-.07.03 0 .06z"
            style={{
              WebkitTransformOrigin: 303.332,
              MsTransformOrigin: 303.332,
              transformOrigin: 303.332,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M302.53 176.14c0 .1.08.07.15.05.01-.14-.07-.1-.15-.05z"
            style={{
              WebkitTransformOrigin: 302.605,
              MsTransformOrigin: 302.605,
              transformOrigin: 302.605,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M302.7 176.19h.07c.01-.06-.03-.02-.07 0z"
            style={{
              WebkitTransformOrigin: 302.736,
              MsTransformOrigin: 302.736,
              transformOrigin: 302.736,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M301.77 175.88v-.09c.08-.13-.19.21 0 .09z"
            style={{
              WebkitTransformOrigin: 301.743,
              MsTransformOrigin: 301.743,
              transformOrigin: 301.743,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 302.56,
              MsTransformOrigin: 302.56,
              transformOrigin: 302.56,
            }}
            fill="#FFF"
            d="M302.59 176.47L302.57 176.35 302.53 176.45 302.59 176.47z"
            className="animable"
          ></path>
          <path
            d="M302 176.38h.12s-.12-.03-.12 0z"
            style={{
              WebkitTransformOrigin: 302.06,
              MsTransformOrigin: 302.06,
              transformOrigin: 302.06,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M302.16 176.38a.12.12 0 00.09 0z"
            style={{
              WebkitTransformOrigin: 302.205,
              MsTransformOrigin: 302.205,
              transformOrigin: 302.205,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 302.37,
              MsTransformOrigin: 302.37,
              transformOrigin: 302.37,
            }}
            fill="#FFF"
            d="M302.43 176.51L302.4 176.49 302.31 176.48 302.43 176.51z"
            className="animable"
          ></path>
          <path
            d="M300.74 176.36h-.13c0 .05 0 .07.07.06s.08-.02.06-.06z"
            style={{
              WebkitTransformOrigin: 300.68,
              MsTransformOrigin: 300.68,
              transformOrigin: 300.68,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M301.13 176.7a.2.2 0 01-.06-.09v.15z"
            style={{
              WebkitTransformOrigin: 301.1,
              MsTransformOrigin: 301.1,
              transformOrigin: 301.1,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M300.76 176.74s-.19.12 0 .11.11-.08 0-.11z"
            style={{
              WebkitTransformOrigin: 300.775,
              MsTransformOrigin: 300.775,
              transformOrigin: 300.775,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 298.83,
              MsTransformOrigin: 298.83,
              transformOrigin: 298.83,
            }}
            fill="#FFF"
            d="M298.81 176.54L298.85 176.54 298.84 176.28 298.81 176.54z"
            className="animable"
          ></path>
          <path
            d="M297.11 177.15c.15.06 0-.16.17-.08s-.11-.06-.08-.11-.14.04-.09.19z"
            style={{
              WebkitTransformOrigin: 297.218,
              MsTransformOrigin: 297.218,
              transformOrigin: 297.218,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M297.2 177h.05a.11.11 0 00-.05 0z"
            style={{
              WebkitTransformOrigin: 297.225,
              MsTransformOrigin: 297.225,
              transformOrigin: 297.225,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 277.85,
              MsTransformOrigin: 277.85,
              transformOrigin: 277.85,
            }}
            fill="#FFF"
            d="M277.9 175.86L277.8 175.81 277.86 175.9 277.9 175.86z"
            className="animable"
          ></path>
          <path
            d="M277.71 176.05v-.16l-.06.15s.04-.04.06.01z"
            style={{
              WebkitTransformOrigin: 277.68,
              MsTransformOrigin: 277.68,
              transformOrigin: 277.68,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M291.12 177.35l-.09-.05z"
            style={{
              WebkitTransformOrigin: 291.075,
              MsTransformOrigin: 291.075,
              transformOrigin: 291.075,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 289.79,
              MsTransformOrigin: 289.79,
              transformOrigin: 289.79,
            }}
            fill="#FFF"
            d="M289.79 177.23L289.81 177.23 289.77 177.09 289.79 177.23z"
            className="animable"
          ></path>
          <path
            d="M288.67 177.42h.15c-.1 0-.16-.19-.15 0z"
            style={{
              WebkitTransformOrigin: 288.744,
              MsTransformOrigin: 288.744,
              transformOrigin: 288.744,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M280.13 128.05a.68.68 0 00-.37.12.52.52 0 01-.4.07c-.05 0-.07-.05-.06-.13a1.69 1.69 0 000-.23.59.59 0 000-.23c0-.08-.1-.11-.21-.11a.36.36 0 00-.16.28 1.58 1.58 0 000 .23.41.41 0 00-.15 0l-.1.05-.07.08a.09.09 0 01-.1 0 .33.33 0 01-.28-.16 1.45 1.45 0 01-.16-.38 3.15 3.15 0 01-.09-.42v-.32a1.43 1.43 0 01.09-.27 1.15 1.15 0 00.08-.28h.61a1.11 1.11 0 00.19.18.47.47 0 00.25.11.72.72 0 00.36-.11.65.65 0 01.37-.09c.09 0 .14 0 .16.08s.07.08.16.08a.37.37 0 00.2 0 .67.67 0 00.15-.17.14.14 0 01-.14-.09s0-.06.09-.13l.11-.13v-.53c0-.22 0-.44-.05-.67s0-.46 0-.68a2.17 2.17 0 01.05-.51.7.7 0 010-.14c0-.07 0-.16.06-.25l.06-.28v-.2a.71.71 0 000-.33.86.86 0 010-.28 1.88 1.88 0 010-.19v-.26c0-.23.07-.45.11-.68a3 3 0 000-.67.24.24 0 00-.07-.1c0-.06-.07-.09-.1-.09s0-.09 0-.19a1 1 0 010-.19h-.09a.23.23 0 01-.05.07.7.7 0 00-.19.1l-.14.11H280a.53.53 0 00-.15.05h-.07a1.38 1.38 0 00-.36.21c-.13.09-.26.18-.4.26a2.74 2.74 0 01-.42.21.61.61 0 01-.4 0 .92.92 0 00.05-.35.87.87 0 00-.05-.28 2.43 2.43 0 00-.14-.28l-.18-.35a.28.28 0 010-.08.35.35 0 010-.07s0-.08.05-.14.08-.06.16 0a.21.21 0 01.05.08.43.43 0 00.07.1.21.21 0 00.15 0l.2-.14a1.8 1.8 0 00.2-.18.29.29 0 00.08-.14.24.24 0 000-.18.42.42 0 010-.19h.2a1.16 1.16 0 01.17-.37.13.13 0 01.13-.06l.16.05q.09 0 .24-.09a.19.19 0 00.09-.09.21.21 0 000-.06h.12a.17.17 0 01.13 0s-.06 0-.12.05a.59.59 0 00-.11.1.19.19 0 000 .13.63.63 0 010 .16h.15a1.36 1.36 0 01.12-.17.57.57 0 01.16-.15.33.33 0 01.29 0l.15-.54h.08a.13.13 0 01.1 0 2.63 2.63 0 01.49.36 1.63 1.63 0 01.36.41.36.36 0 00.09.09l.09.1a.83.83 0 01.16.52 5.31 5.31 0 01-.05.68c0 .23 0 .44-.06.63s0 .33.11.39 0 .12 0 .21v.3l-.06.3c0 .1 0 .17-.05.21v.2a.27.27 0 00.11.08.35.35 0 01.12.09 1.09 1.09 0 010 .4 4 4 0 01-.11.56c0 .2-.08.4-.13.58a4.2 4.2 0 00-.08.43.46.46 0 010 .15v.48a1.41 1.41 0 000 .18 1.37 1.37 0 000 .19 2.51 2.51 0 00.08.33h-.11v.08h.15a.56.56 0 00-.1.23.38.38 0 000 .25.17.17 0 00.13.14 1.49 1.49 0 00.25.07 1.73 1.73 0 00.32 0h.29a.16.16 0 00.12 0 1 1 0 00.13-.14v.23h.25a.09.09 0 01.07 0s0 .05.1.07h.1a.1.1 0 00.06-.09l-.11-.07a.29.29 0 00-.1 0v-.05c0-.05 0 0 0 0h.07a1.72 1.72 0 00.51.15.52.52 0 01.28.09.33.33 0 01.11.26 5.56 5.56 0 010 .65v.35a.74.74 0 01-.11.37l-.07-.1v-.6h-.15a.05.05 0 01-.05 0 .2.2 0 010-.11.59.59 0 00-.14.19l-.12.26-.12.23a.21.21 0 01-.1.12h-.05l-.1.08a.14.14 0 00-.08.07V128a.62.62 0 00-.2.15 1.15 1.15 0 00-.15.2.36.36 0 01-.07-.1.36.36 0 00-.08-.12.09.09 0 010 .11h-.18a.32.32 0 010-.09.2.2 0 000-.09H282.55a.42.42 0 01-.11.32.55.55 0 01-.28.17v-.19a.21.21 0 00-.12 0l-.09.11a.65.65 0 01-.11.12.25.25 0 01-.16.05l-.08-.07a.19.19 0 00-.13 0 .55.55 0 00-.13-.19.38.38 0 00-.19-.06c-.14 0-.26 0-.35.22a.36.36 0 00-.07-.09.29.29 0 00-.08-.08h-.15a.88.88 0 01-.07-.12.37.37 0 010-.09v-.07a.19.19 0 00-.3-.04zm-.42-9.38h-.06a.1.1 0 000 .11s.05 0 .06-.06.03-.04 0-.05zm0 .18a1.19 1.19 0 010 .17c0 .1 0 .16.06.2a.31.31 0 00.14-.06 1 1 0 00.08-.11.1.1 0 000-.13h-.21zm1.63 8.7s0-.06-.05-.06zm.32-.3a.1.1 0 00-.07.1c0 .05 0 .07.07.05s.05 0 .05-.05a.11.11 0 00-.01-.1zm.06.82a.1.1 0 00-.06.09.36.36 0 010 .11h.08zm0-.43h.08v-.07zm.06.22s-.06 0-.06.08 0 .08.06.08.06 0 .06-.06.06-.09.02-.1zm.24.1s.13.04.08.04zm.12-.81a.21.21 0 00-.09.17v.07a.11.11 0 00.06-.09.25.25 0 000-.08.1.1 0 00.11-.07zm.26.29a.23.23 0 00-.1.16 1.18 1.18 0 000 .16h.1z"
            style={{
              WebkitTransformOrigin: 281.188,
              MsTransformOrigin: 281.188,
              transformOrigin: 281.188,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M291 128.84a.31.31 0 000-.14c0-.08 0-.12-.07-.14a.41.41 0 00-.15-.05h-.2a.13.13 0 01-.07-.05l-.15-.1-.15-.12h-.3l-.18-.05a.19.19 0 01-.1 0 1 1 0 01-.38-.22 3.72 3.72 0 00-.34-.26q-.09 0-.12.12a.75.75 0 010 .16c-.1 0-.16-.06-.17-.12a.28.28 0 00-.13-.16.3.3 0 000 .16.22.22 0 000 .14.18.18 0 01-.09 0 .14.14 0 01-.07-.06.2.2 0 010-.17c0-.05 0-.09-.07-.11h-.05-.05v.33a.44.44 0 00-.2.13.3.3 0 01-.2.12h-.42a.31.31 0 010 .08v.06H286.73a.64.64 0 01-.21 0 .21.21 0 01-.06-.1.48.48 0 00-.08-.12 1.14 1.14 0 01-.16-.55v-.57a3 3 0 010-.47 4.38 4.38 0 01.11-.57c.05-.19.11-.38.17-.57a3.39 3.39 0 01.19-.45.49.49 0 01.25-.22.49.49 0 00.25-.22.29.29 0 00.09-.16l.08-.19.07-.08.09-.08a.18.18 0 00.05-.07.06.06 0 000-.07.13.13 0 010-.06l.05-.06.08-.06a.51.51 0 010 .09h.1c.1 0 .07 0 .1-.09a.78.78 0 00.11-.18c0-.07.06-.13.09-.19a.53.53 0 000-.13h.17a.66.66 0 00.21 0 .49.49 0 00.18-.08.26.26 0 00.09-.16h.35a.17.17 0 010-.07.22.22 0 01.05-.08h.29l.36-.29.25-.19.14-.09a.51.51 0 000-.09.07.07 0 010-.08l.08-.06.12-.07a.15.15 0 000-.07.16.16 0 010-.06l.08-.09.08-.06c0-.05.05-.13.1-.24a1.71 1.71 0 01.1-.2.58.58 0 010-.1v-.18a1.11 1.11 0 010-.19v-.18-.06a1 1 0 00.06-.14v-.1a.07.07 0 00-.06 0l-.29-.09-.28-.07v-.19h-.28a.88.88 0 01-.11-.13.48.48 0 00-.1-.12l-.3-.11-.3-.09h-.2a2.73 2.73 0 00-.77.12 1 1 0 00-.63.45v.08a.34.34 0 00.07.22l.3.15a1.92 1.92 0 01.43.32 4.43 4.43 0 01.37.39.18.18 0 000 .06.35.35 0 000 .06.68.68 0 01-.09.22c-.05.11-.09.16-.11.16a.12.12 0 01-.12-.1v-.2a.77.77 0 01-.42.1.1.1 0 01.1-.11.09.09 0 00.1-.1v-.09a1 1 0 01-.27.12 1.29 1.29 0 01-.29 0h-.17c0-.1 0-.15-.1-.15a.37.37 0 01-.18-.08.54.54 0 01-.25-.31.65.65 0 00-.19-.32s-.07 0-.16-.08l-.25-.07-.22-.07c-.07 0-.1 0-.1-.07v-1.31a.18.18 0 01-.08-.09.58.58 0 010-.1.32.32 0 00.27-.12c.07-.09.12-.17.18-.26h.75l.09-.06a.24.24 0 01.11-.06.69.69 0 01.25-.08c.06 0 .12 0 .2-.14h.62v-.15c0-.01 0-.07-.07-.15h.08a3.49 3.49 0 01.59.25.82.82 0 01.41.49c.06 0 .09 0 .1-.13a.12.12 0 01.13-.12H289.81a.48.48 0 01.15 0h.29a.47.47 0 01.17 0 .14.14 0 01.09.12 1.57 1.57 0 010 .2 1.62 1.62 0 010 .21 2.17 2.17 0 01.39.24.63.63 0 01.27.35.78.78 0 010 .13.45.45 0 000 .14.43.43 0 00.17 0 .33.33 0 01.15 0h.73v.12a.22.22 0 000 .12l.11.14a.76.76 0 01.11.16.69.69 0 01.05.29v.32a2.6 2.6 0 010 .4 3 3 0 000 .42v.36a1.11 1.11 0 00.06.34l-.17.13-.18.1s-.06 0-.15-.08a.46.46 0 00-.16-.1.32.32 0 000 .08.83.83 0 000 .15v.24a.16.16 0 000 .08.17.17 0 010 .07v.13a.48.48 0 010 .22.17.17 0 01-.16.08c-.09 0-.14 0-.16-.11s-.05-.11-.1-.11a.44.44 0 01-.07.26 1.1 1.1 0 01-.14.21l-.15.21a.54.54 0 00-.09.26.49.49 0 000-.12s0-.09-.05-.1a.25.25 0 00-.13 0 .41.41 0 01-.19 0v.39h-.08a.29.29 0 01-.15 0h-.15l-.12.1a.13.13 0 01-.1-.1.13.13 0 00.05-.06l.05-.07v-.07s-.07 0-.1-.08a.23.23 0 01-.07.07l-.07.08V124.23a.27.27 0 010 .08 2.12 2.12 0 01-.28.2l-.21.15a.32.32 0 01-.11.07l.08.07-.16.31a1.22 1.22 0 00-.17.19l-.15.21h.17a.59.59 0 01.18-.06.1.1 0 00.05-.07.22.22 0 010-.08h.07v-.12h.05a.14.14 0 01.09 0 .23.23 0 00.22.14.7.7 0 01.24 0v.07l.07.06a.48.48 0 00.33.13h.34a.25.25 0 000 .08v.07a.38.38 0 01-.16.08.6.6 0 00-.17.07v.79s0 .08.06.08 0 0 .05-.16 0-.22.06-.34a1.35 1.35 0 01.09-.32c0-.1.09-.14.17-.13l.2.28a.93.93 0 000 .14.09.09 0 00.1.08.25.25 0 00.13 0 .17.17 0 01.12 0 .18.18 0 01.16.06s.05.09.07.14h.35a.19.19 0 01-.11-.05.22.22 0 01-.1-.08 1.62 1.62 0 00.24.08l.2.07h.6a.35.35 0 000 .12.53.53 0 000 .11h.19a.23.23 0 000-.09v-.07H293.27a.33.33 0 01-.11.28 1.19 1.19 0 00-.19.2v.09c0 .09-.06.15-.1.17a.28.28 0 01-.15 0h-.25l.15.21v.05h-.06c-.08 0-.13 0-.15-.07a.33.33 0 010-.14v-.14a.09.09 0 00-.1-.07v.12a.6.6 0 010 .23.19.19 0 01-.13.14.58.58 0 01-.39-.14v-.45a.79.79 0 000 .09.15.15 0 000 .06 1.06 1.06 0 000 .3v.32-.08a.16.16 0 000-.08 1.17 1.17 0 01.15.16.32.32 0 01.06.17.14.14 0 010 .11.19.19 0 000 .13.53.53 0 000-.11.58.58 0 01.05-.14.1.1 0 01.1-.07l.2-.12.13-.08h.14l-.14.85a1 1 0 00-.56.14.8.8 0 01-.5.14h-.28a.89.89 0 01-.14-.02zm-4.19-3.49v-.14a.15.15 0 01.1-.14h-.08zm.32-.56c-.05 0-.07 0-.07.07s0 .08.07.08.05 0 .05-.08-.01-.07-.04-.07zm.2.28s-.07 0-.07.07 0 .08.07.08.06 0 .06-.08-.01-.07-.05-.07zm.08-.35h.07l-.07-.07zm.07-.37l.21.07a.78.78 0 00.22 0c0-.08 0-.12-.07-.14a.39.39 0 00-.16 0h-.11a.08.08 0 00-.08.07zm.06 3s-.05 0-.05.08 0 .07.05.07.05 0 .05-.07 0-.11-.04-.11zm.14-7.42s-.05 0-.05.06 0 .06.05.06a.06.06 0 100-.12zm.41 5.79a.62.62 0 00.06.26.2.2 0 00.19.12l.11-.15-.23-.06a.9.9 0 00-.12-.2zm.2-1.84V124.3a1.62 1.62 0 010 .21v.12h.05a.15.15 0 00.05-.1.5.5 0 010-.12h.14v-.14a.66.66 0 010-.16.63.63 0 000-.14.1.1 0 00-.06-.09.27.27 0 00-.12 0h-.13a.14.14 0 01-.06-.12l-.05.1a.35.35 0 000 .12zm.12 3.54s-.06 0 0 0 .01 0 .01-.03zm.15-4.12a.06.06 0 00-.07.07v.06l.07-.06v-.07zm0-5.26a.13.13 0 00.08.13.41.41 0 00.16 0v-.25h-.22zm0 9.31l.07.12a.31.31 0 00.08.1.19.19 0 000-.08.26.26 0 000-.07v-.07a.16.16 0 000-.08c-.05 0-.07 0-.07.06zm.07-1.5c0-.06.07-.1.07-.13a.57.57 0 000-.14v-.1s0-.07-.08-.1l-.07.1zm.08-1.25a.06.06 0 00-.07.07.07.07 0 00.07.08v-.08c0-.08.04-.1.01-.1zm0 .65c.06 0 .08-.07.08-.15h-.08zm.87.57a.13.13 0 00-.14.08.49.49 0 000 .15c.08 0 .13 0 .14-.07a.45.45 0 00.01-.19zm.1 2a.14.14 0 00.15.16h.28c0-.09-.05-.14-.16-.15zm.18-2.17c0 .1 0 .18-.05.25v.19a1.55 1.55 0 010 .15v.13l.07.08a.43.43 0 00.11.12h.09a.94.94 0 000-.33.44.44 0 000-.09 1 1 0 000-.16v-.15a.58.58 0 000-.1zm.2-2.52a.17.17 0 00.08.14v-.14zm.15 4.06l.09-.09-.09-.06zm.57-.14v.1h.11a.28.28 0 01.12.08.5.5 0 01.1.22.49.49 0 010-.12.2.2 0 01.07-.1v.14s0 .06.13.06 0-.19 0-.34-.07-.23-.15-.26h-.07a.13.13 0 01-.08 0v-.27l-.35.39zm.3-3.85l.07.2h.05a.11.11 0 010-.05.54.54 0 000-.08l.05-.27h-.11a.33.33 0 01-.18.09zm.3 3.45h.01zm.08.1s-.06 0-.06.07 0 .07.06.07 0 0 0-.07.05-.07.01-.07zm.07.07s-.05 0-.05.08 0 .07.05.07 0 0 0-.07.03-.08.01-.08zm0 .22l.08-.07h-.08zm.2-5.24s-.05 0-.08.08a.94.94 0 00-.06.15 1.24 1.24 0 000 .16v.08s.05 0 .07-.08a.77.77 0 00.07-.16.4.4 0 000-.15s.08-.08.06-.08zm.32 5.52l.06-.07h-.06z"
            style={{
              WebkitTransformOrigin: 289.565,
              MsTransformOrigin: 289.565,
              transformOrigin: 289.565,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M309.72 128.52a1.83 1.83 0 010-.21.88.88 0 000-.24c-.07 0-.1.05-.11.14a.27.27 0 01-.11.2l-.07-.12c0-.06-.05-.08-.1-.08s-.07 0-.08.09a.14.14 0 01-.08.11v-.55H309a.94.94 0 010 .16c0 .08-.06.13-.12.13H308.3a.07.07 0 010-.08v-.08a1.15 1.15 0 010-.19 1.23 1.23 0 000-.2h-.26a.24.24 0 00-.12.07v.14-.16-.16c0-.02.05 0 .13 0a.44.44 0 010-.08v-.08h-.18c.05 0 .07 0 .07-.07a.31.31 0 00-.27.11.67.67 0 00-.08.35 1.77 1.77 0 000-.19 1 1 0 000-.19h-.1v-.35h-.06a1 1 0 00-.21.09.18.18 0 00-.09.19h-.15c-.13 0-.2 0-.24-.09a.63.63 0 01-.05-.28h.14v-.13a.48.48 0 01-.26-.07.26.26 0 01-.11-.25.17.17 0 010-.07.27.27 0 000-.07l-.06-.06h-.06a.23.23 0 00.12-.2c0-.1-.06-.16-.17-.2a1.17 1.17 0 00-.3 0h-.15a.19.19 0 01.1.14 1.1 1.1 0 010 .18.47.47 0 01-.11.16 2.53 2.53 0 01-.23.26l-.27.25a.33.33 0 01-.18.11.63.63 0 010-.14.15.15 0 00-.08-.1.22.22 0 00-.11.15.86.86 0 01-.06.23.4.4 0 01-.1.18c-.05.05-.15.06-.28 0v.1a.35.35 0 00.2.33l-.07.62h-.05l-.08.07s-.07 0-.06-.11 0-.11-.09-.11l-.14.1a.47.47 0 01-.13.09.41.41 0 01-.22.06.52.52 0 01-.21 0 .18.18 0 000 .13.21.21 0 010 .14.46.46 0 01-.05.2.21.21 0 01-.16.08.18.18 0 01-.1 0 .19.19 0 00-.12 0 .15.15 0 00-.12 0 .26.26 0 01-.16 0h-.15s-.05-.05-.05-.12a.52.52 0 01.14-.35l.22-.31a.39.39 0 000-.13.49.49 0 000-.12.29.29 0 010-.1.09.09 0 00.06 0 .38.38 0 00.1-.13 3.84 3.84 0 00.21-.4 2.3 2.3 0 01.23-.4 3.58 3.58 0 01.28-.36l.32-.42a4.92 4.92 0 00.26-.43 1 1 0 00.1-.45.14.14 0 00-.05-.11l-.14-.09-.13-.12a.28.28 0 01-.06-.18.64.64 0 010-.15v-.1h.13a1.09 1.09 0 000 .23s0 .06.06.06a.12.12 0 00.08 0 .2.2 0 01.12 0 .62.62 0 01.08.1.22.22 0 00.09.1.1.1 0 00.08-.05.44.44 0 000-.1.24.24 0 000-.13v-.07a.3.3 0 010-.1.46.46 0 010-.17.25.25 0 01-.16-.14.62.62 0 00-.14-.18v.09a.56.56 0 00.07.26.45.45 0 01.07.25.16.16 0 01-.14-.06.37.37 0 01-.05-.11l-.06-.12a.12.12 0 00-.12-.06.24.24 0 00-.11 0h-.09s-.07 0-.09-.11 0-.12-.08-.14h-.3a.55.55 0 00-.05-.13.8.8 0 00-.08-.16.34.34 0 00-.12-.12.18.18 0 00-.16 0 1.86 1.86 0 00-.11-.27.7.7 0 00-.13-.16.64.64 0 00-.15-.13 1.31 1.31 0 01-.18-.17.26.26 0 01-.06-.24.6.6 0 000-.23.47.47 0 00-.13-.25c-.08-.08-.12-.14-.12-.2s0-.08.07-.08.06 0 .06-.14v-.15h-.15v.28a.14.14 0 00-.17.11.89.89 0 000 .19h-.08v-.5c-.12 0-.17-.09-.17-.17s0-.13.13-.13v-.37H302.26v-.53h.15v.16a.24.24 0 00.11.16l.12-.14a.23.23 0 01.07.13.72.72 0 00.05.14l.23-.13a.23.23 0 000 .16 1 1 0 00.15.2l.17.19.13.11h.25v.06a.16.16 0 00.1 0 .12.12 0 01.09.06.54.54 0 01.07.13 1 1 0 01.07.15.15.15 0 00.1.09.21.21 0 00.15-.07.22.22 0 01.18-.08c.09 0 .15 0 .18.07a.49.49 0 01.06.16.52.52 0 00.07.15.18.18 0 00.17.07h.07a.25.25 0 01.13.24.1.1 0 00-.08 0 .17.17 0 00.07.14.48.48 0 00.19.09.78.78 0 00.21 0h.38s.1-.07.16-.17l.21-.35c.09-.13.18-.26.29-.39a1 1 0 01.36-.29.19.19 0 00.09-.12.83.83 0 000-.13.3.3 0 01.11.13l.09.12-.31.12.05.23h.45v-.33h.16c.09 0 .14 0 .14-.1h.32s.05 0 .06-.11a.84.84 0 010-.12h.11c0 .09.05.19.08.31a.2.2 0 00.21.17h.12a.12.12 0 01.11 0 1.34 1.34 0 010 .18.76.76 0 010 .17v.05a.7.7 0 010 .24.38.38 0 01-.09.13l-.14.09a.5.5 0 00-.17.16.48.48 0 00-.06.26.25.25 0 01-.11.24.46.46 0 01-.05-.14.2.2 0 00-.06-.13.52.52 0 01-.07.22.35.35 0 01-.11.1l-.11.08a.27.27 0 00-.08.17.66.66 0 010 .13 1.17 1.17 0 01-.05.2 1.11 1.11 0 01-.09.19.14.14 0 01-.11.08.15.15 0 010-.06.13.13 0 010-.07.43.43 0 00-.18.33.45.45 0 00.08.26 1.8 1.8 0 00.19.2 1.21 1.21 0 01.2.19.37.37 0 01.08.22.13.13 0 010 .08.15.15 0 010 .06.43.43 0 010 .07v.06h.07a.15.15 0 000-.07.39.39 0 000-.06h.15a.68.68 0 01.4.35 2.21 2.21 0 00.32.46 2.62 2.62 0 00.23.21l.31.25c.11.09.21.17.29.25a1.25 1.25 0 01.2.23v.25a.12.12 0 00.09 0h.08a2.56 2.56 0 01.51.61 1.78 1.78 0 01.14.76q-.09 0-.18-.18a.28.28 0 00-.27-.17.36.36 0 00-.21 0 .2.2 0 00-.09.2h.18v-.1h.05v.2l.16.07h.17q.09 0 .09.09a.29.29 0 01-.08.08h-.54a.28.28 0 01-.11-.08.3.3 0 01-.02-.3zm-6.91-.16h-.05l.05.05s.05 0 .05-.05-.01 0-.05 0zm.17-.25v0c0-.06.02 0 .02 0zm.13-.35h-.05s0 .06.05.06.05 0 .05-.06-.01 0-.05 0zm.12-.24s0 .06.05.06v-.16s-.05 0-.05.06zm.13-5.92h.12-.05zm0 6.32h.12a.33.33 0 000-.1.14.14 0 010-.06zm.17-.37a1.25 1.25 0 000 .21.31.31 0 00.11.16v-.55l-.06-.07c-.06 0-.08.06-.08.13a.83.83 0 01.03.12zm.07-4.43v-.07zm.4 4.42a.09.09 0 00.06.1v-.1zm1.23-3.69a.11.11 0 00.12.07v-.13a.14.14 0 00-.12.06zm.3 1.34a.33.33 0 000 .14.14.14 0 00.11.06h.08l.15-.13a1 1 0 00.13-.16.24.24 0 00.06-.13.08.08 0 00-.05-.08H306s-.07 0-.12.13-.14.14-.3.17zm.07-1.09s-.05 0-.05.06 0 .06.05.06 0 0 0-.06.02-.06 0-.06zm.5-.38v.07h.25v-.17a.72.72 0 00-.25.1zm.1 1.4a.68.68 0 000 .12.07.07 0 00.07.08h.05l.07-.07a.09.09 0 00-.08-.1zm.43 1.65s-.05 0-.05.06 0 .06.05.06.05 0 .05-.06-.01-.06-.05-.06zm.3-2.43h.07v-.07h-.07zm.19-1h-.07zm-.07 1.42h.07v-.07h-.07zm.12-2.42s-.05.05-.05.11v.11h.05zm-.05 2.9a.17.17 0 00.05.14v-.14zm.05-.73c0 .1.05.15.16.15a1 1 0 000-.14c0-.07 0-.12-.09-.13v.06a.1.1 0 00-.07.07zm.2.87s0 .06 0 0 .02.01 0 .01zm.06-2.92h.05-.05zm.05 2.67v.01zm.14.55a.09.09 0 00.06-.1v-.29c0-.09-.05-.13-.11-.13zm0-.75h.05v-.07zm.05-1.59v.13s.05 0 .05-.06-.02-.06-.05-.06zm.11-1.55h.15c0-.09 0-.13-.13-.13zm0 4.3h.14V126h-.14zm.14-.3h.08v-.06zm.35.47h-.12a.12.12 0 00-.12.07h.24zm-.19.72h.09s0-.07-.09-.1zm.14-.39v-.06zm.23.64v-.12l-.07.07zm.05.62v.01zm.13-.62s-.05 0-.05.06 0 .07.05.07 0 0 0-.07.03-.05 0-.05zm.12-5.51s-.05 0-.05.06 0 .06.05.06 0 0 0-.06.02-.05 0-.05zm0 6a.16.16 0 010-.09.25.25 0 000-.07h-.07zm.37-.26h.06v-.06h-.06zm.11-.56c0 .09 0 .13.14.13v-.13z"
            style={{
              WebkitTransformOrigin: 306.291,
              MsTransformOrigin: 306.291,
              transformOrigin: 306.291,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M327.11 129.89a.23.23 0 00-.24-.15.31.31 0 01-.26-.1l-.11-.19a1.9 1.9 0 01-.14-.24l-.25-.5v-.25-.39-.37-.26a.17.17 0 000-.08v-.12-.14a.17.17 0 010-.08v-.75a2.7 2.7 0 010-.31v-.29H325.52a1 1 0 01-.33-.11.29.29 0 01-.11-.14l-.06-.16a.39.39 0 00-.18-.19.21.21 0 00-.11.13.79.79 0 00-.06.22 2.28 2.28 0 000 .26v.2a.92.92 0 01-.42-.1 3.55 3.55 0 01-.39-.2h-.1s-.07 0-.14.08l-.15.11a.74.74 0 01-.21.07.16.16 0 00-.12.18h-1.76a.16.16 0 00-.09 0h-.59a.71.71 0 01-.21-.08.72.72 0 00-.22-.08.37.37 0 00-.17 0h-.16l-.17-.17h-.05a.47.47 0 01-.14-.29.66.66 0 00-.13-.31.51.51 0 01-.08-.21v-.29a1.26 1.26 0 010-.16V124a.36.36 0 01.24-.1c.18 0 .29 0 .35.14s.1.14.13.14a.4.4 0 00.27-.11.83.83 0 00.19-.26 2.88 2.88 0 00.13-.31l.11-.26.09-.07c.05 0 .08-.07.08-.09a.3.3 0 000-.19.12.12 0 01.1-.16h.12a.28.28 0 00.11 0 .26.26 0 000-.18s-.09-.06-.19-.09l.16-.09.17-.07a.58.58 0 01.17 0 .52.52 0 00.17-.06.44.44 0 000-.17v-.17a.19.19 0 01.1-.1l.17-.12a.44.44 0 00.14-.13.11.11 0 000-.15.49.49 0 01.18 0H322.83c.1 0 .14 0 .11-.14a.25.25 0 010-.21.4.4 0 01.13-.06l.23-.07.23-.08a.55.55 0 00.16-.12v-.08a.31.31 0 01.05-.09H323.91h-.13v-.29h.33l.07.08h.1a.22.22 0 00.14 0 1.14 1.14 0 00.11-.11l.11-.12a.27.27 0 01.14-.07h.42v-.27h-.16-.06a.16.16 0 01-.16-.14c0-.1 0-.17-.05-.21v-.23a.89.89 0 01.09-.16l.08-.11a.72.72 0 01.21 0h.2s.05-.08.09-.21a.58.58 0 01.08-.21.19.19 0 01.09 0h.08a.69.69 0 00.09-.15 1.87 1.87 0 00.07-.18h.05a.51.51 0 01.28.08l.25.15.25.16a.55.55 0 00.29.08.83.83 0 01-.06.28 2.7 2.7 0 01-.17.34l-.2.34-.17.26a.27.27 0 01-.18.1.19.19 0 00-.15.15V120a3.43 3.43 0 01-.47.7c-.2.25-.38.46-.55.65l-.12.13-.17.18-.18.18-.11.1h-.09a.18.18 0 01-.08 0h-.05v.06a.18.18 0 010 .08l-.08.16a.87.87 0 01-.07.17.25.25 0 000 .09h-.44l-.07.12a.32.32 0 01-.09.13H323a.75.75 0 01-.23 0 .78.78 0 00-.22 0 .25.25 0 00.05.15.55.55 0 01.1.16.26.26 0 00-.14 0h-.13a.31.31 0 000 .14.27.27 0 010 .13.09.09 0 010 .05v.09a.17.17 0 01-.13.08h-.3a.38.38 0 00-.15 0 .11.11 0 00-.08.09.49.49 0 00.17.09l.18.08h.17v-.16c.1 0 .15 0 .16.13a.63.63 0 00.07.22h.1v-.15a.67.67 0 01.3.08c.1.05.14.14.12.29a.11.11 0 00.09-.08v-.13a.62.62 0 010-.13s0-.07.08-.09h2.37a3.94 3.94 0 01.42 0l.08-.08a.77.77 0 000-.12v-.24l.05-.26V122.29a.7.7 0 010-.14l.05-.13c.05-.18.08-.33.11-.47s0-.26.07-.38 0-.25 0-.38 0-.3.05-.49a.13.13 0 01.09-.09h.5q.09 0 .09.09s0-.06 0 0a.58.58 0 00.35.27 1.61 1.61 0 00.43.07.31.31 0 010 .12l-.07.13a.18.18 0 000-.1.22.22 0 00-.06-.07H327.51a.54.54 0 01.14.12l.13.11.11.2c.06.11.12.17.17.17l-.08-.14a.35.35 0 010-.16h.28a.21.21 0 01.13.16.22.22 0 00.12.18h.25a.35.35 0 01-.12.05h-.13a.07.07 0 00.08.08h.47a.5.5 0 010 .15 1.09 1.09 0 010 .17.08.08 0 01-.11.08c-.06 0-.11 0-.14.09s-.06.11-.07.14-.07.06-.18.09h.43a.73.73 0 01-.13.43.7.7 0 00-.13.42 1 1 0 000 .25c0 .11.07.17.12.17h.09a.18.18 0 01.08 0 1.4 1.4 0 01.4-.09h1a.34.34 0 01.13 0h.12l.19.05H331.77l.1.09c.05 0 .07.06.07.08s0 .06-.08.13l-.09.12v.05a.16.16 0 00.1.13l.15.07a.43.43 0 00-.18.33v.07a.51.51 0 00.07.17l.09.16v.09a.5.5 0 00-.32-.24 2.56 2.56 0 00-.39 0H331a.32.32 0 00-.13.19c0 .09-.08.14-.14.14h-.12l-.09-.09h-.05q0 .2-.06.24a.24.24 0 01-.14 0h-.13s-.06.08-.06.18l-.27-.12a.93.93 0 01-.23-.13.14.14 0 01-.06-.07.16.16 0 010-.09h-.75c0-.11 0-.18-.17-.21a1.37 1.37 0 00-.29 0v.07l-.05.09h-.5l-.05.06a.51.51 0 000 .13 1.22 1.22 0 000 .21v.19l.09.13.09.13a.78.78 0 00.07.17.41.41 0 00.1.17.44.44 0 00.17 0H328h.05a.29.29 0 01-.17.14h-.19a.44.44 0 00-.16.06.16.16 0 00-.06.15v.2a2.18 2.18 0 000 .25.79.79 0 00.06.22.19.19 0 00.11.12l-.13.07c-.09 0-.14.07-.14.1v.08l.06.08v.1a.35.35 0 01-.26.14h-.25a.21.21 0 00.19.12l.3.06a1 1 0 01.27.1.24.24 0 01.12.22h-.35v.05H327.62a.31.31 0 010 .12.24.24 0 000 .13h.16a.39.39 0 01.1.16.51.51 0 01.07.17c0 .05 0 .09-.06.09h-.11a.23.23 0 01-.23-.17c-.06 0-.09.05-.09.07a.19.19 0 000 .08zm-6.57-4.49a.21.21 0 00-.12 0 .18.18 0 00-.06.14h.18zm0-1.92s-.05 0-.05.09 0 .08.05.08.09 0 .09-.08a.08.08 0 00-.09-.09zm.6-.18s-.06 0-.06.09 0 .09.06.09.07 0 .07-.09-.02-.09-.07-.09zm.08-.28a.21.21 0 00.09.17.27.27 0 00.17.06.62.62 0 00-.34-.26zm1 .26a.17.17 0 00-.18.14 1.13 1.13 0 000 .25c.11 0 .17 0 .19-.13a2.11 2.11 0 00-.04-.26zm-.13-1.41c.12 0 .2-.05.22-.14a.75.75 0 00.05-.26h-.27zm.17.18h-.03zm.33-.25H322.42a.17.17 0 00.1 0c.02.03.04.02.04 0zm-.08.4a1.47 1.47 0 000 .33.23.23 0 00.24.19 1.56 1.56 0 00-.05-.33.23.23 0 00-.22-.19zm.26-.23h.09v-.09zm.09-.67h.25v-.08h-.25zm0 3h.08v-.08h-.08zm1.85-4.8h-.05.05c.05 0-.04.05-.03.02zm.08-.5h.17l-.17-.07zm.77-.59h.16l-.16-.08zm1.25 3.54h.08v-.09zm.08.25s-.06 0-.06.08 0 .08.06.08.07 0 .07-.08-.05-.06-.1-.06zm.25 4h.09v-.1h-.09zm.15-2.63a.39.39 0 00.05.2s.08.08.17.08a.4.4 0 000-.2c-.1.01-.16-.01-.25-.01zm.37 2.16a.41.41 0 01.17-.32c.11-.11.19-.18.23-.23h.1a.38.38 0 01.05.11.5.5 0 010 .14h-.45v.06a.19.19 0 000 .09l-.06.1h-.05zm.23-1.48h-.05c-.05 0 0 .06 0 .08s0 0 .06 0-.01.02-.04-.01zm.59.6c0 .11.06.17.18.17a.07.07 0 00.06 0 .07.07 0 000-.06.24.24 0 00-.1-.1l-.15-.07v.05a.11.11 0 00-.02.08zm.1-2.1c-.05 0-.07 0-.07.07s0 .08.07.08.06 0 .06-.08-.05 0-.09 0zm.68 1.82a.32.32 0 00-.27.15.6.6 0 00-.1.3c.16 0 .26 0 .3-.13a.61.61 0 00.04-.25zm.25.7l.07-.09-.07-.08-.1.08zm.17-.35a.09.09 0 000 .18s.06 0 .06-.09-.05-.01-.09-.01zm0 .35h.18a.23.23 0 00.12 0h-.25-.05a.09.09 0 00-.03.07z"
            style={{
              WebkitTransformOrigin: 325.694,
              MsTransformOrigin: 325.694,
              transformOrigin: 325.694,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M340.79 128.15a.84.84 0 000-.1.36.36 0 00-.06-.11.31.31 0 00-.06-.12.29.29 0 01-.06-.1v-.05-.13a.37.37 0 000-.1.71.71 0 00-.09-.13l-.11-.14a.14.14 0 010-.07v-.21a.19.19 0 010-.07.79.79 0 010-.1.81.81 0 01.08-.12h.05a.34.34 0 01.17 0H341.52l.07-.07.07-.07h.17a.69.69 0 00.18 0h.1a.22.22 0 01.1 0h.41a.52.52 0 01.07.11.27.27 0 00.08.11h.15l.05-.07a.23.23 0 00.03-.61.22.22 0 000-.09.43.43 0 010-.11l.13-.07.11-.07c.05 0 .08-.06.11-.06l.13.07a.11.11 0 00.07 0h.28a.31.31 0 01.14-.08l.15-.07h1.43a.59.59 0 00.18-.06l.19-.09v-.07h.2l.08-.07a.15.15 0 00.06-.07.58.58 0 000 .15.61.61 0 000 .15.21.21 0 00.05.09.15.15 0 00.07.06h.85a2.09 2.09 0 00.1-.23 1.65 1.65 0 01.11-.19.15.15 0 010-.08h.09l.22.06h.19a.25.25 0 00.1 0h.47a.25.25 0 000 .07 1.5 1.5 0 000 .18.84.84 0 010 .18.6.6 0 00.11.1c.06.06.09.09.09.1l.1.12a.44.44 0 01.06.1l-.08.13.08.07h.12v.45c.05 0 .07.05.07.09v.13l.06-.14.07-.14.08-.09h.2a.74.74 0 010 .15.93.93 0 01-.05.14l-.07.14-.06.12a.24.24 0 010 .12.65.65 0 000 .1.13.13 0 01-.09 0h-.11a.19.19 0 01-.07-.08.23.23 0 00-.08-.07h-.25a.33.33 0 000-.1H348.24c-.05 0-.07 0-.07-.07H348.32a.43.43 0 000-.07.13.13 0 000-.08h-.15l-.09.12-.11.16v.13l-.07-.09s-.06-.06-.08-.06h-.07a.65.65 0 010 .1.27.27 0 000 .1l-.1.11-.1.12a.23.23 0 00-.07-.08l-.08-.07h-.2l-.06.07-.09.08v.07H346.35v-.07s0-.08-.07-.08H344.98a.51.51 0 00-.17.07l-.18.06h-.28l-.15.15h-.2s-.05 0-.08.06l-.06.06h-.91.05l-.1.07-.1.06H342.32a.19.19 0 000 .08v.07H341.7a.1.1 0 00-.08.05l-.07.08h-.68l.07-.15.06-.15s-.21.23-.21.21zm.27-4.15a.71.71 0 000-.12v-.2-.21a1 1 0 000-.15v-.08a.61.61 0 01-.05-.12.78.78 0 01-.01-.12.27.27 0 010-.08.36.36 0 010-.11.2.2 0 01.06-.11h.13l.1-.06a.22.22 0 01.12-.06l.14.12s.06 0 .15.07a1.14 1.14 0 01.2.08h.1l.07-.12c0-.05.05-.09.07-.1s.06 0 .12 0h.13a.43.43 0 010-.05.22.22 0 010-.09.36.36 0 010-.11c0-.06.05-.09.07-.09h.07l.07.07c.07.07.06.07.08.07h.2a.13.13 0 00.08 0h.06a.63.63 0 010-.09.19.19 0 010-.08s.05 0 .05-.07h.08a.29.29 0 010 .08.25.25 0 00.05.07l.05.09.06-.09a.23.23 0 00.07-.08v-.13a.26.26 0 000 .07v.06s.06 0 .06-.07v-.06h-.06l.13-.09.13-.06h.09a.15.15 0 010 .07.22.22 0 000 .08h.1l.26-.07a.77.77 0 00.22-.07H344.61l.13-.14.14-.15h.2a.12.12 0 01.08 0h.37l.17-.08.18-.09c.05 0 .09 0 .1-.06H347.15a1.45 1.45 0 00.48 0h.08a.21.21 0 000-.07.32.32 0 000-.08h.05a.27.27 0 000 .08.13.13 0 010 .07h.11v-.05h.26a.27.27 0 010 .08.33.33 0 000 .1.21.21 0 00.06.08.43.43 0 00.07.07H348.41a.43.43 0 000 .1.4.4 0 000 .12h.05a.14.14 0 000 .06v.07l.13-.07a.13.13 0 000 .08l.06.07h.13a.2.2 0 00-.07.11l-.06.14h.2l.12.28h.08a.11.11 0 01.07 0h.07v.29H348.9l-.21.22v.08a.15.15 0 010 .07h.31-.35v.13l-.07.07h-.61a.35.35 0 01-.11-.09l-.11-.11h-.13l-.11-.05h-.11l-.2.2h-.55l-.06-.06s0-.06-.07-.06h-.2s-.06 0-.11.06a.24.24 0 01-.11.06h-.48a.6.6 0 00-.16 0h-.26a2.06 2.06 0 00-.26 0h-.78H343.73a.49.49 0 01-.2 0h-.2l-.12.09a.29.29 0 01-.1.06H342 341.31zm.61-1h.09v-.08h-.09zm.29 0h.04zm.76-.41a.41.41 0 000 .12.37.37 0 000 .11v-.13a.21.21 0 000-.07zm.69 3.62l.06-.07h-.06zm.76.21h.05-.05l-.06.08a.13.13 0 00.06-.05zm.09-.5h-.05.05c.05 0 0 0 0 0a.05.05 0 000 .08zm.4.22s-.05 0-.05.07 0 .06.05.06a.05.05 0 00.06-.06s-.02-.04-.06-.04zm.28-.55a.06.06 0 00-.07.07s0 .06.07.06.05 0 .05-.06.01-.04-.05-.04zm2.7-.5l-.14.15c-.07.08-.12.12-.14.12h-.05a1.11 1.11 0 01.11-.11l.11-.11h.13zm-.13.35v.07l-.07-.07zm.07-3.4s0 .05 0 0v-.06zm.26 4V126.19s.07 0 .07-.07-.02-.12-.07-.12zm.35-4.44v-.02zm.64 0s-.02-.09 0-.07zm.2 5.54l-.03-.07zm.2-1.45v.07h-.05v-.07zm.21 1.58v-.06h-.05z"
            style={{
              WebkitTransformOrigin: 344.94,
              MsTransformOrigin: 344.94,
              transformOrigin: 344.94,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M279.25 147H279a.76.76 0 01-.23-.13 2.09 2.09 0 01-.22-.2 1.68 1.68 0 01-.18-.21l-.12-.15c-.09-.32-.17-.64-.25-1a4.17 4.17 0 01-.12-1 .41.41 0 010-.21l.06-.16a1.05 1.05 0 00.05-.19 1.57 1.57 0 000-.31c.06 0 .09.09.1.19s.05.16.12.16H278.36a.62.62 0 01-.08-.1l-.07-.1a.19.19 0 010-.15 1.07 1.07 0 01.14-.16.94.94 0 01.18-.12.31.31 0 01.16 0 .2.2 0 01.19.13 1.81 1.81 0 01.06.27 1.31 1.31 0 010 .28.26.26 0 00.05.19.44.44 0 00.2.07l.34.06a1.26 1.26 0 01.31.09.21.21 0 01.13.21h-.19c-.01 0 0 .06 0 .15h.22a.05.05 0 000-.05h.24a.37.37 0 01.05.11.35.35 0 00.07.12.23.23 0 00.17 0 .2.2 0 00.18-.09l.12-.2a.81.81 0 01.18-.19.36.36 0 01.32-.05s.06 0 .1.06a.11.11 0 01.05.09l.07-.12a.18.18 0 01.09-.1h.16a.43.43 0 00.28-.12l.28-.25a1.26 1.26 0 01.32-.21.52.52 0 01.37 0l.1-.13.05.05a.51.51 0 010 .18v.19a.25.25 0 00.24-.1.48.48 0 00.07-.22 2.72 2.72 0 000-.28.6.6 0 010-.27.82.82 0 01.15-.16l.16-.14a1.19 1.19 0 000-.17 1.16 1.16 0 010-.16.35.35 0 00-.16.06c-.07 0-.13.06-.16 0a.51.51 0 010-.15.37.37 0 000-.16.13.13 0 00-.13 0h-.14c-.05 0-.08 0-.12-.09a1.09 1.09 0 01-.05-.4h-.15v.34a.32.32 0 01-.22-.12.24.24 0 00-.18-.1h-.05l-.13.08a2.13 2.13 0 01-.46-.05 1.07 1.07 0 01-.43-.18.94.94 0 00-.1.38.75.75 0 01-.34-.09.74.74 0 00-.36-.09v-.06a.13.13 0 000-.06l-.05-.08a.12.12 0 010-.08v-.07a1.28 1.28 0 000-.33v-.33h-.08v.16a.3.3 0 000 .13s0 .06.07.07c-.12 0-.19.09-.2.2a1.82 1.82 0 000 .33 1.47 1.47 0 010 .31c0 .09-.09.13-.23.13a3.06 3.06 0 01-.74-.09 2.52 2.52 0 00-.79-.06l-.15-.15-.07.15h-.16s-.1 0-.19-.11a3.44 3.44 0 01-.27-.27 2.21 2.21 0 01-.25-.3.55.55 0 01-.1-.22.74.74 0 00.29.22 1 1 0 00.33.08.59.59 0 01-.24-.27.22.22 0 010-.21.24.24 0 01.19-.1.67.67 0 01.32.06.33.33 0 000-.14h-.21c-.11 0 0-.11-.07-.23l-.06-.21s.05-.08.17-.1l.36-.08a1.81 1.81 0 00.37-.1c.11-.05.16-.11.15-.2a.76.76 0 01-.23-.15.83.83 0 00.29-.33c.06-.13.12-.25.17-.37a1.32 1.32 0 01.23-.35.69.69 0 01.42-.2h.09l.11-.15.1-.15s.06-.05.07 0l.18.4.07.05a.19.19 0 010 .08v.08l-.11.2a1.07 1.07 0 00-.09.19l.06.08a.17.17 0 00.09.07h.06s.06-.06.1-.18.06-.17.07-.17.09.06.12.19a2.36 2.36 0 010 .24.36.36 0 010 .1.11.11 0 01-.1 0H280.5c-.05 0-.07 0-.07.08s.07.14.13.14h.39c.06 0 .11-.05.13-.14l.2.18.21.19.24.15a.81.81 0 00.33.06h.18a.7.7 0 00.19-.06.37.37 0 00.05.15.15.15 0 00.14.08h.15a2.08 2.08 0 000 .34.73.73 0 00.09.22.13.13 0 00.13.1h.14s.06 0 .08.08l.06.15a1.21 1.21 0 00.05.18.25.25 0 000 .11.19.19 0 00.07-.08.23.23 0 01.08-.07h.07l.16.31h.15a.14.14 0 000-.09.36.36 0 010-.11s0-.07.09-.09a.53.53 0 00.09.11.19.19 0 01.07.12v.11a.42.42 0 00-.08.13.22.22 0 01.11 0l.14.11a.29.29 0 01.11.11v.09l-.06.07.14.17a.17.17 0 00.22 0l.09.3a.33.33 0 00-.24.2.73.73 0 00-.06.3 1.08 1.08 0 000 .35.69.69 0 00.17.25v.1h-.2c-.11 0-.16.06-.16.15a.36.36 0 00.12.13.21.21 0 01.09.17.17.17 0 010 .07.27.27 0 000 .08v.22H284.34s-.05 0-.07.08l-.06.19c0 .06 0 .13-.05.19a.4.4 0 010 .12 1.57 1.57 0 01-.28.31l-.32.29h-.08l-.1-.11-.1-.12a.09.09 0 00-.07 0 .05.05 0 000 .05.24.24 0 000 .12c0 .06 0 .09.06.1a.45.45 0 00-.19.05.27.27 0 00-.12.14.16.16 0 00-.15-.09.68.68 0 00-.26.07 1.24 1.24 0 01-.26.1v.07a.41.41 0 00.25.09.72.72 0 00.27 0 .53.53 0 01-.23.19.93.93 0 01-.29 0h-.15a1.84 1.84 0 00-.13-.33.28.28 0 00-.27-.19c-.08 0-.12 0-.14.13s0 .13-.05.15a.53.53 0 00-.11.11l-.12.12a.28.28 0 00.05.16.3.3 0 010 .15.36.36 0 010 .19l-.1.13-.1.15a.54.54 0 000 .24H281.02l-.12-.09c0-.05-.09-.08-.11-.08l-.08.06h-.07a.33.33 0 010-.06h-.08s-.07 0-.13.09l-.19.19c-.07.07-.13.14-.19.19a.38.38 0 01-.11.09h-.05l-.35-.37zm-.2-2.21a1 1 0 01.28.35 2.5 2.5 0 01.17.4l.07-.1a1.59 1.59 0 00.08-.18 1.8 1.8 0 00.05-.19.72.72 0 000-.13.23.23 0 00-.1-.16.59.59 0 00-.19-.11l-.22-.08a.35.35 0 01-.15-.08c0 .09 0 .14.08.15zm.15 1h.08l-.08-.07zm.11-6.67c0 .12.05.18.14.18h.1a.14.14 0 00-.11-.1zm.19.85a.26.26 0 00-.09.21.22.22 0 00.1 0 .09.09 0 00.07-.09l-.05-.05zm0 6.27h.08c0-.09 0-.14-.08-.15zm.08-2.15a.06.06 0 00-.07.07.07.07 0 00.07.08v-.08c0-.08.02.01 0 .01zm.05-5.67v.13a.06.06 0 00.07-.07s-.03.02-.07.02zm0 8s.02.13 0 .11zm.27-1.15a1.39 1.39 0 000 .17V145.66s.08-.05.08-.08V145.34c.02.07.02.04-.08.04zm.1-.4a.18.18 0 00-.09.15h.09zm-.07 1.84h.07v-.14h-.07zm.22-2.22V144.64s.06 0 .06-.08-.02.04-.06.04zm.06-5.09v.15a.4.4 0 000 .15.09.09 0 000 .05.26.26 0 00.16-.24.11.11 0 00-.08-.11.35.35 0 00-.08.11zm0 5.72a.27.27 0 00.15.27c.06 0 .08 0 .08-.08v-.1a.57.57 0 000-.14s-.06-.05-.15-.05l-.07.07zm2.28-7.18v.1l-.05.13h-.05l-.12-.05h-.2a.14.14 0 010 .07.2.2 0 000 .08h-.36a.21.21 0 00-.16.09l-.15.17-.14.18c-.05.05-.09.08-.12.08l-.2-.06-.15-.07a.21.21 0 01-.1-.08v-.05a.26.26 0 01-.05-.09.31.31 0 010-.1.26.26 0 01.09-.1.3.3 0 01-.21-.26.46.46 0 01.06-.36.61.61 0 01.77-.29v-.59a.72.72 0 00.45-.2v.46a.67.67 0 01.38-.2.72.72 0 00-.12-.25 1.53 1.53 0 00-.18-.18.18.18 0 01.17-.08.11.11 0 01.1 0l.06.1.06.1a.12.12 0 00.11 0 .37.37 0 00.22-.12c.09-.09.19-.18.29-.29a3.84 3.84 0 01.3-.28.55.55 0 01.3-.13.3.3 0 01.15 0l.1.1.26-.1.27-.1h.05a.36.36 0 010 .18.29.29 0 000 .17.3.3 0 00.2-.06.24.24 0 01.18-.06v.05c0 .05 0 0 .05 0h.06l.09-.05h.1v.39a.22.22 0 01.08-.14H285.29s.07-.09.11-.19a.31.31 0 01.14.16.41.41 0 00.16.19c-.06 0-.08.08-.08.17l.15-.13q.08 0 .15.21a.86.86 0 01.06.25.92.92 0 01-.13.51 2.88 2.88 0 01-.28.38l-.29.32a.48.48 0 00-.13.33.57.57 0 01-.28-.08l-.31.15-.34.15h-.07l-.08-.05H284a.42.42 0 00-.16 0 .34.34 0 01-.17.05.22.22 0 01-.14-.05.15.15 0 00-.13 0l-.2.3h-.05s-.07 0-.09-.1l-.08-.22a1.12 1.12 0 00-.13-.24.27.27 0 00-.22-.1zm-1.78 2.43v.13s.08 0 .08-.06 0 .04-.06.04zm.08-2.07v.14s.09 0 .09-.07-.01.04-.07.04zm.07 8.41v.16s.08 0 .08-.08 0 .03-.06.03zm0-6.92a.15.15 0 000 .06l.07.09a.38.38 0 00.1-.15.51.51 0 00.05-.17l-.07.12a.41.41 0 00-.13.16zm.65 5.37a.46.46 0 00-.36.23.85.85 0 00-.16.42.42.42 0 00.38-.22.81.81 0 00.16-.32zm-.4-.72h-.05.05c.05 0 .05.11.02.11zm.43 0a.15.15 0 00-.15.08.41.41 0 00-.05.19.26.26 0 00.25-.17.2.2 0 000-.07s-.01.13-.03.13zm-.16-4.55a.16.16 0 00.08.13v-.13zm.3 0a.24.24 0 010 .07.25.25 0 010 .08v-.21h-.06zm.16 4.54h.06zm.29 1l.08-.06s.06-.06.07-.09v-.08l-.07-.11-.08-.11-.23.22zm-.14-7.53c-.05 0-.08 0-.08.07a.07.07 0 00.08.08v-.08c0-.08.01.08.01.08zm.05 2.13a.2.2 0 000 .08.25.25 0 000 .07h.05v-.08h-.05s.02.07.02.08zm.24 4.22h.08l-.08-.08zm.43 1.1h.1a.15.15 0 00-.1-.15zm.15-8.86a.13.13 0 00.1-.13h-.1zm.44-.8v.14s.06 0 .06-.07 0 .08-.04.08zm0 1.15h.1a.41.41 0 00.19-.05.41.41 0 01.23-.05.44.44 0 000-.14c0-.06 0-.13-.07-.2a.81.81 0 00-.1-.18.22.22 0 00-.12-.1s-.06 0-.12.08l-.11.12c0 .06 0 .09.08.1s.08 0 .08.1 0 .1-.08.1-.08 0-.08.09zm.3 7.71s.04.15.02.15zm.16-3.12s.08.15.02.15zm.15-5.4a.11.11 0 00-.11.06.17.17 0 000 .12h.15zm-.08 7.1s.06.17.02.15zm.15.74a.22.22 0 000 .1v.08a.28.28 0 00.08-.11.34.34 0 01.06-.12H284zm0-6.07v.16c0 .09 0 .15.11.17a.59.59 0 000-.08v-.07c.13.02.07.02-.09.02zm.19 4.82s0 .06 0 0l.05.15zm.06 1.18v-.07h-.06zm.15-1.78a.25.25 0 00-.08.18.26.26 0 00.17-.1zm0-4.27s-.05 0-.05.07 0 .08.05.08.07 0 .07-.08.03.08-.02.08zm.3.15l.14-.15h-.14zm.44-.81h.05v-.22h-.05v.1zm.08-.73s.07.15.05.15zm.37.13s.05.18.05.15z"
            style={{
              WebkitTransformOrigin: 281.705,
              MsTransformOrigin: 281.705,
              transformOrigin: 281.705,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M302.08 146.63a1.5 1.5 0 010-.2 1 1 0 000-.25c-.07 0-.1 0-.11.14a.26.26 0 01-.11.2.33.33 0 01-.06-.12c0-.05-.06-.08-.1-.08s-.08 0-.09.09a.12.12 0 01-.08.11V146h-.19a.8.8 0 010 .16c0 .09-.06.13-.12.13h-.53a.09.09 0 01-.05-.09v-.2a1.15 1.15 0 010-.19.62.62 0 000-.19h-.11a.4.4 0 00-.15 0 .35.35 0 00-.12.07.12.12 0 000 .14v-.15a.49.49 0 010-.17h.13a.42.42 0 010-.09v-.08h-.18v-.05c.05 0 .07 0 .07-.06a.29.29 0 00-.27.12.65.65 0 00-.08.35 1.58 1.58 0 000-.19.62.62 0 000-.2h-.1v-.35h-.06l-.21.1a.17.17 0 00-.09.19H299c-.13 0-.2 0-.24-.09a.62.62 0 01-.05-.27h.14v-.14a.51.51 0 01-.25-.06.27.27 0 01-.12-.25v-.07-.06a.13.13 0 00-.06-.07h-.06a.26.26 0 00.12-.2.2.2 0 00-.17-.2.86.86 0 00-.3-.05H298a.16.16 0 01.1.13 1.41 1.41 0 010 .18s0 .08-.1.16l-.24.26-.26.25c-.09.08-.15.12-.19.12a.51.51 0 010-.14.12.12 0 00-.08-.09.2.2 0 00-.11.15 1.74 1.74 0 010 .22.59.59 0 01-.11.19h-.28v.1a.38.38 0 00.2.34l-.07.61v.05l-.09.07c-.06 0-.08 0-.07-.11s0-.11-.08-.11l-.14.11a.47.47 0 01-.13.09.68.68 0 01-.22.06h-.21a.17.17 0 000 .13.21.21 0 010 .14.33.33 0 01-.05.2.21.21 0 01-.16.08.13.13 0 01-.1 0 .17.17 0 00-.12 0 .16.16 0 00-.12 0H295.07s-.06 0-.06-.12a.54.54 0 01.14-.35c.09-.12.17-.22.22-.3a.93.93 0 00.05-.14v-.11a.39.39 0 010-.11h.1s.06-.06.1-.12a4 4 0 00.21-.41 1.9 1.9 0 01.23-.39c.08-.11.17-.24.28-.37a4.63 4.63 0 00.32-.42 4.92 4.92 0 00.26-.43 1 1 0 00.11-.45.13.13 0 00-.06-.11l-.14-.09a.49.49 0 01-.13-.12.24.24 0 01-.06-.18.64.64 0 010-.15v-.1h.13a1.41 1.41 0 000 .24h.06a.11.11 0 00.08 0h.12l.08.1a.3.3 0 00.09.1.09.09 0 00.08-.05.36.36 0 000-.1.45.45 0 000-.13.25.25 0 010-.07.2.2 0 010-.09.38.38 0 010-.18.24.24 0 01-.17-.14.59.59 0 00-.13-.18v.09a.53.53 0 00.06.26.48.48 0 01.07.26c-.07 0-.11 0-.13-.06a.34.34 0 01-.06-.12l-.06-.12a.12.12 0 00-.12-.06h-.2s-.07 0-.09-.11a.26.26 0 00-.07-.14H296a.55.55 0 000-.13.48.48 0 00-.08-.16.34.34 0 00-.12-.12.21.21 0 00-.16 0 1.35 1.35 0 00-.11-.26.76.76 0 00-.13-.17l-.15-.12-.18-.18a.27.27 0 01-.06-.23.66.66 0 000-.24.5.5 0 00-.13-.25.29.29 0 01-.12-.2s0-.08.07-.08.06 0 .06-.13v-.16h-.15v.28a.15.15 0 00-.17.11 1 1 0 000 .19h-.08v-.5c-.11 0-.17-.09-.17-.16s0-.14.13-.14V139h.18v-.54h.15a.8.8 0 000 .16.19.19 0 00.1.16l.12-.13a.23.23 0 01.08.12.84.84 0 000 .14l.23-.13a.26.26 0 00.05.17l.15.2c.06.06.11.12.18.18a1.29 1.29 0 01.12.12h.25s.05 0 .05.06v.05a.16.16 0 00.1 0 .12.12 0 01.09.06l.08.13.06.16a.15.15 0 00.1.09.21.21 0 00.15-.07.22.22 0 01.31.07.22.22 0 01.18.07.38.38 0 01.06.16.77.77 0 00.07.16.22.22 0 00.18.06h.11a.23.23 0 01.14.23v-.05a.21.21 0 00-.09 0 .16.16 0 00.07.14.56.56 0 00.19.09.8.8 0 00.21.05h.38a.33.33 0 00.16-.16c.06-.1.13-.22.22-.35a2.14 2.14 0 01.28-.39 1 1 0 01.36-.3.2.2 0 00.09-.11.39.39 0 000-.14.5.5 0 01.11.13l.09.12-.31.12v.23h.5v-.33h.16c.09 0 .14 0 .14-.1h.32s.05 0 .06-.11a.83.83 0 000-.12h.11c0 .09.05.19.08.31a.2.2 0 00.21.17h.12a.16.16 0 01.11 0v.18a1.19 1.19 0 010 .17.72.72 0 010 .25.27.27 0 01-.09.12l-.14.09a.43.43 0 00-.23.42.25.25 0 01-.11.24.72.72 0 01-.05-.14.23.23 0 00-.06-.13.47.47 0 01-.07.22.26.26 0 01-.11.1l-.11.08a.27.27 0 00-.08.17v.13l-.06.2a.66.66 0 01-.09.19.14.14 0 01-.11.08v-.06a.11.11 0 010-.07.43.43 0 00-.18.33.45.45 0 00.08.26 1.26 1.26 0 00.2.2l.19.19a.37.37 0 01.08.22.25.25 0 010 .07s0 .05-.05.06v.05l.05.07a.39.39 0 010 .06h.07a.16.16 0 000-.06v-.07h.06a.72.72 0 01.4.35 2.29 2.29 0 00.32.47l.23.2.31.25c.11.09.21.17.3.26a1.9 1.9 0 01.2.22.27.27 0 010 .13v.12a.12.12 0 00.09 0h.08a2.4 2.4 0 01.51.62 1.76 1.76 0 01.14.75c-.06 0-.11-.06-.18-.18a.29.29 0 00-.27-.17.36.36 0 00-.21.05.2.2 0 00-.09.2h.05l.05-.1h.05v.2a.46.46 0 00.16.07h.18c.05 0 .08 0 .08.09l-.08.08-.1.05H302.29a.2.2 0 01-.12-.08.36.36 0 01-.09-.45zm-6.91-.16s-.05 0-.05.05h.1s-.01-.05-.05-.05zm.17-.25v.11s.05 0 .05-.05-.02-.06-.05-.06zm.13-.35h-.05l.05.05v-.05c0-.05.04 0 0 0zm.12-.24s0 .07.05.07v-.17s-.05 0-.05.07zm.13-5.92h.12v-.05h-.07zm0 6.32h.12a.33.33 0 000-.1.14.14 0 010-.06zm.17-.36a1.12 1.12 0 000 .2.31.31 0 00.11.16v-.55l-.06-.06c-.06 0-.08.05-.08.12a.93.93 0 01.03.13zm.07-4.44v-.07zm.4 4.42c0 .06 0 .09.07.1v-.1zm1.23-3.69a.11.11 0 00.12.07v-.13a.16.16 0 00-.12.1zm.3 1.34a.29.29 0 000 .14.14.14 0 00.11.06l.09-.05.14-.13.13-.15a.27.27 0 00.06-.14v-.07h-.1s-.07 0-.12.13a.35.35 0 01-.3.17zm.07-1.09v.06c0-.06.04-.06.04-.06zm.5-.38s0 .07.05.07a.31.31 0 00.13 0h.12v-.17a.92.92 0 00-.3.1zm.1 1.4a.62.62 0 000 .12.07.07 0 00.07.08h.05l.07-.06a.09.09 0 00-.08-.1zm.43 1.65s-.05 0-.05.06 0 .06.05.06.05 0 .05-.06-.04-.06-.04-.06zm.3-2.43h.07v-.07h-.07zm.19-1h-.07zm-.07 1.42h.07v-.06h-.07zm.12-2.42v.22zm0 2.91a.15.15 0 000 .13v-.13zm0-.74c0 .1.05.15.16.15v-.14c0-.07 0-.11-.1-.12zm.2.87v.05c0 .05 0 .06 0 0s.02-.04 0-.04zm.06-2.92v-.05zm0 2.67v.06s.05-.03.05-.05zm.14.55s.06 0 .06-.1v-.28c0-.09-.05-.14-.11-.14zm0-.75V143zm0-1.59v.14s.05 0 .05-.07.08-.06.02-.06zm.11-1.55h.15c0-.09 0-.13-.13-.13zm0 4.31h.14v-.07h-.14zm.14-.3h.05v-.07zm.35.46h-.12a.15.15 0 00-.12.07h.24zm-.19.72h.09s0-.07-.09-.1zm.14-.38h.05l-.05-.07zm.23.63v-.12l-.07.07zm.05.62l.1.04zm.14-.62s-.06 0-.06.07a.05.05 0 00.06.06v-.06c0-.06.1-.06.1-.06zm.11-5.5l-.05.05s0 .06.05.06 0 0 0-.06.12-.04.1-.04zm0 6a.23.23 0 010-.09v-.06h-.07zm.37-.25h.07v-.07h-.07zm.11-.57c0 .09.05.13.14.13v-.13z"
            style={{
              WebkitTransformOrigin: 298.701,
              MsTransformOrigin: 298.701,
              transformOrigin: 298.701,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M317.39 146.75l-.13.09a.44.44 0 00-.12.1l-.05-.06-.09-.12a1.32 1.32 0 01-.08-.14H316.7a.16.16 0 000-.08.18.18 0 00-.05-.07.88.88 0 00-.33.08.77.77 0 01-.35.08h-.42a.77.77 0 01-.27 0 .34.34 0 01-.2-.12.62.62 0 01-.1-.31h-.05a.06.06 0 010 .05h-.1v-.27a.78.78 0 00-.18-.11.38.38 0 01-.15-.12v-.25c-.09.06-.13.11-.13.18s-.07.09-.2.09H314v-.16-.17a.63.63 0 00-.21-.13.52.52 0 01-.15-.06.28.28 0 01-.09-.14 1.17 1.17 0 010-.32.2.2 0 010 .08l-.05.08a.34.34 0 01-.2 0 .28.28 0 01-.09-.16.57.57 0 010-.18v-.16h-.19a.43.43 0 01-.19 0s-.05 0-.08-.07-.07-.08-.09-.08a.38.38 0 00-.2 0 .45.45 0 00-.21 0l-.15-.73-.1-.1h.1l.22-.05.22-.07h.07a.41.41 0 01-.21 0 1.37 1.37 0 01-.2-.13l-.16-.16a.24.24 0 01-.06-.13.83.83 0 010-.13l.06-.15a.53.53 0 01.08-.15.19.19 0 01.09-.09v-.58l.09-.08.16-.09-.25.12-.25.11v.05c0 .05 0 0 .06 0h.85a.87.87 0 00-.15-.13l-.15-.15-.08-.07a.32.32 0 01-.1.1l-.15.07v-.25a1.59 1.59 0 010-.36 1.55 1.55 0 01.13-.36.83.83 0 01.21-.28.47.47 0 01.32-.12v-.08a.18.18 0 010-.1l.12-.26.13-.24a.14.14 0 01.1.1.59.59 0 010 .14.29.29 0 00.05.13s.07.05.15.05a.23.23 0 00.18-.07.64.64 0 00.08-.14.64.64 0 01.08-.14.17.17 0 01.16-.07.2.2 0 01-.14-.13.54.54 0 010-.18v-.4c0-.05 0-.08-.1-.1l-.13.13-.12.13v.07h.09a.18.18 0 01.08.06v.07a.49.49 0 010 .12.79.79 0 000 .13.44.44 0 01-.2-.21c0-.09-.1-.15-.22-.21l-.06-.31a1.57 1.57 0 010-.32v-.1a.88.88 0 01.15-.17l.18-.15.08.07-.08.33c0 .17-.07.27-.08.32a.19.19 0 00.14-.07l.13-.15a.52.52 0 00.1-.18.61.61 0 000-.17s0-.1-.07-.2-.07-.16-.09-.2 0 0 .1 0h.27l.22-.16c.08 0 .12-.1.12-.17a.14.14 0 00-.05-.12s-.05-.06-.05-.12a.87.87 0 010-.2c0-.08 0-.17.07-.26a.65.65 0 01.11-.22.16.16 0 01.15-.07l.3-.31a1.24 1.24 0 01.27-.21 1.1 1.1 0 01.32-.11 2.46 2.46 0 01.41 0H316.68a1.25 1.25 0 01.45.13.28.28 0 01.2.27v.07a3.56 3.56 0 00-.54.76l-.42.81a.22.22 0 00-.1.08s-.06.07-.07.07h-.18c-.09 0-.14 0-.16.06l-.24.72c-.06.18-.11.36-.16.53a2.51 2.51 0 00-.08.28.63.63 0 000 .2v.18a.5.5 0 01.31.1l.19.21a1.68 1.68 0 00.18.21.4.4 0 00.3.1l.08-.07a.36.36 0 00.09-.09h.08l.07.05a.25.25 0 01.08.05.22.22 0 00.1-.07.16.16 0 00.07-.1v-.08a.58.58 0 00-.05-.09v-.1a.58.58 0 01.45.21.75.75 0 01.21.48.25.25 0 00.08-.14v-.3a.28.28 0 01.08-.15l.07.09v.65s0 .05.06.08l.14.1.21.15c.05 0 .08-.05.09-.13a1.93 1.93 0 000-.27v-.29a.55.55 0 010-.21.82.82 0 01.24.25.34.34 0 00.29.17l.08-.05.08-.05v.1a.8.8 0 010 .15.66.66 0 000 .16 1.57 1.57 0 000 .2.51.51 0 000 .2v.05c0 .05 0 0 .05 0s.11-.07.11-.1v-.11a.22.22 0 01.06-.13 1 1 0 01.31-.15l.08-.05h.07a.36.36 0 01.19.11l.07.11.07.09a.36.36 0 00.17.09l.23.08a.16.16 0 01.12.17v.05l-.4.39v.1H320a.1.1 0 00.1-.06l.06-.12.06-.12s.06-.05.11-.05a.76.76 0 01.09.17l.07.17s0 .07-.16.14l-.19.14h.17a.37.37 0 01-.1.26.39.39 0 00-.1.27v.05l.12.12.11.11a1.82 1.82 0 00-.13.24 2.44 2.44 0 01-.12.24.62.62 0 00.13.38.69.69 0 01.14.4.33.33 0 01-.06.24.57.57 0 01-.28.08h-.09a.18.18 0 01-.08-.06 1.42 1.42 0 01-.22.5 1.6 1.6 0 01-.36.4.38.38 0 01-.09-.15c0-.07-.05-.1-.11-.1s-.12 0-.12.16v.09a1.16 1.16 0 000 .16c0 .08 0 .13.06.15h-.44a.28.28 0 010 .16h-.17a.54.54 0 000-.19c0-.05-.08-.07-.17-.07h-.06a1.49 1.49 0 01-.2.36.48.48 0 01-.35.12.57.57 0 01-.06-.15.14.14 0 00-.14-.1zM311.8 143a.19.19 0 00.09 0h.08v-.27zm.17.63l.09.11.13.11a.19.19 0 00.1.05v-.05l-.1-.11-.12-.11zm.15-2.6a.17.17 0 00.1.15v-.15zm.18 2.77v.05a.07.07 0 000-.05s.02.02 0 .02zm.14-1.15a.85.85 0 000 .13v.21l.06.2a.61.61 0 00.05.11l.2-.27.14-.22zm1-2.52a.38.38 0 00-.16.15.41.41 0 00-.05.18.15.15 0 00.06.13.26.26 0 00.22 0v-.22a.83.83 0 000-.15s-.04-.07-.06-.07zm-.16 3.67s-.05 0-.05.08 0 .09.05.08 0 0 0-.08.03-.05.01-.06zm.06-.39a.56.56 0 010 .07.23.23 0 010 .07.94.94 0 00.12.2c.07.09.1.13.11.13h.12a.55.55 0 00-.1-.32.32.32 0 00-.24-.13zm.42-3.28v.07a1.21 1.21 0 000 .18.84.84 0 00.05.17c0 .05.05.08.07.08s0 0 0-.08a1 1 0 000-.17.78.78 0 00-.05-.18c-.02-.03-.04-.05-.06-.05zm.45-2.89H313.91v.4h.1l.07-.06.06-.15a.64.64 0 00.05-.17c.02.06.03.02.03 0zm.22 4.5a.49.49 0 00-.27.23.88.88 0 00-.07.36v.17a.71.71 0 00.24-.35 1.43 1.43 0 00.1-.36zm.08 2.31a.23.23 0 01.08.07l.09.09h.16a3.89 3.89 0 01.25.4 4.63 4.63 0 00.24.43 2 2 0 00.31.4 1 1 0 00.42.24.22.22 0 00.14 0h.11l.65-.1a2.43 2.43 0 00.56-.16 1.75 1.75 0 00.48-.3 2.09 2.09 0 00.43-.52 3.41 3.41 0 01.24-.35 1 1 0 00.18-.37.32.32 0 01.21.15.26.26 0 00.22.12.28.28 0 00-.06-.2l-.12-.1a.41.41 0 01-.13-.1.21.21 0 01-.06-.17q0-.15.09-.15c.07 0 .1 0 .1-.15a.59.59 0 00-.05-.23l-.11-.24a1.09 1.09 0 01-.09-.23.36.36 0 010-.25H318.68a.2.2 0 01-.15-.06 1.59 1.59 0 01-.13-.13l-.14-.12a.28.28 0 00-.15-.08h-.1l-.15-.06-.16-.06h-1.3q-.12 0-.15-.06a.29.29 0 01-.05-.13.52.52 0 00-.06-.13s-.06-.06-.13-.06c0 .2 0 .33-.16.39a.88.88 0 01-.44.09h-.08v-.17a1.5 1.5 0 000-.2.39.39 0 00-.07-.16.2.2 0 00-.16-.07h-.1a2.56 2.56 0 01-.16.23l-.22.3a2.42 2.42 0 00-.2.33.57.57 0 00-.09.26 2.91 2.91 0 00.1.72 2.3 2.3 0 01.09.91zm.07 1V145.22s.08 0 .08-.09a.07.07 0 00-.07-.08zm.1.07c-.06 0-.09 0-.09.08s0 .08.09.08.05 0 .05-.08-.01-.08-.04-.08zm.83-4a.48.48 0 00.1.36.54.54 0 00.35.09.44.44 0 00-.45-.45zm.15-3.09s.03-.03.01-.03zm.65 3.27h-.05c-.05 0 0 0 0 0a.05.05 0 00.05 0l.01-.02zm1-.08v.05s0-.06-.02-.07zm.33 5.32l.09-.09-.09-.08zm.74-.42a.19.19 0 00.14.2.85.85 0 00.26 0 .25.25 0 00-.13-.22.39.39 0 00-.26-.1zm.5-.57a.63.63 0 00-.2.5h.17a.13.13 0 00.11-.14s0-.09-.05-.18a.8.8 0 01-.05-.2zm.25-.4a.91.91 0 00.52-.15.57.57 0 00.23-.5.67.67 0 01-.3 0 .85.85 0 00-.3-.05h-.15zm.15.57h.08l-.08-.1zm.08-2.78v.16a.12.12 0 000-.16zm0 .41s0-.02-.02-.02zm.48.07s0 .1-.07.21l-.09.21v.11a.33.33 0 00.31-.22.86.86 0 00.12-.38l-.12.06a.16.16 0 01-.17-.01zm.1 1.65h.06V145h-.07zm.32-2a.06.06 0 00-.07.07.07.07 0 00.07.08c.05 0 .07 0 .07-.08s-.04-.14-.09-.14z"
            style={{
              WebkitTransformOrigin: 316.145,
              MsTransformOrigin: 316.145,
              transformOrigin: 316.145,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M329.38 146.27a.89.89 0 000-.11.36.36 0 00-.06-.11.31.31 0 00-.06-.12c0-.05-.06-.08-.06-.1v-.13a.64.64 0 000-.1.52.52 0 00-.09-.12 1 1 0 01-.11-.15.14.14 0 010-.06v-.22a.25.25 0 010-.07.79.79 0 01.05-.1l.08-.11h.05s.08 0 .18-.06H329.95a.24.24 0 00.11 0h.1l.07-.07.07-.06.17-.05a.59.59 0 00.18 0h.61l.07.1a.21.21 0 00.08.11h.16v-.06a.24.24 0 00.07-.09.41.41 0 000-.09.81.81 0 010-.11l.13-.06.11-.08a.24.24 0 01.11-.06l.13.07H332.52a.25.25 0 01.13-.08l.15-.07h.2a.31.31 0 00.15 0 .09.09 0 000-.05h.07l.07.05h1.03l.18-.06.19-.09V143.84H335l.08-.07s.06 0 .06-.06v.15a.61.61 0 000 .15.14.14 0 00.05.09.15.15 0 00.07.06h.85l.11-.22a.53.53 0 01.11-.19.14.14 0 010-.09h.09a.66.66 0 00.22.06h.76a.19.19 0 000 .07v.05a.84.84 0 000 .18 1.29 1.29 0 010 .19l.11.1a.29.29 0 01.09.1l.1.11.07.1-.09.14.09.06h.11v.18s.07.05.07.08v.13l.07-.14.06-.14a.29.29 0 01.08-.08H338.37a.43.43 0 010 .14.93.93 0 01-.05.14l-.06.14-.07.13a.36.36 0 010 .11.35.35 0 000 .1l-.09.05a.26.26 0 01-.11 0l-.07-.07s-.05-.07-.08-.08h-.25a.26.26 0 000-.1H337.44a.13.13 0 01-.07 0h-.05a.24.24 0 01-.12 0h-.11s-.07 0-.07-.07a.18.18 0 00.09 0h.06v-.08a.13.13 0 000-.07h-.15l-.09.13-.11.15v.14h-.05a.36.36 0 00-.07-.09s-.06-.06-.08-.06h-.07a.43.43 0 010 .1v.1a.69.69 0 00-.11.12.53.53 0 00-.09.11.59.59 0 00-.08-.08l-.08-.07H336l-.06.07-.08.08v.07h-.27a.13.13 0 01-.07 0H335.16V145.84c0-.05 0-.08-.07-.08h-.13l-.07.05h-.1a.28.28 0 01-.11 0h-.17l-.28.05-.29.05h-.15l-.17.07a.62.62 0 01-.18.07h-.28l-.15.15h-.2a.1.1 0 00-.08.05l-.05.06h-.5a.22.22 0 01-.12 0h-.37l-.1.07a.29.29 0 01-.1.06h-.14l-.08-.05h-.26V146.54h-.17a.8.8 0 01-.15 0H330.39a.1.1 0 00-.08 0l-.07.08h-.68l.07-.15.06-.15s-.31-.04-.31-.05zm.27-4.16a.29.29 0 000-.12v-.2a1.49 1.49 0 010-.21v-.15a.14.14 0 000-.07s0-.08-.05-.13 0-.09-.05-.13a.29.29 0 010-.09.33.33 0 010-.1s0-.09.06-.11h.13l.1-.06c.06 0 .09-.06.12-.06h.06l.14.12s.06.05.16.08a.77.77 0 01.19.07.54.54 0 00.07-.12l.07-.1h.12a.34.34 0 00.13 0 .19.19 0 010-.08.5.5 0 010-.12c0-.06.05-.08.07-.08h.13l.07.06c.07.06.06.07.08.07h.26V140.41v-.06h.09v.07a.19.19 0 000 .08.15.15 0 00.05.08.23.23 0 01.07-.08.35.35 0 00.06-.09v-.05c0-.05 0-.07.05-.08a.17.17 0 000 .08v.05s.07 0 .07-.06v-.07s0-.05-.07-.05l.13-.08.14-.07h.08a.22.22 0 010 .08.21.21 0 000 .07l.26-.07.22-.06H332.96l.14-.14.13-.14h.06a.11.11 0 00.07 0h.52l.18-.08.17-.09.1-.05.18-.05h.37l.08.05h.64a.15.15 0 000-.07.32.32 0 000-.08h.13a.27.27 0 000 .08v.07h.07v-.05h.27v.09a.22.22 0 000 .1l.06.07.07.08h.15a.43.43 0 000 .1.4.4 0 000 .12h.05a.25.25 0 000 .07v.06l.14-.06a.11.11 0 000 .07l.06.08h.13s0 .05-.07.12l-.06.13h.08a.26.26 0 00.09-.05l.11.28H337.1v.15h-.28l-.22.21a.45.45 0 010 .08.15.15 0 010 .07h-.5v.06a.26.26 0 000 .07l-.06.07h-.14a.09.09 0 01-.06 0h-.21a.72.72 0 01-.21 0l-.11-.09-.11-.11H334.86l-.21.2a.11.11 0 01-.07 0H334.15l-.06-.06c-.06-.06-.05-.06-.07-.06h-.2s-.06 0-.11.06a.24.24 0 01-.11.06h.4-1a.34.34 0 01-.14 0h-.58a.35.35 0 01-.12 0h-.4l-.11.09c-.06 0-.09.06-.11.06h-1.8zm.61-1h.09V141h-.09zm.29.05h.06v-.05h-.06zm.76-.42a.49.49 0 000 .12.34.34 0 000 .11v-.13a.21.21 0 000-.11zm.69 3.62l.07-.07H332zm.77.22h.05v-.09l-.06.07a.12.12 0 00.01.01zm.08-.5h-.05.05c.05 0 0 0 0 0s.02 0 0-.01zm.4.21s-.05 0-.05.07 0 .07.05.07a.07.07 0 000-.14zm.28-.55s-.06 0-.06.07 0 .07.06.07.05 0 .05-.07-.01-.08-.05-.08zm2.7-.5l-.14.15c-.07.08-.12.12-.14.12h-.05v-.05a.06.06 0 010-.05l.1-.11.11-.11h.13zm-.13.35v.07l-.07-.07zm.07-3.4v-.01zm.26 3.95V144.29s.07 0 .07-.07-.02-.09-.07-.09zm.36-4.43v-.01zm.63 0s-.02-.09 0-.06zm.2 5.53v-.06zm.2-1.45v.07h-.05v-.07zm.22 1.59v-.07H338z"
            style={{
              WebkitTransformOrigin: 333.686,
              MsTransformOrigin: 333.686,
              transformOrigin: 333.686,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M162.67 97.39s-.09.08-.18.25a.79.79 0 01-.2.29.45.45 0 00-.18-.28 2.91 2.91 0 00-.33-.26 1.94 1.94 0 00-.33-.2.45.45 0 00-.22-.08.21.21 0 00-.12.05.72.72 0 00.08.35 1.67 1.67 0 01.11.31.78.78 0 010 .22c0 .08-.11.14-.27.21h-.62a2.29 2.29 0 01-.94-.15l-.87-.33-.62-.19-.39-.09a2.57 2.57 0 01-.38-.14 3.31 3.31 0 01-.53-.36h-.07a.41.41 0 010 .16s0 .09.1.12a.77.77 0 01-.51.41 2.48 2.48 0 01-.68.09h-.73a1.82 1.82 0 00-.79.23l-.19.09a.76.76 0 00-.19.12h-.1l-.11-.12a.68.68 0 01.06-.15 1.07 1.07 0 00.05-.16.45.45 0 000-.11.46.46 0 010-.1.24.24 0 01-.13 0 .17.17 0 00-.13 0s-.06.05-.13.14l-.13.17a.25.25 0 01-.24-.11.86.86 0 01-.14-.32c0-.12-.05-.25-.07-.38s0-.22 0-.3a.85.85 0 01.06-.46 1.34 1.34 0 00.08-.46 1.94 1.94 0 000-.24.53.53 0 00-.15-.24l-.07-2.83a2.49 2.49 0 00.13-.32 1.09 1.09 0 01.13-.27v-.25a13.49 13.49 0 01-.47-3.36 1.72 1.72 0 01.07-.52 4.68 4.68 0 01.18-.48c.07-.17.13-.33.19-.49a1.67 1.67 0 00.08-.52.56.56 0 00-.07-.3.48.48 0 01-.07-.26.78.78 0 01.06-.31.46.46 0 000-.28v-.08a4.37 4.37 0 01-.4-.77 3.13 3.13 0 01-.16-1v-.39a2.42 2.42 0 01.07-.47 1.17 1.17 0 01.18-.39.39.39 0 01.35-.17c.06 0 .1 0 .1.12a1.12 1.12 0 00.22-.25 3.31 3.31 0 00.18-.29l.14.23a.62.62 0 01.49-.23 1.39 1.39 0 01.32 0 1.12 1.12 0 01.25.11 1.77 1.77 0 01.24.17 1.7 1.7 0 00.32.23 1.66 1.66 0 00.5.13.66.66 0 01.26.06.3.3 0 01.12.23c0 .12.06.32.11.62v.29a.29.29 0 00-.25.13 2 2 0 00-.11.2h-.14v-.11a.46.46 0 00.07-.1v-.08a.16.16 0 010-.06v-.21l-.13-.12a.64.64 0 00-.13-.12s-.08 0-.09.08a.54.54 0 000 .15.54.54 0 01-.06.18.51.51 0 01-.16.21l-.18.11c-.07 0-.1.08-.1.1a.42.42 0 00.09.35 1.72 1.72 0 00.27.27l.29.25a.41.41 0 01.13.29l.07 1.86a.56.56 0 01-.1.18.35.35 0 01-.16.15l-.1 1a.15.15 0 00.06.07s.06.05.06.07a2.19 2.19 0 000 .3c0 .18.05.31.07.39V89h-.25a1.51 1.51 0 00-.3 0 .53.53 0 00-.24.11.3.3 0 00-.11.25.38.38 0 00.12.28l.23.24a2.73 2.73 0 01.23.25.47.47 0 01.11.31.24.24 0 01-.24-.15.28.28 0 00-.28-.15s-.06 0-.11.09l-.17.21-.16.23c-.06.07-.09.11-.09.13l.08.13s.06.08.09.08h.8a.39.39 0 00-.2.16c-.07.1-.1.18-.08.24a1.66 1.66 0 00.28.67 1.2 1.2 0 01.24.68c0 .42-.21.59-.64.52h.14a1 1 0 01.22.26c.06.11.12.22.17.33a1.7 1.7 0 00.18.28.2.2 0 00.21.1.42.42 0 01-.29.21.22.22 0 00-.2.24v.07a1 1 0 00.54.26 3 3 0 00.62.07.3.3 0 00.13 0 .21.21 0 00.1-.06H158.48l.1.05h1.84c0-.13 0-.2.07-.2h.24a1 1 0 01.55.16 1.09 1.09 0 00.56.17.77.77 0 00.23.06l.4.07.42.08h.27l.12.1v.68a1.23 1.23 0 00.15.71.22.22 0 00.12-.13 1 1 0 000-.18.54.54 0 010-.15.09.09 0 01.09-.06c.11 0 .18.07.2.21a1.61 1.61 0 010 .31.61.61 0 01-.16.42.7.7 0 00-.17.52 1 1 0 00.12.39 2.42 2.42 0 00.21.39q0 .12-.09.12a.53.53 0 01-.41-.2 2.23 2.23 0 01-.29-.44l-.25-.42a.33.33 0 00-.13-.31zM153 86.88v-.12h-.1zm1.27-3.15a.17.17 0 000 .1v.11h.05a.13.13 0 00.06-.14.19.19 0 00-.1-.07zm.25 11.27v.26a.14.14 0 00.14.14 1.44 1.44 0 00.07-.25 1.09 1.09 0 000-.25l-.06-.06a.28.28 0 01-.08-.06h-.09a.13.13 0 00-.13.08.34.34 0 00.15.14zm.12-7.37c-.07 0-.1 0-.1.13s0 .13.1.13.12 0 .12-.13-.04-.17-.12-.17zm.45-5.25c-.08 0-.12 0-.11.13s.05.13.13.13 0 0 0-.13.01-.17-.02-.17zM159 96.54l.12.09-.06-.08c-.06-.08-.07-.06-.1-.06zm.73.26a.22.22 0 00.13.2.61.61 0 00.25.06v-.43a.8.8 0 00-.2.05l-.18.07zm1.49-1.09c0 .19.06.29.17.29a.68.68 0 00.32-.18.45.45 0 00.13-.3c0-.09 0-.15-.12-.16a.57.57 0 00-.26 0c-.11 0-.18 0-.2.1a1 1 0 00-.01.25zm1.23.24v.12c0-.01.05 0 .05-.06s.01-.01-.02-.01zm0 1h.24v-.12h-.24zm.31-1a.31.31 0 00.19-.28h-.19z"
            style={{
              WebkitTransformOrigin: 157.994,
              MsTransformOrigin: 157.994,
              transformOrigin: 157.994,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M171.77 98.05a.34.34 0 00-.09.16.66.66 0 000 .13c0-.07 0-.1-.07-.1h-.24a.53.53 0 01-.24 0l-.23-.07-.33-.12h-.31v-.18a.38.38 0 00-.1-.17.5.5 0 00-.22-.1h-.22v-.22l-.38.26-.07-.06a.5.5 0 01-.1-.13v-.19c0-.1 0-.14-.08-.16s-.12.07-.12.12v.14a.21.21 0 010 .13s-.11.06-.23.06a.83.83 0 01-.55-.12.38.38 0 01-.12-.28v-.32a.19.19 0 00-.16-.2 1 1 0 00-.26 0 2 2 0 00-.3 0l.11-.22a.77.77 0 01-.4-.14 1.28 1.28 0 01-.28-.29c-.08-.12-.15-.25-.23-.38a4.13 4.13 0 00-.2-.37L166 95l-.15-.22a1.8 1.8 0 01-.37-.63c0-.18-.12-.39-.19-.64h-.05l-.06-.37v-.52a1 1 0 010-.31.88.88 0 00.05-.33v-.12a.14.14 0 00-.05-.09.22.22 0 010-.1v-.42a2.74 2.74 0 010-.35c0-.16 0-.33.07-.52a1.86 1.86 0 01.14-.47c.07-.13.15-.2.24-.2a.39.39 0 010 .2.39.39 0 000 .18h.28a.24.24 0 00.26-.09l.07-.19a1.47 1.47 0 000-.17h.07v.22h.31a.82.82 0 00.2 0 .38.38 0 00.18-.06v-.11a1 1 0 00-.12-.49 1.07 1.07 0 01-.12-.51.71.71 0 01.26 0 .75.75 0 00.26 0c.1 0 .15 0 .17-.1a.15.15 0 00-.15-.11.5.5 0 01-.21-.05.51.51 0 01.1-.25.73.73 0 00.11-.25h.58c.17 0 .25.08.25.17a.21.21 0 01-.13-.1.22.22 0 000 .1v.07a2.69 2.69 0 00.44 0 .55.55 0 00.38-.21.66.66 0 00.09-.27c0-.15.07-.23.15-.23 0 .16.08.24.26.24h.18a.22.22 0 00.15-.08.38.38 0 000-.15v-.09h-.33a.07.07 0 00.07-.06.27.27 0 000-.08.8.8 0 000-.16c0-.07 0-.1-.07-.1h.1a.4.4 0 01.13.07l.15.09a.77.77 0 00.24.06c.12 0 .2.07.23.13a2.53 2.53 0 01.07.38.61.61 0 00.19.35h.1v-.19l.1.1c.06.06.09.08.11.08h.32a.68.68 0 00.22-.06q0-.12-.15-.15a.43.43 0 01-.2-.08.38.38 0 01.08-.13c0-.06.07-.09.08-.09a.38.38 0 01.19.1l.19.12q.26 0 .3-.18a.54.54 0 01.22-.3l.14.19a1 1 0 00.14.19l.05.07a.34.34 0 000 .1h.08v-.76l.17-.07a1.41 1.41 0 000 .54 2.72 2.72 0 00.18.55l.14-.08V86.9c.05 0 .07 0 .07.07a.56.56 0 01.08.27 1.73 1.73 0 010 .3h.09l.1-.1a.36.36 0 00.09-.12h.81a.5.5 0 00-.11.2.86.86 0 00-.06.2v.09l.06.08a.41.41 0 00.23.07 1.3 1.3 0 00.24 0 .1.1 0 01-.1.08h-.18l-.2.06a.31.31 0 00-.15.23 1.48 1.48 0 00-.05-.25c0-.11-.06-.19-.07-.22a.5.5 0 000-.14.84.84 0 000-.14c-.05-.08-.08-.11-.11-.09s-.07 0-.15 0a1.09 1.09 0 00.09.5 1 1 0 01.1.47h-.17v.09l.29.29v-.16a.18.18 0 010-.1h.07a.2.2 0 01.21.18.48.48 0 010 .29c.05-.16.11-.25.19-.28a1.11 1.11 0 01.38 0v.45a1.2 1.2 0 00.34 0 .56.56 0 01.3.1h-.19v.07c0 .13.08.21.23.24a2 2 0 00.36 0l-.05.12s-.05.07-.06.07a.19.19 0 01-.1 0H175.02l-.09.06a3 3 0 01.47.57.25.25 0 01-.25.08 1 1 0 00-.27 0 .25.25 0 000 .07 1.32 1.32 0 00.08.14l.08.12a.8.8 0 00.16.15c.08.07.13.11.13.13a.63.63 0 01-.07.21.45.45 0 01-.12.17c0-.08-.08-.12-.19-.12h-.1l-.07.11a.1.1 0 01.1.11v.17a.29.29 0 01-.07.22.51.51 0 01-.18.09h-.51a.13.13 0 00-.08.19c0 .1 0 .16-.08.19s-.09-.15-.13-.16a.42.42 0 00-.18 0c-.17 0-.28 0-.32.12a.34.34 0 01-.2.17l-.19-.1a.51.51 0 01-.14-.09l-.14-.1-.07.1.07.09a.62.62 0 00-.12.27c0 .09 0 .17-.05.25a.63.63 0 01-.08.23.42.42 0 01-.23.17.36.36 0 000-.32.25.25 0 00-.26-.15.21.21 0 00.08.04 1.28 1.28 0 00-.11.2.26.26 0 000-.07.29.29 0 010-.15.13.13 0 000-.06.87.87 0 010-.13.58.58 0 00.05-.13c0-.06 0-.09-.1-.09h-.14a.82.82 0 00-.32.09c-.13.06-.2.14-.2.21a.08.08 0 000 .05.41.41 0 00.15.11.46.46 0 01.14.1 1 1 0 010 .26.63.63 0 000 .29.12.12 0 000 .07l.05.09-.31.19a1 1 0 01-.23.12h-.14a.38.38 0 01.11-.29.32.32 0 00.12-.28c0-.12 0-.19-.08-.19h-.25a.39.39 0 000 .13 1.05 1.05 0 010 .13c0 .06-.06.18-.12.33a1.42 1.42 0 00-.07.22h-.05a1.52 1.52 0 000-.24c0-.11-.09-.15-.2-.12a2 2 0 00-.37.06 2 2 0 00-.39.11h-.31a.59.59 0 00-.23-.45h-.1V94c-.11 0-.17-.06-.2-.18s-.09-.19-.2-.19 0 .12 0 .22a1.31 1.31 0 000 .23.74.74 0 00.07.18.45.45 0 00.12.17h.14a.79.79 0 00.22 0l.62.13a5.5 5.5 0 01.58.16 3.27 3.27 0 00.56.13 1.73 1.73 0 01.55.15l.22.08c.09 0 .14.07.14.09a.33.33 0 010 .14.62.62 0 00.05.14h.17a.68.68 0 00.21 0h.09a.62.62 0 00.25 0 .62.62 0 01.25 0 1.53 1.53 0 01.45.06 1.53 1.53 0 00.47.06c0 .12 0 .2.1.22a.46.46 0 00.21 0c.12 0 .2 0 .22-.06a.18.18 0 01.16-.06.14.14 0 01.12 0 .3.3 0 010 .1.36.36 0 000 .11.14.14 0 00.12 0c.11 0 .15 0 .13-.16s0-.15.13-.15h.12a.21.21 0 00.12 0h.14a.58.58 0 00.19 0 .19.19 0 01.09.17c0 .08 0 .12.14.12l.47-.45h.83l-.07.09a.3.3 0 00.29.18.43.43 0 01.34.18l-.21.12a2.66 2.66 0 010 .3 1.93 1.93 0 000 .27v.25c0 .06 0 .13-.05.13h-.14v.12h.26v.48h-.05c-.05 0 0 0 0 0l-.19-.12-.19-.09h-.05a.3.3 0 000 .14.09.09 0 00.06 0h.06v.08a.31.31 0 01-.29.29h-.38a1.16 1.16 0 01-.28-.05h-.09v.05a.45.45 0 00-.14 0h-.14v-.33a1.79 1.79 0 00-.83.29v-.43h-.05s0 .06-.06.13a.64.64 0 000 .15h-.45l-.12.17-.07-.1h-.36v-.13c0-.05.07-.1.07-.13H173v-.23.07h-.07-.08a.13.13 0 010-.07h-.1a.35.35 0 00-.16.2 2.58 2.58 0 00-.08.26 1.09 1.09 0 01-.09.21.12.12 0 01-.12.08c-.07 0-.12 0-.14-.07s0-.1 0-.16a.71.71 0 000-.17s-.07-.07-.16-.07zm-6.36-8s-.07 0-.07.08 0 .08.07.08.05 0 .05-.08-.02-.06-.05-.06zm.83.82c-.05 0-.07 0-.07.09s0 .08.07.08 0 0 0-.08.03-.07 0-.07zm.07-.47a.27.27 0 00-.1.21.25.25 0 00.22-.11zm0 1.58s-.05 0 0 0 0 .02 0 .02zm.4-2.22c-.08 0-.13.06-.16.17a.7.7 0 00-.05.21.67.67 0 00.21-.09c.11-.07.17-.11.17-.14v-.05a.46.46 0 00-.1-.07zm.07.36s-.05 0-.05.1 0 .13.05.11a.16.16 0 00.05-.11.14.14 0 00-.05-.08zm.61 2.79a.16.16 0 010 .09.08.08 0 000 .09l.08.07a.47.47 0 00.11.1q.09 0 .09-.18v-.2a.54.54 0 00-.06-.27.54.54 0 01-.06-.27.32.32 0 01.06-.2.2.2 0 01.18-.09h.05s0 .06.08.11.09.08.11.08h.26a.51.51 0 01.2 0c.1 0 .16 0 .17-.06s0-.07 0-.17a.5.5 0 01.05-.18h.15a.68.68 0 01.2 0h.38a.65.65 0 00.39-.17 1.65 1.65 0 01.34-.21 1 1 0 00.11.31c0 .06.12.09.25.09h.2a.23.23 0 00.2-.1l.16-.74.35-.11a1.22 1.22 0 01.34-.08h.05l.15.1.13.09h.09a.07.07 0 00.06 0v-.07l.06-.26a2.75 2.75 0 000-.29h.32l.32-.06a1.38 1.38 0 00.28 0 .65.65 0 01.19 0v-.76c0 .06 0 .09.07.09a1.55 1.55 0 00.24.19.53.53 0 00.14.1l.1-.1a2 2 0 01-.26-.53 1.19 1.19 0 00-.38-.48 4.6 4.6 0 00-.39-.27.88.88 0 00-.41-.18.73.73 0 00-.45.13l-.38.28a3 3 0 01-.41.29 1.19 1.19 0 01-.56.13h-.07a.57.57 0 01-.2-.09l-.18-.1h-.09a.49.49 0 010 .13.57.57 0 01-.06.15l-.19.19-.07.05h-.07l-.1.11-.09.1h-.19a.5.5 0 00-.19 0l-.06.12a1.2 1.2 0 000 .14h-.06l-.07-.1a1.8 1.8 0 00-.83 1.21.14.14 0 00-.23.05l-.14.21a1.06 1.06 0 01-.05.19.76.76 0 00-.05.19h-.16l-.19-.45a.55.55 0 000 .09.74.74 0 000 .12.68.68 0 00.06.31.67.67 0 01.06.3v.07a.22.22 0 01-.14.08.2.2 0 01-.17 0v.64h-.23V93a.6.6 0 00.24 0 .73.73 0 01.17-.07zm-.25.54h.05c.05 0-.05.05-.05.02zm-.08-4.45h.4q0-.24-.15-.24a.33.33 0 00-.14 0zm.29.28s-.07 0-.07.08 0 .08.07.08 0 0 0-.08.03-.12 0-.12zm0-1.35a.33.33 0 00.15.29.51.51 0 00.28.09c0-.17 0-.28-.09-.32a.71.71 0 00-.3-.1zm.22 6.12s-.05 0-.05.1 0 .09.05.09.07 0 .07-.09.01-.15-.03-.15zm.19-1.11c-.05 0-.07 0-.07.11s0 .1.07.1.07 0 .07-.1.01-.15-.03-.15zm0-4.32a.08.08 0 00.09.09.14.14 0 00.11-.13 1 1 0 000-.15.32.32 0 00-.14 0 .14.14 0 00-.07.13zm0 1.49s0 .07.09.07v-.07-.06-.06.12zm.37 6.61c-.06 0-.09 0-.09.1v.09l.25-.08a.19.19 0 00.13-.2.68.68 0 00-.17-.12l-.18-.1-.09.1.07.09a.16.16 0 00.12.08zm-.09.38c-.05 0-.07 0-.07.08s0 .08.07.08.07 0 .07-.08.02-.12-.03-.12zm0-7.82h.09V89h-.09zm.09 3.31h-.06a.05.05 0 00.1-.04zm0 4.67v.12s.12-.11.04-.16zm.08-8.55s-.05 0 0 0h.05s-.01-.01-.01-.04zm-.08 7.44h.17V96h-.17zm.26 1.23h-.06a.09.09 0 00.06 0l.04-.04zm.1-.4c-.05 0-.07 0-.07.11s0 .1.07.1.07 0 .07-.1.02-.15-.03-.15zm0-2.2h.09v-.09h-.09zm.09-6.61s-.07 0-.07.09 0 .1.07.1.07 0 .07-.1.02-.13-.03-.13zm.1.09c-.05 0-.07 0-.07.1s0 .09.07.09.07 0 .07-.09.02-.14-.03-.14zm.09 1.18s-.07 0-.07.1 0 .09.07.09.07 0 .07-.09.02-.14-.03-.14zm0 7.19h.23-.05-.05zm.19-8.46a.23.23 0 000 .14 1.14 1.14 0 01.06.14h.1l.28-.09a.52.52 0 00-.08-.25.46.46 0 00-.2-.17l-.1.14a.35.35 0 00-.02.05zm.45 8.43a.42.42 0 00-.2 0 .17.17 0 00-.08.17h.28zm.19 0v.1a.36.36 0 000 .11l.05.14h.12v-.59c-.07-.08-.13 0-.13.16zm.07-8.39s-.05 0-.05.09 0 .1.05.1.09 0 .09-.1a.08.08 0 00-.05-.17zm0 1s-.05 0-.05.09 0 .08.05.08.09 0 .09-.08a.08.08 0 00-.05-.16zm.19-1.51a.22.22 0 00-.19.14h.19zm-.07 1.42c0-.09 0-.17.07-.24a1.4 1.4 0 000-.23v-.14a.1.1 0 00-.09-.12zm.28 4.49l.07-.07H170zm.26 2.31c-.05 0-.07 0-.07.1s0 .09.07.09.07 0 .07-.09.02-.17-.03-.17zm.1-2.67h-.06s.07.03.1-.07zm0 4.33v-.05s-.06 0-.06.05.07.02.1-.07zm0-9.1l.16.25a.28.28 0 00.24.11h.17c.05 0 .08 0 .09-.1s0 0-.05 0h-.13a.31.31 0 01-.13-.06l-.05-.08c-.05-.08 0-.08 0-.08h-.12v.05l-.14-.16zm.35 7.82h-.16.09c.09 0 .11-.04.11-.07zm.28.1a.24.24 0 00.19-.1h-.19zm.29-4.7h.09v-.1h-.09zm.19.63v-.09h-.1zm-.07-1.32a.79.79 0 000 .2 1.11 1.11 0 00.07.26.9.9 0 00.12.24.22.22 0 00.19.1h.05a1 1 0 000-.24v-.24a.3.3 0 00-.21.1 1.05 1.05 0 00-.12-.21.24.24 0 00-.06-.28zm.4-3.19a1 1 0 000 .15c0 .08 0 .12.11.13a.08.08 0 00.09-.09.11.11 0 00-.07-.12zm0 4.25h.1v-.11h-.1zm.19 4.3a1 1 0 01.35.29.1.1 0 00.08 0v-.2-.21a.49.49 0 00-.25.08zm0 1.59h.12a.21.21 0 00-.12-.19zm.26-1.14a2.46 2.46 0 000 .26c0 .1.08.14.19.14h.07a1.34 1.34 0 00-.07-.27.2.2 0 00-.13-.2zm.07-4.68a2.07 2.07 0 000 .21c0 .1 0 .16.13.17s.12-.07.12-.17v-.21zm.14.76v-.19l-.12.07zm0-2.36a.25.25 0 01.24-.21.7.7 0 01.33 0 .15.15 0 00-.14-.09h-.36c.02.11-.03.15-.03.23zm.73.14l-.13.06a.12.12 0 00-.08.11h.33zm-.16-2.48h.16V88h-.16zm.16 9.64s-.05 0-.05.1 0 .11.05.11.1 0 .1-.11a.09.09 0 00-.06-.17zm.28-5.6l.12-.1h-.19zm0-1.11v.19s.1 0 .1-.1.01-.16-.06-.16zm.12-.36h-.12.06c.06 0 .09-.03.1-.07zm-.12 1.11h.12v-.09h-.12zm.38.26h-.06c-.06 0-.05 0 0 0s0 .05.06.05.08-.08.08-.12zm-.09-.54h.17v-.09zm.09-1.46s-.07 0-.07.08a.07.07 0 00.07.08s.07 0 .07-.08.01-.15.01-.15zm.07.33a.65.65 0 00.12.41 1.29 1.29 0 01.19.37.19.19 0 00.07-.12V91a.8.8 0 000-.16.4.4 0 010-.13c0-.11-.05-.18-.06-.23s-.12-.08-.31-.08zm.31 1.32c-.05 0-.07 0-.07.08s0 .09.07.09 0 0 0-.09.07-.15.04-.15zm.07-2.32v.19c0-.02.05 0 .05-.09a.11.11 0 00-.01-.17zm.1-.35s-.07 0-.07.09 0 .1.07.1.07 0 .07-.1.01-.16-.03-.16zm.37 1.65v-.09h-.28zm.15 5.82c-.18 0-.26.06-.26.19a.39.39 0 00.3-.19zm.01-7.28s-.07 0-.07.11 0 .1.07.1.07 0 .07-.1-.07-.11-.07-.11zm.09.09s-.07 0-.07.1 0 .09.07.09.07 0 .07-.09-.04-.1-.09-.1zm.36 7.54v.07h.05a.25.25 0 00.16-.07l.13-.12-.1-.09h-.09a.34.34 0 01-.1 0c-.05 0-.08 0-.09.05v.07zm.19.83v-.07h-.1zm.09-1.25c-.05 0-.07 0-.07.08s0 .08.07.08.07 0 .07-.08-.04-.08-.09-.08zm.28.07a.08.08 0 00-.09.09c0 .06 0 .1.09.1s0 0 0-.1-.01-.09-.01-.09zm.64 1.3c-.11 0-.17 0-.19.09h.26z"
            style={{
              WebkitTransformOrigin: 171.339,
              MsTransformOrigin: 171.339,
              transformOrigin: 171.339,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M181.33 98a.14.14 0 010-.06.35.35 0 010-.06.29.29 0 010-.11.21.21 0 000-.1h-.05l-.29.31-.3.33h-.09l-.12-.12h-.1l-.11.12h-.05a1.34 1.34 0 01-.26 0c-.05 0-.07 0-.07-.06a.3.3 0 010-.11.36.36 0 000-.19.55.55 0 00-.31 0v.09a.17.17 0 010 .1h-.2a.53.53 0 01-.29-.12.33.33 0 01-.16-.26.74.74 0 00.41-.18c.17-.12.25-.23.25-.34a1 1 0 00-.13-.46.64.64 0 01-.08-.44l.09-.06a.26.26 0 00.12-.06.38.38 0 00.08-.19 1.4 1.4 0 00.06-.28 1.63 1.63 0 01.07-.26.16.16 0 01.15-.12h.11l.11.05a1 1 0 00.38-.21A1.48 1.48 0 01181 95a.46.46 0 01.16.06.49.49 0 00.17.06h.35v.59h.38a.22.22 0 01.17.07 1 1 0 01.11.17 1.62 1.62 0 00.1.18.19.19 0 00.14.1v-.73a1.21 1.21 0 01.34.09.65.65 0 01.25.22h.48l.27-.2.25-.2h.34l.51-.07.49-.06a2.36 2.36 0 00.33 0l.45-.1a.31.31 0 00.29-.32 1.12 1.12 0 00-.15-.52 1.86 1.86 0 00-.36-.52 2.05 2.05 0 00-.5-.39 1.08 1.08 0 00-.5-.16h-.48a.56.56 0 00-.42.19.47.47 0 000 .42.9.9 0 01-.17-.2.45.45 0 01-.05-.22c0-.1 0-.16.06-.19s.06-.11.06-.24a.71.71 0 00-.33-.61V93l-.09.09h-.05a.25.25 0 01-.25-.2c0-.14-.07-.28-.1-.44s-.07-.3-.12-.44a.27.27 0 00-.26-.2c-.13 0-.19.06-.19.18a.34.34 0 01-.07.25h-.16a.24.24 0 00-.17 0l-.1.09-.15.14-.25.22-.26.2a.56.56 0 01-.14.08h-.05l-.12-.09-.09-.12q.13-.07.12-.09v-.1l-.1.06-.11.06a.29.29 0 00-.07-.25l-.23-.17a2.27 2.27 0 01-.26-.27 1.38 1.38 0 01-.17-.58 1.85 1.85 0 000-.26v-.84-.27a6.64 6.64 0 01.3-.81 1.6 1.6 0 01.53-.66c.06 0 .1-.08.11-.12a.2.2 0 000-.11.55.55 0 000-.17.74.74 0 010-.21v-.06a.34.34 0 01.06-.06l.11-.05h.1a1.2 1.2 0 00.23-.21l.16-.17a1.19 1.19 0 01.18-.15 1 1 0 01.28-.1h.38a.51.51 0 00.14-.09l.09.17a.22.22 0 00.13.14 1.6 1.6 0 010-.26.33.33 0 01.17-.26.23.23 0 000 .09.66.66 0 01.06.12h.12l.19-.22a1 1 0 01.21-.2H184.02a.21.21 0 00-.11.21 1 1 0 00.37-.23.47.47 0 00.15-.4h.57l.06.11a.29.29 0 00.06.1h.05a.37.37 0 00.06-.15.58.58 0 01.06-.16h.05c.08 0 .15.1.23.29a.8.8 0 00.24.35l.09-.12a.36.36 0 01.12-.09h.05c.11.12.19.18.25.17a.61.61 0 01.27.13 3.41 3.41 0 01.47.51 3.93 3.93 0 01.41.69 4.34 4.34 0 01.29.72 2.22 2.22 0 01.1.64v.39a2.91 2.91 0 000 .31 2.51 2.51 0 010 .31 1.26 1.26 0 000 .21c-.11.23-.25.34-.42.34s-.14 0-.14-.09a1.19 1.19 0 000-.25 3.23 3.23 0 01-.12-.47c-.05-.23-.08-.39-.09-.47s-.17-.12-.4-.18a.9.9 0 01-.55-.34l-.12-.12h-.4a1.31 1.31 0 00-.41.06 1.23 1.23 0 01-.39.06 1.16 1.16 0 00-.26-.07h-.35l-.12.07-.06.05a.07.07 0 01-.06 0h-.31l-.21-.05h-.09a1.28 1.28 0 00-.94.39 1.2 1.2 0 00-.39.86h.26l.64.64a.28.28 0 01.05-.12.45.45 0 000-.09 3.45 3.45 0 01.58.06 6.36 6.36 0 01.7.16 3.83 3.83 0 01.65.26 1.34 1.34 0 01.46.37l.25.07.38.21.37.13.25.08a1.34 1.34 0 01.25.11 2.31 2.31 0 01.35.18 2.05 2.05 0 01.32.24.38.38 0 01.15.27.24.24 0 01-.12.23q-.12.06-.12.27v.25a.33.33 0 00.12.24l.15-.16a.55.55 0 01.15-.14h.05s.14.08.15.23 0 .25 0 .32 0 .17-.07.2-.07.07-.07.15a.13.13 0 00.07.13.13.13 0 01.07.13 2.37 2.37 0 01-.09.3c-.07.18-.14.37-.23.59s-.17.41-.26.6-.14.29-.18.31a.14.14 0 01-.11 0 .3.3 0 01-.1-.09 6 6 0 01-.34.59 2 2 0 01-.48.55.35.35 0 01-.17-.26v-.26H186a1.92 1.92 0 00-.23.19.29.29 0 00-.07.23c0 .08 0 .13.06.14a.12.12 0 01.06.12.15.15 0 010 .06.17.17 0 00-.06.06l-.21-.17-.22-.16h-.12a2.53 2.53 0 010 .28c0 .08-.08.13-.22.13a.4.4 0 01-.18 0 .17.17 0 01-.08-.09.54.54 0 010-.15.29.29 0 00-.08-.17c-.11 0-.15.11-.13.2a.2.2 0 01-.08.22l-.16.11-.15.1-.12.12h-1.13c-.07-.2-.11-.35-.14-.45a1.35 1.35 0 01-.05-.47.17.17 0 00-.12.05l-.09.09a.3.3 0 01-.11.06.17.17 0 01-.13 0 1.59 1.59 0 01-.13.53 1.29 1.29 0 01-.39.32 1 1 0 01-.12-.22l-.09-.21zm-1.44-1.07V97s.11-.06 0-.11zm.52 0V97s.08-.06 0-.11zm0 .55l.22-.22h-.22zm.52-8.51s-.07 0-.07.1 0 .09.07.09.07 0 .07-.09 0-.14-.07-.14zm.64.4v-.09h-.12zm0-1.46a.45.45 0 000 .16.81.81 0 000 .15c.08 0 .12-.08.12-.19s0-.2-.12-.22 0 0 0 .06zm.4.64a.77.77 0 00.1.28 1 1 0 00.1.21.24.24 0 00.13.12h.05l.26-.18a.3.3 0 00.07-.22v-.17h-.26a.12.12 0 01-.12 0 .59.59 0 01-.09-.22.49.49 0 010-.21.36.36 0 00-.15.2.77.77 0 00-.06.15zm.21 2.19s-.07 0-.07.11 0 .11.07.11.1 0 .1-.11-.03-.15-.1-.15zm.12-2.93c-.06 0-.09 0-.09.11s0 .11.09.11.07 0 .07-.11-.02-.15-.07-.15zm.62 8.72v.06a.07.07 0 000-.06s.08-.04 0-.04zm.09-8a1.12 1.12 0 00.06.35.26.26 0 00.27.17v-.85a.39.39 0 00-.33.33zm.33 7.26s-.07 0-.07.1 0 .11.07.11a.1.1 0 00.1-.11.09.09 0 00-.1-.15zm0 1.89s-.07 0-.07.1 0 .11.07.11a.1.1 0 00.1-.11.09.09 0 00-.1-.15zm.43-.83h.09v-.31h-.09zm.78-9.9a.18.18 0 00.13.19.74.74 0 00.25 0 .16.16 0 00-.15-.17zm.26 5.6v-.21l-.1.09zm.54-4.73a.22.22 0 000 .1l.06.12.11-.12v-.1a.41.41 0 00-.06-.11l-.05-.1c-.07 0-.1 0-.1.1v.11zm.21 4.52c-.06 0-.09 0-.09.1s0 .11.09.11.07 0 .07-.11-.02-.15-.07-.15zm1.14-5.15V87.29c0-.11.03-.14 0-.15zm1.15 7.13v.07s.05 0 .05-.06-.01-.04-.05-.06z"
            style={{
              WebkitTransformOrigin: 183.502,
              MsTransformOrigin: 183.502,
              transformOrigin: 183.502,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M192.13 98a.13.13 0 010-.06.18.18 0 000-.06.41.41 0 010-.11.42.42 0 00.05-.1h-.05l-.3.31-.29.33h-.1l-.12-.12h-.09l-.12.12h-.37c-.05 0-.07 0-.07-.06a.21.21 0 010-.11.5.5 0 000-.19.54.54 0 00-.3 0 .07.07 0 000 .09.12.12 0 010 .1h-.2A.5.5 0 01190 98a.34.34 0 01-.17-.26.8.8 0 00.42-.18c.16-.12.25-.23.25-.34a1.2 1.2 0 00-.13-.46.65.65 0 01-.09-.44l.1-.06a.33.33 0 00.12-.06.5.5 0 00.08-.19l.06-.28a1 1 0 01.07-.26c0-.08.08-.12.14-.12a.27.27 0 01.1 0l.11.05a.94.94 0 00.39-.21 1.46 1.46 0 01.34-.22.49.49 0 01.17.06.46.46 0 00.16.06h.36v.59h.38a.25.25 0 01.18.07c0 .05.07.11.11.17l.09.18a.21.21 0 00.14.1v-.73a1.13 1.13 0 01.34.09.54.54 0 01.25.22h.47l.27-.2.25-.2h.35l.5-.07.5-.06a2.36 2.36 0 00.33 0l.45-.1a.31.31 0 00.28-.32 1.1 1.1 0 00-.14-.52 1.9 1.9 0 00-.37-.52 2 2 0 00-.49-.39 1.08 1.08 0 00-.51-.16h-.47a.6.6 0 00-.43.19v.42a.81.81 0 01-.16-.2.36.36 0 010-.22c0-.1 0-.16.06-.19s.06-.11.06-.24a.71.71 0 00-.33-.61V93l-.1.09a.25.25 0 01-.25-.2c0-.14-.08-.28-.11-.44a2.83 2.83 0 00-.12-.44.26.26 0 00-.26-.2.17.17 0 00-.19.18.34.34 0 01-.07.25h-.15a.26.26 0 00-.18 0l-.09.09a1.4 1.4 0 01-.16.14l-.24.22-.26.2-.14.08h-.05l-.12-.09a.36.36 0 01-.09-.12c.09 0 .13-.08.11-.09s0 0 0-.1a.29.29 0 01-.1.06l-.12.06a.26.26 0 00-.07-.25l-.22-.17a1.34 1.34 0 01-.26-.27 1.24 1.24 0 01-.18-.58v-.26-.42-.42-.27a6.64 6.64 0 01.3-.81 1.78 1.78 0 01.53-.66.45.45 0 00.12-.12.2.2 0 000-.11.52.52 0 000-.17.37.37 0 010-.21.07.07 0 010-.06l.06-.06.1-.05h.11a1.12 1.12 0 00.22-.21l.17-.17a.8.8 0 01.17-.15 1.07 1.07 0 01.29-.1h.38l.14-.09a.89.89 0 01.08.17.25.25 0 00.13.14 2.41 2.41 0 010-.26c0-.14.08-.23.16-.26a.16.16 0 000 .09.67.67 0 00.06.12h.12a1.16 1.16 0 01.18-.22 1 1 0 01.22-.2H194.88a.2.2 0 00-.12.21 1 1 0 00.36-.23.48.48 0 00.16-.4h.51l.06.11.06.1h.05l.06-.15a.75.75 0 010-.16h.05c.08 0 .16.1.24.29a.9.9 0 00.23.35l.1-.12a.36.36 0 01.12-.09h.05c.11.12.19.18.25.17a.56.56 0 01.27.13 2.61 2.61 0 01.47.51 4 4 0 01.42.69 4.28 4.28 0 01.28.72 2.26 2.26 0 01.11.64v.18a1.42 1.42 0 010 .21v.31a2.36 2.36 0 010 .31v.21c-.11.23-.25.34-.43.34s-.14 0-.14-.09a1 1 0 000-.25 1.75 1.75 0 01-.12-.47c0-.23-.08-.39-.1-.47s-.16-.12-.4-.18a.88.88 0 01-.54-.34l-.12-.12h-.4a1.33 1.33 0 00-.42.06 1.14 1.14 0 01-.39.06 1.16 1.16 0 00-.26-.07h-.26a.29.29 0 00-.1 0l-.11.07-.06.05h-.37l-.21-.05H194a1.27 1.27 0 00-.93.39 1.2 1.2 0 00-.39.86h.32l.64.64a.24.24 0 010-.12.2.2 0 00.05-.09 3.45 3.45 0 01.58.06 6.36 6.36 0 01.7.16 3.72 3.72 0 01.64.26 1.25 1.25 0 01.46.37l.25.07.38.12.38.13.25.08a1.34 1.34 0 01.25.11l.35.18a2.67 2.67 0 01.32.24.4.4 0 01.14.27.24.24 0 01-.12.23q-.12.06-.12.27v.25a.33.33 0 00.12.24s.09-.08.16-.16a.55.55 0 01.15-.14c.09 0 .15.08.15.23v.32c0 .07 0 .17-.08.2a.16.16 0 00-.07.15.14.14 0 00.07.13.13.13 0 01.08.13s0 .12-.1.3-.14.37-.22.59l-.26.6a1.11 1.11 0 01-.18.31.17.17 0 01-.12 0 .19.19 0 01-.09-.09c-.08.16-.2.36-.34.59a2.24 2.24 0 01-.49.55.34.34 0 01-.16-.26 1.23 1.23 0 01-.05-.26h-.12a2.22 2.22 0 00-.24.19.33.33 0 00-.07.23c0 .08 0 .13.06.14a.12.12 0 01.06.12v.06l-.06.06-.21-.17-.21-.16h-.12a2.53 2.53 0 010 .28c0 .08-.09.13-.23.13a.32.32 0 01-.17 0 .26.26 0 01-.09-.09v-.15a.51.51 0 00-.08-.17c-.12 0-.16.11-.13.2a.21.21 0 01-.09.22 1.13 1.13 0 01-.15.11.85.85 0 00-.15.1l-.12.12h-1.14l-.14-.45a1.65 1.65 0 010-.47.16.16 0 00-.11.05l-.1.09a.27.27 0 01-.1.06.16.16 0 01-.13 0 1.89 1.89 0 01-.13.53 1.63 1.63 0 01-.39.32.68.68 0 01-.12-.22 2.28 2.28 0 00-.1-.21zm-1.44-1.07h-.05s0 .07.05.07.08-.06 0-.11zm.52 0h-.05s0 .07.05.07.08-.06 0-.11zm0 .55l.21-.22h-.21zm.52-8.51s-.07 0-.07.1 0 .09.07.09.07 0 .07-.09-.02-.14-.07-.14zm.64.4v-.09h-.12zm0-1.46a.69.69 0 000 .16.62.62 0 00.06.15c.08 0 .12-.08.12-.19s0-.2-.12-.22-.06 0-.06.06zm.4.64a.62.62 0 00.09.28 1 1 0 00.14.17c0 .07.08.11.13.12h.05a2.52 2.52 0 00.26-.18.26.26 0 00.07-.22v-.17h-.26a.12.12 0 01-.12 0 .77.77 0 01-.1-.22v-.21a.36.36 0 00-.15.2.77.77 0 00-.11.19zm.23 2.15s-.07 0-.07.11 0 .11.07.11.09 0 .09-.11-.09-.11-.09-.11zm.12-2.93a.11.11 0 000 .22s.07 0 .07-.11-.05-.11-.09-.11zm.61 8.72h-.05s0 .06.05.06 0 0 0-.06.01 0-.02 0zm.1-8a1.12 1.12 0 00.06.35.26.26 0 00.27.17v-.85a.33.33 0 00-.23.11.3.3 0 00-.12.21zm.33 7.26s-.07 0-.07.1 0 .11.07.11.09 0 .09-.11-.05-.11-.11-.11zm0 1.89s-.07 0-.07.1 0 .11.07.11.09 0 .09-.11-.05-.11-.11-.11zm.42-.83h.1v-.31h-.1zm.78-9.9a.19.19 0 00.13.19.79.79 0 00.25 0 .16.16 0 00-.14-.17zm.26 5.6v-.21l-.09.09zm.54-4.73a.49.49 0 000 .1.67.67 0 00.06.12l.12-.12v-.1l-.06-.11a.64.64 0 00-.06-.1.09.09 0 00-.1.1v.11zm.22 4.52a.09.09 0 00-.1.1.1.1 0 00.1.11s.07 0 .07-.11-.05-.11-.09-.11zm1.13-5.15V87.36a.12.12 0 000-.11.1.1 0 00-.02-.11zm1.16 7.13h-.05s0 .07.05.07 0 0 0-.06.01 0-.02-.02z"
            style={{
              WebkitTransformOrigin: 194.28,
              MsTransformOrigin: 194.28,
              transformOrigin: 194.28,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M206.23 97.46h-.35v.08c0 .08-.05 0-.07 0h-.52l-.09.22a.46.46 0 00-.37-.48 2.73 2.73 0 00-.65-.09H204a.31.31 0 00-.17.11v-.71h-.05v-.07a.46.46 0 01-.16-.06l-.26-.13-.26-.14a.55.55 0 01-.14-.1.23.23 0 01-.17-.24.32.32 0 00-.17-.28c-.07 0-.11.06-.11.12a.86.86 0 000 .22.5.5 0 010 .21c0 .06-.05.09-.13.09a1.27 1.27 0 01-.31-.07c-.15 0-.23-.11-.23-.19a.19.19 0 01.14-.12 1.16 1.16 0 00-.15-.13.33.33 0 00-.18-.09.18.18 0 00-.18.08.58.58 0 00-.05.14.39.39 0 010 .14.1.1 0 01-.1.07.53.53 0 01-.2 0 .26.26 0 01-.15-.16.14.14 0 00.12-.14v-.24a.74.74 0 00-.19-.52l-.38-.43v-.07a.34.34 0 00.35-.22 2.78 2.78 0 00.14-.44v-1.25a.82.82 0 01.11-.42.83.83 0 00.1-.41.54.54 0 00-.09-.16.47.47 0 01-.1-.15 3 3 0 00.19-.48 1.35 1.35 0 01.24-.48v-.05c0-.05 0 0 0 0a1 1 0 00.43-.45 4.86 4.86 0 00.23-.59c0 .06.05.1.1.11h.21l-.26-.5 1.11-.28a.56.56 0 01.16-.48.77.77 0 01.36-.18l.45-.1a.62.62 0 00.4-.26h.92v-.33h-.11a.29.29 0 01-.1 0l-.09-.07.09-.1h1l.12-.21a1.92 1.92 0 000 .59 3 3 0 00.12.45c0 .14.09.28.13.41a1.77 1.77 0 01.06.49v.16l-.74.64a.11.11 0 01-.12-.12c0-.08-.07-.12-.19-.12s-.29.05-.31.15 0 .24 0 .39a.36.36 0 00-.38.22l-.11.2a.63.63 0 01-.2.2l-.28.07a1.4 1.4 0 00-.14.22L204 91a.25.25 0 01-.19.16h-.22l-.18.06s-.07.08-.07.18a.71.71 0 00.06.28.84.84 0 01.06.33.81.81 0 01-.11.5 4.38 4.38 0 01-.32.33V93a1.73 1.73 0 00.06.54.57.57 0 00.16.25.8.8 0 00.21.15.63.63 0 01.21.24 2.85 2.85 0 01.14.5c.05.2.15.32.29.35l.76.26c.26.1.53.18.8.26a5.65 5.65 0 001.3.19h1.32a2.35 2.35 0 00.5 0 .86.86 0 00.3-.16 1 1 0 00.21-.27c.07-.11.14-.24.22-.38.11.18.17.25.19.24s.08 0 .21 0 0-.18 0-.31.05-.27.08-.41a1 1 0 01.19-.34.47.47 0 01.35-.14c0 .13 0 .2.09.22a.46.46 0 00.21 0 1.55 1.55 0 010-.39.82.82 0 00-.07-.34.51.51 0 01.38.12.68.68 0 01.18.26c0 .09.07.18.11.26a.16.16 0 00.16.11h.05l.08-.43a2.15 2.15 0 000-.4.36.36 0 00-.07-.22 1.06 1.06 0 00-.15-.15l-.14-.16a.27.27 0 01-.07-.2.83.83 0 01.12-.31.8.8 0 00.12-.4.6.6 0 00-.12-.4 4.15 4.15 0 01-.33-.47c-.05 0-.12 0-.2-.06s-.18-.16-.29-.26-.2-.21-.32-.31a.84.84 0 00-.33-.2l-.43-.06c-.22 0-.44-.06-.68-.1a4.19 4.19 0 01-.62-.18q-.27-.1-.27-.27v-.93s0-.07-.1-.12l-.14-.12-.05.05a.24.24 0 01-.05.12v.14c0 .03 0 .07.1.15a.33.33 0 01.09.16.4.4 0 01-.07.14l-.12.19-.09.1a.54.54 0 000-.18.18.18 0 00-.15-.13.63.63 0 010 .2.48.48 0 01-.12.2c-.1 0-.17-.17-.24-.37a3.77 3.77 0 01-.13-.62v-.63-.34c.26 0 .41 0 .46-.09a3.51 3.51 0 00.28-.45.16.16 0 01.09.16.73.73 0 01-.06.3.6.6 0 00-.06.27.27.27 0 000 .16s.08.09.18.12a.45.45 0 00.22-.25.8.8 0 01.18-.27l.1.18a.19.19 0 010 .12v.12a.81.81 0 000 .17h.66a1.45 1.45 0 000-.35c0-.13-.12-.19-.29-.19a.5.5 0 00.16 0h.36a1.77 1.77 0 01.11.26c.07.15.15.23.26.23s.13 0 .16-.14a.61.61 0 01.08-.21h.07a.38.38 0 01.31.16.94.94 0 01.16.29l.31-.3a.57.57 0 01.26.34.36.36 0 00.26.27l.46.18a3.86 3.86 0 01.59.27 3 3 0 01.52.36.63.63 0 01.23.47v1.7h.07l.66-.62a1.17 1.17 0 01-.27-.34.8.8 0 01-.16-.37V90l.06-.1s0-.08.06-.11h.05s.09 0 .13.1.08.16.12.25.06.19.08.27 0 .14 0 .16a.14.14 0 00.15-.12 2 2 0 000-.23h.31a6.93 6.93 0 00.2.79 2.37 2.37 0 01.1.74v.41a1 1 0 01-.08.28 2.05 2.05 0 01-.16.26l-.26.35a.28.28 0 00.2.14.15.15 0 01.13.17.14.14 0 01-.14.16l-.32.06a.88.88 0 00-.32.16.53.53 0 00-.14.42.12.12 0 00.06.12.32.32 0 00.14 0h.15a.12.12 0 01.05.12l-.34.1a.68.68 0 01-.19 0h-.49v.73c0 .06 0 .05-.06.11a.29.29 0 00-.06.1.41.41 0 00-.05.16.84.84 0 010 .18.74.74 0 00-.09-.31.46.46 0 00-.21-.24h-.18a.33.33 0 000 .17.35.35 0 00.12.28.31.31 0 01.12.24.33.33 0 01-.1.26.65.65 0 01-.21.16l-.22.13a.3.3 0 00-.13.21l-.21-.42v.66a.16.16 0 00-.1 0l-.12.05h-.16v-.64H211a.64.64 0 01-.07.24 2.94 2.94 0 01-.18.35 1.72 1.72 0 01-.22.33.31.31 0 01-.24.14.22.22 0 01-.22-.12 1.27 1.27 0 01-.11-.3.51.51 0 00-.31.07.81.81 0 00-.16.16l-.15.2a.88.88 0 01-.18.21c-.08 0-.12-.06-.14-.17s0-.23-.06-.35a1.09 1.09 0 00-.12-.36.31.31 0 00-.32-.16 1.58 1.58 0 000 .26v.36a1.67 1.67 0 010 .39.6.6 0 01-.12.33.08.08 0 01-.09-.09 1.05 1.05 0 010-.18c0-.09.05-.14.06-.18v.14c0-.09-.07-.22-.11-.39s-.09-.25-.12-.25h-.07a2 2 0 00-.28.25q-.24.26-.39.39a.89.89 0 01-.14.26c-.09.18-.15.26-.19.26s-.15 0-.17-.1a1.55 1.55 0 01-.07-.23.54.54 0 00-.16-.22.7.7 0 00-.44-.11zm-5-6.57s-.05 0-.05.06 0 0 .05 0a.07.07 0 00-.05-.06zm.73-.19h.04a3.12 3.12 0 00.31-.49 1.1 1.1 0 00.14-.55s-.08 0-.16.12L202 90l-.34.38c.04.23.11.32.25.32zm1.87 5.53h.09l-.09-.12zm.75-8.17h.07v-.43h-.07zm.43 0h.19a.33.33 0 000-.14.11.11 0 00-.11-.07zm.49 8.9l.1-.09-.1-.09zm1-.4a.25.25 0 00-.27.19 2.43 2.43 0 000 .38v.12c.15 0 .24-.09.27-.26a3.88 3.88 0 00-.01-.43zm.55-8.41l.07-.09H207zm.07.24a.2.2 0 000 .09l.1.12v-.31h-.14zm.21.64h.17a.58.58 0 000-.19.25.25 0 00-.13-.14zm0 7.93a.09.09 0 00.05.08.07.07 0 010 .07h.1a.63.63 0 00.5-.25.89.89 0 00.18-.53 1.37 1.37 0 00-.56.13.47.47 0 00-.31.48zm1.89.41c-.05 0-.07 0-.07.11s0 .12.07.12.09 0 .09-.12-.04-.11-.1-.11zm2.62-6.05s-.07 0-.07.11 0 .1.07.1.1 0 .1-.1-.04-.11-.11-.11zm.12.21c-.06 0-.09 0-.09.11s0 .1.09.1.07 0 .07-.1-.03-.11-.03-.11zm.09.21a.48.48 0 000 .15.76.76 0 01-.05.16v.17c.08 0 .14 0 .17-.16a.66.66 0 00.06-.22c-.07-.06-.11-.1-.23-.1zm-.09.83l.09-.09H212zm.09-1.75h.12v-.12H212zm.12 4.28h.33c0-.08-.07-.12-.11-.13H212.22zm.22-5.46c-.07 0-.1 0-.1.1s0 .09.1.09a.08.08 0 00.09-.09c-.01-.07-.04-.1-.1-.1zm0 .31c-.07 0-.1 0-.1.1s0 .11.1.11.09 0 .09-.11-.04-.05-.1-.05zm.11 1.27h.07v-.09h-.07zm.07 3.88v.16s.1 0 .1-.08-.04-.08-.11-.08zm.12-3.57c-.06 0-.09 0-.09.11s0 .1.09.1.07 0 .07-.1-.03-.11-.08-.11zm.07 1.3a.43.43 0 000 .07h.08v-.12H212.72zm1-1.2h.12v-.1h-.12z"
            style={{
              WebkitTransformOrigin: 207.505,
              MsTransformOrigin: 207.505,
              transformOrigin: 207.505,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M231.18 97.6l-.29.11a1.58 1.58 0 00-.3.13.27.27 0 00-.15.22c0 .12-.08.18-.16.18 0-.33 0-.53-.13-.61a.4.4 0 00-.33-.11l-.42.06a.55.55 0 01-.44-.1c-.09-.06-.15-.13-.15-.2a1.36 1.36 0 010-.2.33.33 0 000-.15s-.11-.06-.25-.06a.29.29 0 00-.29.2.35.35 0 01-.37.2.41.41 0 01.1-.27.35.35 0 00.14-.3c0-.1 0-.16-.08-.18a.6.6 0 00-.2 0h-.24a.24.24 0 01-.18 0s-.1-.07-.18-.18-.15-.15-.18-.15a.32.32 0 00-.28.13.32.32 0 01-.26.13l-.11-.14a3.58 3.58 0 00-.18-.32c-.06-.12-.11-.24-.16-.35a.67.67 0 01-.07-.21v-.07l.08-.09c.08-.09-.1-.27-.1-.27a1.25 1.25 0 00-.18-.19c-.1-.1-.15-.15-.15-.17a.38.38 0 01-.09-.17 1 1 0 00-.06-.2l-.33-2.82a2 2 0 00-.1-.28 2.86 2.86 0 00-.16-.31h-.22l-.22.07a.34.34 0 00-.08.2c0 .11 0 .16-.07.16h-.13a.45.45 0 00-.15-.07 2 2 0 00.05.24v.23a.34.34 0 01-.06.06.07.07 0 01-.06 0h-.94a1.31 1.31 0 01-.18.2l-.18.18h-.09a.28.28 0 00-.12 0 1.65 1.65 0 010 .29s0 .13.12.26a.89.89 0 00-.31.11.43.43 0 00-.15.18.88.88 0 00-.11.24 2.45 2.45 0 01-.14.29l-.11-.07h-.11c0 .17 0 .27.06.29a.2.2 0 00.14 0 .2.2 0 01.14.06.62.62 0 01.06.36.59.59 0 00-.36.1.74.74 0 00-.2.25c0 .1-.11.21-.16.33a1.21 1.21 0 01-.25.32.3.3 0 01-.2.07h-.47a.14.14 0 00-.13.13 2.52 2.52 0 00-.06.59.94.94 0 01-.18.59 1.46 1.46 0 00-.54.08.85.85 0 00-.32.23 1.87 1.87 0 00-.25.34 2.6 2.6 0 01-.31.41.62.62 0 01-.12-.26 2 2 0 00-.05-.26.33.33 0 00-.13-.17.62.62 0 00-.38 0l-.14.11a.41.41 0 00-.12.13.17.17 0 00.06.06l.08.06h.12l.09-.07.12-.05.07.05c.07.05 0 0 0 .07v.05l-.12.1-.12.13a1.59 1.59 0 00-.12.35q-.06.27-.09.36c-.13-.06-.25-.26-.38-.59a10.07 10.07 0 01-.34-1.12c-.1-.42-.19-.82-.25-1.19a6 6 0 01-.09-.81v-.16l.1.06h.23a.49.49 0 00.13-.11.94.94 0 01.13-.14 3 3 0 01-.36-.19 2.17 2.17 0 01-.37-.21 5.84 5.84 0 01-.09-.63v-.55a3.24 3.24 0 01.06-.64 3.39 3.39 0 00.06-.64 4.32 4.32 0 00-.06-.73 4.59 4.59 0 01-.06-.76v-.05l.1-.11c.1-.11.1-.11.14-.12v-.05a6.55 6.55 0 01-.19-.45 3.76 3.76 0 01-.13-.4 1.49 1.49 0 01-.06-.4.45.45 0 01.07-.27.43.43 0 00.07-.25.71.71 0 00-.06-.19.88.88 0 01-.06-.16.1.1 0 01.09-.11h.18a.46.46 0 00.23-.1.6.6 0 00.19-.36v-.22a1.33 1.33 0 01-.05-.21h-.27q-.15 0-.15.15l.26.26v.11l-.18.06a.65.65 0 01-.18 0v-.85a.44.44 0 00.41-.21.89.89 0 00.13-.48 1.09 1.09 0 01.25.07 2.69 2.69 0 01.38.19 3.41 3.41 0 01.37.25.7.7 0 01.21.23.59.59 0 00-.27.18.36.36 0 01-.25.15h-.28v.24h.17a2 2 0 01.33 0 1.25 1.25 0 01.31.1c.09.05.13.11.13.17a.65.65 0 01-.19.48.73.73 0 00-.2.52.24.24 0 00.12.21l.25.14a1.44 1.44 0 01.25.18.4.4 0 01.11.29 1.44 1.44 0 010 .18 1.36 1.36 0 000 .15.55.55 0 01-.06.19.85.85 0 00-.06.17.32.32 0 00.2.33 1.09 1.09 0 00.37.07 5.15 5.15 0 000 .7 2.82 2.82 0 00.09.55 1 1 0 01.12.23l.12.25v.11a.68.68 0 01-.17.11l-.19.11v.11a3.22 3.22 0 00.26.69c.07.09.13.15.19.15h.2c.07 0 .17.11.3.32l.12-.12a2.65 2.65 0 010-1 .6.6 0 01.27-.37l.41-.19a1 1 0 00.45-.45c.16-.3.29-.55.38-.75a2.06 2.06 0 01.57-.66c0 .06 0 .15.07.26a.29.29 0 00.17.21.63.63 0 01.1-.14c.06-.07.1-.1.13-.1h.12a.26.26 0 00.12.07h.45a.88.88 0 00-.06-.21.41.41 0 010-.21l.11-.07h.13a.22.22 0 01.07-.06v-.21c0-.09-.05-.19-.08-.3s-.06-.21-.08-.32a.79.79 0 010-.22.82.82 0 01.13-.36.8.8 0 01.22-.28c.08 0 .13.06.13.12a.51.51 0 010 .21.91.91 0 000 .23.15.15 0 00.13.13.42.42 0 00.07-.11.36.36 0 000-.13 2.94 2.94 0 01.05-.47 4.44 4.44 0 000-.45.1.1 0 01.05-.08.13.13 0 01.1 0 .27.27 0 01.1 0 .32.32 0 01.13.08.26.26 0 010 .19v.28s.05-.1.11-.19a1.93 1.93 0 00.1-.19h.13a.67.67 0 01.29.08l.32.18.33.2a.76.76 0 00.28.13.29.29 0 00.19 0 .43.43 0 01.17 0s0 .12.06.25 0 .21.06.22a.58.58 0 00.21.28l.28.21a1 1 0 01.25.25.6.6 0 01.11.37.49.49 0 01-.07.25.39.39 0 00-.07.23.18.18 0 00.11.19.2.2 0 01.12.21v.14a1.64 1.64 0 010 .3 1.28 1.28 0 01-.07.29.41.41 0 00.05.21.32.32 0 00.12.11l.15.07a.38.38 0 01.16.13.56.56 0 010 .19.3.3 0 000 .19l.11.14a.42.42 0 01.1.19s0 .12.07.23a3.21 3.21 0 01.08.36c0 .12.05.24.07.35a1 1 0 010 .24l.21.31.26 1.18.59.54.57.43.47.33.43.59.16.14zm-14.1-9.26l.38-.38v-.09h-.4zm.12 0c-.07 0-.1 0-.1.11s0 .1.1.1.11 0 .11-.1a.1.1 0 00-.11-.11zm0 5.15h.14v-.12zm.26 1.28h.09v-.1zm.21-7.16h-.08.08zm0-.45v.08a.12.12 0 000-.08zm.26 9.26h.07v-.12h-.09zm.19-3.16a1.58 1.58 0 00.16.6c.11.24.18.39.21.44.11 0 .18-.1.22-.28a1.2 1.2 0 01.3-.55v-.12a.22.22 0 01-.06-.07h-.06zm.14-1a1.64 1.64 0 00.06.42.26.26 0 00.27.22.43.43 0 00.25-.07.41.41 0 01.25-.07v-.09h-.36v-.51a1.18 1.18 0 000-.2v-.07a.11.11 0 010-.1l.09-.05a.23.23 0 00.1-.07.3.3 0 000-.16v-.25a.17.17 0 00-.19-.15.82.82 0 01-.2.57.82.82 0 00-.27.58zm.35-1.58h.39c0-.08-.07-.12-.11-.13h-.25zm1.87 2.81h.14v-.12h-.14zm2-2.34l.06-.17a.6.6 0 01.06-.18l.07-.12a.31.31 0 000-.12s0-.09-.11-.14h-.12a.27.27 0 01-.07.08v.06zm1.18.12a.1.1 0 00-.1.11.09.09 0 00.1.1c.06 0 .09 0 .09-.1s-.02-.11-.08-.11zm.12-1.18a.26.26 0 00.14-.24h-.14zm.35.8l.12-.09h-.12zm.12-1.44a.39.39 0 00.05.24s.11.07.23.07a.58.58 0 00-.28-.5zm.45.69a.14.14 0 00.09.15.72.72 0 00.22 0 .18.18 0 00-.09-.17.77.77 0 00-.2-.07zm2.24.42q-.09 0-.09.12t.09.12c.06 0 .1 0 .1-.12s-.04-.12-.04-.12zm.24 3.64h-.05s0 .06.05 0v-.1zm.24-1.23a1.26 1.26 0 00.15.23 1.33 1.33 0 00.25.27l.11-.14a.74.74 0 00-.21-.36 2.26 2.26 0 00-.35-.28l-.1-.1-.07-.09a1.83 1.83 0 000 .21.44.44 0 000 .17V93zm0-.9h.11V92h-.11zm.47-.11c-.08 0-.12 0-.12.13s0 .13.12.13.09 0 .09-.13.02-.09-.08-.09zm-.1 2.57l.12.12.13-.1a.27.27 0 00.13-.16v-.12h-.06a.09.09 0 00-.08 0 .21.21 0 00-.13.09l-.11.12v.14zm.43.5s-.07 0-.07.1 0 .11.07.11.12 0 .12-.11-.03-.13-.11-.13zm.14.59c-.08 0-.12 0-.12.1s0 .11.12.11.09 0 .09-.11-.02-.1-.08-.1zm.61.52c0 .19.1.28.29.28a.54.54 0 00-.05-.26s-.1-.05-.21-.02zm.1 1h.21l.37-.06c.15 0 .22 0 .22-.06v-.12l-.28-.09-.25-.08-.2-.06v.09a.09.09 0 01-.07 0H229z"
            style={{
              WebkitTransformOrigin: 223.77,
              MsTransformOrigin: 223.77,
              transformOrigin: 223.77,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M247 97.27a1 1 0 00-.53.17.68.68 0 01-.55.09c-.08 0-.12-.07-.1-.18a1.72 1.72 0 000-.33 1.26 1.26 0 00-.05-.33q-.06-.15-.3-.15a.52.52 0 00-.22.4 3 3 0 000 .33.42.42 0 00-.21-.06.24.24 0 00-.13.07l-.11.11a.13.13 0 01-.14 0 .44.44 0 01-.39-.23 1.94 1.94 0 01-.23-.53 5.09 5.09 0 01-.16-1.06 2.72 2.72 0 01.13-.37 1.38 1.38 0 00.11-.41h.87a2.11 2.11 0 00.26.25.64.64 0 00.36.15 1.06 1.06 0 00.52-.15.9.9 0 01.52-.13c.12 0 .2 0 .22.12s.1.12.22.12a.55.55 0 00.29-.06.81.81 0 00.21-.25.19.19 0 01-.19-.12s0-.09.12-.19a1.66 1.66 0 00.17-.19v-.74c0-.31 0-.63-.07-1s0-.65 0-.95a3.21 3.21 0 01.07-.72v-.21c0-.11.05-.22.08-.35l.09-.39a1.81 1.81 0 01.06-.28 1.07 1.07 0 000-.48 1.29 1.29 0 01-.06-.4v-.27a2.78 2.78 0 01.05-.37c0-.31.09-.63.15-1a3.86 3.86 0 000-1 .61.61 0 00-.09-.14c-.06-.08-.11-.12-.14-.12a.84.84 0 00.07-.27 1 1 0 01.05-.27h-.12l-.07.09a.11.11 0 00-.05.07 2.09 2.09 0 00-.27.16l-.2.15h-.13l-.23.07a1 1 0 00-.21.07c-.06 0-.1 0-.1.06a2.44 2.44 0 00-.5.29 5.65 5.65 0 01-.57.38 3.15 3.15 0 01-.59.28.89.89 0 01-.58 0 1.4 1.4 0 00.08-.5 1.06 1.06 0 00-.08-.4 2.87 2.87 0 00-.33-.1l-.26-.5a1 1 0 000-.11v-.1a.87.87 0 01.08-.19c0-.08.11-.09.22 0a.54.54 0 01.07.12.64.64 0 00.1.14q.08 0 .21-.06a1.74 1.74 0 00.3-.2 2.1 2.1 0 00.27-.24.4.4 0 00.12-.2.34.34 0 000-.25.36.36 0 010-.27l.28.07a1.89 1.89 0 01.24-.54.2.2 0 01.19-.08l.22.07a.37.37 0 00.34-.11.33.33 0 00.12-.13v-.1c0-.02 0 0 0 0a.65.65 0 01.18 0 .29.29 0 01.19.07s-.09 0-.18.07-.14.11-.15.15-.05.07-.05.17a1.13 1.13 0 010 .23.17.17 0 00.21-.06l.17-.24a.77.77 0 01.23-.21.47.47 0 01.4 0l.22-.75s.05-.06.11-.06a.18.18 0 01.15 0 4.13 4.13 0 01.69.52 2.8 2.8 0 01.51.57l.12.14.14.14a1.15 1.15 0 01.21.73 7.73 7.73 0 01-.06 1c0 .32-.06.62-.08.9a.68.68 0 00.14.55 1.85 1.85 0 010 .3l-.06.42c0 .15 0 .3-.08.43s-.06.23-.07.3l-.05.14v.14s.07.07.16.12a.37.37 0 01.17.11 1.57 1.57 0 010 .57c0 .25-.09.52-.16.81s-.12.55-.19.81-.1.46-.12.6a.84.84 0 01.08.23 1.72 1.72 0 010 .22v.45a1.3 1.3 0 000 .26 1.39 1.39 0 000 .27 2.86 2.86 0 00.11.46v.05h-.14V94.05h.22a.74.74 0 00-.14.33.56.56 0 000 .35.25.25 0 00.18.2 1.51 1.51 0 00.37.1h.85a.24.24 0 00.17 0 .74.74 0 00.18-.2v.33l.17-.06H251.53a.11.11 0 01.1 0s.06.06.14.09a.26.26 0 00.14 0c.06 0 .09-.07.09-.11v.02l-.15-.1a.45.45 0 00-.15-.07l.06-.07c.06-.07 0-.07.05-.07h.19a2.26 2.26 0 00.72.21.9.9 0 01.4.12.51.51 0 01.16.37 8.74 8.74 0 010 .93v.49a1 1 0 01-.17.53l-.09-.14.05-.85H252.78a.41.41 0 010-.16.73.73 0 00-.2.27 3 3 0 01-.18.36c-.06.13-.11.24-.16.33a.36.36 0 01-.14.17l-.05-.06c-.05-.06-.05 0-.05-.06h-.07a.42.42 0 01-.14.11.44.44 0 00-.12.11v-.31a1 1 0 00-.27.21c-.07.08-.14.18-.22.29l-.1-.15a.91.91 0 00-.11-.16v.15a.23.23 0 01-.14 0 .12.12 0 01-.12-.06.5.5 0 010-.13.5.5 0 000-.13s0-.06-.12-.06h-.07a.56.56 0 01-.16.45.75.75 0 01-.39.24v-.26a.24.24 0 00-.18.06l-.13.15a.8.8 0 01-.15.17.36.36 0 01-.51.02l-.12-.1a.27.27 0 00-.18.07.87.87 0 00-.18-.27.72.72 0 00-.27-.08c-.21-.05-.37.06-.5.31l-.09-.13a.54.54 0 00-.12-.11h-.21a.82.82 0 01-.1-.17.79.79 0 010-.13.19.19 0 00-.05-.09s-.12-.03-.18-.03zM246.37 84s-.06 0-.08.08a.13.13 0 000 .16c.05 0 .08 0 .09-.1s.02-.14-.01-.14zm0 .26a1.4 1.4 0 010 .25.26.26 0 00.08.27.34.34 0 00.21-.08.56.56 0 00.1-.15.13.13 0 00-.06-.18.88.88 0 00-.2-.09h-.09zm2.31 12.33c0-.06 0-.09-.07-.09zm.45-.42c-.06 0-.09.06-.09.13s0 .1.09.08.07 0 .07-.08.03-.15-.02-.16zm.1 1.16a.13.13 0 00-.1.13.77.77 0 010 .15h.12zm0-.62h.12v-.09zm.1.31c-.06 0-.1 0-.1.12s0 .11.1.11.07 0 .07-.09.07-.16.02-.16zm.33.14s-.05 0-.05.05 0 .07.05.07.17-.07.09-.15zm.16-1.13a.3.3 0 00-.11.23v.1a.2.2 0 00.08-.12.57.57 0 000-.12l.12-.12zm.38.4a.31.31 0 00-.14.23 1.19 1.19 0 000 .22h.14z"
            style={{
              WebkitTransformOrigin: 248.516,
              MsTransformOrigin: 248.516,
              transformOrigin: 248.516,
            }}
            fill="#FFF"
            className="animable"
          ></path>
        </g>
      </g>
      <g
        className="animable"
        style={{
          WebkitTransformOrigin: 128.731,
          MsTransformOrigin: 128.731,
          transformOrigin: 128.731,
        }}
      >
        <path
          d="M182.22 434.66c-2.29.74-67.66-.11-70.12-1.72-.95-.6-1.38-10.13-1.57-21.66v-.36c0-2.38-.07-4.83-.08-7.31v-1c-.09-16.64.17-33.91.17-33.91l43.73.44-1.35 33.57v1.33l-.3 6.96v.72s24.88 11.51 27.4 13.57 4.41 8.64 2.12 9.37z"
          style={{
            WebkitTransformOrigin: 146.841,
            MsTransformOrigin: 146.841,
            transformOrigin: 146.841,
          }}
          fill="#EB9481"
          className="animable"
        ></path>
        <path
          d="M182.22 434.66c-2.29.74-67.66-.11-70.12-1.72-.95-.6-1.38-10.13-1.57-21.66v-.36c0-2.38-.07-4.83-.08-7.31v-1l42.58.12v1.33l-.33 6.94v.72s24.88 11.51 27.4 13.57 4.41 8.64 2.12 9.37z"
          style={{
            WebkitTransformOrigin: 146.85,
            MsTransformOrigin: 146.85,
            transformOrigin: 146.85,
          }}
          fill="#EBEBEB"
          className="animable"
        ></path>
        <path
          d="M182.22 434.66c-1.42.46-26.74.31-46.56-.25-12.38-.34-22.61-.85-23.56-1.47s-1.37-9.86-1.56-21.18v-.48-.37l42.17.08v.72s24.88 11.51 27.4 13.57 4.4 8.65 2.11 9.38z"
          style={{
            WebkitTransformOrigin: 146.897,
            MsTransformOrigin: 146.897,
            transformOrigin: 146.897,
          }}
          fill="#1DD21D"
          className="animable"
        ></path>
        <path
          d="M181.51 432.11c-11-.41-55.48-1-66.4-.61-.09 0-.09.07 0 .07 10.91.65 55.38.92 66.4.73.23-.01.24-.18 0-.19z"
          style={{
            WebkitTransformOrigin: 148.364,
            MsTransformOrigin: 148.364,
            transformOrigin: 148.364,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M157.39 411.17c-4.32-.86-9.63-.27-13 2.78-.13.12 0 .3.18.26a61.06 61.06 0 0112.79-2.49.28.28 0 00.03-.55z"
          style={{
            WebkitTransformOrigin: 150.971,
            MsTransformOrigin: 150.971,
            transformOrigin: 150.971,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M160.5 413.1c-4.33-.87-9.64-.27-13 2.78-.13.12 0 .3.18.26a60.33 60.33 0 0112.78-2.49.28.28 0 00.04-.55z"
          style={{
            WebkitTransformOrigin: 154.079,
            MsTransformOrigin: 154.079,
            transformOrigin: 154.079,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M163.6 415c-4.32-.87-9.63-.27-13 2.77-.13.12 0 .3.18.26a61.71 61.71 0 0112.79-2.49.27.27 0 00.03-.54z"
          style={{
            WebkitTransformOrigin: 157.201,
            MsTransformOrigin: 157.201,
            transformOrigin: 157.201,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M163.15 401.79c-1.67-2.37-4.86-1.36-6.69.14a23.11 23.11 0 00-6.8 9.85.11.11 0 00.1.15c0 .33.3.69.67.56 3.6-1.28 7.6-2.21 10.7-4.55 1.81-1.37 3.61-3.94 2.02-6.15zm-7.66 7.64c-1.76.67-3.53 1.25-5.26 2a66.75 66.75 0 014.1-5.66 24.53 24.53 0 012.33-2.45c1.3-1.16 6.44-3.59 5.62 1.15-.46 2.61-4.7 4.16-6.79 4.96z"
          style={{
            WebkitTransformOrigin: 156.708,
            MsTransformOrigin: 156.708,
            transformOrigin: 156.708,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M138.65 410.5c3.56 1.57 7.66 1.55 11.46 2a.55.55 0 00.53-.7.11.11 0 00.06-.17 23.2 23.2 0 00-8.89-8c-2.12-1-5.46-1.29-6.54 1.4s1.31 4.56 3.38 5.47zm-1.92-3.11c-1.89-4.43 3.67-3.25 5.21-2.42a25.93 25.93 0 012.83 1.85c1.89 1.38 3.55 3 5.29 4.56-1.85-.32-3.71-.47-5.57-.72-2.22-.3-6.71-.83-7.76-3.27z"
          style={{
            WebkitTransformOrigin: 142.861,
            MsTransformOrigin: 142.861,
            transformOrigin: 142.861,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M135.66 434.41c-12.38-.34-22.61-.85-23.56-1.47s-1.37-9.86-1.56-21.18c5.08 4.53 17.69 15.78 25.12 22.65z"
          style={{
            WebkitTransformOrigin: 123.1,
            MsTransformOrigin: 123.1,
            transformOrigin: 123.1,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M97.19 180.4S107 290.84 108.6 299.27c.37 1.92.6 12.36.75 25.78.34 29.28.14 82.08.14 82.08h46.08s-1.37-91.49-3.41-108.33-15.08-118.4-15.08-118.4z"
          style={{
            WebkitTransformOrigin: 126.38,
            MsTransformOrigin: 126.38,
            transformOrigin: 126.38,
          }}
          fill="#37474F"
          className="animable"
        ></path>
        <path
          d="M153.48 399.11c-7.19-.15-5.12-.21-12.31-.28-3.52 0-26.64-.24-29.93.31a.07.07 0 000 .14c3.29.55 26.41.35 29.93.31 7.19-.07 5.12-.12 12.31-.27a.11.11 0 100-.21z"
          style={{
            WebkitTransformOrigin: 132.396,
            MsTransformOrigin: 132.396,
            transformOrigin: 132.396,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M118.24 346.8q-.08-10-.14-20c0-6.48 0-13-.35-19.42-.62-13.1-3.28-26-5.17-38.92s-3.47-26-4.89-39c-1.6-14.6-3-29.21-4.52-43.82 0-.1-.16-.1-.15 0 2.17 26.09 4.59 52.16 8.2 78.09q1.35 9.67 2.94 19.31c1.08 6.5 2.15 13 2.66 19.58s.58 12.9.65 19.35q.11 10 .2 20c.14 14.83.29 37.66.43 52.5 0 .29.45.27.45 0-.1-13.2-.2-34.47-.31-47.67z"
          style={{
            WebkitTransformOrigin: 110.785,
            MsTransformOrigin: 110.785,
            transformOrigin: 110.785,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M87.48 180.4S107 290.84 108.6 299.27c.37 1.92.6 12.36.75 25.78l22-144.69z"
          style={{
            WebkitTransformOrigin: 109.415,
            MsTransformOrigin: 109.415,
            transformOrigin: 109.415,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M128.72 438.56c-2.34.57-67.48-4.9-69.83-6.69-.9-.66-.66-10.2 0-21.72v-.36c.13-2.37.27-4.81.44-7.29 0-.34 0-.68.06-1 1.08-16.63 2.61-33.83 2.61-33.83l43.59 3.53-3.69 33.42-.15 1.32-.75 6.92-.08.71s24 13.25 26.37 15.48 3.77 8.95 1.43 9.51z"
          style={{
            WebkitTransformOrigin: 94.112,
            MsTransformOrigin: 94.112,
            transformOrigin: 94.112,
          }}
          fill="#EB9481"
          className="animable"
        ></path>
        <path
          d="M128.72 438.56c-2.34.57-67.48-4.9-69.83-6.69-.9-.66-.66-10.2 0-21.72v-.36c.13-2.37.27-4.81.44-7.29 0-.34 0-.68.06-1l42.47 3.14-.15 1.32-.75 6.92-.08.71s24 13.25 26.37 15.48 3.81 8.93 1.47 9.49z"
          style={{
            WebkitTransformOrigin: 94.1061,
            MsTransformOrigin: 94.1061,
            transformOrigin: 94.1061,
          }}
          fill="#EBEBEB"
          className="animable"
        ></path>
        <path
          d="M128.72 438.56c-2.34.57-67.48-4.9-69.83-6.69-.9-.66-.66-10.2 0-21.72v-.36l42.11 3.07-.08.71s24 13.25 26.37 15.48 3.77 8.95 1.43 9.51z"
          style={{
            WebkitTransformOrigin: 94.112,
            MsTransformOrigin: 94.112,
            transformOrigin: 94.112,
          }}
          fill="#1DD21D"
          className="animable"
        ></path>
        <path
          d="M128.19 436c-11-1.2-55.27-5-66.19-5.32-.09 0-.09.06 0 .07 10.83 1.42 55.17 4.84 66.18 5.43.23-.02.24-.18.01-.18z"
          style={{
            WebkitTransformOrigin: 95.145,
            MsTransformOrigin: 95.145,
            transformOrigin: 95.145,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M105.61 413.37c-4.25-1.17-9.59-.95-13.15 1.85-.14.11 0 .3.16.27a61.14 61.14 0 0112.93-1.58.27.27 0 00.06-.54z"
          style={{
            WebkitTransformOrigin: 99.1258,
            MsTransformOrigin: 99.1258,
            transformOrigin: 99.1258,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M108.57 415.51c-4.25-1.17-9.59-.95-13.15 1.85-.14.11 0 .3.16.27a61.13 61.13 0 0112.93-1.57.28.28 0 00.06-.55z"
          style={{
            WebkitTransformOrigin: 102.07,
            MsTransformOrigin: 102.07,
            transformOrigin: 102.07,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M111.54 417.65c-4.26-1.17-9.6-.95-13.16 1.85-.14.11 0 .31.16.27a61.13 61.13 0 0112.93-1.57.28.28 0 00.07-.55z"
          style={{
            WebkitTransformOrigin: 105.034,
            MsTransformOrigin: 105.034,
            transformOrigin: 105.034,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M112 404.42c-1.5-2.48-4.75-1.7-6.68-.33a23.09 23.09 0 00-7.48 9.33.11.11 0 00.08.17.55.55 0 00.64.6c3.68-1 7.74-1.66 11-3.78 1.91-1.24 3.88-3.65 2.44-5.99zm-8.18 7.08c-1.8.54-3.61 1-5.39 1.61 1.47-1.82 2.85-3.69 4.49-5.36a25.7 25.7 0 012.5-2.28c1.38-1.06 6.68-3.12 5.52 1.55-.62 2.58-4.94 3.82-7.1 4.48z"
          style={{
            WebkitTransformOrigin: 105.159,
            MsTransformOrigin: 105.159,
            transformOrigin: 105.159,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M87 411.37c3.43 1.82 7.53 2.09 11.29 2.77a.53.53 0 00.57-.65.12.12 0 00.08-.17 23.22 23.22 0 00-8.3-8.63c-2-1.18-5.36-1.67-6.63.94-1.23 2.46.99 4.68 2.99 5.74zm-1.69-3.24c-1.58-4.56 3.88-3 5.36-2.05a26.52 26.52 0 012.69 2.05 69.9 69.9 0 015 4.93c-1.83-.45-3.67-.74-5.51-1.12-2.27-.46-6.7-1.3-7.57-3.81z"
          style={{
            WebkitTransformOrigin: 91.3045,
            MsTransformOrigin: 91.3045,
            transformOrigin: 91.3045,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M102.82 409.62l-46-1.95s12.57-101 12.8-107.22c.6-16.11 11.31-120.09 11.31-120.09h56.22s-3.55 24-9.61 39.22a71.13 71.13 0 00-11.8 5.42s-5.26 68.77-5.46 77.35c-.39 16.9-7.46 107.27-7.46 107.27z"
          style={{
            WebkitTransformOrigin: 96.985,
            MsTransformOrigin: 96.985,
            transformOrigin: 96.985,
          }}
          fill="#37474F"
          className="animable"
        ></path>
        <path
          d="M101.6 401.19c-7.18-.46-5.11-.43-12.29-.8-3.52-.19-26.61-1.37-29.92-1-.07 0-.08.13 0 .14 3.26.69 26.37 1.47 29.88 1.58 7.19.24 5.13.09 12.32.25a.11.11 0 00.01-.17z"
          style={{
            WebkitTransformOrigin: 80.4846,
            MsTransformOrigin: 80.4846,
            transformOrigin: 80.4846,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M85 186.52c-2.09 26.19-4.23 52.38-6.63 78.54s-5.21 52.48-8.64 78.62c-1.91 14.61-4 35.18-6.3 49.73 0 .1.13.14.15 0 4.64-25.86 8.05-57.94 10.95-84.05s5.27-52.27 7.39-78.44c1.19-14.81 2.27-29.63 3.41-44.44.03-.17-.33-.17-.33.04z"
          style={{
            WebkitTransformOrigin: 74.3809,
            MsTransformOrigin: 74.3809,
            transformOrigin: 74.3809,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M129.51 218.54a87.83 87.83 0 00-13.77 6.46.15.15 0 00.13.28c4.64-2 9.37-3.89 13.89-6.14a.3.3 0 00-.25-.6z"
          style={{
            WebkitTransformOrigin: 122.805,
            MsTransformOrigin: 122.805,
            transformOrigin: 122.805,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M131 186.71c0-.16-.3-.19-.3 0 0 5.51-.31 10.35-.77 15.5-.22 2.39-2.14 15.59-6.28 14.63-.7-.16-1-.85-1.16-1.89a16.52 16.52 0 01.55-4.05c.46-2.77.83-5.54 1.07-8.33a76.21 76.21 0 00-.17-15.62.14.14 0 00-.27 0 142.68 142.68 0 01-1.26 21.57c-.52 3.43-2.25 8.6 1.34 9.13s6-8.12 6.47-10.49a79 79 0 00.78-20.45z"
          style={{
            WebkitTransformOrigin: 126.434,
            MsTransformOrigin: 126.434,
            transformOrigin: 126.434,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M123.75 217.17a22.14 22.14 0 00-.94 2.74 6.45 6.45 0 00-.38 2.25c0 .14.21.16.28.06a7.83 7.83 0 001-2.19c.31-.85.65-1.69.94-2.54a.46.46 0 00-.9-.32z"
          style={{
            WebkitTransformOrigin: 123.554,
            MsTransformOrigin: 123.554,
            transformOrigin: 123.554,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M105 191a7.53 7.53 0 00-.18-1.71.08.08 0 00-.16 0 6.68 6.68 0 00-.2 1.48c-.06.57-.13 1.14-.19 1.71a27.4 27.4 0 01-.61 3.45 12.27 12.27 0 01-3.16 5.68 16.48 16.48 0 01-5.35 3.52 59.08 59.08 0 01-6.87 2 .09.09 0 000 .17 19.75 19.75 0 007.43-1.46 15.85 15.85 0 005.58-3.56 12.42 12.42 0 003.26-5.85A17.53 17.53 0 00105 193a15.7 15.7 0 000-2z"
          style={{
            WebkitTransformOrigin: 96.6257,
            MsTransformOrigin: 96.6257,
            transformOrigin: 96.6257,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M115 135.72c14.72 15.15 33.07 25.08 41.6 23.23 6.65-1.44 29.87-16.68 35.6-31.11 1.27-3.19-23.63-10.19-25-8.18-4 5.9-17.19 15.1-18.32 14.75-1.49-.46-18.2-7-31.35-12.39-15.85-6.56-10.59 5.41-2.53 13.7z"
          style={{
            WebkitTransformOrigin: 149.758,
            MsTransformOrigin: 149.758,
            transformOrigin: 149.758,
          }}
          fill="#EB9481"
          className="animable"
        ></path>
        <path
          d="M197.65 123.23c-2.19 5.15-10.8 13.92-13.69 15.24s-18.3-12.81-18-16.06 9-20 14-22.72 19.96 18.2 17.69 23.54z"
          style={{
            WebkitTransformOrigin: 181.919,
            MsTransformOrigin: 181.919,
            transformOrigin: 181.919,
          }}
          fill="#EB9481"
          className="animable"
        ></path>
        <path
          d="M166.92 119.29a46.41 46.41 0 00-1.68-13.39c-1.62-5.15-4.62-12.6-1.88-13.58 5.61-2 13.06 16.59 13.06 16.59s2 8.73-3.41 11.21a5.89 5.89 0 01-6.09-.83z"
          style={{
            WebkitTransformOrigin: 169.516,
            MsTransformOrigin: 169.516,
            transformOrigin: 169.516,
          }}
          fill="#EB9481"
          className="animable"
        ></path>
        <path
          d="M173.06 105.4c1.8 2.36 3.64.76 3.64.76s-3.88 4.25-2.28 7.11 5.35 0 5.62-.2c-.2.22-3.67 4.22-1.76 6.93s5.32-.62 5.53-.84c-.12.28-1.71 3.93.2 5.66 3.29 3 7.62-6.26 11.05-7.34 0 0 2.48 5.6 2.59 5.75 0 0 4.3-8.7 2.59-13.23a3.1 3.1 0 00-3.31-2s1.69-2.65.26-4.83c-.74-1.11-3.18-.93-3.18-.93a3.88 3.88 0 00-.13-4c-1.11-1.48-3.39-1.06-3.39-1.06s10.51-10 8.26-12.56c-3.88-4.37-23 17.59-25.58 17.43-1.28-.14-.89 2.32-.11 3.35z"
          style={{
            WebkitTransformOrigin: 186.49,
            MsTransformOrigin: 186.49,
            transformOrigin: 186.49,
          }}
          fill="#EB9481"
          className="animable"
        ></path>
        <path
          d="M190.12 97.12v-.08a27.65 27.65 0 00-13.58 9.22c-.1.14-.15 1 0 .82 3.19-3.79 8.46-7.44 13.58-9.96z"
          style={{
            WebkitTransformOrigin: 183.283,
            MsTransformOrigin: 183.283,
            transformOrigin: 183.283,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M194.06 102.14c.05 0 0-.12-.05-.1a25.85 25.85 0 00-14.19 11c-.11.19 0 .46.12.26 2.38-3.46 9.49-8.91 14.12-11.16z"
          style={{
            WebkitTransformOrigin: 186.928,
            MsTransformOrigin: 186.928,
            transformOrigin: 186.928,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M183.72 119.62c3.24-5.09 7.79-8.63 13-11.59.07 0 0-.13-.06-.12-2.93.76-6 3-8.32 4.94a15.92 15.92 0 00-4.78 6.65c-.06.11.09.23.16.12z"
          style={{
            WebkitTransformOrigin: 190.148,
            MsTransformOrigin: 190.148,
            transformOrigin: 190.148,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M176.6 106.16c-.13.17.53.16.41.33-1.32 1.91-3.52 5.44-2.21 6.86 1 1.14 3.31.52 4.09-.06l1.94-1.46-1.32 2a10.09 10.09 0 00-1.32 2.94 3.54 3.54 0 00.32 2.89 2 2 0 002.4.89 6.29 6.29 0 002.54-1.75l2-2.11-1.16 2.62a9.45 9.45 0 00-.68 2.29 3.88 3.88 0 00.2 2.21 1.84 1.84 0 001.61 1.07 4.06 4.06 0 002.09-.88 32.4 32.4 0 003.67-3.39c.59-.6 1.19-1.2 1.81-1.77a6.11 6.11 0 012.11-1.41 6.42 6.42 0 00-1.94 1.57c-.58.61-1.12 1.26-1.67 1.9a27.38 27.38 0 01-3.57 3.66 4.67 4.67 0 01-2.47 1.13 2.59 2.59 0 01-2.43-1.48 4.68 4.68 0 01-.32-2.74 10.05 10.05 0 01.71-2.56l.81.51a7.1 7.1 0 01-3 2.1 2.9 2.9 0 01-2 0 3.24 3.24 0 01-1.51-1.26 4.48 4.48 0 01-.4-3.66 10.88 10.88 0 011.5-3.22l.62.59c-1 .7-3.46 1.67-5.31.11-2.12-2.4 1.72-7.08 2.48-7.92z"
          style={{
            WebkitTransformOrigin: 184.295,
            MsTransformOrigin: 184.295,
            transformOrigin: 184.295,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M163.08 122.19l22.52 19.55s-22.08 20.55-34.11 18.88-35.56-20.37-42.74-31.45c-6.22-9.59 1-11.37 8.5-7.79s31.26 12.4 32 12.17 13.83-11.36 13.83-11.36z"
          style={{
            WebkitTransformOrigin: 145.996,
            MsTransformOrigin: 145.996,
            transformOrigin: 145.996,
          }}
          fill="#1DD21D"
          className="animable"
        ></path>
        <path
          d="M111.79 127.1a1.09 1.09 0 101.09 1.08 1.09 1.09 0 00-1.09-1.08zm0 2.05a1 1 0 111-1 1 1 0 01-1 1zm8.78 10.94a1.07 1.07 0 00-1.07 1l.11.09a1 1 0 111 1l.12.1a1.07 1.07 0 00.9-1.06 1.09 1.09 0 00-1.06-1.13zm-1-9.17a1.08 1.08 0 100 2.15 1.08 1.08 0 100-2.15zm0 2a1 1 0 110-1.93 1 1 0 110 1.93zm15.24-1.31a1.08 1.08 0 101.09 1.07 1.08 1.08 0 00-1.11-1.03zm0 2a1 1 0 111-1 1 1 0 01-1.02 1.08zm2.17 10a1.07 1.07 0 00-1.07 1.07 1.08 1.08 0 101.09-.98zm0 2a1 1 0 01-1-1 1 1 0 111.93 0 1 1 0 01-.91 1.13zm-11.45-11.5a1.08 1.08 0 101.07 1.08 1.08 1.08 0 00-1.09-.95zm0 2a1 1 0 111-1 1 1 0 01-1.02 1.18zm1.48 8.86a1.07 1.07 0 00-1 1.48l.25.2a.91.91 0 01-.23-.62 1 1 0 011.93 0 1 1 0 01-1 1 .77.77 0 01-.37-.08 1.18 1.18 0 00.21.18.44.44 0 00.16 0 1.09 1.09 0 001.08-1.09 1.07 1.07 0 00-1.04-.89zm5.2 4.24a1.08 1.08 0 00-1.08 1.09.38.38 0 01.13.09.2.2 0 010-.1 1 1 0 111.93 0 1 1 0 01-.73.92l.12.09a1.08 1.08 0 00-.35-2.1zm-11.9-25.23a1.08 1.08 0 101.07 1.07 1.07 1.07 0 00-1.09-.89zm0 2a1 1 0 111-1 1 1 0 01-1.02 1.22zM106.58 122a.81.81 0 000 .11 1 1 0 01-.08 1.88.27.27 0 000 .12 1.07 1.07 0 00.91-1.06 1.06 1.06 0 00-.83-1.05zm25 16.4a1.08 1.08 0 101.08 1.09 1.08 1.08 0 00-1.07-1.14zm0 2.05a1 1 0 111-1 1 1 0 01-.99.95zm10.1 9a1.08 1.08 0 101.08 1.09 1.08 1.08 0 00-1.07-1.15zm0 2a1 1 0 111-1 1 1 0 01-.99.98zm3.95-8.54a1.08 1.08 0 101.08 1.07 1.08 1.08 0 00-1.07-1.09zm0 2a1 1 0 111-1 1 1 0 01-.99 1.02zm11.4-9.37a1.09 1.09 0 101.08 1.08 1.09 1.09 0 00-1.11-1.06zm0 2.05a1 1 0 111-1 1 1 0 01-1.03 1.02zm3-8.65a1.09 1.09 0 101.09 1.08 1.09 1.09 0 00-1.04-1.02zm0 2a1 1 0 111-1 1 1 0 01-.95 1.06zm5.15 3.17a1.08 1.08 0 101.08 1.07 1.08 1.08 0 00-1.03-1zm0 2a1 1 0 111-1 1 1 0 01-.95 1.11zm-1-13a.94.94 0 01-.94.85 1 1 0 01-1-1 .69.69 0 010-.25l-.15.13a.49.49 0 000 .12 1.08 1.08 0 002.14.21zm5.83 5.06l-.15-.13a.91.91 0 01.06.32 1 1 0 11-.78-.93l-.15-.14a1.08 1.08 0 101.07 1.07.58.58 0 00-.01-.12zm-23.63 26.39a1.08 1.08 0 101.08 1.08 1.07 1.07 0 00-1.04-1.01zm0 2a1 1 0 110-1.93 1 1 0 010 1.93zM128 127.1a1.09 1.09 0 101.08 1.08 1.08 1.08 0 00-1.08-1.08zm0 2.05a1 1 0 010-1.94 1 1 0 110 1.94zm12.93 8.18a1.08 1.08 0 101.07 1.08 1.09 1.09 0 00-1.06-1.08zm0 2a1 1 0 110-1.94 1 1 0 010 1.94zm12.86 2.91a1.08 1.08 0 101.08 1.08 1.09 1.09 0 00-1.07-1.03zm0 2.05a1 1 0 111-1 1 1 0 01-.99 1.05zm1.8 8.55a1.08 1.08 0 00-1.07 1.09 1.07 1.07 0 001.07 1.07 1.08 1.08 0 100-2.16zm0 2a1 1 0 111-1 1 1 0 01-.99 1.09zm10.33-3.85a1.08 1.08 0 101.08 1.08 1.08 1.08 0 00-1.07-.99zm0 2a1 1 0 111-1 1 1 0 01-.99 1.13zm-20.69-20.8a1 1 0 01-1.83-.41.65.65 0 010-.21h-.12a1 1 0 000 .25 1.07 1.07 0 001.07 1.07 1.09 1.09 0 001-.61zm3.76 4.27a1.08 1.08 0 101.07 1.08 1.08 1.08 0 00-1.06-.95zm0 2a1 1 0 111-1 1 1 0 01-.99 1.17zm4.21-8.15l-.11.08a1 1 0 01.65.91 1 1 0 01-1.91.11l-.1.09a1.06 1.06 0 001 .87 1.08 1.08 0 001.09-1.07 1.11 1.11 0 00-.61-.82zm-3 18.16a1.08 1.08 0 101.07 1.07 1.08 1.08 0 00-1.07-.9zm0 2a1 1 0 111-1 1 1 0 01-1 1.21zm11.39 5.6a1.09 1.09 0 000 2.17.38.38 0 00.18 0 .85.85 0 00.44-.2 1.13 1.13 0 00.4-.85 1.08 1.08 0 00-1.02-.91zm0 2.05a1 1 0 010-1.94 1 1 0 010 1.94zm-9.35.25a1.09 1.09 0 00-1.08 1.09 1.12 1.12 0 00.62 1 1.42 1.42 0 00.42.08.75.75 0 00.26 0 1.06 1.06 0 00.81-1 1.09 1.09 0 00-1.03-.96zm0 2a1 1 0 110-1.92 1 1 0 110 1.92zm7.09-13.78a1.08 1.08 0 101.08 1.07 1.07 1.07 0 00-1.08-.82zm0 2a1 1 0 111-1 1 1 0 01-1 1.29zm9-3.95a1.08 1.08 0 101.09 1.09 1.08 1.08 0 00-1.06-.8zm0 2a1 1 0 111-.95 1 1 0 01-.97 1.31zm-6.11-6.63a1.08 1.08 0 101.08 1.07 1.08 1.08 0 00-1.05-.74zm0 2a1 1 0 111-1 1 1 0 01-.97 1.37zm9.07-3.36a1.08 1.08 0 101.08 1.08 1.07 1.07 0 00-1.05-.73zm0 2a1 1 0 111-1 1 1 0 01-.97 1.41zm3.19 8a1.08 1.08 0 00-.46 2.05.32.32 0 00.12-.08 1 1 0 111.3-.95l.11-.08a1.07 1.07 0 00-1.04-.59zm6.63-11.16a.13.13 0 010 .09 1 1 0 01-1.94 0 1 1 0 01.92-1l-.11-.11a1.09 1.09 0 101.24 1.09zm-6.63-5.22a1.09 1.09 0 101.08 1.09 1.09 1.09 0 00-1.05-.7zm0 2.06a1 1 0 111-1 1 1 0 01-.97 1.39zm2.92 8.59a1.08 1.08 0 101.08 1.09 1.09 1.09 0 00-1.05-.7zm0 2.05a1 1 0 111-1 1 1 0 01-.97 1.39z"
          style={{
            WebkitTransformOrigin: 143.857,
            MsTransformOrigin: 143.857,
            transformOrigin: 143.857,
          }}
          fill="#050504"
          className="animable"
          opacity="0.2"
        ></path>
        <path
          d="M153.8 160.68a9.74 9.74 0 01-2.3-.06c-12-1.66-35.57-20.37-42.75-31.44-3.39-5.23-2.78-8.13-.31-9.12z"
          style={{
            WebkitTransformOrigin: 130.098,
            MsTransformOrigin: 130.098,
            transformOrigin: 130.098,
          }}
          className="animable"
          opacity="0.1"
        ></path>
        <path
          d="M180.25 145.63a24.73 24.73 0 00-2.37-2.32l-2.56-2.45c-1.65-1.55-3.39-3-5.12-4.5-3.51-3-7-6.07-10.73-8.79-.07-.06-.18 0-.11.11 3.17 3.26 6.64 6.25 10.06 9.26 1.7 1.5 3.4 3 5.16 4.44.88.71 1.78 1.4 2.67 2.11a28.28 28.28 0 002.9 2.23c.07.04.16-.03.1-.09z"
          style={{
            WebkitTransformOrigin: 169.804,
            MsTransformOrigin: 169.804,
            transformOrigin: 169.804,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M74.59 208.56c.17.17 69-4.54 69.63-5.29.8-1.06-20.08-74.57-27.81-83.28-1.65-1.86-6.68-2-10.88-1.22a18.81 18.81 0 00-3.22.9h-.1a7.71 7.71 0 00-2.32 1.34c-11.12 10.3-18.7 43.93-20.31 53.99-2.68 16.55-5.58 33-4.99 33.56z"
          style={{
            WebkitTransformOrigin: 109.378,
            MsTransformOrigin: 109.378,
            transformOrigin: 109.378,
          }}
          fill="#1DD21D"
          className="animable"
        ></path>
        <path
          d="M96.2 125.45a1 1 0 00.37-.54c-.12.17-.25.35-.37.54zm-2 16a1.08 1.08 0 101.08 1.09 1.09 1.09 0 00-1.1-1.11zm0 2a1 1 0 110-1.92 1 1 0 110 1.92zm1 7.1a1.08 1.08 0 101.08 1.07 1.08 1.08 0 00-1.08-1.05zm0 2a1 1 0 110-1.93 1 1 0 010 1.93zm-10.35-.17a.23.23 0 000 .11 1 1 0 01.86.95 1 1 0 01-1 1 .92.92 0 01-.43-.11v.12a1 1 0 00.46.1 1.08 1.08 0 001.08-1.08 1.06 1.06 0 00-.97-1.03zm11.71-20.51a1.09 1.09 0 101.08 1.13 1.09 1.09 0 00-1.08-1.07zm0 2.06a1 1 0 010-1.94 1 1 0 110 1.94zm3.87 11.57a1.08 1.08 0 101.07 1.08 1.08 1.08 0 00-1.07-1.02zm0 2a1 1 0 11.95-1 1 1 0 01-.95 1.1zm7.94 10.7a1.08 1.08 0 101.09 1.08 1.09 1.09 0 00-1.09-.98zm0 2a1 1 0 110-1.93 1 1 0 110 1.93zm16.81 2.8a1.08 1.08 0 101.08 1.07 1.07 1.07 0 00-1.08-1.07zm0 2a1 1 0 111-1 1 1 0 01-1 1zm-21.18-.7a1.08 1.08 0 101.08 1.08 1.09 1.09 0 00-1.08-1.08zm0 2a1 1 0 010-1.94 1 1 0 110 1.94zm-12.28 7.43a1.08 1.08 0 101.07 1.09 1.08 1.08 0 00-1.11-1.04zm0 2a1 1 0 111-.95 1 1 0 01-1.04 1.04zm-10.73 7a1.08 1.08 0 101.01 1.13 1.07 1.07 0 00-1-1.07zm0 2a1 1 0 111-1 1 1 0 01-.99 1.1zm17.13 2.53a1.09 1.09 0 101.07 1.09 1.09 1.09 0 00-1.11-.99zm0 2a1 1 0 111-1 1 1 0 01-1.04 1.15zm13.71-62.31a1.09 1.09 0 101.09 1.08 1.09 1.09 0 00-1.13-.93zm0 2.05a1 1 0 111-1 1 1 0 01-1.04 1.15zm-5.12 4a1.08 1.08 0 100 2.16 1.08 1.08 0 000-2.16zm0 2a1 1 0 111-1 1 1 0 01-1 1zm8.15 10.14a1.08 1.08 0 00-1.08 1.07 1.08 1.08 0 102.16 0 1.08 1.08 0 00-1.08-1.06zm0 2a1 1 0 111-1 1 1 0 01-1 1.05zm10.81 6.73a1.08 1.08 0 101.07 1.07 1.07 1.07 0 00-1.07-1.02zm0 2a1 1 0 111-1 1 1 0 01-1 1.13zm-25.55-18.63a1.08 1.08 0 101.08 1.08 1.1 1.1 0 00-1.08-.99zm0 2a1 1 0 110-1.94 1 1 0 110 1.94zm7.23 9.51a1.09 1.09 0 000 2.17 1.09 1.09 0 000-2.17zm0 2.05a1 1 0 010-1.94 1 1 0 010 1.94zm-10.3 10a1.09 1.09 0 101.08 1.2 1.09 1.09 0 00-1.08-1.08zm0 2.05a1 1 0 111-1 1 1 0 01-1 1.15zm-5.67 2.81a1.08 1.08 0 101.09 1.08 1.09 1.09 0 00-1.09-.96zm0 2.05a1 1 0 111-1 1 1 0 01-1 1.12zm-11.25 7.38a1.13 1.13 0 00-.62.19v.16a1 1 0 011.61.72 1 1 0 01-1 1 .93.93 0 01-.83-.49.76.76 0 000 .16 1.05 1.05 0 00.86.44 1.08 1.08 0 100-2.15zm5.61-5.09a1.08 1.08 0 101.08 1.07 1.07 1.07 0 00-1.08-1.07zm0 2a1 1 0 111-1 1 1 0 01-1 1.08zm.51-11.37a1.09 1.09 0 101.09 1.09 1.09 1.09 0 00-1.09-1.01zm0 2.06a1 1 0 010-1.94 1 1 0 010 1.94zm11.83 15.15a1.08 1.08 0 101.07 1.16 1.08 1.08 0 00-1.07-1.08zm0 2a1 1 0 111-1 1 1 0 01-1 1.16zm-11.31-1a1.08 1.08 0 101.08 1.16 1.09 1.09 0 00-1.08-1.06zm0 2.05a1 1 0 111-1 1 1 0 01-1 1.11zm-.52 6.69a1.08 1.08 0 100 2.16 1.08 1.08 0 100-2.16zm0 2a1 1 0 01-1-1 1 1 0 011.94 0 1 1 0 01-.94 1.14zM76 196.81v.12a1 1 0 01-.29 1.85.5.5 0 000 .12 1.08 1.08 0 00.33-2.09zm10.25-.06a1.08 1.08 0 101.09 1.07 1.08 1.08 0 00-1.09-1.07zm0 2a1 1 0 110-1.93 1 1 0 110 1.93zm-11.22 7a1 1 0 00-.35.06.53.53 0 000 .12.9.9 0 01.36-.08 1 1 0 010 1.94.92.92 0 01-.51-.15.29.29 0 000 .13 1 1 0 00.47.23 1.08 1.08 0 100-2.16zm6.42-40.23a.59.59 0 000 .13.95.95 0 01-.37 1.6.43.43 0 010 .12 1.06 1.06 0 00.41-1.85zm9.64-9.12a1.08 1.08 0 101.08 1.07 1.08 1.08 0 00-1.08-1.01zm0 2a1 1 0 111-1 1 1 0 01-1 1.1zm-2.37-12.7a1.09 1.09 0 101.08 1.08 1.08 1.08 0 00-1.08-.98zm0 2a1 1 0 010-1.94 1 1 0 010 1.94zM114.8 119a1 1 0 01-1.92 0 1 1 0 01.13-.51h-.11a1 1 0 00-.14.53 1.08 1.08 0 002.16 0zm5.77 21.12a1.08 1.08 0 101.09 1.08 1.09 1.09 0 00-1.09-1.11zm0 2a1 1 0 111-1 1 1 0 01-1 1.02zm-5.71 11.78a1.08 1.08 0 101.08 1.07 1.08 1.08 0 00-1.08-1.05zm0 2a1 1 0 111-1 1 1 0 01-1 1.1zm-17.27 12.81a1.08 1.08 0 101.08 1.08 1.09 1.09 0 00-1.08-1.08zm0 2a1 1 0 010-1.94 1 1 0 010 1.94zm5.78 2.39a1.09 1.09 0 101.08 1.09 1.1 1.1 0 00-1.08-1.04zm0 2.06a1 1 0 111-1 1 1 0 01-1 1.05zm22.3-2.33a1.08 1.08 0 101.07 1.08 1.08 1.08 0 00-1.07-1.03zm0 2a1 1 0 111-1 1 1 0 01-1 1.09zm12.84 6.23a1 1 0 01-.91.66 1 1 0 010-1.94.9.9 0 01.6.22v-.16a1 1 0 00-.55-.16 1.08 1.08 0 100 2.15 1.07 1.07 0 001-.59 1.54 1.54 0 01-.14-.09zm-4.15 12.5a1.08 1.08 0 101.08 1.08 1.09 1.09 0 00-1.08-.99zm0 2a1 1 0 111-1 1 1 0 01-1 1.14zm2 6.21a1.08 1.08 0 101.08 1.09 1.08 1.08 0 00-1.04-.95zm0 2a1 1 0 111-.95 1 1 0 01-.96 1.18zm4.77-7.83a1.09 1.09 0 101.08 1.08 1.07 1.07 0 00-1.04-.9zm0 2a1 1 0 010-1.94 1 1 0 010 1.94zm-26.71-25a1.09 1.09 0 000 2.17 1.09 1.09 0 000-2.17zm0 2.06a1 1 0 010-1.94 1 1 0 010 1.94zm1 7.58a1.08 1.08 0 000 2.15 1.08 1.08 0 100-2.15zm0 2a1 1 0 010-1.93 1 1 0 110 1.93zm.41 6.77a1.08 1.08 0 100 2.16 1.08 1.08 0 000-2.16zm0 2.05a1 1 0 111-1 1 1 0 01-.94 1.25zm-2-30.37a1.08 1.08 0 101.08 1.07 1.07 1.07 0 00-1.07-.82zm0 2a1 1 0 111-1 1 1 0 01-.99 1.29zm-4.44 3a1.08 1.08 0 101.07 1.08 1.08 1.08 0 00-1.06-.8zm0 2.05a1 1 0 111-1 1 1 0 01-.99 1.28zm-.27 7.94a1.08 1.08 0 101.07 1.08 1.08 1.08 0 00-1.06-.8zm0 2a1 1 0 111-1 1 1 0 01-.99 1.33zm-16.72 2.86a1.08 1.08 0 101.07 1.07 1.07 1.07 0 00-1.06-.74zm0 2a1 1 0 111-1 1 1 0 01-.99 1.37zm6.2 11.5a1.08 1.08 0 101.08 1.07 1.08 1.08 0 00-1.07-.7zm0 2a1 1 0 110-1.93 1 1 0 010 1.93zm-12.87 6.73a1.08 1.08 0 101.08 1.07 1.06 1.06 0 00-1.07-.66zm0 2a1 1 0 010-1.93 1 1 0 110 1.93zm18.8-5.91a1.08 1.08 0 000 2.15 1.08 1.08 0 100-2.15zm0 2a1 1 0 111-1 1 1 0 01-.99 1.49zm6.34 2.12a1.06 1.06 0 00-.82.39h.16a.92.92 0 011.22-.09h.15a1 1 0 00-.7.19zm-29.71-12.69a1.08 1.08 0 101.08 1.07 1.08 1.08 0 00-1.08-1.07zm0 2a1 1 0 110-1.93 1 1 0 110 1.93zm-.65 6.37a1.08 1.08 0 101.08 1.08 1.08 1.08 0 00-1.08-1.08zm0 2a1 1 0 111-1 1 1 0 01-1 1.05zm29.35-15.69a1.09 1.09 0 101.08 1.09 1.08 1.08 0 00-1.08-1.04zm0 2a1 1 0 010-1.93 1 1 0 110 1.93zm-4.86 2.82a1.08 1.08 0 101.07 1.07 1.07 1.07 0 00-1.07-1.07zm0 2a1 1 0 111-1 1 1 0 01-1 1.04zm-6.55 11.64a1.07 1.07 0 00-1.08 1.07 1.64 1.64 0 000 .22h.12a.76.76 0 010-.21 1 1 0 111.93 0 .15.15 0 010 .07h.11a.15.15 0 000-.07 1.07 1.07 0 00-1.09-1.04zm18.86-4.42a1.08 1.08 0 000 2.15 1.08 1.08 0 100-2.15zm0 2a1 1 0 111-1 1 1 0 01-1.01 1.08zm6.87 1.06a1.07 1.07 0 00-1 .74h.12a1 1 0 01.9-.63 1 1 0 01.83.49h.12a1.06 1.06 0 00-.98-.52zm-4.62-73.57a1.08 1.08 0 100 2.15 1.08 1.08 0 100-2.15zm0 2a1 1 0 110-1.93 1 1 0 110 1.93zm-12.2 8.47a1.08 1.08 0 101.08 1.09 1.08 1.08 0 00-1.09-.97zm0 2a1 1 0 110-1.92 1 1 0 110 1.92zm20.42 3.32a1 1 0 01-.78.4 1 1 0 110-1.93.87.87 0 01.28.05v-.14h-.23a1.08 1.08 0 00-1.08 1.07 1.1 1.1 0 001.08 1.09 1 1 0 00.82-.39.5.5 0 00-.1.01zm-25.85 7.86a1.08 1.08 0 101.07 1.08 1.08 1.08 0 00-1.08-.92zm0 2a1 1 0 110-1.94 1 1 0 010 1.94zm0-29.6a1.09 1.09 0 101.07 1.08 1.08 1.08 0 00-1.08-.87zm0 2.05a1 1 0 010-1.94 1 1 0 010 1.94zm-.26-9.2a.21.21 0 00-.1.06 1 1 0 010 .19 1 1 0 01-1 1 .92.92 0 01-.57.01l-.1.07a1.06 1.06 0 00.69.25 1.08 1.08 0 001.08-1.07 1 1 0 00-.01-.25zm-11.22 16.64a.61.61 0 000 .12.93.93 0 01.63.89 1 1 0 01-1 1 .89.89 0 01-.39-.09.42.42 0 000 .12 1.22 1.22 0 00.43.09 1.08 1.08 0 00.39-2.09zm29.44-10.27a1 1 0 01-.57-.88.58.58 0 01.05-.26 1.18 1.18 0 01-.08-.16 1.16 1.16 0 00-.08.42 1.07 1.07 0 00.75 1 1.07 1.07 0 00-.07-.12zm-13.56-4.2a1.08 1.08 0 100 2.16 1.08 1.08 0 000-2.16zm0 2a1 1 0 111-1 1 1 0 01-1 1.09zm6.49 12a1.08 1.08 0 00-1.08 1.08 1.08 1.08 0 002.15 0 1.08 1.08 0 00-1.07-.99zm0 2a1 1 0 111-1 1 1 0 01-1 1.09zm8.18 11.48a1.08 1.08 0 101.07 1.09 1.08 1.08 0 00-1.07-1.09zm0 2a1 1 0 111-1 1 1 0 01-1 1.04zm9.18 6.42a1.09 1.09 0 101.08 1.09 1.09 1.09 0 00-1.04-1.05zm0 2.05a1 1 0 111-1 1 1 0 01-.96 1.04zm6.16 14a1 1 0 01-.3-.7.45.45 0 010-.2.7.7 0 01-.06-.19.9.9 0 00-.09.4 1 1 0 00.47.89zm-16.54-15.33a1.08 1.08 0 101.09 1.09 1.09 1.09 0 00-1.05-1.04zm0 2a1 1 0 111-1 1 1 0 01-.96 1.09zm.4 7.69a1.08 1.08 0 101.09 1.08 1.09 1.09 0 00-1.05-.99zm0 2.05a1 1 0 111-1 1 1 0 01-.96 1.09zm10.32-2.68a1.09 1.09 0 101.09 1.08 1.08 1.08 0 00-1.05-.99zm0 2a1 1 0 111-1 1 1 0 01-.96 1.14zm-10 7.55a1.08 1.08 0 100 2.16 1.08 1.08 0 100-2.16zm0 2a1 1 0 111-1 1 1 0 01-.95 1.18zm-17.2 3.89a1.08 1.08 0 000 2.16 1.08 1.08 0 100-2.16zm0 2a1 1 0 111-1 1 1 0 01-.95 1.22zm-11.26 7.38a1.08 1.08 0 101.08 1.07 1.07 1.07 0 00-1.03-.85zm0 2a1 1 0 111-1 1 1 0 01-.95 1.26zm0 6.84a1.08 1.08 0 101.08 1.07 1.07 1.07 0 00-1.03-.81zm0 2a1 1 0 110-1.92 1 1 0 110 1.92zM127 181.16a1.09 1.09 0 101.08 1.08 1.09 1.09 0 00-1.08-1.08zm0 2.05a1 1 0 111-1 1 1 0 01-1 1zm12.65 4.85a1.08 1.08 0 101.08 1.08 1.08 1.08 0 00-1.09-1.08zm0 2.05a1 1 0 111-1 1 1 0 01-1.01 1zm-11.63.47a1.08 1.08 0 101.08 1.08 1.08 1.08 0 00-1.1-1.08zm0 2a1 1 0 010-1.94 1 1 0 110 1.94zm-5.73-5.6a1.09 1.09 0 000 2.17 1.09 1.09 0 100-2.17zm0 2.05a1 1 0 111-1 1 1 0 01-1.01 1.05zm-11.4 7.67a1.08 1.08 0 101.09 1.07 1.08 1.08 0 00-1.1-1.02zm0 2a1 1 0 110-1.93 1 1 0 110 1.93zm21.18-22.1a1.08 1.08 0 00-1.08 1.08 1.08 1.08 0 002.16 0 1.09 1.09 0 00-1.09-.99zm0 2a1 1 0 111-1 1 1 0 01-1.01 1.13zm1.27 6.59a1.08 1.08 0 101.09 1.08 1.08 1.08 0 00-1.1-.95zm0 2a1 1 0 111-1 1 1 0 01-1.01 1.17zm-11.05 8.36a1.08 1.08 0 101.09 1.08 1.07 1.07 0 00-1.1-.91zm0 2a1 1 0 010-1.93 1 1 0 110 1.93zm7 1.19a1.08 1.08 0 101.07 1.07 1.08 1.08 0 00-1.06-.81zm0 2a1 1 0 111-1 1 1 0 01-.99 1.26z"
          style={{
            WebkitTransformOrigin: 108.366,
            MsTransformOrigin: 108.366,
            transformOrigin: 108.366,
          }}
          fill="#030402"
          className="animable"
          opacity="0.2"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 164.505,
            MsTransformOrigin: 164.505,
            transformOrigin: 164.505,
          }}
          fill="#FFF"
          d="M147.68 187.29H181.33V191.10999999999999H147.68z"
          className="animable"
          transform="rotate(-55.14)"
        ></path>
        <path
          d="M94.77 125.77C83 141.05 56.22 181.4 63.36 189.66c11.74 13.58 40.48 25.54 49.45 28.23 3.88 1.16 17.65-27 14-29.37-4.38-2.77-33.3-12.17-33.14-14.81.08-1.5 3.88-17.64 7-33.72 3.5-18.64-1.87-19.45-5.9-14.22z"
          style={{
            WebkitTransformOrigin: 94.7938,
            MsTransformOrigin: 94.7938,
            transformOrigin: 94.7938,
          }}
          fill="#EB9481"
          className="animable"
        ></path>
        <path
          d="M112.7 186.55s11.8-3.46 19.62-5.36c4.37-1.06 12-2.21 15.58-1.52 5.33 1 27 8.74 25.21 14-1.59 4.79-19.34-4.2-19.34-4.2s18.71 7.48 15.74 12.89-21.68-7.4-21.68-7.4 19 8.12 15.11 13.21c-3 3.85-20.58-6.81-20.58-6.81s16.33 7.1 13.43 11.19c-3.21 4.52-20.06-4.3-20.06-4.3-9.12 9.16-17.21 9.79-23 9.55-1.42-.03-.03-31.25-.03-31.25z"
          style={{
            WebkitTransformOrigin: 142.653,
            MsTransformOrigin: 142.653,
            transformOrigin: 142.653,
          }}
          fill="#EB9481"
          className="animable"
        ></path>
        <path
          d="M148.34 186.87c14.2 4.46 19.8 11 19.62 10.86-4.35-3.4-12-7.08-14.14-8.07s-3.37-1.66-5.52-2.66c-.05-.07-.01-.14.04-.13z"
          style={{
            WebkitTransformOrigin: 158.121,
            MsTransformOrigin: 158.121,
            transformOrigin: 158.121,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M143.74 194.19a50.81 50.81 0 0116.26 7.59c.18.15.08.19-.13.08-2.7-1.34-13.41-6.4-16.16-7.6-.05-.02-.02-.08.03-.07z"
          style={{
            WebkitTransformOrigin: 151.889,
            MsTransformOrigin: 151.889,
            transformOrigin: 151.889,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M139.34 200.23a37.45 37.45 0 0112.41 6.24c.19.14 0 .2-.18.09-4.09-2.16-7.28-3.88-12.28-6.18-.08-.04-.04-.19.05-.15z"
          style={{
            WebkitTransformOrigin: 145.538,
            MsTransformOrigin: 145.538,
            transformOrigin: 145.538,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M109.59 180.66L94.72 213s-31.45-15-33.64-26.62 26.23-52.37 31.64-59c1.54-1.88 5.72-6.16 7.76-5.66 2.29.55 2.07 3.93 2 11.73-.16 10.4-8.26 39-7.64 40.18s14.75 7.03 14.75 7.03z"
          style={{
            WebkitTransformOrigin: 85.275,
            MsTransformOrigin: 85.275,
            transformOrigin: 85.275,
          }}
          fill="#1DD21D"
          className="animable"
        ></path>
        <path
          d="M96.21 123.75s-.06.07-.09.08a.93.93 0 01.38.77 1 1 0 01-1 1 1 1 0 01-.81-.44l-.09.09a1.09 1.09 0 00.9.46 1.06 1.06 0 001.07-1.07 1.09 1.09 0 00-.36-.89zm-2 17.68a1.08 1.08 0 101.08 1.09 1.09 1.09 0 00-1.11-1.09zm0 2a1 1 0 110-1.92 1 1 0 110 1.92zm-9.85-2.7a1.08 1.08 0 101.08 1.08 1.09 1.09 0 00-1.11-1.04zm0 2a1 1 0 111-1 1 1 0 01-1.03 1.08zm10.87 7.76a1.08 1.08 0 101.08 1.07 1.08 1.08 0 00-1.11-.99zm0 2a1 1 0 110-1.93 1 1 0 010 1.93zm-10.48-.18a1.08 1.08 0 101.08 1.07 1.07 1.07 0 00-1.11-.95zm0 2a1 1 0 111-1 1 1 0 01-1.03 1.16zm-5-7.64a1.08 1.08 0 101.08 1.08 1.07 1.07 0 00-1.1-.92zm0 2a1 1 0 111-1 1 1 0 01-1.02 1.2zm16.83-16.94a1.09 1.09 0 101.06 1.27 1.09 1.09 0 00-1.08-1.07zm0 2.06a1 1 0 010-1.94 1 1 0 110 1.94zm3.87 11.57a1.08 1.08 0 00-1.09 1.08 1.06 1.06 0 001 1.06.45.45 0 000-.11 1 1 0 01-.9-1 1 1 0 011-1 1.07 1.07 0 01.3.06.35.35 0 010-.11 1 1 0 00-.33.22zm-8.75 28.22a1.08 1.08 0 101.07 1.09 1.08 1.08 0 00-1.09-.89zm0 2a1 1 0 111-.95 1 1 0 01-1.02 1.19zm-10.73 7a1.08 1.08 0 101.03 1.28 1.07 1.07 0 00-1-1.07zm0 2a1 1 0 111-1 1 1 0 01-.97 1.25zm-12.16-10.8a1.08 1.08 0 101.08 1.09 1.07 1.07 0 00-1.08-1.09zm0 2a1 1 0 110-1.92 1 1 0 110 1.92zm6.51-5.78a1.08 1.08 0 000 2.16 1.08 1.08 0 100-2.16zm0 2a1 1 0 111-1 1 1 0 01-1 1.08zm22.76 15.28a1.09 1.09 0 101.07 1.09 1.09 1.09 0 00-1.07-1.01zm0 2a1 1 0 111-1 1 1 0 01-1 1.13zm2-52.08a1.08 1.08 0 101.08 1.08 1.1 1.1 0 00-1.04-.95zm0 2a1 1 0 110-1.94 1 1 0 110 1.94zm-3.07 21.54a1.08 1.08 0 00-.16 2.15v-.11a1 1 0 01.14-1.93 1 1 0 01.31.06.36.36 0 010-.11.92.92 0 00-.25.12zm-5.67 4.86a1.08 1.08 0 101.09 1.08 1.09 1.09 0 00-1.05-.9zm0 2.05a1 1 0 111-1 1 1 0 01-.96 1.18zm-11.25 7.38a1.08 1.08 0 101.08 1.07 1.07 1.07 0 00-1.04-.89zm0 2a1 1 0 111-1 1 1 0 01-.96 1.22zm5.65-7.03a1.08 1.08 0 101.08 1.07 1.07 1.07 0 00-1.08-1.07zm0 2a1 1 0 111-1 1 1 0 01-1 1.08zm.51-11.37a1.09 1.09 0 101.09 1.09 1.09 1.09 0 00-1.09-1.01zm0 2.06a1 1 0 010-1.94 1 1 0 010 1.94zm-6.52-5.5a1.09 1.09 0 101.08 1.08 1.08 1.08 0 00-1.08-1zm0 2a1 1 0 111-1 1 1 0 01-1 1.13zm18.35 18.6a1.08 1.08 0 101.07 1.21 1.08 1.08 0 00-1.07-1.08zm0 2a1 1 0 111-1 1 1 0 01-1 1.21zm-11.31-1a1.08 1.08 0 101.08 1.21 1.09 1.09 0 00-1.08-1.06zm0 2.05a1 1 0 111-1 1 1 0 01-1 1.16zm-10.89 6.37a1.09 1.09 0 101.12 1.24 1.09 1.09 0 00-1.12-1.09zm0 2a1 1 0 111-1 1 1 0 01-1 1.2zM67.35 184a1.09 1.09 0 101.07 1.09 1.09 1.09 0 00-1.07-1.09zm0 2.06a1 1 0 111-1 1 1 0 01-1 1.03zm18.9 1.59a1.08 1.08 0 100 2.16 1.08 1.08 0 100-2.16zm0 2a1 1 0 01-1-1 1 1 0 011.94 0 1 1 0 01-.94 1.07zm-12.6-10.44a1.08 1.08 0 101.09 1.08 1.08 1.08 0 00-1.09-1.01zm0 2a1 1 0 010-1.93 1 1 0 110 1.93zm-10.45-2.5a1.08 1.08 0 101.07 1.07 1.08 1.08 0 00-1.07-1.07zm0 2a1 1 0 01-1-1 1 1 0 111.92 0 1 1 0 01-.92 1.04zm6.19-15a1.08 1.08 0 101.08 1.08 1.09 1.09 0 00-1.08-1.01zm0 2.05a1 1 0 111-1 1 1 0 01-1 1.07zm6.24 28.92a1.08 1.08 0 101.08 1.07 1.08 1.08 0 00-1.08-1zm0 2a1 1 0 110-1.93 1 1 0 010 1.93zm10.62-2a1.08 1.08 0 101.09 1.07 1.08 1.08 0 00-1.09-1zm0 2a1 1 0 110-1.93 1 1 0 110 1.93zm-5.49-33.47a1.08 1.08 0 101.08 1.08 1.08 1.08 0 00-1.08-.97zm0 2a1 1 0 111-1 1 1 0 01-1 1.15zm-6.08-6.06a1.08 1.08 0 101.08 1.08 1.09 1.09 0 00-1.08-.93zm0 2a1 1 0 111-1 1 1 0 01-1 1.2zm.9-10.89a.27.27 0 01-.06.1 1 1 0 01.77.94 1 1 0 01-1 1 1 1 0 01-.74-.36.3.3 0 00-.06.11 1.06 1.06 0 00.8.36 1.08 1.08 0 00.26-2.12zm15.51 4a1.08 1.08 0 101.08 1.07 1.08 1.08 0 00-1.08-.87zm0 2a1 1 0 111-1 1 1 0 01-1 1.24zm-2.37-12.7a1.09 1.09 0 101.08 1.08 1.08 1.08 0 00-1.08-.84zm0 2a1 1 0 010-1.94 1 1 0 010 1.94zm2.39-18.46a.71.71 0 01-.07.09 1 1 0 01-.61 1.71.88.88 0 01-.53-.16.61.61 0 01-.07.1 1.11 1.11 0 00.6.18 1.09 1.09 0 001.08-1.09 1.1 1.1 0 00-.4-.54zm17.24 50.73a1 1 0 00.78.34c-.21.2-.47.1-.78-.05zm-15.94 3.09a1.08 1.08 0 101.07 1.07 1.07 1.07 0 00-1.07-.78zm0 2a1 1 0 111-1 1 1 0 01-1 1.33zm6.2 11.5a1.08 1.08 0 101.08 1.07 1.08 1.08 0 00-1.08-.74zm0 2a1 1 0 110-1.93 1 1 0 010 1.93zm-12.87 6.73a1.08 1.08 0 101.08 1.07 1.06 1.06 0 00-1.08-.7zm0 2a1 1 0 010-1.93 1 1 0 110 1.93zm-4.58-14.93a1.08 1.08 0 101.08 1.07 1.08 1.08 0 00-1.08-.66zm0 2a1 1 0 110-1.93 1 1 0 110 1.93zm-11.33-3.12a1.08 1.08 0 101.09 1.09 1.08 1.08 0 00-1.09-1.09zm0 2a1 1 0 111-.95 1 1 0 01-1 .99zm10.68 7.9a1.08 1.08 0 101.08 1.08 1.08 1.08 0 00-1.08-1.08zm0 2a1 1 0 111-1 1 1 0 01-1 1.05zM98 205.93a1 1 0 00-.6.95 1.18 1.18 0 000 .27l.09-.19a.19.19 0 010-.08.93.93 0 01.41-.78zm4-78.72a.84.84 0 01.57.21.75.75 0 000-.15 1 1 0 00-.57-.17 1.09 1.09 0 000 2.17 1 1 0 00.57-.17.38.38 0 000-.15.88.88 0 01-.57.2 1 1 0 010-1.94zm-11.86 9.1a1.08 1.08 0 000 2.16 1.08 1.08 0 100-2.16zm0 2a1 1 0 111-1 1 1 0 01-1.08 1.04zm13.31 44.86a1.08 1.08 0 000 2.16 1.08 1.08 0 100-2.16zm0 2a1 1 0 111-1 1 1 0 01-1.08 1.08zm-11.26 7.38a1.08 1.08 0 101.08 1.07 1.07 1.07 0 00-1.16-.99zm0 2a1 1 0 111-1 1 1 0 01-1.08 1.12zm0 6.84a1.08 1.08 0 101.08 1.07 1.07 1.07 0 00-1.16-.95zm0 2a1 1 0 110-1.92 1 1 0 110 1.92zm-.43 5.94a1.08 1.08 0 00-1.08 1.09.92.92 0 000 .29l.15.08a.77.77 0 01-.08-.37 1 1 0 111.18.94l.13.07a1.05 1.05 0 00.73-1 1.08 1.08 0 00-1.11-.94z"
          style={{
            WebkitTransformOrigin: 85.62,
            MsTransformOrigin: 85.62,
            transformOrigin: 85.62,
          }}
          fill="#030402"
          className="animable"
          opacity="0.2"
        ></path>
        <path
          d="M89.8 206.93c.69-1 1.18-2.2 1.77-3.29s1.13-2.21 1.67-3.33c1-2.16 2.05-4.33 3.05-6.5l3-6.54c1-2.25 2.17-4.5 3-6.82 0-.11-.1-.18-.16-.08-1.26 2.13-2.25 4.44-3.34 6.67s-2.14 4.38-3.2 6.58-2.11 4.4-3.13 6.61c-.5 1.09-1 2.18-1.44 3.29a35.69 35.69 0 00-1.37 3.35c-.03.13.1.13.15.06z"
          style={{
            WebkitTransformOrigin: 95.9678,
            MsTransformOrigin: 95.9678,
            transformOrigin: 95.9678,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M85.52 208c-1.59-1.17-3.34-2.18-5-3.19s-3.55-2-5.22-3.18c-.09 0-.16.08-.08.14 1.67 1.21 3.27 2.47 5 3.58a26.5 26.5 0 005.29 2.73s.04-.08.01-.08z"
          style={{
            WebkitTransformOrigin: 80.3581,
            MsTransformOrigin: 80.3581,
            transformOrigin: 80.3581,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M109.86 180.25c-1.25-.66-14.5-6.19-14.69-6.35-.41-.35 2.66-12.85 3.87-18.7.09-.41.16-.82.25-1.24.26-.59.53-1.18.8-1.78.42-.94.76-1.91 1.12-2.87 0 0 0-.05-.06 0-.45.93-.93 1.86-1.31 2.82l-.36.86c.52-2.59 1-5.19 1.53-7.79 0 0-.05-.05-.06 0-1.56 6.15-3.11 12.29-4.52 18.48-.35 1.53-2 9-2.1 10.56-.06.66 14 5.91 15.18 6.35-.06.19-.12.38-.19.56s.1.12.15.06c.14-.21.28-.42.44-.62a.2.2 0 00-.05-.34z"
          style={{
            WebkitTransformOrigin: 102.157,
            MsTransformOrigin: 102.157,
            transformOrigin: 102.157,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M114.38 130c-3.5.58-9.81-5.56-11.86-10-.14-.3.51-3.36 1.13-7.12.36-2.27.72-4.82.87-7.17l14.48 4.51a37.31 37.31 0 00-2 8.91 4.37 4.37 0 000 1v.16c.21 1.82.77 9.08-2.62 9.71z"
          style={{
            WebkitTransformOrigin: 110.75,
            MsTransformOrigin: 110.75,
            transformOrigin: 110.75,
          }}
          fill="#EB9481"
          className="animable"
        ></path>
        <path
          d="M117 120.1v.16a9.69 9.69 0 01-1.52 0c-8.7-.77-10.07-11.71-10.27-14.35l13.79 4.31a37.31 37.31 0 00-2 8.91 4.37 4.37 0 000 .97z"
          style={{
            WebkitTransformOrigin: 112.105,
            MsTransformOrigin: 112.105,
            transformOrigin: 112.105,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M101 91.38c-1 5.38 3.56 20.06 7.65 23 5.93 4.21 14.75 3.63 18.11-3.29 3.25-6.72-3-25.74-7.47-28.29-6.6-3.8-16.85.63-18.29 8.58z"
          style={{
            WebkitTransformOrigin: 114.261,
            MsTransformOrigin: 114.261,
            transformOrigin: 114.261,
          }}
          fill="#EB9481"
          className="animable"
        ></path>
        <path
          d="M116.06 99.65s-.07.07 0 .11c.33 1 .54 2.16-.25 2.76v.06c1.02-.49.72-2.05.25-2.93z"
          style={{
            WebkitTransformOrigin: 116.152,
            MsTransformOrigin: 116.152,
            transformOrigin: 116.152,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M114.86 98.89c-1.63.36-.79 3.59.72 3.26s.65-3.57-.72-3.26z"
          style={{
            WebkitTransformOrigin: 115.175,
            MsTransformOrigin: 115.175,
            transformOrigin: 115.175,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M121.73 97.8s.09 0 .1.07c.23 1 .66 2.13 1.65 2.22v.06c-1.13.13-1.69-1.35-1.75-2.35z"
          style={{
            WebkitTransformOrigin: 122.605,
            MsTransformOrigin: 122.605,
            transformOrigin: 122.605,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M122.35 96.52c1.58-.54 2.55 2.66 1.09 3.16S121 97 122.35 96.52z"
          style={{
            WebkitTransformOrigin: 122.933,
            MsTransformOrigin: 122.933,
            transformOrigin: 122.933,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M113.2 97.74c.41-.22.75-.5 1.14-.76a2.29 2.29 0 001-1 .72.72 0 00-.33-.8 1.75 1.75 0 00-1.75.27 2.61 2.61 0 00-1.16 1.45.76.76 0 001.1.84z"
          style={{
            WebkitTransformOrigin: 113.722,
            MsTransformOrigin: 113.722,
            transformOrigin: 113.722,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M123.18 94.57a12.52 12.52 0 01-1.37 0 2.18 2.18 0 01-1.4-.26.7.7 0 01-.18-.85 1.76 1.76 0 011.6-.76 2.56 2.56 0 011.77.56.75.75 0 01-.42 1.31z"
          style={{
            WebkitTransformOrigin: 122.006,
            MsTransformOrigin: 122.006,
            transformOrigin: 122.006,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M117.55 108.84a1.6 1.6 0 001 .37 2.82 2.82 0 001-.54h.06a1.39 1.39 0 01-1.13.88 1.12 1.12 0 01-1-.68c-.05-.02.02-.06.07-.03z"
          style={{
            WebkitTransformOrigin: 118.536,
            MsTransformOrigin: 118.536,
            transformOrigin: 118.536,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M117.82 105.57a3.51 3.51 0 002.67.92 4.42 4.42 0 001.24-.26l.22-.09.21-.09a.26.26 0 00.15-.28 1 1 0 010-.1v-.09c-.18-.78-.56-1.93-.56-1.93.32.07 1.92.34 1.8-.06a52.93 52.93 0 00-4-10 .09.09 0 00-.17.08c.9 3.19 2.36 6.2 3.31 9.4a6 6 0 00-1.73-.07c-.1.06.77 2.21.83 2.57a4.9 4.9 0 01-3.81-.18c-.18.02-.25.11-.16.18z"
          style={{
            WebkitTransformOrigin: 120.669,
            MsTransformOrigin: 120.669,
            transformOrigin: 120.669,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M121.17 106a4.18 4.18 0 01-1.29 1.68 1.92 1.92 0 01-1.09.36c-.85 0-1.06-.73-1.08-1.4a4.19 4.19 0 01.11-1 5.36 5.36 0 003.35.36z"
          style={{
            WebkitTransformOrigin: 119.44,
            MsTransformOrigin: 119.44,
            transformOrigin: 119.44,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M119.88 107.63a1.92 1.92 0 01-1.09.36c-.85 0-1.06-.73-1.08-1.4a2 2 0 012.17 1.04z"
          style={{
            WebkitTransformOrigin: 118.795,
            MsTransformOrigin: 118.795,
            transformOrigin: 118.795,
          }}
          fill="#FF99BA"
          className="animable"
        ></path>
        <path
          d="M103.52 105.73s-6.47-8.3-6.58-13.53c0-2.36 3-4.31 3-4.31a5.33 5.33 0 011-5.51c2.46-2.93 9.22-3.14 9.22-3.14s3.59-6.78 10-5 3.26 9.19 3.26 9.19 2.63 2.93-2.57 6.08-16.3 2-16.3 2a38.51 38.51 0 011.18 11.36 3.51 3.51 0 01-2.21 2.86z"
          style={{
            WebkitTransformOrigin: 110.567,
            MsTransformOrigin: 110.567,
            transformOrigin: 110.567,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M111.21 79.19a10.93 10.93 0 00-4.41-.27A11.76 11.76 0 00103 80a6.5 6.5 0 00-4 5.38 4.59 4.59 0 001.26 3.3s.09 0 0-.07c-1.62-1.58-1.2-4.4.09-6a9.81 9.81 0 016.19-3.16 19.5 19.5 0 014.58-.06.07.07 0 00.09-.2z"
          style={{
            WebkitTransformOrigin: 105.136,
            MsTransformOrigin: 105.136,
            transformOrigin: 105.136,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M124.9 76.65a5.27 5.27 0 00-4-2.91 9 9 0 00-5.78.89 11.42 11.42 0 00-4.34 4.08s0 .08.07.05a10 10 0 019.07-4.66 4.89 4.89 0 014.65 6.79 10.22 10.22 0 01-3.48 4.43v.05a10.43 10.43 0 003.53-3.82 5.92 5.92 0 00.28-4.9z"
          style={{
            WebkitTransformOrigin: 118.041,
            MsTransformOrigin: 118.041,
            transformOrigin: 118.041,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M122.21 89.61a18.54 18.54 0 01-7.56 2.26 38.58 38.58 0 01-8.25-.15c-1.59-.19-3.18-.44-4.76-.72-.06 0-.07.06 0 .08a42.08 42.08 0 008.62 1.58 20.94 20.94 0 008-1 17.71 17.71 0 004-2s-.02-.06-.05-.05z"
          style={{
            WebkitTransformOrigin: 111.926,
            MsTransformOrigin: 111.926,
            transformOrigin: 111.926,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M114.77 105.56a4.83 4.83 0 113.88-6.56 4.83 4.83 0 01-3.88 6.55zm-1.13-8.93a4 4 0 00-1 .25 4.22 4.22 0 101-.25z"
          style={{
            WebkitTransformOrigin: 114.154,
            MsTransformOrigin: 114.154,
            transformOrigin: 114.154,
          }}
          fill="#1DD21D"
          className="animable"
        ></path>
        <path
          d="M125.5 102.85c-1.83.23-3.73-1.44-4.33-3.88a5.73 5.73 0 01.18-3.52 3 3 0 015-1.24 5.71 5.71 0 011.8 3c.64 2.58-.4 5.07-2.33 5.55zM123.89 94h-.24a2.57 2.57 0 00-1.71 1.64 5.13 5.13 0 00-.15 3.12c.56 2.24 2.28 3.75 3.87 3.35s2.41-2.53 1.86-4.76a5.17 5.17 0 00-1.59-2.69 2.68 2.68 0 00-2.04-.66z"
          style={{
            WebkitTransformOrigin: 124.657,
            MsTransformOrigin: 124.657,
            transformOrigin: 124.657,
          }}
          fill="#1DD21D"
          className="animable"
        ></path>
        <path
          d="M118.63 99.59l-.52-.38c.56-.77 2-2 3.45-1l-.35.54c-1.3-.89-2.53.77-2.58.84z"
          style={{
            WebkitTransformOrigin: 119.835,
            MsTransformOrigin: 119.835,
            transformOrigin: 119.835,
          }}
          fill="#1DD21D"
          className="animable"
        ></path>
        <path
          d="M98.05 106l-.62-.15c.07-.29.72-2.87 2.06-3.44s9.85-1.82 10.21-1.88l.1.64c-2.47.37-9.09 1.42-10.06 1.83s-1.52 2.25-1.69 3z"
          style={{
            WebkitTransformOrigin: 103.615,
            MsTransformOrigin: 103.615,
            transformOrigin: 103.615,
          }}
          fill="#1DD21D"
          className="animable"
        ></path>
        <path
          d="M105.67 103.23s-4.06-4.37-6.09-2.86 1.5 8.18 4.21 8.78a2.65 2.65 0 003.32-1.9z"
          style={{
            WebkitTransformOrigin: 103.044,
            MsTransformOrigin: 103.044,
            transformOrigin: 103.044,
          }}
          fill="#EB9481"
          className="animable"
        ></path>
        <path
          d="M100.64 102.26v.07c1.91.48 3.09 2 4 3.67a1.46 1.46 0 00-2.22-.1.06.06 0 00.06.09 1.61 1.61 0 011.85.32 7.43 7.43 0 011 1.32c.11.15.39 0 .3-.16-.24-2.35-2.48-5.33-4.99-5.21z"
          style={{
            WebkitTransformOrigin: 103.144,
            MsTransformOrigin: 103.144,
            transformOrigin: 103.144,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M117.09 120l-3.59 8.66-10.68-11.13-3.1 3.5s10.37 17.6 10.44 16.81l3.67-7.46 5.12 5.28-.27-13.1z"
          style={{
            WebkitTransformOrigin: 109.335,
            MsTransformOrigin: 109.335,
            transformOrigin: 109.335,
          }}
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M119.18 129.19c-.12-2.16-.17-4.34-.39-6.5 0-.07-.13-.11-.15 0-.45 2.08 0 10.34 0 12.32-.21-.23-4.74-4.65-4.79-4.58-.79 1.18-3.48 6.61-3.66 7.11-1.64-2.8-7.94-13-9.88-15.61-.06-.08-.18 0-.13.07 1.44 3 9.76 16.64 9.89 16.6a84.49 84.49 0 003.84-7.88c.76 1 5.33 5.94 5.35 5.61a67.27 67.27 0 00-.08-7.14z"
          style={{
            WebkitTransformOrigin: 109.744,
            MsTransformOrigin: 109.744,
            transformOrigin: 109.744,
          }}
          fill="#263238"
          className="animable"
        ></path>
      </g>
      <g
        className="animable"
        style={{
          WebkitTransformOrigin: 215.93,
          MsTransformOrigin: 215.93,
          transformOrigin: 215.93,
        }}
      >
        <path
          style={{
            WebkitTransformOrigin: 215.93,
            MsTransformOrigin: 215.93,
            transformOrigin: 215.93,
          }}
          fill="#455A64"
          d="M134.99 326.41H296.87V333.99H134.99z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 215.935,
            MsTransformOrigin: 215.935,
            transformOrigin: 215.935,
          }}
          fill="#455A64"
          d="M141.74 333.99H290.13V354.09000000000003H141.74z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 155.33,
            MsTransformOrigin: 155.33,
            transformOrigin: 155.33,
          }}
          fill="#455A64"
          d="M158.17 465.76L152.5 465.76 150.36 354.09 160.3 354.09 158.17 465.76z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 155.33,
            MsTransformOrigin: 155.33,
            transformOrigin: 155.33,
          }}
          fill="#263238"
          d="M160.3 354.09L160.15 362.44 150.51 362.44 150.36 354.09 160.3 354.09z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 276.535,
            MsTransformOrigin: 276.535,
            transformOrigin: 276.535,
          }}
          fill="#455A64"
          d="M273.7 465.76L279.37 465.76 281.5 354.09 271.57 354.09 273.7 465.76z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 276.53,
            MsTransformOrigin: 276.53,
            transformOrigin: 276.53,
          }}
          fill="#263238"
          d="M271.56 354.09L271.71 362.44 281.36 362.44 281.5 354.09 271.56 354.09z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 215.94,
            MsTransformOrigin: 215.94,
            transformOrigin: 215.94,
          }}
          fill="#263238"
          d="M141.74 333.99H290.14V338.92H141.74z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 210.51,
            MsTransformOrigin: 210.51,
            transformOrigin: 210.51,
          }}
          fill="#1DD21D"
          d="M185.98 323.48H235.04V326.42H185.98z"
          className="animable"
        ></path>
        <path
          d="M188.58 323.48h46.47v-2.83s-.48-.3-1.38-.77c-.63-.33-1.46-.72-2.47-1.14a34.79 34.79 0 00-12.93-2.74c-9.65-.12-24.77 4.26-24.77 4.26z"
          style={{
            WebkitTransformOrigin: 211.815,
            MsTransformOrigin: 211.815,
            transformOrigin: 211.815,
          }}
          fill="#EBEBEB"
          className="animable"
        ></path>
        <path
          d="M235.05 321.45c-2.36-3.15-6.08-5.05-9.84-6.17a31.16 31.16 0 00-11.76-.94 74.31 74.31 0 00-11.52 2.06l-5.62 1.52c-1.85.58-3.71 1.11-5.56 1.72 3.85-.54 7.65-1.33 11.45-2s7.58-1.37 11.39-1.67a35.74 35.74 0 0111.31.53 24.34 24.34 0 015.38 1.81 16.79 16.79 0 014.77 3.14z"
          style={{
            WebkitTransformOrigin: 212.9,
            MsTransformOrigin: 212.9,
            transformOrigin: 212.9,
          }}
          fill="#EBEBEB"
          className="animable"
        ></path>
        <path
          d="M235.05 321.72a39.91 39.91 0 00-9.86-3.43 37.1 37.1 0 00-10.46-.87 78.66 78.66 0 00-10.37 1.46q-5.12 1-10.12 2.57c1.7-.38 3.4-.71 5.11-1s3.42-.66 5.13-.93a92 92 0 0110.3-1.28 39.54 39.54 0 0110.29.66 49.35 49.35 0 015.06 1.16 37 37 0 014.92 1.66z"
          style={{
            WebkitTransformOrigin: 214.645,
            MsTransformOrigin: 214.645,
            transformOrigin: 214.645,
          }}
          fill="#DBDBDB"
          className="animable"
        ></path>
        <path
          d="M235.05 322c-3.52-.74-7.08-1.35-10.67-1.76a51.38 51.38 0 00-5.42-.37c-1.81 0-3.62.06-5.42.16-3.61.26-7.19.62-10.77 1.09s-7.13 1-10.68 1.69l10.75-1.08c3.58-.33 7.16-.7 10.75-.89q2.68-.19 5.37-.24c1.78 0 3.57.14 5.36.26 3.58.33 7.16.73 10.73 1.14z"
          style={{
            WebkitTransformOrigin: 213.57,
            MsTransformOrigin: 213.57,
            transformOrigin: 213.57,
          }}
          fill="#DBDBDB"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 259.58,
            MsTransformOrigin: 259.58,
            transformOrigin: 259.58,
          }}
          fill="#1DD21D"
          d="M235.05 323.48H284.11V326.42H235.05z"
          className="animable"
        ></path>
        <path
          d="M281.52 323.48h-46.47v-2.83s.48-.3 1.38-.77c.64-.33 1.46-.72 2.47-1.14a34.79 34.79 0 0112.93-2.74c9.65-.12 24.77 4.26 24.77 4.26z"
          style={{
            WebkitTransformOrigin: 258.285,
            MsTransformOrigin: 258.285,
            transformOrigin: 258.285,
          }}
          fill="#EBEBEB"
          className="animable"
        ></path>
        <path
          d="M235.05 321.45c2.36-3.15 6.09-5.05 9.84-6.17a31.16 31.16 0 0111.76-.94 74.31 74.31 0 0111.52 2.06l5.62 1.52c1.85.58 3.71 1.11 5.56 1.72-3.85-.54-7.65-1.33-11.44-2s-7.59-1.37-11.4-1.67a35.75 35.75 0 00-11.31.53 24.34 24.34 0 00-5.38 1.81 16.79 16.79 0 00-4.77 3.14z"
          style={{
            WebkitTransformOrigin: 257.2,
            MsTransformOrigin: 257.2,
            transformOrigin: 257.2,
          }}
          fill="#EBEBEB"
          className="animable"
        ></path>
        <path
          d="M235.05 321.72a39.91 39.91 0 019.86-3.43 37.1 37.1 0 0110.46-.87 78.42 78.42 0 0110.37 1.46q5.13 1 10.12 2.57c-1.7-.38-3.4-.71-5.11-1s-3.41-.66-5.13-.93a92 92 0 00-10.3-1.28 39.54 39.54 0 00-10.29.66A49.35 49.35 0 00240 320a37.54 37.54 0 00-4.95 1.72z"
          style={{
            WebkitTransformOrigin: 255.455,
            MsTransformOrigin: 255.455,
            transformOrigin: 255.455,
          }}
          fill="#DBDBDB"
          className="animable"
        ></path>
        <path
          d="M235.05 322c3.53-.74 7.08-1.35 10.67-1.76a51.56 51.56 0 015.42-.37c1.81 0 3.62.06 5.42.16q5.42.39 10.77 1.09t10.67 1.73l-10.75-1.08c-3.58-.33-7.16-.7-10.75-.89q-2.69-.19-5.37-.24c-1.78 0-3.57.14-5.36.26-3.57.29-7.15.69-10.72 1.1z"
          style={{
            WebkitTransformOrigin: 256.525,
            MsTransformOrigin: 256.525,
            transformOrigin: 256.525,
          }}
          fill="#DBDBDB"
          className="animable"
        ></path>
        <path
          d="M242.55 463.11c-1.84-.3-43.15-19.89-44.28-21.87-.45-.74 2.6-7.46 6.51-15.47l.12-.25c.8-1.65 14.86-29.07 14.86-29.07L249 411.1l-15.1 29.25-.27.48s9.68 12.76 10.7 15.07.06 7.51-1.78 7.21z"
          style={{
            WebkitTransformOrigin: 223.613,
            MsTransformOrigin: 223.613,
            transformOrigin: 223.613,
          }}
          fill="#D3766A"
          className="animable"
        ></path>
        <path
          d="M198.27 441.24c1.13 2 42.44 21.57 44.28 21.86s2.82-4.91 1.81-7.2a93.66 93.66 0 00-6.92-10c1.43 2.69 2.16 12.73-32.55-19.19l-.4-.36c-3.76 7.74-6.66 14.17-6.22 14.89z"
          style={{
            WebkitTransformOrigin: 221.496,
            MsTransformOrigin: 221.496,
            transformOrigin: 221.496,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M215.62 330.2v35.27s2.31 1.52 3.2 2S220 389.3 220.27 391s-16.09 33-16.09 33L235 440s20-33.87 20-44.2c0-12.52-9.49-58.12-10.32-59s-.93-6.64-.93-6.64z"
          style={{
            WebkitTransformOrigin: 229.59,
            MsTransformOrigin: 229.59,
            transformOrigin: 229.59,
          }}
          fill="#37474F"
          className="animable"
        ></path>
        <path
          d="M237.15 432.42c-4.32-2.67-8.82-5.06-13.32-7.42-2.24-1.17-4.47-2.35-6.73-3.5s-4.63-2.24-6.91-3.42c-.09-.05-.18.08-.09.13 2.25 1.23 4.44 2.56 6.67 3.81s4.5 2.46 6.76 3.68c4.46 2.39 8.93 4.79 13.55 6.88.09.05.16-.11.07-.16z"
          style={{
            WebkitTransformOrigin: 223.627,
            MsTransformOrigin: 223.627,
            transformOrigin: 223.627,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M222 340.61c.31 1.27.42 2.6.61 3.89l.57 4c.37 2.57.72 5.13 1.11 7.7 2 .6 4 1.24 5.95 1.81a12.89 12.89 0 003.16.76c1.11 0 1.94-.92 2.74-1.58l2.45-2c.79-.65 1.84-1.26 1.82-2.4s-.19-2.18-.29-3.26-.19-2.2-.28-3.3c-.2-2.48-.31-5-.51-7.45 0-.09.14-.1.15 0 .31 2.43.72 4.85 1 7.27.16 1.22.32 2.44.46 3.66a22.25 22.25 0 01.34 3.35 3.12 3.12 0 01-1.43 2.28l-2.85 2.32a11.46 11.46 0 01-2.5 1.88 4.5 4.5 0 01-3-.15c-2.63-.73-5.25-1.5-7.82-2.41a.48.48 0 01-.31-.44c-.29-2.7-.62-5.4-.94-8.11l-.45-3.92c-.15-1.28-.38-2.58-.4-3.86a.17.17 0 01.42-.04z"
          style={{
            WebkitTransformOrigin: 231.43,
            MsTransformOrigin: 231.43,
            transformOrigin: 231.43,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M196.61 467.09c1.77-.56 42.58-30.33 43.42-32.45.33-.8-3.67-7-8.71-14.36l-.16-.23c-1-1.51-2.11-3.07-3.21-4.63-.16-.22-.31-.43-.45-.65-7.39-10.53-15.28-21.29-15.28-21.29l-27.36 19.83 15.86 20.58.62.82 3.28 4.26.34.44s-10.53 18.39-11.2 20.82 1.08 7.43 2.85 6.86z"
          style={{
            WebkitTransformOrigin: 212.455,
            MsTransformOrigin: 212.455,
            transformOrigin: 212.455,
          }}
          fill="#D3766A"
          className="animable"
        ></path>
        <path
          d="M240 434.63c-.84 2.12-41.64 31.9-43.42 32.46s-3.5-4.45-2.85-6.86c.32-1.18 2.92-6 5.52-10.73-1 2.87 2.4 8.38 32.07-28.28l.34-.41c4.89 7.11 8.7 13.05 8.34 13.82z"
          style={{
            WebkitTransformOrigin: 216.807,
            MsTransformOrigin: 216.807,
            transformOrigin: 216.807,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M215.62 330.2v35.27s-2.32 1.52-3.2 2-2.85 18.25-3.12 19.94 21.14 30.48 21.14 30.48l-30 22.51s-27-37.67-27-48c0-12.53 12.27-54.69 13.1-55.53s.94-6.64.94-6.64z"
          style={{
            WebkitTransformOrigin: 201.94,
            MsTransformOrigin: 201.94,
            transformOrigin: 201.94,
          }}
          fill="#37474F"
          className="animable"
        ></path>
        <path
          d="M224.15 414.15c-4.28 2.73-8.39 5.76-12.47 8.78-2 1.51-4.06 3-6.07 4.54s-4 3.19-6.09 4.74c-.08.06 0 .19.08.13 2.08-1.48 4.24-2.88 6.33-4.35s4.17-3 6.25-4.49c4.09-3 8.2-6 12.09-9.21.08-.06-.03-.2-.12-.14z"
          style={{
            WebkitTransformOrigin: 211.892,
            MsTransformOrigin: 211.892,
            transformOrigin: 211.892,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M230.53 417.72a103.34 103.34 0 00-6.5-9.58c-1.12-1.53-2.23-3.06-3.39-4.56-.6-.79-1.22-1.56-1.82-2.35a14.88 14.88 0 00-1.77-2.11c-.06-.06-.15 0-.11.09a15.46 15.46 0 001.59 2.49c.54.77 1.06 1.56 1.6 2.34 1.11 1.58 2.24 3.15 3.37 4.71 2.21 3.08 4.4 6.22 6.91 9.07.06.07.17-.03.12-.1z"
          style={{
            WebkitTransformOrigin: 223.736,
            MsTransformOrigin: 223.736,
            transformOrigin: 223.736,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M231.05 363.7a11.93 11.93 0 01-5.45 1.46c-2 .1-4 0-5.94.07-4.14 0-8.27.33-12.42.31a54.69 54.69 0 01-7.35-.39c-.1 0-.14.13 0 .15a96 96 0 0012.89 1.15 75.79 75.79 0 0012.59-.8 13.94 13.94 0 005.76-1.88l-.08-.07z"
          style={{
            WebkitTransformOrigin: 215.465,
            MsTransformOrigin: 215.465,
            transformOrigin: 215.465,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M209.37 340.61c-.31 1.27-.42 2.6-.61 3.89s-.38 2.68-.58 4c-.36 2.57-.71 5.13-1.1 7.7-2 .6-4 1.24-6 1.81a13 13 0 01-3.16.76c-1.11 0-1.94-.92-2.74-1.58l-2.45-2c-.79-.65-1.84-1.26-1.83-2.4s.19-2.18.3-3.26.19-2.2.28-3.3c.2-2.48.31-5 .51-7.45 0-.09-.14-.1-.15 0-.32 2.43-.72 4.85-1 7.27-.15 1.22-.31 2.44-.45 3.66a22.25 22.25 0 00-.34 3.35 3.14 3.14 0 001.42 2.28l2.82 2.33a11.46 11.46 0 002.5 1.88 4.5 4.5 0 003-.15c2.62-.73 5.25-1.5 7.82-2.41a.48.48 0 00.31-.44c.29-2.7.62-5.4.93-8.11.16-1.3.31-2.61.46-3.92s.37-2.58.4-3.86a.17.17 0 00-.34-.05z"
          style={{
            WebkitTransformOrigin: 199.881,
            MsTransformOrigin: 199.881,
            transformOrigin: 199.881,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M229.53 274.16c22.67 17.37 36.74 43 34.78 50.55-2.08 8-23.3-11.26-24-13-1.24-3.06-11.88-19.56-17-31.42-5.31-12.42.15-10.78 6.22-6.13z"
          style={{
            WebkitTransformOrigin: 242.825,
            MsTransformOrigin: 242.825,
            transformOrigin: 242.825,
          }}
          fill="#D3766A"
          className="animable"
        ></path>
        <path
          d="M231.39 293.59s2.64-3.37 5-1.12-.82 5.09-.82 5.09z"
          style={{
            WebkitTransformOrigin: 234.326,
            MsTransformOrigin: 234.326,
            transformOrigin: 234.326,
          }}
          fill="#D3766A"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 223.3,
            MsTransformOrigin: 223.3,
            transformOrigin: 223.3,
          }}
          fill="#263238"
          d="M220.41 291.37H226.19V321.47H220.41z"
          className="animable"
          transform="rotate(43.24)"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 233.315,
            MsTransformOrigin: 233.315,
            transformOrigin: 233.315,
          }}
          fill="#37474F"
          d="M229.94 295.17H236.69V296.37H229.94z"
          className="animable"
          transform="rotate(43.24)"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 232.405,
            MsTransformOrigin: 232.405,
            transformOrigin: 232.405,
          }}
          fill="#37474F"
          d="M229.03 296.14H235.78V297.34H229.03z"
          className="animable"
          transform="rotate(43.24)"
        ></path>
        <path
          d="M215.1 319.36l-4.1 1.22-1.36.41.31-1.39 1-4.2.94-.15s-.1.93-.09.94l.94-.14s-.1.92-.1.94l.93-.16s-.09.93-.09.95l.93-.16s-.09.93-.08.95l.93-.15z"
          style={{
            WebkitTransformOrigin: 212.45,
            MsTransformOrigin: 212.45,
            transformOrigin: 212.45,
          }}
          fill="#FFF"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 210.29,
            MsTransformOrigin: 210.29,
            transformOrigin: 210.29,
          }}
          fill="#37474F"
          d="M210.97 320.58L209.61 320.99 209.92 319.6 210.97 320.58z"
          className="animable"
        ></path>
        <path
          d="M247.88 309.39c7.08 2.33 15.44 8.16 14.46 14.87-1.07 7.25-18.77 7.14-18.77 7.14z"
          style={{
            WebkitTransformOrigin: 252.994,
            MsTransformOrigin: 252.994,
            transformOrigin: 252.994,
          }}
          fill="#D3766A"
          className="animable"
        ></path>
        <path
          d="M217.3 306.43c-.39 2.58 6 3 6 3a4.8 4.8 0 00-2.31 2.3c-.76 1.83 1.77 3.82 1.77 3.82a5.89 5.89 0 00-2.06 2.82c-.55 1.82 1.72 4.19 1.72 4.19a5.17 5.17 0 00-.25 3.61c1.08 3.16 6 4.32 9.18 5.09s12.78 0 14.64.05l5.11-20.13s-13.11-7.47-16.94-7.85c-3.16-.33-16.26-.83-16.86 3.1z"
          style={{
            WebkitTransformOrigin: 234.191,
            MsTransformOrigin: 234.191,
            transformOrigin: 234.191,
          }}
          fill="#D3766A"
          className="animable"
        ></path>
        <path
          d="M223.4 309.37a43.32 43.32 0 0110.61.27.06.06 0 010 .12c-3.46-.43-7.12.07-10.59-.22a.09.09 0 01-.02-.17z"
          style={{
            WebkitTransformOrigin: 228.709,
            MsTransformOrigin: 228.709,
            transformOrigin: 228.709,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M222.92 315.31a9.22 9.22 0 012.4.22c.85.14 1.69.29 2.53.45q2.52.5 5 1.11c.07 0 .06.14 0 .12-1.67-.32-3.36-.62-5-.87-.85-.13-1.69-.25-2.54-.36a11.23 11.23 0 01-2.38-.44.12.12 0 01-.01-.23z"
          style={{
            WebkitTransformOrigin: 227.869,
            MsTransformOrigin: 227.869,
            transformOrigin: 227.869,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M222.52 322.58a6.59 6.59 0 012.15.31l2.3.49c1.52.31 3.05.63 4.59.89.08 0 .06.13 0 .12-1.57-.26-3.14-.5-4.7-.77l-2.3-.41a6 6 0 01-2.05-.55s-.02-.07.01-.08z"
          style={{
            WebkitTransformOrigin: 227.058,
            MsTransformOrigin: 227.058,
            transformOrigin: 227.058,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M258.05 331.93l-18.3-21.37S224.41 286 222 278s-.71-11.27 12-.57c13.06 10.94 25.37 28.54 30.42 40.06 5.01 11.22-6.37 14.44-6.37 14.44z"
          style={{
            WebkitTransformOrigin: 243.382,
            MsTransformOrigin: 243.382,
            transformOrigin: 243.382,
          }}
          fill="#1DD21D"
          className="animable"
        ></path>
        <path
          d="M234.29 280.41a.38.38 0 01.39.39.39.39 0 01-.39.39.4.4 0 01-.39-.39.39.39 0 01.39-.39zm-8.88.39a.4.4 0 00.39.39.39.39 0 00.39-.39.38.38 0 00-.39-.39.39.39 0 00-.39.39zm4.25-5.7a.39.39 0 00.39.39.4.4 0 00.39-.39.39.39 0 00-.39-.39.38.38 0 00-.39.39zm-8.5 0a.4.4 0 00.39.39.39.39 0 00.39-.39.38.38 0 00-.39-.39.39.39 0 00-.39.39zm21.24 17.19a.39.39 0 00.39.39.4.4 0 00.39-.39.39.39 0 00-.39-.39.38.38 0 00-.39.39zm-8.5 0a.4.4 0 00.39.39.39.39 0 00.39-.39.38.38 0 00-.39-.39.39.39 0 00-.39.39zm4.25-5.7a.4.4 0 00.39.39.39.39 0 00.39-.39.38.38 0 00-.39-.39.39.39 0 00-.39.39zm-8.49 0a.39.39 0 00.39.39.4.4 0 00.39-.39.39.39 0 00-.39-.39.38.38 0 00-.39.39zm21.23 17.19a.4.4 0 00.39.39.39.39 0 00.39-.39.38.38 0 00-.39-.39.39.39 0 00-.39.39zm-8.49 0a.39.39 0 00.39.39.4.4 0 00.39-.39.39.39 0 00-.39-.39.38.38 0 00-.39.39zm4.24-5.7a.4.4 0 00.39.39.39.39 0 00.39-.39.38.38 0 00-.39-.39.39.39 0 00-.39.39zm-8.49 0a.4.4 0 00.39.39.39.39 0 00.39-.39.38.38 0 00-.39-.39.39.39 0 00-.39.39zm21.23 17.19a.4.4 0 00.39.39.39.39 0 00.39-.39.38.38 0 00-.39-.39.39.39 0 00-.39.39zm-8.49 0a.4.4 0 00.39.39.39.39 0 00.39-.39.38.38 0 00-.39-.39.39.39 0 00-.39.39zm4.25-5.7a.39.39 0 00.39.39.4.4 0 00.39-.39.39.39 0 00-.39-.39.38.38 0 00-.39.39zm-8.5 0a.4.4 0 00.39.39.39.39 0 00.39-.39.38.38 0 00-.39-.39.39.39 0 00-.39.39zm12.74 17.19a.4.4 0 00.39.39.39.39 0 00.39-.39.38.38 0 00-.39-.39.39.39 0 00-.39.39zm4.25-5.7a.4.4 0 00.39.39.39.39 0 00.39-.39.38.38 0 00-.39-.39.39.39 0 00-.39.39zm-8.49 0a.39.39 0 00.39.39.4.4 0 00.39-.39.39.39 0 00-.39-.39.38.38 0 00-.39.39z"
          style={{
            WebkitTransformOrigin: 242.785,
            MsTransformOrigin: 242.785,
            transformOrigin: 242.785,
          }}
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M228.43 291.57c2 3 3.86 6.05 5.66 9.15.88 1.52 4.92 7.77 5.53 9.41a.08.08 0 01-.13.07c-1-1.36-5.12-7.59-6-9.14-.47-.83-.94-1.66-1.42-2.48-.51-.54-1-1.08-1.47-1.66a23 23 0 01-1.83-2.57.05.05 0 01.08-.06c.68.81 1.3 1.66 2 2.46l.62.75c-1.1-1.93-2.18-3.86-3.22-5.82a.11.11 0 01.18-.11z"
          style={{
            WebkitTransformOrigin: 233.933,
            MsTransformOrigin: 233.933,
            transformOrigin: 233.933,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M240.56 310.56a32.33 32.33 0 0111.5 2.45 48.8 48.8 0 0110.37 5.61c.08.05 0 .17-.08.12a53.18 53.18 0 00-10.62-5c-1.81-.64-3.65-1.19-5.51-1.67s-3.8-.86-5.68-1.35a.07.07 0 01.02-.16z"
          style={{
            WebkitTransformOrigin: 251.466,
            MsTransformOrigin: 251.466,
            transformOrigin: 251.466,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M200.36 274.16c-22.67 17.37-36.74 43-34.77 50.55 2.08 8 23.29-11.26 24-13 1.24-3.06 11.88-19.56 17-31.42 5.35-12.42-.16-10.78-6.23-6.13z"
          style={{
            WebkitTransformOrigin: 187.082,
            MsTransformOrigin: 187.082,
            transformOrigin: 187.082,
          }}
          fill="#D3766A"
          className="animable"
        ></path>
        <path
          d="M182 309.39c-7.07 2.33-15.44 8.16-14.45 14.87 1.06 7.25 18.76 7.14 18.76 7.14z"
          style={{
            WebkitTransformOrigin: 176.89,
            MsTransformOrigin: 176.89,
            transformOrigin: 176.89,
          }}
          fill="#D3766A"
          className="animable"
        ></path>
        <path
          d="M212.59 306.43c.39 2.58-6 3-6 3a4.8 4.8 0 012.31 2.3c.76 1.83-1.77 3.82-1.77 3.82a5.89 5.89 0 012.06 2.82c.55 1.82-1.72 4.19-1.72 4.19a5.17 5.17 0 01.25 3.61c-1.08 3.16-6 4.32-9.18 5.09s-12.78 0-14.63.05l-5.12-20.13s13.12-7.47 16.94-7.85c3.19-.33 16.27-.83 16.86 3.1z"
          style={{
            WebkitTransformOrigin: 195.699,
            MsTransformOrigin: 195.699,
            transformOrigin: 195.699,
          }}
          fill="#D3766A"
          className="animable"
        ></path>
        <path
          d="M206.5 309.37a43.3 43.3 0 00-10.61.27.06.06 0 100 .12c3.46-.43 7.12.07 10.59-.22a.09.09 0 00.02-.17z"
          style={{
            WebkitTransformOrigin: 201.191,
            MsTransformOrigin: 201.191,
            transformOrigin: 201.191,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M207 315.31a9.26 9.26 0 00-2.4.22c-.85.14-1.69.29-2.53.45q-2.52.5-5 1.11c-.08 0-.07.14 0 .12 1.68-.32 3.36-.62 5.05-.87.84-.13 1.69-.25 2.53-.36a11.23 11.23 0 002.38-.44.12.12 0 00-.03-.23z"
          style={{
            WebkitTransformOrigin: 202.059,
            MsTransformOrigin: 202.059,
            transformOrigin: 202.059,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M207.37 322.58a6.59 6.59 0 00-2.15.31l-2.29.49c-1.53.31-3.06.63-4.6.89-.08 0-.06.13 0 .12 1.56-.26 3.13-.5 4.69-.77l2.3-.41a6 6 0 002-.55l.05-.08z"
          style={{
            WebkitTransformOrigin: 202.824,
            MsTransformOrigin: 202.824,
            transformOrigin: 202.824,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M171.84 331.93l18.3-21.37S205.49 286 207.87 278s.71-11.27-12.05-.57c-13.06 10.94-25.37 28.54-30.42 40.06-4.94 11.22 6.44 14.44 6.44 14.44z"
          style={{
            WebkitTransformOrigin: 186.472,
            MsTransformOrigin: 186.472,
            transformOrigin: 186.472,
          }}
          fill="#1DD21D"
          className="animable"
        ></path>
        <path
          d="M196 280.8a.4.4 0 01-.39.39.39.39 0 01-.39-.39.38.38 0 01.39-.39.39.39 0 01.39.39zm8.1-.39a.39.39 0 00-.39.39.4.4 0 00.39.39.39.39 0 00.39-.39.38.38 0 00-.4-.39zm-4.25-5.7a.39.39 0 00-.39.39.4.4 0 00.39.39.39.39 0 00.39-.39.38.38 0 00-.4-.39zm8.5 0a.38.38 0 00-.39.39.39.39 0 00.39.39.4.4 0 00.39-.39.39.39 0 00-.4-.39zM187.1 291.9a.38.38 0 00-.38.39.39.39 0 10.77 0 .38.38 0 00-.39-.39zm8.5 0a.38.38 0 00-.39.39.39.39 0 00.39.39.4.4 0 00.39-.39.39.39 0 00-.39-.39zm-4.25-5.7a.39.39 0 00-.39.39.4.4 0 00.39.39.39.39 0 00.39-.39.38.38 0 00-.39-.39zm8.49 0a.39.39 0 00-.39.39.4.4 0 00.39.39.39.39 0 00.39-.39.38.38 0 00-.39-.39zm-21.23 17.19a.39.39 0 00-.39.39.4.4 0 00.39.39.39.39 0 00.39-.39.38.38 0 00-.39-.39zm8.49 0a.38.38 0 00-.38.39.39.39 0 10.77 0 .38.38 0 00-.39-.39zm-4.24-5.7a.38.38 0 00-.39.39.39.39 0 00.39.39.4.4 0 00.39-.39.39.39 0 00-.39-.39zm8.49 0a.39.39 0 00-.39.39.4.4 0 00.39.39.39.39 0 00.39-.39.38.38 0 00-.39-.39zm-21.23 17.19a.38.38 0 00-.39.39.39.39 0 00.39.39.4.4 0 00.39-.39.39.39 0 00-.39-.39zm8.49 0a.39.39 0 00-.39.39.4.4 0 00.39.39.39.39 0 00.39-.39.38.38 0 00-.39-.39zm-4.25-5.7a.38.38 0 00-.38.39.39.39 0 10.77 0 .38.38 0 00-.39-.39zm8.5 0a.38.38 0 00-.39.39.39.39 0 00.39.39.4.4 0 00.39-.39.39.39 0 00-.39-.39zm-12.74 17.19a.38.38 0 00-.39.39.39.39 0 00.39.39.4.4 0 00.39-.39.39.39 0 00-.39-.39zm-4.25-5.7a.39.39 0 00-.39.39.4.4 0 00.39.39.39.39 0 00.39-.39.38.38 0 00-.39-.39zm8.49 0a.38.38 0 00-.38.39.39.39 0 10.77 0 .38.38 0 00-.39-.39z"
          style={{
            WebkitTransformOrigin: 187.11,
            MsTransformOrigin: 187.11,
            transformOrigin: 187.11,
          }}
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M201.47 291.57c-2 3-3.87 6.05-5.67 9.15-.88 1.52-4.92 7.77-5.53 9.41a.08.08 0 00.13.07c1-1.36 5.12-7.59 6-9.14l1.42-2.48c.51-.54 1-1.08 1.47-1.66a23 23 0 001.83-2.57.05.05 0 00-.08-.06c-.68.81-1.3 1.66-2 2.46l-.63.75c1.1-1.93 2.18-3.86 3.22-5.82.1-.13-.09-.22-.16-.11z"
          style={{
            WebkitTransformOrigin: 195.964,
            MsTransformOrigin: 195.964,
            transformOrigin: 195.964,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M189.33 310.56a32.28 32.28 0 00-11.49 2.44 48.88 48.88 0 00-10.38 5.61c-.07.05 0 .17.08.12a53.18 53.18 0 0110.62-5c1.81-.64 3.65-1.19 5.51-1.67s3.8-.86 5.68-1.35a.07.07 0 00-.02-.15z"
          style={{
            WebkitTransformOrigin: 178.423,
            MsTransformOrigin: 178.423,
            transformOrigin: 178.423,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M185 333.12s61.65.1 61.74 0c.76-1-10.25-49.55-24.77-62.74-6.52-5.92-15.07-3.46-18.69 4.32-10.73 22.99-19.12 57.6-18.28 58.42z"
          style={{
            WebkitTransformOrigin: 215.86,
            MsTransformOrigin: 215.86,
            transformOrigin: 215.86,
          }}
          fill="#1DD21D"
          className="animable"
        ></path>
        <path
          d="M217.31 268.92a.38.38 0 01.39.39.39.39 0 01-.39.39.4.4 0 01-.39-.39.39.39 0 01.39-.39zm-8.88.39a.39.39 0 00.39.39.4.4 0 00.39-.39.39.39 0 00-.39-.39.38.38 0 00-.39.39zm17 11.49a.39.39 0 10.77 0 .39.39 0 10-.77 0zm-8.5 0a.4.4 0 00.39.39.39.39 0 00.39-.39.38.38 0 00-.39-.39.39.39 0 00-.4.39zm-8.49 0a.39.39 0 00.39.39.4.4 0 00.39-.39.39.39 0 00-.39-.39.38.38 0 00-.4.39zm-8 .37a.38.38 0 00.3-.37.27.27 0 00-.06-.2c-.11.19-.18.4-.27.57zm20.76-6.07a.39.39 0 00.39.39.4.4 0 00.39-.39.39.39 0 00-.39-.39.38.38 0 00-.42.39zm-8.49 0a.39.39 0 10.77 0 .39.39 0 10-.77 0zm-8.5 0a.4.4 0 00.39.39.39.39 0 00.39-.39.38.38 0 00-.39-.39.39.39 0 00-.42.39zm29.73 17.19a.39.39 0 00.39.39.4.4 0 00.39-.39.39.39 0 00-.39-.39.38.38 0 00-.42.39zm-8.49 0a.39.39 0 10.77 0 .39.39 0 10-.77 0zm-8.5 0a.4.4 0 00.39.39.39.39 0 00.39-.39.38.38 0 00-.39-.39.39.39 0 00-.42.39zm-8.49 0a.39.39 0 00.39.39.4.4 0 00.39-.39.39.39 0 00-.39-.39.38.38 0 00-.42.39zm-8.49 0a.39.39 0 10.77 0 .39.39 0 10-.77 0zm29.72-5.7a.4.4 0 00.39.39.39.39 0 00.39-.39.38.38 0 00-.39-.39.39.39 0 00-.42.39zm-8.49 0a.39.39 0 00.39.39.4.4 0 00.39-.39.39.39 0 00-.39-.39.38.38 0 00-.42.39zm-8.49 0a.39.39 0 10.77 0 .39.39 0 10-.77 0zm-8.5 0a.4.4 0 00.39.39.39.39 0 00.39-.39.38.38 0 00-.39-.39.39.39 0 00-.42.39zm29.73 17.19a.39.39 0 00.39.39.4.4 0 00.39-.39.39.39 0 00-.39-.39.38.38 0 00-.42.39zm-8.49 0a.39.39 0 10.77 0 .39.39 0 10-.77 0zm-8.5 0a.4.4 0 00.39.39.39.39 0 00.39-.39.38.38 0 00-.39-.39.39.39 0 00-.42.39zm-8.49 0a.39.39 0 00.39.39.4.4 0 00.39-.39.39.39 0 00-.39-.39.38.38 0 00-.42.39zm-8.49 0a.39.39 0 10.77 0 .39.39 0 10-.77 0zm29.72-5.7a.4.4 0 00.39.39.39.39 0 00.39-.39.38.38 0 00-.39-.39.39.39 0 00-.42.39zm-8.49 0a.39.39 0 00.39.39.4.4 0 00.39-.39.39.39 0 00-.39-.39.38.38 0 00-.42.39zm-8.49 0a.39.39 0 10.77 0 .39.39 0 10-.77 0zm-8.5 0a.4.4 0 00.39.39.39.39 0 00.39-.39.38.38 0 00-.39-.39.39.39 0 00-.42.39zm-8.49 0a.39.39 0 00.39.39.4.4 0 00.39-.39.39.39 0 00-.39-.39.38.38 0 00-.42.39zm46.71 17.19a.38.38 0 00.39.39.11.11 0 00.08 0l-.21-.74a.4.4 0 00-.29.35zm-8.49 0a.39.39 0 00.39.39.4.4 0 00.39-.39.39.39 0 00-.39-.39.38.38 0 00-.42.39zm-8.49 0a.39.39 0 10.77 0 .39.39 0 10-.77 0zm-8.5 0a.4.4 0 00.39.39.39.39 0 00.39-.39.38.38 0 00-.39-.39.39.39 0 00-.42.39zm-8.49 0a.39.39 0 00.39.39.4.4 0 00.39-.39.39.39 0 00-.39-.39.38.38 0 00-.42.39zm-8.49 0a.39.39 0 10.77 0 .39.39 0 10-.77 0zm-8.5 0a.4.4 0 00.39.39.39.39 0 00.39-.39.38.38 0 00-.39-.39.39.39 0 00-.42.39zm46.72-5.7a.39.39 0 00.39.39.4.4 0 00.39-.39.39.39 0 00-.39-.39.38.38 0 00-.42.39zm-8.5 0a.4.4 0 00.39.39.39.39 0 00.39-.39.38.38 0 00-.39-.39.39.39 0 00-.42.39zm-8.49 0a.39.39 0 00.39.39.4.4 0 00.39-.39.39.39 0 00-.39-.39.38.38 0 00-.42.39zm-8.49 0a.39.39 0 10.77 0 .39.39 0 10-.77 0zm-8.5 0a.4.4 0 00.39.39.39.39 0 00.39-.39.38.38 0 00-.39-.39.39.39 0 00-.42.39zm-8.49 0a.39.39 0 00.39.39.4.4 0 00.39-.39.39.39 0 00-.39-.39.38.38 0 00-.42.39zm46.71 17.19a.4.4 0 00.39.39.39.39 0 00.39-.39.38.38 0 00-.39-.39.39.39 0 00-.42.39zm-8.49 0a.39.39 0 00.39.39.4.4 0 00.39-.39.39.39 0 00-.39-.39.38.38 0 00-.42.39zm-8.49 0a.39.39 0 10.77 0 .39.39 0 10-.77 0zm-8.5 0a.4.4 0 00.39.39.39.39 0 00.39-.39.38.38 0 00-.39-.39.39.39 0 00-.42.39zm-8.49 0a.39.39 0 00.39.39.4.4 0 00.39-.39.39.39 0 00-.39-.39.38.38 0 00-.42.39zm-8.49 0a.39.39 0 10.77 0 .39.39 0 10-.77 0zm-8.5 0a.4.4 0 00.39.39.39.39 0 00.39-.39.38.38 0 00-.39-.39.39.39 0 00-.42.39zm46.72-5.7a.39.39 0 00.39.39.4.4 0 00.39-.39.39.39 0 00-.39-.39.38.38 0 00-.42.39zm-8.5 0a.4.4 0 00.39.39.39.39 0 00.39-.39.38.38 0 00-.39-.39.39.39 0 00-.42.39zm-8.49 0a.39.39 0 00.39.39.4.4 0 00.39-.39.39.39 0 00-.39-.39.38.38 0 00-.42.39zm-8.49 0a.39.39 0 10.77 0 .39.39 0 10-.77 0zm-8.5 0a.4.4 0 00.39.39.39.39 0 00.39-.39.38.38 0 00-.39-.39.39.39 0 00-.42.39zm-8.49 0a.39.39 0 00.39.39.4.4 0 00.39-.39.39.39 0 00-.39-.39.38.38 0 00-.42.39zm-8.38.29a.45.45 0 00.28.1.39.39 0 00.38-.39.38.38 0 00-.38-.39h-.11c-.08.24-.14.46-.2.68zm59.34 11.2a.37.37 0 00.11.27v-.5a.32.32 0 00-.14.23zm-8.49 0a.39.39 0 00.39.39.4.4 0 00.39-.39.39.39 0 00-.39-.39.38.38 0 00-.42.39zm-8.5 0a.4.4 0 00.39.39.39.39 0 00.39-.39.38.38 0 00-.39-.39.39.39 0 00-.42.39zm-8.49 0a.39.39 0 00.39.39.4.4 0 00.39-.39.39.39 0 00-.39-.39.38.38 0 00-.42.39zm-8.49 0a.39.39 0 10.77 0 .39.39 0 10-.77 0zm-8.5 0a.4.4 0 00.39.39.39.39 0 00.39-.39.38.38 0 00-.39-.39.39.39 0 00-.42.39zm-8.49 0a.39.39 0 00.39.39.4.4 0 00.39-.39.39.39 0 00-.39-.39.38.38 0 00-.42.39zm-8.49 0a.39.39 0 10.77 0 .39.39 0 10-.77 0z"
          style={{
            WebkitTransformOrigin: 217.007,
            MsTransformOrigin: 217.007,
            transformOrigin: 217.007,
          }}
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M185 333.12a115.11 115.11 0 012.16-11.81c.89-3.91 2-7.77 3.05-11.62s2.36-7.65 3.67-11.43c.66-1.89 1.36-3.77 2-5.65s1.44-3.73 2.2-5.58l-3.69 11.41c-1.2 3.81-2.41 7.62-3.5 11.46s-2.2 7.68-3.21 11.55c-.5 1.93-1 3.87-1.44 5.81s-.87 3.9-1.24 5.86z"
          style={{
            WebkitTransformOrigin: 191.54,
            MsTransformOrigin: 191.54,
            transformOrigin: 191.54,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M195.12 295.41c0-1 .08-2 .16-3s.21-2 .41-3c0 1-.08 2-.16 3s-.21 2.01-.41 3z"
          style={{
            WebkitTransformOrigin: 195.405,
            MsTransformOrigin: 195.405,
            transformOrigin: 195.405,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M247.05 333.12q-.62-3-1.36-5.89c-.47-2-1-3.91-1.53-5.85-1.08-3.88-2.22-7.74-3.47-11.58s-2.52-7.65-3.85-11.45-2.75-7.58-4.13-11.37c.83 1.84 1.63 3.69 2.42 5.54s1.53 3.74 2.25 5.63c1.45 3.77 2.76 7.59 4 11.43s2.35 7.73 3.31 11.65a109.55 109.55 0 012.36 11.89z"
          style={{
            WebkitTransformOrigin: 239.88,
            MsTransformOrigin: 239.88,
            transformOrigin: 239.88,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M236.1 295.41c-.2-1-.3-2-.41-3s-.17-2-.16-3c.2 1 .3 2 .41 3s.17 1.99.16 3z"
          style={{
            WebkitTransformOrigin: 235.815,
            MsTransformOrigin: 235.815,
            transformOrigin: 235.815,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M216.63 278.06c3.49.43 6.84-5.29 8.06-9.4.1-.32-.65-3.31-1.43-7-.46-2.24-.93-4.75-1.18-7.07l-14.14 5.15a36.88 36.88 0 012.39 8.73 5.26 5.26 0 010 1v.16c-.09 1.81 2.92 8.01 6.3 8.43z"
          style={{
            WebkitTransformOrigin: 216.32,
            MsTransformOrigin: 216.32,
            transformOrigin: 216.32,
          }}
          fill="#D3766A"
          className="animable"
        ></path>
        <path
          d="M210.33 269.45v.16a8.79 8.79 0 001.49-.09c7.87-1 9.25-10.87 9.49-14.64l-13.38 4.87a36.86 36.86 0 012.39 8.74 4.4 4.4 0 01.01.96z"
          style={{
            WebkitTransformOrigin: 214.62,
            MsTransformOrigin: 214.62,
            transformOrigin: 214.62,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M227.82 235.7c1.55 6.26-1.8 21.55-6.4 25.29-6.66 5.41-17.09 5.4-21.57-2.5-4.34-7.65.14-26.93 5.23-30.28 7.49-4.92 20.45-1.76 22.74 7.49z"
          style={{
            WebkitTransformOrigin: 213.151,
            MsTransformOrigin: 213.151,
            transformOrigin: 213.151,
          }}
          fill="#D3766A"
          className="animable"
        ></path>
        <path
          d="M200.88 237s-.45 3.71 1.92 4.93c.19.1 7.45 18.38 20.58 17.39 0 0 10.2-10.87 8-21.12-1.43-6.63-5.87-8.63-5.87-8.63s-9-8.58-19.86-4.85-8.77 11.69-4.77 12.28z"
          style={{
            WebkitTransformOrigin: 214.668,
            MsTransformOrigin: 214.668,
            transformOrigin: 214.668,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M218.83 225.31c-1.2 0-6.31-1.05-10.21 3.33-3.68 4.14-6.1 17.56-7.08 20.45s-4.88 3-6.12 6.29c-1.06 2.87 1 4.16 1 6.34 0 1.69-1.91 4-.61 6.67 1.17 2.38 3.66 2.14 5.07 3s2 4.35 4.66 5.53 5.3-1.08 6.74-.93 2.75 4.76 7.52 4.82 6.51-3.82 8.54-4.43 6.81 1.22 9.28-1 3.16-5.45 4.28-6.55 3.21-.72 4.73-3.38-.9-4.66-1-7.11c-.09-1.7 1.54-3.1.74-5.76-1.11-3.66-5.5-3.32-6.8-7.09-1-3-2.52-15.55-9.7-19.29-4.99-2.62-11.04-.89-11.04-.89z"
          style={{
            WebkitTransformOrigin: 221.123,
            MsTransformOrigin: 221.123,
            transformOrigin: 221.123,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M201.75 248.39a4.22 4.22 0 01-1.41 1.47l-1.67 1.14a12.84 12.84 0 00-3 2.63 4.09 4.09 0 00-.8 3.55 6.28 6.28 0 00.84 1.73 7.31 7.31 0 011 1.91 3.48 3.48 0 01-.41 2.2c-.28.64-.58 1.24-.82 1.86a4.79 4.79 0 00-.23 3.72 2.8 2.8 0 001.17 1.39 5.08 5.08 0 001.85.59c.66.11 1.34.15 2 .22a3.45 3.45 0 011.93.64 3.6 3.6 0 00-1.94-.43c-.68 0-1.36 0-2-.05a5.57 5.57 0 01-2.05-.54 3.32 3.32 0 01-1.48-1.59 5.23 5.23 0 01.12-4.21c.24-.65.54-1.28.8-1.89A2.82 2.82 0 00196 261c-.3-1.12-1.43-2.2-1.76-3.65a4.57 4.57 0 011-4.09 12.93 12.93 0 013.26-2.57l1.75-1a4.58 4.58 0 001.5-1.3z"
          style={{
            WebkitTransformOrigin: 198.155,
            MsTransformOrigin: 198.155,
            transformOrigin: 198.155,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M236.07 233.78a58.74 58.74 0 012.49 6.87c.41 1.15.77 2.3 1.26 3.4a7.9 7.9 0 00.83 1.52 1.05 1.05 0 00.26.29 1.11 1.11 0 00.3.25c.24.16.5.3.76.45a34.71 34.71 0 013.19 1.86 6.18 6.18 0 012.41 2.92 3.84 3.84 0 01.2 1.93 5.27 5.27 0 01-.72 1.76 7.77 7.77 0 00-1.46 3.28 7.53 7.53 0 011.12-3.47 4.47 4.47 0 00.57-1.64 3.26 3.26 0 00-.27-1.65 6 6 0 00-2.26-2.55 35.16 35.16 0 00-3.15-1.76c-.27-.16-.54-.32-.81-.5a2.63 2.63 0 01-.73-.72 8.58 8.58 0 01-.89-1.69 30 30 0 01-1.18-3.5l-.93-3.54a30.48 30.48 0 00-.99-3.51z"
          style={{
            WebkitTransformOrigin: 241.942,
            MsTransformOrigin: 241.942,
            transformOrigin: 241.942,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M243.14 268.08a6.4 6.4 0 00-1 2.36c-.26.84-.52 1.67-.83 2.5a13.33 13.33 0 01-1.14 2.42 5.74 5.74 0 01-1.94 2 7.24 7.24 0 01-5.37.13c-.85-.25-1.68-.53-2.51-.75a5.51 5.51 0 00-2.55-.23 5.09 5.09 0 012.63-.14c.87.15 1.72.37 2.57.53 1.66.34 3.45.54 4.85-.22a5.11 5.11 0 001.7-1.7 15.62 15.62 0 001.21-2.25c.37-.78.69-1.59 1-2.4.18-.4.36-.8.56-1.19a2.52 2.52 0 01.82-1.06z"
          style={{
            WebkitTransformOrigin: 235.47,
            MsTransformOrigin: 235.47,
            transformOrigin: 235.47,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M199.16 246.58s2.43-5.49 4.86-4.72 1.25 8.27-1.13 9.73a2.66 2.66 0 01-3.78-.72z"
          style={{
            WebkitTransformOrigin: 202.234,
            MsTransformOrigin: 202.234,
            transformOrigin: 202.234,
          }}
          fill="#D3766A"
          className="animable"
        ></path>
        <path
          d="M203.63 244s.06.05 0 .07c-1.66 1.08-2.29 2.94-2.61 4.8a1.46 1.46 0 012.08-.81c.05 0 0 .1 0 .1a1.64 1.64 0 00-1.66.91 8.24 8.24 0 00-.57 1.6c-.05.18-.36.15-.34 0-.48-2.39.68-5.95 3.1-6.67z"
          style={{
            WebkitTransformOrigin: 202.04,
            MsTransformOrigin: 202.04,
            transformOrigin: 202.04,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 215.665,
            MsTransformOrigin: 215.665,
            transformOrigin: 215.665,
          }}
          fill="#C7C7C7"
          d="M177.28 292H254.05V332.31H177.28z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 188.205,
            MsTransformOrigin: 188.205,
            transformOrigin: 188.205,
          }}
          fill="#DBDBDB"
          d="M184.41 332.31H192V366.1H184.41z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 243.115,
            MsTransformOrigin: 243.115,
            transformOrigin: 243.115,
          }}
          fill="#DBDBDB"
          d="M239.32 332.31H246.91V366.1H239.32z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 215.665,
            MsTransformOrigin: 215.665,
            transformOrigin: 215.665,
          }}
          fill="#C7C7C7"
          d="M173.06 366.1H258.27V376.3H173.06z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 185.765,
            MsTransformOrigin: 185.765,
            transformOrigin: 185.765,
          }}
          fill="#DBDBDB"
          d="M188.37 467.44L183.16 467.44 181.2 376.3 190.33 376.3 188.37 467.44z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 185.765,
            MsTransformOrigin: 185.765,
            transformOrigin: 185.765,
          }}
          fill="#A6A6A6"
          d="M190.33 376.3L190.19 383.98 181.33 383.98 181.2 376.3 190.33 376.3z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 248.685,
            MsTransformOrigin: 248.685,
            transformOrigin: 248.685,
          }}
          fill="#DBDBDB"
          d="M246.08 467.44L251.29 467.44 253.25 376.3 244.12 376.3 246.08 467.44z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 248.685,
            MsTransformOrigin: 248.685,
            transformOrigin: 248.685,
          }}
          fill="#A6A6A6"
          d="M244.12 376.3L244.25 383.98 253.12 383.98 253.25 376.3 244.12 376.3z"
          className="animable"
        ></path>
        <path
          d="M190.27 319.34a2.06 2.06 0 11-2.06-2.06 2.06 2.06 0 012.06 2.06z"
          style={{
            WebkitTransformOrigin: 188.21,
            MsTransformOrigin: 188.21,
            transformOrigin: 188.21,
          }}
          fill="#DBDBDB"
          className="animable"
        ></path>
        <path
          d="M245.18 319.34a2.06 2.06 0 11-2.06-2.06 2.06 2.06 0 012.06 2.06z"
          style={{
            WebkitTransformOrigin: 243.12,
            MsTransformOrigin: 243.12,
            transformOrigin: 243.12,
          }}
          fill="#DBDBDB"
          className="animable"
        ></path>
      </g>
      <g
        className="animable"
        style={{
          WebkitTransformOrigin: 387.74,
          MsTransformOrigin: 387.74,
          transformOrigin: 387.74,
        }}
      >
        <path
          style={{
            WebkitTransformOrigin: 387.74,
            MsTransformOrigin: 387.74,
            transformOrigin: 387.74,
          }}
          fill="#455A64"
          d="M306.8 326.41H468.68V333.99H306.8z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 387.735,
            MsTransformOrigin: 387.735,
            transformOrigin: 387.735,
          }}
          fill="#455A64"
          d="M313.54 333.99H461.93V354.09000000000003H313.54z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 327.135,
            MsTransformOrigin: 327.135,
            transformOrigin: 327.135,
          }}
          fill="#455A64"
          d="M329.97 465.76L324.3 465.76 322.17 354.09 332.1 354.09 329.97 465.76z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 327.14,
            MsTransformOrigin: 327.14,
            transformOrigin: 327.14,
          }}
          fill="#263238"
          d="M332.11 354.09L331.96 362.44 322.32 362.44 322.17 354.09 332.11 354.09z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 448.34,
            MsTransformOrigin: 448.34,
            transformOrigin: 448.34,
          }}
          fill="#455A64"
          d="M445.5 465.76L451.17 465.76 453.31 354.09 443.37 354.09 445.5 465.76z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 448.34,
            MsTransformOrigin: 448.34,
            transformOrigin: 448.34,
          }}
          fill="#263238"
          d="M443.37 354.09L443.52 362.44 453.16 362.44 453.31 354.09 443.37 354.09z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 387.74,
            MsTransformOrigin: 387.74,
            transformOrigin: 387.74,
          }}
          fill="#263238"
          d="M313.54 333.99H461.94000000000005V338.92H313.54z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 342.83,
            MsTransformOrigin: 342.83,
            transformOrigin: 342.83,
          }}
          fill="#1DD21D"
          d="M314.87 315.38H370.79V326.40999999999997H314.87z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 321.08,
            MsTransformOrigin: 321.08,
            transformOrigin: 321.08,
          }}
          fill="#37474F"
          d="M318.35 315.38H323.81V326.40999999999997H318.35z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 326.98,
            MsTransformOrigin: 326.98,
            transformOrigin: 326.98,
          }}
          fill="#37474F"
          d="M325.84 315.38H328.11999999999995V326.40999999999997H325.84z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 361.47,
            MsTransformOrigin: 361.47,
            transformOrigin: 361.47,
          }}
          fill="#37474F"
          d="M358.74 315.38H364.2V326.40999999999997H358.74z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 331.015,
            MsTransformOrigin: 331.015,
            transformOrigin: 331.015,
          }}
          fill="#455A64"
          d="M311.62 307.15H350.41V315.38H311.62z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 358.78,
            MsTransformOrigin: 358.78,
            transformOrigin: 358.78,
          }}
          fill="#455A64"
          d="M350.41 307.15H367.15000000000003V315.38H350.41z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 331.015,
            MsTransformOrigin: 331.015,
            transformOrigin: 331.015,
          }}
          fill="#FFF"
          d="M311.62 308H350.41V314.52H311.62z"
          className="animable"
        ></path>
        <path
          d="M314.13 309.34c3-.09 6.05-.16 9.07-.19l9.07-.06 9.07.06c3 0 6.05.1 9.07.19-3 .09-6.05.16-9.07.19l-9.07.06-9.07-.06c-3.02-.03-6.05-.1-9.07-.19z"
          style={{
            WebkitTransformOrigin: 332.27,
            MsTransformOrigin: 332.27,
            transformOrigin: 332.27,
          }}
          fill="#DBDBDB"
          className="animable"
        ></path>
        <path
          d="M314.13 310.62c3-.09 6.05-.16 9.07-.19l9.07-.06 9.07.06c3 0 6.05.1 9.07.19-3 .09-6.05.16-9.07.19l-9.07.06-9.07-.06c-3.02-.03-6.05-.1-9.07-.19z"
          style={{
            WebkitTransformOrigin: 332.27,
            MsTransformOrigin: 332.27,
            transformOrigin: 332.27,
          }}
          fill="#DBDBDB"
          className="animable"
        ></path>
        <path
          d="M314.13 311.9c3-.09 6.05-.16 9.07-.19l9.07-.06 9.07.06c3 0 6.05.1 9.07.19-3 .09-6.05.16-9.07.19l-9.07.06-9.07-.06c-3.02-.03-6.05-.09-9.07-.19z"
          style={{
            WebkitTransformOrigin: 332.27,
            MsTransformOrigin: 332.27,
            transformOrigin: 332.27,
          }}
          fill="#DBDBDB"
          className="animable"
        ></path>
        <path
          d="M314.13 313.18c3-.09 6.05-.16 9.07-.19l9.07-.06 9.07.06c3 0 6.05.1 9.07.19-3 .09-6.05.16-9.07.19l-9.07.06-9.07-.06c-3.02-.03-6.05-.1-9.07-.19z"
          style={{
            WebkitTransformOrigin: 332.27,
            MsTransformOrigin: 332.27,
            transformOrigin: 332.27,
          }}
          fill="#DBDBDB"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 339.73,
            MsTransformOrigin: 339.73,
            transformOrigin: 339.73,
          }}
          fill="#37474F"
          d="M320.32 298.12H359.14V307.14H320.32z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 353.21,
            MsTransformOrigin: 353.21,
            transformOrigin: 353.21,
          }}
          fill="#1DD21D"
          d="M351.4 298.12H355.02V307.14H351.4z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 348.32,
            MsTransformOrigin: 348.32,
            transformOrigin: 348.32,
          }}
          fill="#1DD21D"
          d="M347.62 298.12H349.02V307.14H347.62z"
          className="animable"
        ></path>
        <path
          d="M346.19 461.47c2.06.58 45.48 1.06 47.63-.44.48-.34.71-4.16.78-8.77 0-3.18-12.09-35.21-12.09-35.21h-34.69l4.49 25.95s-3.53 6.89-5.5 10.09c-1.52 2.42-2.69 7.8-.62 8.38z"
          style={{
            WebkitTransformOrigin: 369.837,
            MsTransformOrigin: 369.837,
            transformOrigin: 369.837,
          }}
          fill="#DD6A57"
          className="animable"
        ></path>
        <path
          d="M394.6 452.26c-.06 4.61-.29 8.43-.78 8.77-2.15 1.5-45.57 1-47.63.44s-.9-6 .62-8.41c1.68-2.71 4.46-8.08 5.27-9.65l.23-.44-.54-3.11h39.08l1.22 3.55c1.49 4.43 2.54 7.91 2.53 8.85z"
          style={{
            WebkitTransformOrigin: 369.84,
            MsTransformOrigin: 369.84,
            transformOrigin: 369.84,
          }}
          fill="#EBEBEB"
          className="animable"
        ></path>
        <path
          d="M394.6 452.26c-.06 4.61-.29 8.43-.78 8.77-2.15 1.5-45.57 1-47.63.44s-.9-6 .62-8.41c1.68-2.71 4.46-8.08 5.27-9.65h40c1.48 4.43 2.53 7.91 2.52 8.85z"
          style={{
            WebkitTransformOrigin: 369.84,
            MsTransformOrigin: 369.84,
            transformOrigin: 369.84,
          }}
          fill="#1DD21D"
          className="animable"
        ></path>
        <path
          d="M389.82 330.2v35.27s-2.31 1.52-3.2 2-9.16 19.81-9.43 21.49 15.08 52.78 15.08 52.78h-42s-8-44.67-8-55c0-12.52 17.6-49 18.43-49.87s.93-6.64.93-6.64z"
          style={{
            WebkitTransformOrigin: 367.27,
            MsTransformOrigin: 367.27,
            transformOrigin: 367.27,
          }}
          fill="#37474F"
          className="animable"
        ></path>
        <path
          d="M364 339.87c.31 1.27.42 2.6.61 3.89s.38 2.68.58 4c.36 2.57.71 5.13 1.1 7.69 2 .61 4 1.24 6 1.82a12.82 12.82 0 003.15.76c1.11 0 1.94-.92 2.74-1.58l2.45-2c.79-.65 1.84-1.26 1.83-2.4s-.19-2.18-.3-3.26-.19-2.2-.28-3.3c-.2-2.48-.31-5-.51-7.45 0-.09.14-.1.15 0 .32 2.43.72 4.85 1 7.27.15 1.22.31 2.44.45 3.65a22.51 22.51 0 01.34 3.36 3.14 3.14 0 01-1.42 2.28l-2.89 2.32a11.11 11.11 0 01-2.5 1.87 4.43 4.43 0 01-3-.14c-2.62-.73-5.25-1.5-7.82-2.42a.45.45 0 01-.31-.43c-.29-2.7-.62-5.4-.93-8.11-.16-1.31-.31-2.62-.46-3.92s-.37-2.58-.4-3.87a.17.17 0 01.42-.03z"
          style={{
            WebkitTransformOrigin: 373.445,
            MsTransformOrigin: 373.445,
            transformOrigin: 373.445,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M387 433.67c-4.58-.24-9.18-.49-13.77-.51s-9.25.11-13.87.3c-2.61.1-5.2.36-7.8.55a.08.08 0 000 .16c9.21 0 18.44.3 27.64-.1 2.6-.11 5.21-.1 7.81-.14.11 0 .1-.25-.01-.26z"
          style={{
            WebkitTransformOrigin: 369.284,
            MsTransformOrigin: 369.284,
            transformOrigin: 369.284,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M435.9 464.28c-1.86 0-49.31-17.37-50.7-19.18-.54-.67 1.58-7.74 4.39-16.19l.09-.27c.58-1.74 1.18-3.54 1.81-5.35.09-.25.18-.49.25-.75 4.19-12.16 8.8-24.68 8.8-24.68l31.78 11.49-9.55 24.17-.38 1-2 5-.2.51s15.2 14.76 16.52 16.91 1.05 7.4-.81 7.34z"
          style={{
            WebkitTransformOrigin: 411.324,
            MsTransformOrigin: 411.324,
            transformOrigin: 411.324,
          }}
          fill="#DD6A57"
          className="animable"
        ></path>
        <path
          d="M435.9 464.28c-1.86 0-49.31-17.37-50.7-19.18-.54-.67 1.58-7.74 4.39-16.19l.09-.27c.58-1.74 1.18-3.54 1.81-5.35.09-.25.18-.49.25-.75l31 11-.38 1-2 5-.2.51s15.2 14.76 16.52 16.91 1.08 7.38-.78 7.32z"
          style={{
            WebkitTransformOrigin: 411.314,
            MsTransformOrigin: 411.314,
            transformOrigin: 411.314,
          }}
          fill="#EBEBEB"
          className="animable"
        ></path>
        <path
          d="M423.8 441.81c-2.93-1.74-7-2.66-10.18-1.3-.13.06-.05.23.06.24a46.68 46.68 0 0110 1.45.21.21 0 00.12-.39z"
          style={{
            WebkitTransformOrigin: 418.728,
            MsTransformOrigin: 418.728,
            transformOrigin: 418.728,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M425.57 444c-2.93-1.74-7-2.66-10.18-1.3-.13.06-.05.23.06.24a46.5 46.5 0 0110 1.45.21.21 0 00.12-.39z"
          style={{
            WebkitTransformOrigin: 420.498,
            MsTransformOrigin: 420.498,
            transformOrigin: 420.498,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M427.34 446.21c-2.93-1.74-7-2.66-10.18-1.3-.13 0-.05.23.07.24a46.68 46.68 0 0110 1.45.21.21 0 00.11-.39z"
          style={{
            WebkitTransformOrigin: 422.268,
            MsTransformOrigin: 422.268,
            transformOrigin: 422.268,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M435.9 464.28c-1.86 0-49.31-17.37-50.7-19.18-.54-.67 1.58-7.74 4.39-16.19l.09-.27 30.74 10.84-.2.51s15.2 14.76 16.52 16.91 1.02 7.44-.84 7.38z"
          style={{
            WebkitTransformOrigin: 411.333,
            MsTransformOrigin: 411.333,
            transformOrigin: 411.333,
          }}
          fill="#1DD21D"
          className="animable"
        ></path>
        <path
          d="M436 462.25c-7.93-3.12-40.2-14.94-48.27-17.42-.07 0-.08 0 0 .05 7.79 3.26 40.15 14.82 48.24 17.5.19.06.24-.07.03-.13z"
          style={{
            WebkitTransformOrigin: 411.905,
            MsTransformOrigin: 411.905,
            transformOrigin: 411.905,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M389.83 330.2v35.27s2.31 1.52 3.2 2 9.16 19.81 9.43 21.49-12.63 37.25-12.63 37.25l35.5 13.66s12-42.8 12-53.13c0-12.52-17.6-49-18.43-49.87s-.93-6.64-.93-6.64z"
          style={{
            WebkitTransformOrigin: 413.58,
            MsTransformOrigin: 413.58,
            transformOrigin: 413.58,
          }}
          fill="#37474F"
          className="animable"
        ></path>
        <path
          d="M414.57 339.87c-.31 1.27-.42 2.6-.61 3.89s-.38 2.68-.58 4c-.37 2.57-.72 5.13-1.11 7.69-2 .61-3.95 1.24-5.95 1.82a12.82 12.82 0 01-3.15.76c-1.11 0-1.94-.92-2.74-1.58l-2.45-2c-.79-.65-1.84-1.26-1.83-2.4s.19-2.18.29-3.26.2-2.2.29-3.3c.19-2.48.31-5 .51-7.45 0-.09-.14-.1-.16 0-.31 2.43-.71 4.85-1 7.27-.16 1.22-.31 2.44-.45 3.65a21.26 21.26 0 00-.34 3.36 3.14 3.14 0 001.42 2.28l2.81 2.33a11.33 11.33 0 002.5 1.87 4.46 4.46 0 003-.14c2.62-.73 5.25-1.5 7.81-2.42a.45.45 0 00.32-.43c.28-2.7.62-5.4.93-8.11.15-1.31.31-2.62.46-3.92s.37-2.58.4-3.87a.17.17 0 00-.37-.04z"
          style={{
            WebkitTransformOrigin: 405.115,
            MsTransformOrigin: 405.115,
            transformOrigin: 405.115,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M395.28 418.52c4.08 1.33 8.18 2.65 12.2 4.16s8.07 3.15 12.07 4.84c2.25 1 4.44 2 6.66 3a.07.07 0 110 .12c-8.07-3-16.23-5.88-24.17-9.25-2.24-.95-4.53-1.81-6.8-2.7a.11.11 0 01.04-.17z"
          style={{
            WebkitTransformOrigin: 410.766,
            MsTransformOrigin: 410.766,
            transformOrigin: 410.766,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M404.39 364.47a21.48 21.48 0 01-7.2.24 34.55 34.55 0 00-7.26.14c-2.36.31-4.69.82-7 1.23-1.23.21-2.46.41-3.7.53a19.78 19.78 0 01-3.69.12c-.09 0-.11.15 0 .16a29.27 29.27 0 003.49.26 35.16 35.16 0 003.7-.23c2.47-.29 4.92-.74 7.39-1a64.86 64.86 0 017.38-.28 19.86 19.86 0 007-1 .05.05 0 10-.11-.17z"
          style={{
            WebkitTransformOrigin: 390.006,
            MsTransformOrigin: 390.006,
            transformOrigin: 390.006,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M337.58 320.91c4.11 3.81 12.83 2.83 35 2.41 3.07-.06 8.12-24.6 4.84-24.71-4.14-.13-18.29 1.5-20.88 2.34-9.48 3.05-21.74 17.38-18.96 19.96z"
          style={{
            WebkitTransformOrigin: 357.833,
            MsTransformOrigin: 357.833,
            transformOrigin: 357.833,
          }}
          fill="#DD6A57"
          className="animable"
        ></path>
        <path
          d="M371.33 299c9-.57 20.13-1.81 29.19 2.78a5 5 0 012.34 2.31c4.1 2 4.39 4.51 4.39 4.51 3.25 3 3.19 5.65 3.19 5.65s4.79 2.39 3.83 5.52c-1.07 3.51-7.58-.52-12.52-.56-11.31-.07-27.41 3-30.67 3.3z"
          style={{
            WebkitTransformOrigin: 392.739,
            MsTransformOrigin: 392.739,
            transformOrigin: 392.739,
          }}
          fill="#DD6A57"
          className="animable"
        ></path>
        <path
          d="M390 310.82a74.45 74.45 0 019.9.62 73.22 73.22 0 0110.48 2.88.09.09 0 00.07-.17 38.5 38.5 0 00-20.45-3.48c-.21.02-.22.15 0 .15z"
          style={{
            WebkitTransformOrigin: 400.172,
            MsTransformOrigin: 400.172,
            transformOrigin: 400.172,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M389 304c3.23.26 8.91.76 18.21 4.73 0 0 .06 0 0-.06a34.6 34.6 0 00-18.21-4.84c-.19 0-.22.17 0 .17z"
          style={{
            WebkitTransformOrigin: 398.041,
            MsTransformOrigin: 398.041,
            transformOrigin: 398.041,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M388.56 300.3c5.48.66 8.85 1.77 14.27 3.81 0 0 .06 0 0-.05-5.92-3-8.4-3.37-14.31-3.95-.17-.02-.18.17.04.19z"
          style={{
            WebkitTransformOrigin: 395.625,
            MsTransformOrigin: 395.625,
            transformOrigin: 395.625,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M388.12 320c-1.48.58-1.19 1.36 1.5 2.18s14.06 1.82 13.38 5.71-16.68 2.35-21.06.64-10.87-6-10.87-6c3.18-.32 10.82-1.83 17.05-2.53z"
          style={{
            WebkitTransformOrigin: 387.05,
            MsTransformOrigin: 387.05,
            transformOrigin: 387.05,
          }}
          fill="#DD6A57"
          className="animable"
        ></path>
        <path
          d="M382.24 277.52c3.49.47 7.27-4.77 7.88-9.25 0-.33-.62-3.32-1.36-7-.44-2.25-.87-4.76-1.11-7.08l-14.19 5a37.12 37.12 0 012.3 8.76 4.47 4.47 0 010 1v.16c-.12 1.78 3.11 7.96 6.48 8.41z"
          style={{
            WebkitTransformOrigin: 381.79,
            MsTransformOrigin: 381.79,
            transformOrigin: 381.79,
          }}
          fill="#DD6A57"
          className="animable"
        ></path>
        <path
          d="M375.75 268.9v.16a8.79 8.79 0 001.5-.08c7.88-1 9.37-10.76 9.64-14.53l-13.42 4.72a37 37 0 012.28 8.77 4.4 4.4 0 010 .96z"
          style={{
            WebkitTransformOrigin: 380.18,
            MsTransformOrigin: 380.18,
            transformOrigin: 380.18,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M393.56 234.9c1.7 6.22-1.3 21.58-5.81 25.42-6.53 5.57-17 5.8-21.62-2-4.52-7.56-.48-26.93 4.53-30.4 7.34-5.08 20.4-2.22 22.9 6.98z"
          style={{
            WebkitTransformOrigin: 379.105,
            MsTransformOrigin: 379.105,
            transformOrigin: 379.105,
          }}
          fill="#DD6A57"
          className="animable"
        ></path>
        <path
          d="M387.75 260.32c-2.62.58-4.93-4.66-5.15-13.66 0 0-1.11 1.41-1.79 1.15s-2.35-.33-2.25-1.33.25-5.93.25-5.93-5.58.2-6.48-6.77a10.66 10.66 0 01-5.95-4.92c-2.53-4.1-1.07-9.36 0-9.26s2 2.92 2 2.92 0-3 1.53-3 3.85 3.38 3.85 3.38 11.45.38 13.48 1.25c5.08 2.16 7.11 8 7.11 8a7.43 7.43 0 014.77 6.3c.71 5-5.57 20.6-11.37 21.87z"
          style={{
            WebkitTransformOrigin: 382.077,
            MsTransformOrigin: 382.077,
            transformOrigin: 382.077,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M366.3 235.57s-2.08 6.26-4.18 12.47h2.21l-.83 2.84a5.76 5.76 0 004.64-.4z"
          style={{
            WebkitTransformOrigin: 365.13,
            MsTransformOrigin: 365.13,
            transformOrigin: 365.13,
          }}
          fill="#DD6A57"
          className="animable"
        ></path>
        <path
          d="M367.84 242.79s.08.07.07.12c-.29 1.13-.44 2.47.51 3.07v.06c-1.24-.45-1.03-2.23-.58-3.25z"
          style={{
            WebkitTransformOrigin: 367.954,
            MsTransformOrigin: 367.954,
            transformOrigin: 367.954,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M369.12 241.83c1.85.27 1.18 4-.54 3.71s-1.02-3.93.54-3.71z"
          style={{
            WebkitTransformOrigin: 368.902,
            MsTransformOrigin: 368.902,
            transformOrigin: 368.902,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M370.85 240.67c-.48-.22-.88-.5-1.33-.76a2.54 2.54 0 01-1.22-1 .79.79 0 01.3-.92 2 2 0 012 .15 2.93 2.93 0 011.41 1.53.85.85 0 01-1.16 1z"
          style={{
            WebkitTransformOrigin: 370.146,
            MsTransformOrigin: 370.146,
            transformOrigin: 370.146,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M367.63 253.75c-.32.22-.66.54-1.09.5a3.07 3.07 0 01-1.17-.52s-.08 0-.06.05a1.54 1.54 0 001.34.89 1.24 1.24 0 001.08-.85c.03-.06-.05-.1-.1-.07z"
          style={{
            WebkitTransformOrigin: 366.522,
            MsTransformOrigin: 366.522,
            transformOrigin: 366.522,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M368.52 250.28a3.91 3.91 0 01-4.16.83c-.08 0-.11-.12-.08-.12a7.17 7.17 0 004.21-.85c.1-.05.11.06.03.14z"
          style={{
            WebkitTransformOrigin: 366.421,
            MsTransformOrigin: 366.421,
            transformOrigin: 366.421,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M380.81 247.81s3.95-5.41 6.41-4-.59 9.31-3.53 10.34a3 3 0 01-3.95-1.68z"
          style={{
            WebkitTransformOrigin: 383.93,
            MsTransformOrigin: 383.93,
            transformOrigin: 383.93,
          }}
          fill="#DD6A57"
          className="animable"
        ></path>
        <path
          d="M386.29 246.06v.08c-2.06.78-3.18 2.66-4 4.62a1.64 1.64 0 012.47-.4s0 .12-.06.11a1.82 1.82 0 00-2 .6 8.73 8.73 0 00-1 1.6c-.1.19-.43.08-.36-.13.03-2.66 2.14-6.28 4.95-6.48z"
          style={{
            WebkitTransformOrigin: 383.81,
            MsTransformOrigin: 383.81,
            transformOrigin: 383.81,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M396.18 275.09c6.56-2.38 21.21-10.94 33.6-28.69 3.81-5.45 2.68-37.38 1.12-42.15-.85-2.6-23.61 3.05-23.55 6.19.1 5.51 2.86 27.58 2.13 29-1.12 2.13-10.35 15.53-18.65 26.19-5.72 7.37-5.56 13.37 5.35 9.46z"
          style={{
            WebkitTransformOrigin: 409.724,
            MsTransformOrigin: 409.724,
            transformOrigin: 409.724,
          }}
          fill="#DD6A57"
          className="animable"
        ></path>
        <path
          d="M431.52 207.11c-1.94-8.79-3.82-19.85-10.74-27.28a5 5 0 00-2.87-1.62c-3-3.39-5.55-3-5.55-3-3.8-2.29-6.31-1.5-6.31-1.5s-3.62-3.94-6.36-2.15c-3.08 2 2.6 7.13 4 11.87 3.2 10.85 4.7 27.17 5.31 30.39z"
          style={{
            WebkitTransformOrigin: 415.154,
            MsTransformOrigin: 415.154,
            transformOrigin: 415.154,
          }}
          fill="#DD6A57"
          className="animable"
        ></path>
        <path
          d="M415 192.48a73 73 0 00-3.33-9.34 73.69 73.69 0 00-5.66-9.28.09.09 0 01.13-.11 38.51 38.51 0 019 18.69c.05.15-.07.2-.14.04z"
          style={{
            WebkitTransformOrigin: 410.578,
            MsTransformOrigin: 410.578,
            transformOrigin: 410.578,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M421.85 191.5c-1.15-3-3.2-8.35-9.58-16.19 0 0 0-.07 0 0a34.46 34.46 0 019.73 16.14c.05.19-.07.25-.15.05z"
          style={{
            WebkitTransformOrigin: 417.141,
            MsTransformOrigin: 417.141,
            transformOrigin: 417.141,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M425.51 190.91c-2.15-5.09-4.15-8-7.6-12.67 0 0 0-.07 0 0 4.49 4.87 5.56 7.14 7.75 12.66.11.15-.07.21-.15.01z"
          style={{
            WebkitTransformOrigin: 421.802,
            MsTransformOrigin: 421.802,
            transformOrigin: 421.802,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M406.7 196.78c-.14 1.58-1 1.51-2.5-.85s-5.6-13-9.2-11.29 2.36 16.68 5.21 20.42 8.78 8.79 8.78 8.79c-.57-3.14-1.24-10.85-2.29-17.07z"
          style={{
            WebkitTransformOrigin: 401.434,
            MsTransformOrigin: 401.434,
            transformOrigin: 401.434,
          }}
          fill="#DD6A57"
          className="animable"
        ></path>
        <path
          d="M417 264.42L398 255a161.38 161.38 0 00-10.1 13.22c-4.22 6.69-1.6 11.58 7.7 8.81 6.17-1.91 21.4-12.61 21.4-12.61z"
          style={{
            WebkitTransformOrigin: 401.471,
            MsTransformOrigin: 401.471,
            transformOrigin: 401.471,
          }}
          fill="#1DD21D"
          className="animable"
        ></path>
        <path
          d="M414.19 265.27c-2.87-1.19-5.72-2.41-8.51-3.77-1.39-.67-2.78-1.37-4.15-2.08s-2.67-1.58-4-2.27c-.08 0 0-.16.06-.12 1.34.77 2.8 1.36 4.18 2.05l4.16 2.06c2.78 1.36 5.56 2.72 8.37 4 .03.05-.04.16-.11.13z"
          style={{
            WebkitTransformOrigin: 405.902,
            MsTransformOrigin: 405.902,
            transformOrigin: 405.902,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M405.62 271.87c-3.77 2.27-7.62 4.38-10.06 5.11-9.3 2.77-11.92-2.12-7.7-8.81a.61.61 0 01.07-.1z"
          style={{
            WebkitTransformOrigin: 395.761,
            MsTransformOrigin: 395.761,
            transformOrigin: 395.761,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M357.12 335.17c.95.84 62.54-.32 62.62-.44.72-1.05-10.85-53.42-25.86-66.05-6.74-5.66-18.21-3.16-21.9 4.74-10.74 23.01-15.71 60.96-14.86 61.75z"
          style={{
            WebkitTransformOrigin: 388.399,
            MsTransformOrigin: 388.399,
            transformOrigin: 388.399,
          }}
          fill="#1DD21D"
          className="animable"
        ></path>
        <path
          d="M371.27 272.73c-15.77 12.78-37 41-34.32 47.49 2.94 7.24 22.87-9.79 23.33-10.88.39-.93 10.67-19.47 17.42-32.23s-2.53-7.54-6.43-4.38z"
          style={{
            WebkitTransformOrigin: 358.406,
            MsTransformOrigin: 358.406,
            transformOrigin: 358.406,
          }}
          fill="#DD6A57"
          className="animable"
        ></path>
        <path
          d="M352.5 287l20.84 4.33a159.07 159.07 0 006.42-15.33c2.38-7.54.14-10.2-8.15-5.16C366.07 274.2 352.5 287 352.5 287z"
          style={{
            WebkitTransformOrigin: 366.578,
            MsTransformOrigin: 366.578,
            transformOrigin: 366.578,
          }}
          fill="#1DD21D"
          className="animable"
        ></path>
        <path
          d="M355 285.47c3.07.42 6.14.89 9.18 1.49 1.52.3 3 .62 4.55 1s3 .85 4.49 1.17c.08 0 .05.15 0 .13-1.49-.4-3.05-.6-4.56-.92s-3-.64-4.55-.94c-3-.61-6.07-1.22-9.12-1.76-.08-.06-.05-.18.01-.17z"
          style={{
            WebkitTransformOrigin: 364.105,
            MsTransformOrigin: 364.105,
            transformOrigin: 364.105,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M378.51 282.33c-.59.71-1.13 1.45-1.66 2.2.67-1.64 1.29-3.32 1.85-5h-.05a77.58 77.58 0 00-3.4 7.13l-1.9 4.53s-2.09-.4-2.76-.42a.07.07 0 000 .14c1.28.3 3.06.74 3.08.68.93-2 1.95-4.09 2.81-6.08l.15-.37c.67-.9 1.34-1.8 1.95-2.74.02-.06-.04-.11-.07-.07z"
          style={{
            WebkitTransformOrigin: 374.61,
            MsTransformOrigin: 374.61,
            transformOrigin: 374.61,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 387.735,
            MsTransformOrigin: 387.735,
            transformOrigin: 387.735,
          }}
          fill="#C7C7C7"
          d="M349.35 292H426.12V332.31H349.35z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 360.275,
            MsTransformOrigin: 360.275,
            transformOrigin: 360.275,
          }}
          fill="#DBDBDB"
          d="M356.48 332.31H364.07V366.1H356.48z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 415.185,
            MsTransformOrigin: 415.185,
            transformOrigin: 415.185,
          }}
          fill="#DBDBDB"
          d="M411.39 332.31H418.97999999999996V366.1H411.39z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 387.735,
            MsTransformOrigin: 387.735,
            transformOrigin: 387.735,
          }}
          fill="#C7C7C7"
          d="M345.13 366.1H430.34V376.3H345.13z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 357.835,
            MsTransformOrigin: 357.835,
            transformOrigin: 357.835,
          }}
          fill="#DBDBDB"
          d="M360.44 467.44L355.23 467.44 353.27 376.3 362.4 376.3 360.44 467.44z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 357.84,
            MsTransformOrigin: 357.84,
            transformOrigin: 357.84,
          }}
          fill="#A6A6A6"
          d="M362.41 376.3L362.27 383.98 353.41 383.98 353.27 376.3 362.41 376.3z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 420.76,
            MsTransformOrigin: 420.76,
            transformOrigin: 420.76,
          }}
          fill="#DBDBDB"
          d="M418.15 467.44L423.37 467.44 425.33 376.3 416.19 376.3 418.15 467.44z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 420.76,
            MsTransformOrigin: 420.76,
            transformOrigin: 420.76,
          }}
          fill="#A6A6A6"
          d="M416.19 376.3L416.33 383.98 425.19 383.98 425.33 376.3 416.19 376.3z"
          className="animable"
        ></path>
        <path
          d="M362.34 319.34a2.06 2.06 0 11-2.06-2.06 2.06 2.06 0 012.06 2.06z"
          style={{
            WebkitTransformOrigin: 360.28,
            MsTransformOrigin: 360.28,
            transformOrigin: 360.28,
          }}
          fill="#DBDBDB"
          className="animable"
        ></path>
        <path
          d="M417.25 319.34a2.06 2.06 0 11-2.06-2.06 2.06 2.06 0 012.06 2.06z"
          style={{
            WebkitTransformOrigin: 415.19,
            MsTransformOrigin: 415.19,
            transformOrigin: 415.19,
          }}
          fill="#DBDBDB"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 369.41,
            MsTransformOrigin: 369.41,
            transformOrigin: 369.41,
          }}
          fill="#37474F"
          d="M378.57 335.87L369.85 335.87 360.25 292 368.97 292 378.57 335.87z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 363.465,
            MsTransformOrigin: 363.465,
            transformOrigin: 363.465,
          }}
          fill="#37474F"
          d="M372.63 383.2L363.9 383.2 354.3 332.28 363.03 332.28 372.63 383.2z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 412.01,
            MsTransformOrigin: 412.01,
            transformOrigin: 412.01,
          }}
          fill="#37474F"
          d="M402.85 383.2L411.57 383.2 421.17 332.28 412.45 332.28 402.85 383.2z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 406.065,
            MsTransformOrigin: 406.065,
            transformOrigin: 406.065,
          }}
          fill="#37474F"
          d="M396.9 335.87L405.63 335.87 415.23 292 406.5 292 396.9 335.87z"
          className="animable"
        ></path>
        <path
          d="M398.76 310.15h-4.82v-7a26.66 26.66 0 00-6.2-2.87 27.59 27.59 0 00-6.07 2.91v7h-4.81v-8c0-3.32 9.41-6.73 10.88-6.73s11 3.32 11 6.73zm-17.59-6.62z"
          style={{
            WebkitTransformOrigin: 387.81,
            MsTransformOrigin: 387.81,
            transformOrigin: 387.81,
          }}
          fill="#37474F"
          className="animable"
        ></path>
        <path
          d="M418.63 384.89h-61.79s-.08-23.72 1-38.34 6.31-39.63 29.87-39.63 28.79 25 29.89 39.63 1.03 38.34 1.03 38.34z"
          style={{
            WebkitTransformOrigin: 387.735,
            MsTransformOrigin: 387.735,
            transformOrigin: 387.735,
          }}
          fill="#1DD21D"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 387.735,
            MsTransformOrigin: 387.735,
            transformOrigin: 387.735,
          }}
          d="M364.56 352.6H410.91V379.53000000000003H364.56z"
          className="animable"
          opacity="0.1"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 387.735,
            MsTransformOrigin: 387.735,
            transformOrigin: 387.735,
          }}
          fill="#1DD21D"
          d="M364.56 359.32H410.91V360.28H364.56z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 387.74,
            MsTransformOrigin: 387.74,
            transformOrigin: 387.74,
          }}
          fill="#A6A6A6"
          d="M382.79 323.2H392.69V333.09999999999997H382.79z"
          className="animable"
          transform="rotate(-45)"
        ></path>
      </g>
      <defs>
        <filter id="active" height="200%">
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius="2"
            result="DILATED"
          ></feMorphology>
          <feFlood
            floodColor="#32DFEC"
            floodOpacity="1"
            result="PINK"
          ></feFlood>
          <feComposite
            in="PINK"
            in2="DILATED"
            operator="in"
            result="OUTLINE"
          ></feComposite>
          <feMerge>
            <feMergeNode in="OUTLINE"></feMergeNode>
            <feMergeNode in="SourceGraphic"></feMergeNode>
          </feMerge>
        </filter>
        <filter id="hover" height="200%">
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius="2"
            result="DILATED"
          ></feMorphology>
          <feFlood floodColor="red" floodOpacity="0.5" result="PINK"></feFlood>
          <feComposite
            in="PINK"
            in2="DILATED"
            operator="in"
            result="OUTLINE"
          ></feComposite>
          <feMerge>
            <feMergeNode in="OUTLINE"></feMergeNode>
            <feMergeNode in="SourceGraphic"></feMergeNode>
          </feMerge>
          <feColorMatrix values="0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0"></feColorMatrix>
        </filter>
      </defs>
    </svg>
  );
}

export default Icon;
